(() => {
var $fc034be10a6fa8a8$exports = {};
/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ /*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ /** DO NOT EDIT THIS AUTO-GENERATED FILE! */ const $b14b56bfe58815ff$export$83d89fbfd8236492 = '5.9.0';


/*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ /*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ /* eslint-disable @typescript-eslint/no-namespace, no-inner-declarations */ /** @private */ const $95162f6f50e12e59$var$lengths = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
/** @private */ const $95162f6f50e12e59$var$monthLengths = [
    $95162f6f50e12e59$var$lengths,
    $95162f6f50e12e59$var$lengths.slice()
];
$95162f6f50e12e59$var$monthLengths[1][2] = 29;
/**
 * @private
 */ function $95162f6f50e12e59$var$mod(x, y) {
    return x - y * Math.floor(x / y);
}
/**
 * @private
 */ function $95162f6f50e12e59$var$quotient(x, y) {
    return Math.floor(x / y);
}
/**
 * @private
 * @param abs - R.D. number of days
 */ function $95162f6f50e12e59$var$yearFromFixed(abs) {
    const l0 = abs - 1;
    const n400 = $95162f6f50e12e59$var$quotient(l0, 146097);
    const d1 = $95162f6f50e12e59$var$mod(l0, 146097);
    const n100 = $95162f6f50e12e59$var$quotient(d1, 36524);
    const d2 = $95162f6f50e12e59$var$mod(d1, 36524);
    const n4 = $95162f6f50e12e59$var$quotient(d2, 1461);
    const d3 = $95162f6f50e12e59$var$mod(d2, 1461);
    const n1 = $95162f6f50e12e59$var$quotient(d3, 365);
    const year = 400 * n400 + 100 * n100 + 4 * n4 + n1;
    return n100 !== 4 && n1 !== 4 ? year + 1 : year;
}
/*
const ABS_14SEP1752 = 639797;
const ABS_2SEP1752 = 639785;
*/ /*
 * Formerly in namespace, now top-level
 */ /**
 * Returns true if the Gregorian year is a leap year
 * @param year Gregorian year
 */ function $95162f6f50e12e59$export$58229a3fc17e87d(year) {
    return !(year % 4) && (!!(year % 100) || !(year % 400));
}
/**
 * Number of days in the Gregorian month for given year
 * @param month Gregorian month (1=January, 12=December)
 * @param year Gregorian year
 */ function $95162f6f50e12e59$export$f7b5f2637d35d70d(month, year) {
    // 1 based months
    return $95162f6f50e12e59$var$monthLengths[+$95162f6f50e12e59$export$58229a3fc17e87d(year)][month];
}
/**
 * Returns true if the object is a Javascript Date
 */ function $95162f6f50e12e59$export$871608497c498473(obj) {
    // eslint-disable-next-line no-prototype-builtins
    return typeof obj === 'object' && Date.prototype.isPrototypeOf(obj);
}
/**
 * @private
 * @param year
 * @param month (1-12)
 * @param day (1-31)
 */ function $95162f6f50e12e59$var$toFixed(year, month, day) {
    const py = year - 1;
    return 365 * py + $95162f6f50e12e59$var$quotient(py, 4) - $95162f6f50e12e59$var$quotient(py, 100) + $95162f6f50e12e59$var$quotient(py, 400) + $95162f6f50e12e59$var$quotient(367 * month - 362, 12) + (month <= 2 ? 0 : $95162f6f50e12e59$export$58229a3fc17e87d(year) ? -1 : -2) + day;
}
/**
 * Converts Gregorian date to absolute R.D. (Rata Die) days
 * @param date Gregorian date
 */ function $95162f6f50e12e59$export$5562ed62796cf6a1(date) {
    if (!$95162f6f50e12e59$export$871608497c498473(date)) throw new TypeError(`not a Date: ${date}`);
    const abs = $95162f6f50e12e59$var$toFixed(date.getFullYear(), date.getMonth() + 1, date.getDate());
    /*
      if (abs < ABS_14SEP1752 && abs > ABS_2SEP1752) {
        throw new RangeError(`Invalid Date: ${date}`);
      }
      */ return abs;
}
/**
 * Converts from Rata Die (R.D. number) to Gregorian date.
 * See the footnote on page 384 of ``Calendrical Calculations, Part II:
 * Three Historical Calendars'' by E. M. Reingold,  N. Dershowitz, and S. M.
 * Clamen, Software--Practice and Experience, Volume 23, Number 4
 * (April, 1993), pages 383-404 for an explanation.
 *
 * Note that this function returns the daytime portion of the date.
 * For example, the 15th of Cheshvan 5769 began at sundown on
 * 12 November 2008 and continues through 13 November 2008. This
 * function would return only the date 13 November 2008.
 * @param abs - R.D. number of days
 * @example
 * const abs = hebrew2abs(5769, months.CHESHVAN, 15);
 * const date = abs2greg(abs); // 13 November 2008
 * const year = date.getFullYear(); // 2008
 * const monthNum = date.getMonth() + 1; // 11
 * const day = date.getDate(); // 13
 */ function $95162f6f50e12e59$export$fa5d0dc73ec17c41(abs) {
    if (typeof abs !== 'number') throw new TypeError(`not a Number: ${abs}`);
    abs = Math.trunc(abs);
    /*
      if (abs < ABS_14SEP1752 && abs > ABS_2SEP1752) {
        throw new RangeError(`Invalid Date: ${abs}`);
      }
      */ const year = $95162f6f50e12e59$var$yearFromFixed(abs);
    const priorDays = abs - $95162f6f50e12e59$var$toFixed(year, 1, 1);
    const correction = abs < $95162f6f50e12e59$var$toFixed(year, 3, 1) ? 0 : $95162f6f50e12e59$export$58229a3fc17e87d(year) ? 1 : 2;
    const month = $95162f6f50e12e59$var$quotient(12 * (priorDays + correction) + 373, 367);
    const day = abs - $95162f6f50e12e59$var$toFixed(year, month, 1) + 1;
    const dt = new Date(year, month - 1, day);
    if (year < 100 && year >= 0) dt.setFullYear(year);
    return dt;
}


/*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-namespace */ /**
 * Gregorian date helper functions
 */ var $7d3f707c731759b6$export$7abed69d28911b36;
$7d3f707c731759b6$export$7abed69d28911b36 || ($7d3f707c731759b6$export$7abed69d28911b36 = {});
$7d3f707c731759b6$export$7abed69d28911b36.abs2greg = (0, $95162f6f50e12e59$export$fa5d0dc73ec17c41);
$7d3f707c731759b6$export$7abed69d28911b36.daysInMonth = (0, $95162f6f50e12e59$export$f7b5f2637d35d70d);
$7d3f707c731759b6$export$7abed69d28911b36.greg2abs = (0, $95162f6f50e12e59$export$5562ed62796cf6a1);
$7d3f707c731759b6$export$7abed69d28911b36.isDate = (0, $95162f6f50e12e59$export$871608497c498473);
$7d3f707c731759b6$export$7abed69d28911b36.isLeapYear = (0, $95162f6f50e12e59$export$58229a3fc17e87d);


/*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ /*
 * More minimal HDate
 */ const $0118a895d65cebcc$var$NISAN = 1;
const $0118a895d65cebcc$var$IYYAR = 2;
const $0118a895d65cebcc$var$SIVAN = 3;
const $0118a895d65cebcc$var$TAMUZ = 4;
const $0118a895d65cebcc$var$AV = 5;
const $0118a895d65cebcc$var$ELUL = 6;
const $0118a895d65cebcc$var$TISHREI = 7;
const $0118a895d65cebcc$var$CHESHVAN = 8;
const $0118a895d65cebcc$var$KISLEV = 9;
const $0118a895d65cebcc$var$TEVET = 10;
const $0118a895d65cebcc$var$SHVAT = 11;
const $0118a895d65cebcc$var$ADAR_I = 12;
const $0118a895d65cebcc$var$ADAR_II = 13;
/**
 * Hebrew months of the year (NISAN=1, TISHREI=7)
 * @readonly
 * @enum {number}
 */ const $0118a895d65cebcc$export$16352d1b10c5eb38 = {
    NISAN: /** Nissan / ניסן */ $0118a895d65cebcc$var$NISAN,
    IYYAR: /** Iyyar / אייר */ $0118a895d65cebcc$var$IYYAR,
    SIVAN: /** Sivan / סיון */ $0118a895d65cebcc$var$SIVAN,
    TAMUZ: /** Tamuz (sometimes Tammuz) / תמוז */ $0118a895d65cebcc$var$TAMUZ,
    AV: /** Av / אב */ $0118a895d65cebcc$var$AV,
    ELUL: /** Elul / אלול */ $0118a895d65cebcc$var$ELUL,
    TISHREI: /** Tishrei / תִּשְׁרֵי */ $0118a895d65cebcc$var$TISHREI,
    CHESHVAN: /** Cheshvan / חשון */ $0118a895d65cebcc$var$CHESHVAN,
    KISLEV: /** Kislev / כסלו */ $0118a895d65cebcc$var$KISLEV,
    TEVET: /** Tevet / טבת */ $0118a895d65cebcc$var$TEVET,
    SHVAT: /** Sh'vat / שבט */ $0118a895d65cebcc$var$SHVAT,
    ADAR_I: /** Adar or Adar Rishon / אדר */ $0118a895d65cebcc$var$ADAR_I,
    ADAR_II: /** Adar Sheini (only on leap years) / אדר ב׳ */ $0118a895d65cebcc$var$ADAR_II
};
const $0118a895d65cebcc$var$NISAN_STR = 'Nisan';
const $0118a895d65cebcc$var$monthNames0 = [
    '',
    $0118a895d65cebcc$var$NISAN_STR,
    'Iyyar',
    'Sivan',
    'Tamuz',
    'Av',
    'Elul',
    'Tishrei',
    'Cheshvan',
    'Kislev',
    'Tevet',
    "Sh'vat"
];
/*
 * Transliterations of Hebrew month names.
 * Regular years are index 0 and leap years are index 1.
 * @private
 */ const $0118a895d65cebcc$var$monthNames = [
    [
        ...$0118a895d65cebcc$var$monthNames0,
        'Adar',
        $0118a895d65cebcc$var$NISAN_STR
    ],
    [
        ...$0118a895d65cebcc$var$monthNames0,
        'Adar I',
        'Adar II',
        $0118a895d65cebcc$var$NISAN_STR
    ]
];
const $0118a895d65cebcc$var$edCache = new Map();
const $0118a895d65cebcc$var$EPOCH = -1373428;
// Avg year length in the cycle (19 solar years with 235 lunar months)
const $0118a895d65cebcc$var$AVG_HEBYEAR_DAYS = 365.24682220597794;
/**
 * @private
 */ function $0118a895d65cebcc$var$assertNumber(n, name) {
    if (typeof n !== 'number' || isNaN(n)) throw new TypeError(`param '${name}' not a number: ${n}`);
}
/**
 * Converts Hebrew date to R.D. (Rata Die) fixed days.
 * R.D. 1 is the imaginary date Monday, January 1, 1 on the Gregorian
 * Calendar.
 * @param year Hebrew year
 * @param month Hebrew month
 * @param day Hebrew date (1-30)
 * @example
 * const abs = hebrew2abs(5769, months.CHESHVAN, 15);
 */ function $0118a895d65cebcc$export$b4365e722c971925(year, month, day) {
    $0118a895d65cebcc$var$assertNumber(year, 'year');
    $0118a895d65cebcc$var$assertNumber(month, 'month');
    $0118a895d65cebcc$var$assertNumber(day, 'day');
    if (year < 1) throw new RangeError(`hebrew2abs: invalid year ${year}`);
    let tempabs = day;
    if (month < $0118a895d65cebcc$var$TISHREI) {
        for(let m = $0118a895d65cebcc$var$TISHREI; m <= $0118a895d65cebcc$export$80d7e435f744f319(year); m++)tempabs += $0118a895d65cebcc$export$4169ecd548fbc13a(m, year);
        for(let m = $0118a895d65cebcc$var$NISAN; m < month; m++)tempabs += $0118a895d65cebcc$export$4169ecd548fbc13a(m, year);
    } else for(let m = $0118a895d65cebcc$var$TISHREI; m < month; m++)tempabs += $0118a895d65cebcc$export$4169ecd548fbc13a(m, year);
    return $0118a895d65cebcc$var$EPOCH + $0118a895d65cebcc$export$15f8d6bee59f451d(year) + tempabs - 1;
}
/**
 * Converts Hebrew date to R.D. (Rata Die) fixed days.
 * R.D. 1 is the imaginary date Monday, January 1, 1 on the Gregorian
 * Calendar.
 */ function $0118a895d65cebcc$export$90ebbd6be1bf0308(hdate) {
    return $0118a895d65cebcc$export$b4365e722c971925(hdate.yy, hdate.mm, hdate.dd);
}
/**
 * @private
 */ function $0118a895d65cebcc$var$newYear(year) {
    return $0118a895d65cebcc$var$EPOCH + $0118a895d65cebcc$export$15f8d6bee59f451d(year);
}
/**
 * Converts absolute R.D. days to Hebrew date
 * @param abs absolute R.D. days
 */ function $0118a895d65cebcc$export$6bfe4fc23c10d072(abs) {
    $0118a895d65cebcc$var$assertNumber(abs, 'abs');
    abs = Math.trunc(abs);
    if (abs <= $0118a895d65cebcc$var$EPOCH) throw new RangeError(`abs2hebrew: ${abs} is before epoch`);
    // first, quickly approximate year
    let year = Math.floor((abs - $0118a895d65cebcc$var$EPOCH) / $0118a895d65cebcc$var$AVG_HEBYEAR_DAYS);
    while($0118a895d65cebcc$var$newYear(year) <= abs)++year;
    --year;
    let month = abs < $0118a895d65cebcc$export$b4365e722c971925(year, 1, 1) ? 7 : 1;
    while(abs > $0118a895d65cebcc$export$b4365e722c971925(year, month, $0118a895d65cebcc$export$4169ecd548fbc13a(month, year)))++month;
    const day = 1 + abs - $0118a895d65cebcc$export$b4365e722c971925(year, month, 1);
    return {
        yy: year,
        mm: month,
        dd: day
    };
}
/**
 * Returns true if Hebrew year is a leap year
 * @param year Hebrew year
 */ function $0118a895d65cebcc$export$553d7fa8e3805fc0(year) {
    return (1 + year * 7) % 19 < 7;
}
/**
 * Number of months in this Hebrew year (either 12 or 13 depending on leap year)
 * @param year Hebrew year
 */ function $0118a895d65cebcc$export$80d7e435f744f319(year) {
    return 12 + +$0118a895d65cebcc$export$553d7fa8e3805fc0(year); // boolean is cast to 1 or 0
}
/**
 * Number of days in Hebrew month in a given year (29 or 30)
 * @param month Hebrew month (e.g. months.TISHREI)
 * @param year Hebrew year
 */ function $0118a895d65cebcc$export$4169ecd548fbc13a(month, year) {
    switch(month){
        case $0118a895d65cebcc$var$IYYAR:
        case $0118a895d65cebcc$var$TAMUZ:
        case $0118a895d65cebcc$var$ELUL:
        case $0118a895d65cebcc$var$TEVET:
        case $0118a895d65cebcc$var$ADAR_II:
            return 29;
    }
    if (month === $0118a895d65cebcc$var$ADAR_I && !$0118a895d65cebcc$export$553d7fa8e3805fc0(year) || month === $0118a895d65cebcc$var$CHESHVAN && !$0118a895d65cebcc$export$9af239db6913ae90(year) || month === $0118a895d65cebcc$var$KISLEV && $0118a895d65cebcc$export$cfc9164cd88e25a7(year)) return 29;
    else return 30;
}
/**
 * Returns a transliterated string name of Hebrew month in year,
 * for example 'Elul' or 'Cheshvan'.
 * @param month Hebrew month (e.g. months.TISHREI)
 * @param year Hebrew year
 */ function $0118a895d65cebcc$export$e7af3ee2c84591cc(month, year) {
    $0118a895d65cebcc$var$assertNumber(month, 'month');
    $0118a895d65cebcc$var$assertNumber(year, 'year');
    if (month < 1 || month > 14) throw new TypeError(`bad monthNum: ${month}`);
    return $0118a895d65cebcc$var$monthNames[+$0118a895d65cebcc$export$553d7fa8e3805fc0(year)][month];
}
/**
 * Days from sunday prior to start of Hebrew calendar to mean
 * conjunction of Tishrei in Hebrew YEAR
 * @param year Hebrew year
 */ function $0118a895d65cebcc$export$15f8d6bee59f451d(year) {
    const n = $0118a895d65cebcc$var$edCache.get(year);
    if (typeof n === 'number') return n;
    const elapsed = $0118a895d65cebcc$var$elapsedDays0(year);
    $0118a895d65cebcc$var$edCache.set(year, elapsed);
    return elapsed;
}
/**
 * Days from sunday prior to start of Hebrew calendar to mean
 * conjunction of Tishrei in Hebrew YEAR
 * @private
 * @param year Hebrew year
 */ function $0118a895d65cebcc$var$elapsedDays0(year) {
    const prevYear = year - 1;
    const mElapsed = 235 * Math.floor(prevYear / 19) + // Months in complete 19 year lunar (Metonic) cycles so far
    12 * (prevYear % 19) + // Regular months in this cycle
    Math.floor((prevYear % 19 * 7 + 1) / 19); // Leap months this cycle
    const pElapsed = 204 + 793 * (mElapsed % 1080);
    const hElapsed = 5 + 12 * mElapsed + 793 * Math.floor(mElapsed / 1080) + Math.floor(pElapsed / 1080);
    const parts = pElapsed % 1080 + 1080 * (hElapsed % 24);
    const day = 1 + 29 * mElapsed + Math.floor(hElapsed / 24);
    let altDay = day;
    if (parts >= 19440 || 2 === day % 7 && parts >= 9924 && !$0118a895d65cebcc$export$553d7fa8e3805fc0(year) || 1 === day % 7 && parts >= 16789 && $0118a895d65cebcc$export$553d7fa8e3805fc0(prevYear)) altDay++;
    if (altDay % 7 === 0 || altDay % 7 === 3 || altDay % 7 === 5) return altDay + 1;
    else return altDay;
}
/**
 * Number of days in the hebrew YEAR.
 * A common Hebrew calendar year can have a length of 353, 354 or 355 days
 * A leap Hebrew calendar year can have a length of 383, 384 or 385 days
 * @param year Hebrew year
 */ function $0118a895d65cebcc$export$3913210603d8e9ae(year) {
    return $0118a895d65cebcc$export$15f8d6bee59f451d(year + 1) - $0118a895d65cebcc$export$15f8d6bee59f451d(year);
}
/**
 * true if Cheshvan is long in Hebrew year
 * @param year Hebrew year
 */ function $0118a895d65cebcc$export$9af239db6913ae90(year) {
    return $0118a895d65cebcc$export$3913210603d8e9ae(year) % 10 === 5;
}
/**
 * true if Kislev is short in Hebrew year
 * @param year Hebrew year
 */ function $0118a895d65cebcc$export$cfc9164cd88e25a7(year) {
    return $0118a895d65cebcc$export$3913210603d8e9ae(year) % 10 === 3;
}
/**
 * Converts Hebrew month string name to numeric
 * @param monthName monthName
 */ function $0118a895d65cebcc$export$613e90e09ea4691e(monthName) {
    if (typeof monthName === 'number') {
        if (isNaN(monthName) || monthName < 1 || monthName > 14) throw new RangeError(`bad monthName: ${monthName}`);
        return monthName;
    }
    let c = monthName.trim().toLowerCase();
    // If Hebrew month starts with a bet (for example `בתמוז`) then ignore it
    if (c[0] === "\u05D1") c = c.substring(1);
    /*
    the Hebrew months are unique to their second letter
    N         Nisan  (November?)
    I         Iyyar
    E        Elul
    C        Cheshvan
    K        Kislev
    1        1Adar
    2        2Adar
    Si Sh     Sivan, Shvat
    Ta Ti Te Tamuz, Tishrei, Tevet
    Av Ad    Av, Adar
  
    אב אד אי אל   אב אדר אייר אלול
    ח            חשון
    ט            טבת
    כ            כסלו
    נ            ניסן
    ס            סיון
    ש            שבט
    תמ תש        תמוז תשרי
    */ switch(c[0]){
        case 'n':
        case "\u05E0":
            if (c[1] === 'o') break; /* this catches "november" */ 
            return $0118a895d65cebcc$var$NISAN;
        case 'i':
            return $0118a895d65cebcc$var$IYYAR;
        case 'e':
            return $0118a895d65cebcc$var$ELUL;
        case 'c':
        case "\u05D7":
            return $0118a895d65cebcc$var$CHESHVAN;
        case 'k':
        case "\u05DB":
            return $0118a895d65cebcc$var$KISLEV;
        case 's':
            switch(c[1]){
                case 'i':
                    return $0118a895d65cebcc$var$SIVAN;
                case 'h':
                    return $0118a895d65cebcc$var$SHVAT;
            }
            break;
        case 't':
            switch(c[1]){
                case 'a':
                    return $0118a895d65cebcc$var$TAMUZ;
                case 'i':
                    return $0118a895d65cebcc$var$TISHREI;
                case 'e':
                    return $0118a895d65cebcc$var$TEVET;
            }
            break;
        case 'a':
            switch(c[1]){
                case 'v':
                    return $0118a895d65cebcc$var$AV;
                case 'd':
                    if (/(1|[^i]i|a|א)$/i.test(monthName)) return $0118a895d65cebcc$var$ADAR_I;
                    return $0118a895d65cebcc$var$ADAR_II; // else assume sheini
            }
            break;
        case "\u05E1":
            return $0118a895d65cebcc$var$SIVAN;
        case "\u05D8":
            return $0118a895d65cebcc$var$TEVET;
        case "\u05E9":
            return $0118a895d65cebcc$var$SHVAT;
        case "\u05D0":
            switch(c[1]){
                case "\u05D1":
                    return $0118a895d65cebcc$var$AV;
                case "\u05D3":
                    if (/(1|[^i]i|a|א)$/i.test(monthName)) return $0118a895d65cebcc$var$ADAR_I;
                    return $0118a895d65cebcc$var$ADAR_II; // else assume sheini
                case "\u05D9":
                    return $0118a895d65cebcc$var$IYYAR;
                case "\u05DC":
                    return $0118a895d65cebcc$var$ELUL;
            }
            break;
        case "\u05EA":
            switch(c[1]){
                case "\u05DE":
                    return $0118a895d65cebcc$var$TAMUZ;
                case "\u05E9":
                    return $0118a895d65cebcc$var$TISHREI;
            }
            break;
    }
    throw new RangeError(`bad monthName: ${monthName}`);
}


/*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 

const $6ddeffc610e4c6d6$var$NISAN = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).NISAN;
const $6ddeffc610e4c6d6$var$CHESHVAN = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).CHESHVAN;
const $6ddeffc610e4c6d6$var$KISLEV = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).KISLEV;
const $6ddeffc610e4c6d6$var$TEVET = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TEVET;
const $6ddeffc610e4c6d6$var$SHVAT = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).SHVAT;
const $6ddeffc610e4c6d6$var$ADAR_I = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ADAR_I;
const $6ddeffc610e4c6d6$var$ADAR_II = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ADAR_II;
/**
 * Returns true if the object is a SimpleHebrewDate
 * @private
 */ function $6ddeffc610e4c6d6$var$isSimpleHebrewDate(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.yy === 'number' && typeof obj.mm === 'number' && typeof obj.dd === 'number';
}
/**
 * @private
 */ function $6ddeffc610e4c6d6$var$toSimpleHebrewDate(obj) {
    if ($6ddeffc610e4c6d6$var$isSimpleHebrewDate(obj)) return obj;
    else if ((0, $95162f6f50e12e59$export$871608497c498473)(obj)) {
        const abs = (0, $95162f6f50e12e59$export$5562ed62796cf6a1)(obj);
        return (0, $0118a895d65cebcc$export$6bfe4fc23c10d072)(abs);
    } else // typeof obj === 'number'
    return (0, $0118a895d65cebcc$export$6bfe4fc23c10d072)(obj);
}
/**
 * Calculates yahrzeit.
 * `hyear` must be after original `date` of death.
 * Returns `undefined` when requested year preceeds or is same as original year.
 *
 * Hebcal uses the algorithm defined in "Calendrical Calculations"
 * by Edward M. Reingold and Nachum Dershowitz.
 *
 * The customary anniversary date of a death is more complicated and depends
 * also on the character of the year in which the first anniversary occurs.
 * There are several cases:
 *
 * * If the date of death is Marcheshvan 30, the anniversary in general depends
 *   on the first anniversary; if that first anniversary was not Marcheshvan 30,
 *   use the day before Kislev 1.
 * * If the date of death is Kislev 30, the anniversary in general again depends
 *   on the first anniversary — if that was not Kislev 30, use the day before
 *   Tevet 1.
 * * If the date of death is Adar II, the anniversary is the same day in the
 *   last month of the Hebrew year (Adar or Adar II).
 * * If the date of death is Adar I 30, the anniversary in a Hebrew year that
 *   is not a leap year (in which Adar only has 29 days) is the last day in
 *   Shevat.
 * * In all other cases, use the normal (that is, same month number) anniversary
 *   of the date of death. [Calendrical Calculations p. 113]
 * @example
 * import {getYahrzeit} from '@hebcal/hdate';
 * const dt = new Date(2014, 2, 2); // '2014-03-02' == '30 Adar I 5774'
 * const anniversary = getYahrzeit(5780, dt); // '2/25/2020' == '30 Sh\'vat 5780'
 * @param hyear Hebrew year
 * @param date Gregorian or Hebrew date of death
 * @returns anniversary occurring in `hyear`
 */ function $6ddeffc610e4c6d6$export$d4c7cd68a7d7f8a9(hyear, date) {
    const hd = $6ddeffc610e4c6d6$export$662088c602cc6396(hyear, date);
    if (typeof hd === 'undefined') return hd;
    return (0, $95162f6f50e12e59$export$fa5d0dc73ec17c41)((0, $0118a895d65cebcc$export$b4365e722c971925)(hd.yy, hd.mm, hd.dd));
}
function $6ddeffc610e4c6d6$export$662088c602cc6396(hyear, date) {
    let hDeath = $6ddeffc610e4c6d6$var$toSimpleHebrewDate(date);
    if (hyear <= hDeath.yy) // Hebrew year ${hyear} occurs on or before original date in ${hDeath.yy}
    return undefined;
    if (hDeath.mm === $6ddeffc610e4c6d6$var$CHESHVAN && hDeath.dd === 30 && !(0, $0118a895d65cebcc$export$9af239db6913ae90)(hDeath.yy + 1)) // If it's Heshvan 30 it depends on the first anniversary;
    // if that was not Heshvan 30, use the day before Kislev 1.
    hDeath = (0, $0118a895d65cebcc$export$6bfe4fc23c10d072)((0, $0118a895d65cebcc$export$b4365e722c971925)(hyear, $6ddeffc610e4c6d6$var$KISLEV, 1) - 1);
    else if (hDeath.mm === $6ddeffc610e4c6d6$var$KISLEV && hDeath.dd === 30 && (0, $0118a895d65cebcc$export$cfc9164cd88e25a7)(hDeath.yy + 1)) // If it's Kislev 30 it depends on the first anniversary;
    // if that was not Kislev 30, use the day before Teveth 1.
    hDeath = (0, $0118a895d65cebcc$export$6bfe4fc23c10d072)((0, $0118a895d65cebcc$export$b4365e722c971925)(hyear, $6ddeffc610e4c6d6$var$TEVET, 1) - 1);
    else if (hDeath.mm === $6ddeffc610e4c6d6$var$ADAR_II) // If it's Adar II, use the same day in last month of year (Adar or Adar II).
    hDeath.mm = (0, $0118a895d65cebcc$export$80d7e435f744f319)(hyear);
    else if (hDeath.mm === $6ddeffc610e4c6d6$var$ADAR_I && hDeath.dd === 30 && !(0, $0118a895d65cebcc$export$553d7fa8e3805fc0)(hyear)) {
        // If it's the 30th in Adar I and year is not a leap year
        // (so Adar has only 29 days), use the last day in Shevat.
        hDeath.dd = 30;
        hDeath.mm = $6ddeffc610e4c6d6$var$SHVAT;
    }
    // In all other cases, use the normal anniversary of the date of death.
    // advance day to rosh chodesh if needed
    if (hDeath.mm === $6ddeffc610e4c6d6$var$CHESHVAN && hDeath.dd === 30 && !(0, $0118a895d65cebcc$export$9af239db6913ae90)(hyear)) {
        hDeath.mm = $6ddeffc610e4c6d6$var$KISLEV;
        hDeath.dd = 1;
    } else if (hDeath.mm === $6ddeffc610e4c6d6$var$KISLEV && hDeath.dd === 30 && (0, $0118a895d65cebcc$export$cfc9164cd88e25a7)(hyear)) {
        hDeath.mm = $6ddeffc610e4c6d6$var$TEVET;
        hDeath.dd = 1;
    }
    hDeath.yy = hyear;
    return hDeath;
}
/**
 * Calculates a birthday or anniversary (non-yahrzeit).
 * `hyear` must be after original `date` of anniversary.
 * Returns `undefined` when requested year preceeds or is same as original year.
 *
 * Hebcal uses the algorithm defined in "Calendrical Calculations"
 * by Edward M. Reingold and Nachum Dershowitz.
 *
 * The birthday of someone born in Adar of an ordinary year or Adar II of
 * a leap year is also always in the last month of the year, be that Adar
 * or Adar II. The birthday in an ordinary year of someone born during the
 * first 29 days of Adar I in a leap year is on the corresponding day of Adar;
 * in a leap year, the birthday occurs in Adar I, as expected.
 *
 * Someone born on the thirtieth day of Marcheshvan, Kislev, or Adar I
 * has his birthday postponed until the first of the following month in
 * years where that day does not occur. [Calendrical Calculations p. 111]
 * @example
 * import {getBirthdayOrAnniversary} from '@hebcal/hdate';
 * const dt = new Date(2014, 2, 2); // '2014-03-02' == '30 Adar I 5774'
 * const anniversary = getBirthdayOrAnniversary(5780, dt); // '3/26/2020' == '1 Nisan 5780'
 * @param hyear Hebrew year
 * @param date Gregorian or Hebrew date of event
 * @returns anniversary occurring in `hyear`
 */ function $6ddeffc610e4c6d6$export$680c4e5470d6d2a2(hyear, date) {
    const hd = $6ddeffc610e4c6d6$export$e4a94214ee3df22c(hyear, date);
    if (typeof hd === 'undefined') return hd;
    return (0, $95162f6f50e12e59$export$fa5d0dc73ec17c41)((0, $0118a895d65cebcc$export$b4365e722c971925)(hd.yy, hd.mm, hd.dd));
}
function $6ddeffc610e4c6d6$export$e4a94214ee3df22c(hyear, date) {
    const orig = $6ddeffc610e4c6d6$var$toSimpleHebrewDate(date);
    const origYear = orig.yy;
    if (hyear === origYear) return orig;
    else if (hyear < origYear) // Hebrew year ${hyear} occurs on or before original date in ${origYear}
    return undefined;
    const isOrigLeap = (0, $0118a895d65cebcc$export$553d7fa8e3805fc0)(origYear);
    let month = orig.mm;
    let day = orig.dd;
    if (month === $6ddeffc610e4c6d6$var$ADAR_I && !isOrigLeap || month === $6ddeffc610e4c6d6$var$ADAR_II && isOrigLeap) month = (0, $0118a895d65cebcc$export$80d7e435f744f319)(hyear);
    else if (month === $6ddeffc610e4c6d6$var$CHESHVAN && day === 30 && !(0, $0118a895d65cebcc$export$9af239db6913ae90)(hyear)) {
        month = $6ddeffc610e4c6d6$var$KISLEV;
        day = 1;
    } else if (month === $6ddeffc610e4c6d6$var$KISLEV && day === 30 && (0, $0118a895d65cebcc$export$cfc9164cd88e25a7)(hyear)) {
        month = $6ddeffc610e4c6d6$var$TEVET;
        day = 1;
    } else if (month === $6ddeffc610e4c6d6$var$ADAR_I && day === 30 && isOrigLeap && !(0, $0118a895d65cebcc$export$553d7fa8e3805fc0)(hyear)) {
        month = $6ddeffc610e4c6d6$var$NISAN;
        day = 1;
    }
    return {
        yy: hyear,
        mm: month,
        dd: day
    };
}


/*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ const $b799e27e1258db2f$var$GERESH = "\u05F3";
const $b799e27e1258db2f$var$GERSHAYIM = "\u05F4";
const $b799e27e1258db2f$var$heb2num = {
    \u05D0: 1,
    \u05D1: 2,
    \u05D2: 3,
    \u05D3: 4,
    \u05D4: 5,
    \u05D5: 6,
    \u05D6: 7,
    \u05D7: 8,
    \u05D8: 9,
    \u05D9: 10,
    \u05DB: 20,
    \u05DC: 30,
    \u05DE: 40,
    \u05E0: 50,
    \u05E1: 60,
    \u05E2: 70,
    \u05E4: 80,
    \u05E6: 90,
    \u05E7: 100,
    \u05E8: 200,
    \u05E9: 300,
    \u05EA: 400
};
const $b799e27e1258db2f$var$num2heb = {};
for (const [key, val] of Object.entries($b799e27e1258db2f$var$heb2num))$b799e27e1258db2f$var$num2heb[val] = key;
function $b799e27e1258db2f$var$num2digits(num) {
    const digits = [];
    while(num > 0){
        if (num === 15 || num === 16) {
            digits.push(9);
            digits.push(num - 9);
            break;
        }
        let incr = 100;
        let i;
        for(i = 400; i > num; i -= incr)if (i === incr) incr = incr / 10;
        digits.push(i);
        num -= i;
    }
    return digits;
}
/**
 * Converts a numerical value to a string of Hebrew letters.
 *
 * When specifying years of the Hebrew calendar in the present millennium,
 * we omit the thousands (which is presently 5 [ה]).
 * @example
 * gematriya(5774) // 'תשע״ד' - cropped to 774
 * gematriya(25) // 'כ״ה'
 * gematriya(60) // 'ס׳'
 * gematriya(3761) // 'ג׳תשס״א'
 * gematriya(1123) // 'א׳קכ״ג'
 */ function $b799e27e1258db2f$export$426b794b832b1254(num) {
    const num1 = parseInt(num, 10);
    if (!num1 || num1 < 0) throw new TypeError(`invalid number: ${num}`);
    let str = '';
    const thousands = Math.floor(num1 / 1000);
    if (thousands > 0 && thousands !== 5) {
        const tdigits = $b799e27e1258db2f$var$num2digits(thousands);
        for (const tdig of tdigits)str += $b799e27e1258db2f$var$num2heb[tdig];
        str += $b799e27e1258db2f$var$GERESH;
    }
    const digits = $b799e27e1258db2f$var$num2digits(num1 % 1000);
    if (digits.length === 1) return str + $b799e27e1258db2f$var$num2heb[digits[0]] + $b799e27e1258db2f$var$GERESH;
    for(let i = 0; i < digits.length; i++){
        if (i + 1 === digits.length) str += $b799e27e1258db2f$var$GERSHAYIM;
        str += $b799e27e1258db2f$var$num2heb[digits[i]];
    }
    return str;
}
/**
 * Converts a string of Hebrew letters to a numerical value.
 *
 * Only considers the value of Hebrew letters `א` through `ת`.
 * Ignores final Hebrew letters such as `ך` (kaf sofit) or `ם` (mem sofit)
 * and vowels (nekudot).
 */ function $b799e27e1258db2f$export$56e3bc2b5cadf0a3(str) {
    let num = 0;
    const gereshIdx = str.indexOf($b799e27e1258db2f$var$GERESH);
    if (gereshIdx !== -1 && gereshIdx !== str.length - 1) {
        const thousands = str.substring(0, gereshIdx);
        num += $b799e27e1258db2f$export$56e3bc2b5cadf0a3(thousands) * 1000;
        str = str.substring(gereshIdx);
    }
    for (const ch of str){
        const n = $b799e27e1258db2f$var$heb2num[ch];
        if (typeof n === 'number') num += n;
    }
    return num;
}


/*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ const $d7ca1ee2cae1c802$var$sefirot = {
    en: {
        infix: 'within ',
        infix26: 'within ',
        words: [
            '',
            'Lovingkindness',
            'Might',
            'Beauty',
            'Eternity',
            'Splendor',
            'Foundation',
            'Majesty'
        ]
    },
    he: {
        infix: "\u05E9\u05B6\u05C1\u05D1\u05B0\u05BC",
        infix26: "\u05E9\u05B6\u05C1\u05D1\u05B4\u05BC",
        words: [
            '',
            "\u05D7\u05B6\u05BD\u05E1\u05B6\u05D3",
            "\u05D2\u05B0\u05D1\u05D5\u05BC\u05E8\u05B8\u05D4",
            "\u05EA\u05B4\u05BC\u05E4\u05D0\u05B6\u05E8\u05B6\u05EA",
            "\u05E0\u05B6\u05BC\u05BD\u05E6\u05B7\u05D7",
            "\u05D4\u05D5\u05B9\u05D3",
            "\u05D9\u05B0\u05BC\u05E1\u05D5\u05B9\u05D3",
            "\u05DE\u05B7\u05BC\u05DC\u05B0\u05DB\u05D5\u05BC\u05EA"
        ]
    },
    translit: {
        infix: "sheb'",
        infix26: 'shebi',
        words: [
            '',
            'Chesed',
            'Gevurah',
            'Tiferet',
            'Netzach',
            'Hod',
            'Yesod',
            'Malkhut'
        ]
    }
};
function $d7ca1ee2cae1c802$var$checkDay(omerDay) {
    if (omerDay < 1 || omerDay > 49) throw new RangeError(`Invalid Omer day ${omerDay}`);
}
function $d7ca1ee2cae1c802$var$getWeeks(omerDay) {
    const weekNum = Math.floor((omerDay - 1) / 7) + 1;
    const daysWithinWeeks = omerDay % 7 || 7;
    return [
        weekNum,
        daysWithinWeeks
    ];
}
/**
 * Returns the sefira. For example, on day 8
 *  חֶֽסֶד שֶׁבִּגְבוּרָה
 *  Chesed shebiGevurah
 *  Lovingkindness within Might
 * @param omerDay the day of the omer, 1-49 inclusive
 * @param lang `en` (English), `he` (Hebrew with nikud), or `translit` (Hebrew in Sephardic transliteration)
 * @returns a string such as `Lovingkindness within Might` or `חֶֽסֶד שֶׁבִּגְבוּרָה`
 */ function $d7ca1ee2cae1c802$export$5897bb1afb34310a(omerDay, lang) {
    $d7ca1ee2cae1c802$var$checkDay(omerDay);
    const [weekNum, daysWithinWeeks] = $d7ca1ee2cae1c802$var$getWeeks(omerDay);
    const config = $d7ca1ee2cae1c802$var$sefirot[lang];
    const week = config.words[weekNum];
    const dayWithinWeek = config.words[daysWithinWeeks];
    const infix = weekNum === 2 || weekNum === 6 ? config.infix26 : config.infix;
    return (dayWithinWeek + ' ' + infix + week).normalize();
}
/**
 * Returns a sentence with that evening's omer count
 * @param omerDay the day of the omer, 1-49 inclusive
 * @param lang `en` (English), `he` (Hebrew with nikud)
 * @returns a string such as `Today is 10 days, which is 1 week and 3 days of the Omer`
 *  or `הַיוֹם עֲשָׂרָה יָמִים, שְׁהֵם שָׁבוּעַ אֶחָד וְשְׁלוֹשָׁה יָמִים לָעוֹמֶר`
 */ function $d7ca1ee2cae1c802$export$5eedd0aad646303d(omerDay, lang) {
    $d7ca1ee2cae1c802$var$checkDay(omerDay);
    if (lang === 'he') return $d7ca1ee2cae1c802$var$omerTodayIsHe(omerDay);
    else return $d7ca1ee2cae1c802$var$omerTodayIsEn(omerDay);
}
function $d7ca1ee2cae1c802$var$omerTodayIsEn(omerDay) {
    const [weekNumber, daysWithinWeeks] = $d7ca1ee2cae1c802$var$getWeeks(omerDay);
    const totalDaysStr = omerDay === 1 ? 'day' : 'days';
    let str = `Today is ${omerDay} ${totalDaysStr}`;
    if (weekNumber > 1 || omerDay === 7) {
        const day7 = daysWithinWeeks === 7;
        const numWeeks = day7 ? weekNumber : weekNumber - 1;
        const weeksStr = numWeeks === 1 ? 'week' : 'weeks';
        str += `, which is ${numWeeks} ${weeksStr}`;
        if (!day7) {
            const daysStr = daysWithinWeeks === 1 ? 'day' : 'days';
            str += ` and ${daysWithinWeeks} ${daysStr}`;
        }
    }
    return str + ' of the Omer';
}
// adapted from pip hdate package (GPL)
// https://github.com/py-libhdate/py-libhdate/blob/master/hdate/date.py
const $d7ca1ee2cae1c802$var$tens = [
    '',
    "\u05E2\u05B2\u05E9\u05B8\u05C2\u05E8\u05B8\u05D4",
    "\u05E2\u05B6\u05E9\u05B0\u05C2\u05E8\u05B4\u05D9\u05DD",
    "\u05E9\u05B0\u05C1\u05DC\u05D5\u05B9\u05E9\u05B4\u05C1\u05D9\u05DD",
    "\u05D0\u05B7\u05E8\u05B0\u05D1\u05B8\u05BC\u05E2\u05B4\u05D9\u05DD"
];
const $d7ca1ee2cae1c802$var$ones = [
    '',
    "\u05D0\u05B6\u05D7\u05B8\u05D3",
    "\u05E9\u05B0\u05C1\u05E0\u05B7\u05D9\u05B4\u05DD",
    "\u05E9\u05B0\u05C1\u05DC\u05D5\u05B9\u05E9\u05B8\u05C1\u05D4",
    "\u05D0\u05B7\u05E8\u05B0\u05D1\u05B8\u05BC\u05E2\u05B8\u05D4",
    "\u05D7\u05B2\u05DE\u05B4\u05E9\u05B8\u05BC\u05C1\u05D4",
    "\u05E9\u05B4\u05C1\u05E9\u05B8\u05BC\u05C1\u05D4",
    "\u05E9\u05B4\u05C1\u05D1\u05B0\u05E2\u05B8\u05D4",
    "\u05E9\u05B0\u05C1\u05DE\u05D5\u05B9\u05E0\u05B8\u05D4",
    "\u05EA\u05B4\u05BC\u05E9\u05B0\u05C1\u05E2\u05B8\u05D4"
];
const $d7ca1ee2cae1c802$var$shnei = "\u05E9\u05B0\u05C1\u05E0\u05B5\u05D9";
const $d7ca1ee2cae1c802$var$yamim = "\u05D9\u05B8\u05DE\u05B4\u05D9\u05DD";
const $d7ca1ee2cae1c802$var$shneiYamim = $d7ca1ee2cae1c802$var$shnei + ' ' + $d7ca1ee2cae1c802$var$yamim;
const $d7ca1ee2cae1c802$var$shavuot = "\u05E9\u05B8\u05C1\u05D1\u05D5\u05BC\u05E2\u05D5\u05B9\u05EA";
const $d7ca1ee2cae1c802$var$yom = "\u05D9\u05D5\u05B9\u05DD";
const $d7ca1ee2cae1c802$var$yomEchad = $d7ca1ee2cae1c802$var$yom + ' ' + $d7ca1ee2cae1c802$var$ones[1];
const $d7ca1ee2cae1c802$var$asar = "\u05E2\u05B8\u05E9\u05B8\u05C2\u05E8";
function $d7ca1ee2cae1c802$var$omerTodayIsHe(omerDay) {
    const ten = Math.floor(omerDay / 10);
    const one = omerDay % 10;
    let str = "\u05D4\u05B7\u05D9\u05BC\u05D5\u05B9\u05DD ";
    if (omerDay === 11) str += "\u05D0\u05B7\u05D7\u05B7\u05D3 " + $d7ca1ee2cae1c802$var$asar;
    else if (omerDay === 12) str += "\u05E9\u05B0\u05C1\u05E0\u05B5\u05D9\u05DD " + $d7ca1ee2cae1c802$var$asar;
    else if (12 < omerDay && omerDay < 20) str += $d7ca1ee2cae1c802$var$ones[one] + ' ' + $d7ca1ee2cae1c802$var$asar;
    else if (omerDay > 9) {
        str += $d7ca1ee2cae1c802$var$ones[one];
        if (one) {
            str += ' ';
            str += ten === 3 ? "\u05D5\u05BC" : "\u05D5\u05B0";
        }
    }
    if (omerDay > 2) {
        if (omerDay > 20 || omerDay === 10 || omerDay === 20) str += $d7ca1ee2cae1c802$var$tens[ten];
        if (omerDay < 11) str += $d7ca1ee2cae1c802$var$ones[one] + ' ' + $d7ca1ee2cae1c802$var$yamim + ' ';
        else str += ' ' + $d7ca1ee2cae1c802$var$yom + ' ';
    } else if (omerDay === 1) str += $d7ca1ee2cae1c802$var$yomEchad + ' ';
    else // omer == 2
    str += $d7ca1ee2cae1c802$var$shneiYamim + ' ';
    if (omerDay > 6) {
        str = str.trim(); // remove trailing space before comma
        str += ", \u05E9\u05B0\u05C1\u05D4\u05B5\u05DD ";
        const weeks = Math.floor(omerDay / 7);
        const days = omerDay % 7;
        if (weeks > 2) str += $d7ca1ee2cae1c802$var$ones[weeks] + ' ' + $d7ca1ee2cae1c802$var$shavuot + ' ';
        else if (weeks === 1) str += "\u05E9\u05B8\u05C1\u05D1\u05BD\u05D5\u05BC\u05E2\u05B7 " + $d7ca1ee2cae1c802$var$ones[1] + ' ';
        else // weeks == 2
        str += $d7ca1ee2cae1c802$var$shnei + ' ' + $d7ca1ee2cae1c802$var$shavuot + ' ';
        if (days) {
            if (days === 2 || days === 3) str += "\u05D5\u05BC";
            else if (days === 5) str += "\u05D5\u05B7";
            else str += "\u05D5\u05B0";
            if (days > 2) str += $d7ca1ee2cae1c802$var$ones[days] + ' ' + $d7ca1ee2cae1c802$var$yamim + ' ';
            else if (days === 1) str += $d7ca1ee2cae1c802$var$yomEchad + ' ';
            else // days == 2
            str += $d7ca1ee2cae1c802$var$shneiYamim + ' ';
        }
    }
    str += "\u05DC\u05B8\u05E2\u05BD\u05D5\u05B9\u05DE\u05B6\u05E8";
    return str.normalize();
}
/**
 * Returns an emoji number symbol with a circle, for example `㊲`
 *  from the “Enclosed CJK Letters and Months” block of the Unicode standard
 * @param omerDay the day of the omer, 1-49 inclusive
 * @returns a single Unicode character from `①` through `㊾`
 */ function $d7ca1ee2cae1c802$export$36be16e9b3fb3077(omerDay) {
    $d7ca1ee2cae1c802$var$checkDay(omerDay);
    let codePoint;
    if (omerDay <= 20) codePoint = 9312 + omerDay - 1;
    else if (omerDay <= 35) // between 21 and 35 inclusive
    codePoint = 12881 + omerDay - 21;
    else // between 36 and 49 inclusive
    codePoint = 12977 + omerDay - 36;
    return String.fromCodePoint(codePoint);
}


/*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 
/**
 * Calculates the molad for a Hebrew month
 */ function $260b4d0153c1f419$export$ffbbbf8d7a2143b3(year, month) {
    let m_adj = month - 7;
    if (m_adj < 0) m_adj += (0, $0118a895d65cebcc$export$80d7e435f744f319)(year);
    const mElapsed = 235 * Math.floor((year - 1) / 19) + // Months in complete 19 year lunar (Metonic) cycles so far
    12 * ((year - 1) % 19) + // Regular months in this cycle
    Math.floor((7 * ((year - 1) % 19) + 1) / 19) + // Leap months this cycle
    m_adj; // add elapsed months till the start of the molad of the month
    const pElapsed = 204 + Math.floor(793 * (mElapsed % 1080));
    const hElapsed = 5 + 12 * mElapsed + 793 * Math.floor(mElapsed / 1080) + Math.floor(pElapsed / 1080) - 6;
    const parts = pElapsed % 1080 + 1080 * (hElapsed % 24);
    const chalakim = parts % 1080;
    const day = 1 + 29 * mElapsed + Math.floor(hElapsed / 24);
    return {
        year: year,
        month: month,
        dayOfWeek: day % 7,
        hour: hElapsed % 24,
        minutes: Math.floor(chalakim / 18),
        chalakim: chalakim % 18
    };
}


/*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ /**
 * Formats a number with leading zeros so the resulting string is 4 digits long.
 * Similar to `string.padStart(4, '0')` but will also format
 * negative numbers similar to how the JavaScript date formats
 * negative year numbers (e.g. `-37` is formatted as `-000037`).
 */ function $37c4ce66a03a0eab$export$ede11a55f43560d0(num) {
    if (num < 0) return '-00' + $37c4ce66a03a0eab$export$ede11a55f43560d0(-num);
    else if (num < 10) return '000' + num;
    else if (num < 100) return '00' + num;
    else if (num < 1000) return '0' + num;
    return String(num);
}
/**
 * Formats a number with leading zeros so the resulting string is 2 digits long.
 * Similar to `string.padStart(2, '0')`.
 */ function $37c4ce66a03a0eab$export$9decc9dc70e2c76f(num) {
    if (num >= 0 && num < 10) return '0' + num;
    return String(num);
}


/*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 
const $55283cdbe290c27d$var$_formatters = new Map();
/**
 * @private
 */ function $55283cdbe290c27d$var$getFormatter(tzid) {
    const fmt = $55283cdbe290c27d$var$_formatters.get(tzid);
    if (fmt) return fmt;
    const f = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: tzid
    });
    $55283cdbe290c27d$var$_formatters.set(tzid, f);
    return f;
}
const $55283cdbe290c27d$var$dateFormatRegex = /^(\d+).(\d+).(\d+),?\s+(\d+).(\d+).(\d+)/;
/**
 * Returns a string similar to `Date.toISOString()` but in the
 * timezone `tzid`. Contrary to the typical meaning of `Z` at the end
 * of the string, this is not actually a UTC date.
 */ function $55283cdbe290c27d$export$b9e305b33626b6ff(tzid, date) {
    const str = $55283cdbe290c27d$var$getFormatter(tzid).format(date);
    const m = $55283cdbe290c27d$var$dateFormatRegex.exec(str);
    if (m === null) throw new Error(`Unable to parse formatted string: ${str}`);
    let hour = m[4];
    if (hour === '24') hour = '00';
    m[3] = (0, $37c4ce66a03a0eab$export$ede11a55f43560d0)(parseInt(m[3], 10));
    return `${m[3]}-${m[1]}-${m[2]}T${hour}:${m[5]}:${m[6]}Z`;
}
/**
 * Returns number of minutes `tzid` is offset from UTC on date `date`.
 */ function $55283cdbe290c27d$export$4c9db454e2785fd9(tzid, date) {
    const utcStr = $55283cdbe290c27d$export$b9e305b33626b6ff('UTC', date);
    const localStr = $55283cdbe290c27d$export$b9e305b33626b6ff(tzid, date);
    const diffMs = new Date(utcStr).getTime() - new Date(localStr).getTime();
    return Math.ceil(diffMs / 1000 / 60);
}
/**
 * Returns YYYY-MM-DD in the local timezone
 */ function $55283cdbe290c27d$export$1155ec213071851(dt) {
    return (0, $37c4ce66a03a0eab$export$ede11a55f43560d0)(dt.getFullYear()) + '-' + (0, $37c4ce66a03a0eab$export$9decc9dc70e2c76f)(dt.getMonth() + 1) + '-' + (0, $37c4ce66a03a0eab$export$9decc9dc70e2c76f)(dt.getDate());
}


/*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ /*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ var $365b069838e63064$export$2e2bcd8739ae039 = {
    "headers": {
        "plural-forms": "nplurals=2; plural=(n > 1);",
        "language": "en_CA@ashkenazi"
    },
    "contexts": {
        "": {
            "Tevet": [
                "Teves"
            ]
        }
    }
};


/*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ var $e2d4160ee48baf0d$export$2e2bcd8739ae039 = {
    "headers": {
        "plural-forms": "nplurals=2; plural=(n > 1);",
        "language": "he"
    },
    "contexts": {
        "": {
            "Adar": [
                "\u05D0\u05B7\u05D3\u05B8\u05E8"
            ],
            "Adar I": [
                "\u05D0\u05B7\u05D3\u05B8\u05E8 \u05D0\u05F3"
            ],
            "Adar II": [
                "\u05D0\u05B7\u05D3\u05B8\u05E8 \u05D1\u05F3"
            ],
            "Av": [
                "\u05D0\u05B8\u05D1"
            ],
            "Cheshvan": [
                "\u05D7\u05B6\u05E9\u05B0\u05C1\u05D5\u05B8\u05DF"
            ],
            "Elul": [
                "\u05D0\u05B1\u05DC\u05D5\u05BC\u05DC"
            ],
            "Iyyar": [
                "\u05D0\u05B4\u05D9\u05B8\u05D9\u05E8"
            ],
            "Kislev": [
                "\u05DB\u05B4\u05BC\u05E1\u05B0\u05DC\u05B5\u05D5"
            ],
            "Nisan": [
                "\u05E0\u05B4\u05D9\u05E1\u05B8\u05DF"
            ],
            "Sh'vat": [
                "\u05E9\u05B0\u05C1\u05D1\u05B8\u05D8"
            ],
            "Sivan": [
                "\u05E1\u05B4\u05D9\u05D5\u05B8\u05DF"
            ],
            "Tamuz": [
                "\u05EA\u05B7\u05BC\u05DE\u05BC\u05D5\u05BC\u05D6"
            ],
            "Tevet": [
                "\u05D8\u05B5\u05D1\u05B5\u05EA"
            ],
            "Tishrei": [
                "\u05EA\u05B4\u05BC\u05E9\u05B0\u05C1\u05E8\u05B5\u05D9"
            ]
        }
    }
};


const $1cde68ba834f0fa8$var$noopLocale = {
    headers: {
        'plural-forms': 'nplurals=2; plural=(n!=1);'
    },
    contexts: {
        '': {}
    }
};
const $1cde68ba834f0fa8$var$alias = {
    h: 'he',
    a: 'ashkenazi',
    s: 'en',
    '': 'en'
};
/** @private */ const $1cde68ba834f0fa8$var$locales = new Map();
/** @private */ let $1cde68ba834f0fa8$var$activeLocale;
/** @private */ let $1cde68ba834f0fa8$var$activeName;
/** @private */ function $1cde68ba834f0fa8$var$getEnOrdinal(n) {
    const s = [
        'th',
        'st',
        'nd',
        'rd'
    ];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
/** @private */ function $1cde68ba834f0fa8$var$checkLocale(locale) {
    if (typeof locale !== 'string') throw new TypeError(`Invalid locale name: ${locale}`);
    return locale.toLowerCase();
}
/** @private */ function $1cde68ba834f0fa8$var$getExistingLocale(locale) {
    const locale1 = $1cde68ba834f0fa8$var$checkLocale(locale);
    const loc = $1cde68ba834f0fa8$var$locales.get(locale1);
    if (!loc) throw new RangeError(`Locale '${locale}' not found`);
    return loc;
}
/**
 * A locale in Hebcal is used for translations/transliterations of
 * holidays. `@hebcal/hdate` supports four locales by default
 * * `en` - default, Sephardic transliterations (e.g. "Shabbat")
 * * `ashkenazi` - Ashkenazi transliterations (e.g. "Shabbos")
 * * `he` - Hebrew (e.g. "שַׁבָּת")
 * * `he-x-NoNikud` - Hebrew without nikud (e.g. "שבת")
 */ class $1cde68ba834f0fa8$export$d4f428a61c37ddfa {
    /**
     * Returns translation only if `locale` offers a non-empty translation for `id`.
     * Otherwise, returns `undefined`.
     * @param id Message ID to translate
     * @param [locale] Optional locale name (i.e: `'he'`, `'fr'`). Defaults to active locale.
     */ static lookupTranslation(id, locale) {
        const loc = typeof locale === 'string' && $1cde68ba834f0fa8$var$locales.get(locale.toLowerCase()) || $1cde68ba834f0fa8$var$activeLocale;
        const array = loc[id];
        if ((array === null || array === void 0 ? void 0 : array.length) && array[0].length) return array[0];
        return undefined;
    }
    /**
     * By default, if no translation was found, returns `id`.
     * @param id Message ID to translate
     * @param [locale] Optional locale name (i.e: `'he'`, `'fr'`). Defaults to active locale.
     */ static gettext(id, locale) {
        const text = this.lookupTranslation(id, locale);
        if (typeof text === 'undefined') return id;
        return text;
    }
    /**
     * Register locale translations.
     * @param locale Locale name (i.e.: `'he'`, `'fr'`)
     * @param data parsed data from a `.po` file.
     */ static addLocale(locale, data) {
        locale = $1cde68ba834f0fa8$var$checkLocale(locale);
        if (typeof data.contexts !== 'object' || typeof data.contexts[''] !== 'object') throw new TypeError(`Locale '${locale}' invalid compact format`);
        $1cde68ba834f0fa8$var$locales.set(locale, data.contexts['']);
    }
    /**
     * Adds a translation to `locale`, replacing any previous translation.
     * @param locale Locale name (i.e: `'he'`, `'fr'`).
     * @param id Message ID to translate
     * @param translation Translation text
     */ static addTranslation(locale, id, translation) {
        const loc = $1cde68ba834f0fa8$var$getExistingLocale(locale);
        if (typeof id !== 'string' || id.length === 0) throw new TypeError(`Invalid id string: ${id}`);
        const isArray = Array.isArray(translation);
        if (isArray) {
            const t0 = translation[0];
            if (typeof t0 !== 'string' || t0.length === 0) throw new TypeError(`Invalid translation array: ${translation}`);
        } else if (typeof translation !== 'string') throw new TypeError(`Invalid translation string: ${translation}`);
        loc[id] = isArray ? translation : [
            translation
        ];
    }
    /**
     * Adds multiple translations to `locale`, replacing any previous translations.
     * @param locale Locale name (i.e: `'he'`, `'fr'`).
     * @param data parsed data from a `.po` file.
     */ static addTranslations(locale, data) {
        const loc = $1cde68ba834f0fa8$var$getExistingLocale(locale);
        if (typeof data.contexts !== 'object' || typeof data.contexts[''] !== 'object') throw new TypeError(`Locale '${locale}' invalid compact format`);
        const ctx = data.contexts[''];
        Object.assign(loc, ctx);
    }
    /**
     * Activates a locale. Throws an error if the locale has not been previously added.
     * After setting the locale to be used, all strings marked for translations
     * will be represented by the corresponding translation in the specified locale.
     * @param locale Locale name (i.e: `'he'`, `'fr'`)
     * @deprecated
     */ static useLocale(locale) {
        const locale0 = $1cde68ba834f0fa8$var$checkLocale(locale);
        const obj = $1cde68ba834f0fa8$var$getExistingLocale(locale0);
        $1cde68ba834f0fa8$var$activeName = $1cde68ba834f0fa8$var$alias[locale0] || locale0;
        $1cde68ba834f0fa8$var$activeLocale = obj;
        return $1cde68ba834f0fa8$var$activeLocale;
    }
    /**
     * Returns the name of the active locale (i.e. 'he', 'ashkenazi', 'fr')
     * @deprecated
     */ static getLocaleName() {
        return $1cde68ba834f0fa8$var$activeName;
    }
    /**
     * Returns the names of registered locales
     */ static getLocaleNames() {
        const keys = Array.from($1cde68ba834f0fa8$var$locales.keys());
        return keys.sort((a, b)=>a.localeCompare(b));
    }
    /**
     * Renders a number in ordinal, such as 1st, 2nd or 3rd
     * @param [locale] Optional locale name (i.e: `'he'`, `'fr'`). Defaults to active locale.
     */ static ordinal(n, locale) {
        const locale1 = locale === null || locale === void 0 ? void 0 : locale.toLowerCase();
        const locale0 = locale1 || $1cde68ba834f0fa8$var$activeName;
        if (!locale0) return $1cde68ba834f0fa8$var$getEnOrdinal(n);
        switch(locale0){
            case 'en':
            case 's':
            case 'a':
                return $1cde68ba834f0fa8$var$getEnOrdinal(n);
            case 'es':
                return n + "\xba";
            case 'h':
            case 'he':
            case 'he-x-nonikud':
                return String(n);
        }
        if (locale0.startsWith('ashkenazi')) return $1cde68ba834f0fa8$var$getEnOrdinal(n);
        return n + '.';
    }
    /**
     * Removes nekudot from Hebrew string
     */ static hebrewStripNikkud(str) {
        return str.replace(/[\u0590-\u05bd]/g, '').replace(/[\u05bf-\u05c7]/g, '');
    }
}
$1cde68ba834f0fa8$export$d4f428a61c37ddfa.addLocale('en', $1cde68ba834f0fa8$var$noopLocale);
$1cde68ba834f0fa8$export$d4f428a61c37ddfa.addLocale('s', $1cde68ba834f0fa8$var$noopLocale);
$1cde68ba834f0fa8$export$d4f428a61c37ddfa.addLocale('', $1cde68ba834f0fa8$var$noopLocale);
$1cde68ba834f0fa8$export$d4f428a61c37ddfa.useLocale('en');
/* Ashkenazic transliterations */ $1cde68ba834f0fa8$export$d4f428a61c37ddfa.addLocale('ashkenazi', (0, $365b069838e63064$export$2e2bcd8739ae039));
$1cde68ba834f0fa8$export$d4f428a61c37ddfa.addLocale('a', (0, $365b069838e63064$export$2e2bcd8739ae039));
/* Hebrew with nikkud */ $1cde68ba834f0fa8$export$d4f428a61c37ddfa.addLocale('he', (0, $e2d4160ee48baf0d$export$2e2bcd8739ae039));
$1cde68ba834f0fa8$export$d4f428a61c37ddfa.addLocale('h', (0, $e2d4160ee48baf0d$export$2e2bcd8739ae039));
/* Hebrew without nikkud */ const $1cde68ba834f0fa8$var$heStrs = (0, $e2d4160ee48baf0d$export$2e2bcd8739ae039).contexts[''];
const $1cde68ba834f0fa8$var$heNoNikud = {};
for (const [key, val] of Object.entries($1cde68ba834f0fa8$var$heStrs))$1cde68ba834f0fa8$var$heNoNikud[key] = [
    $1cde68ba834f0fa8$export$d4f428a61c37ddfa.hebrewStripNikkud(val[0])
];
const $1cde68ba834f0fa8$var$poHeNoNikud = {
    headers: (0, $e2d4160ee48baf0d$export$2e2bcd8739ae039).headers,
    contexts: {
        '': $1cde68ba834f0fa8$var$heNoNikud
    }
};
$1cde68ba834f0fa8$export$d4f428a61c37ddfa.addLocale('he-x-NoNikud', $1cde68ba834f0fa8$var$poHeNoNikud);


/*! @hebcal/hdate v0.13.5, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 



/*
    Hebcal - A Jewish Calendar Generator
    Copyright (c) 1994-2020 Danny Sadinoff
    Portions copyright Eyal Schachter and Michael J. Radwin

    https://github.com/hebcal/hebcal-es6

    This program is free software; you can redistribute it and/or
    modify it under the terms of the GNU General Public License
    as published by the Free Software Foundation; either version 2
    of the License, or (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program. If not, see <http://www.gnu.org/licenses/>.
 */ function $e7dd728d9f060a75$var$mod(x, y) {
    return x - y * Math.floor(x / y);
}
function $e7dd728d9f060a75$var$isSimpleHebrewDate(obj) {
    return obj.yy !== undefined;
}
const $e7dd728d9f060a75$var$UNITS_DAY = 'day';
const $e7dd728d9f060a75$var$UNITS_WEEK = 'week';
const $e7dd728d9f060a75$var$UNITS_MONTH = 'month';
const $e7dd728d9f060a75$var$UNITS_YEAR = 'year';
/**
 * A `HDate` represents a Hebrew calendar date.
 *
 * An instance of this class encapsulates a date in the Hebrew calendar system.
 * It consists of a year, month, and day, without any associated time or location data.
 * The Hebrew calendar is a lunisolar calendar, meaning it is based on both lunar and solar cycles.
 *
 * A Hebrew date internally stores three numbers:
 * - year: The Hebrew year (1-9999). Counted from the traditional Hebrew date of creation (3761 BCE in the Gregorian calendar)
 * - month: The Hebrew month (1-13). Month 1 is Nisan, month 7 is Tishrei. There are 12 months in a regular year and 13 months in a leap year.
 * - day: The day of the month (1-30)
 *
 * This class uses Rata Die to convert between the Hebrew and Gregorian calendars.
 *
 * To calculate times of day, use `Zmanim` class from `@hebcal/core`
 * @see {@link https://en.wikipedia.org/wiki/Rata_Die | Rata Die}
 * @see {@link https://hebcal.github.io/api/core/classes/Zmanim.html | Zmanim}
 */ class $e7dd728d9f060a75$export$8f4940fd510e0848 {
    /**
     * Create a Hebrew date. There are 3 basic forms for the `HDate()` constructor.
     *
     * 1. No parameters - represents the current Hebrew date at time of instantiation
     * 2. One parameter
     *    * `Date` - represents the Hebrew date corresponding to the Gregorian date using
     *       local time. Hours, minutes, seconds and milliseconds are ignored.
     *    * `HDate` - clones a copy of the given Hebrew date
     *    * `number` - Converts absolute R.D. days to Hebrew date.
     *       R.D. 1 == the imaginary date January 1, 1 (Gregorian)
     * 3. Three parameters: Hebrew day, Hebrew month, Hebrew year. Hebrew day should
     *    be a number between 1-30, Hebrew month can be a number or string, and
     *    Hebrew year is always a number.
     * @example
     * import {HDate, months} from '@hebcal/hdate';
     *
     * const hd1 = new HDate();
     * const hd2 = new HDate(new Date(2008, 10, 13));
     * const hd3 = new HDate(15, 'Cheshvan', 5769);
     * const hd4 = new HDate(15, months.CHESHVAN, 5769);
     * const hd5 = new HDate(733359); // ==> 15 Cheshvan 5769
     * const monthName = 'אייר';
     * const hd6 = new HDate(5, monthName, 5773);
     * @param [day] - Day of month (1-30) if a `number`.
     *   If a `Date` is specified, represents the Hebrew date corresponding to the
     *   Gregorian date using local time.
     *   If an `HDate` is specified, clones a copy of the given Hebrew date.
     * @param [month] - Hebrew month of year (1=NISAN, 7=TISHREI)
     * @param [year] - Hebrew year
     */ constructor(day, month, year){
        if (arguments.length === 2 || arguments.length > 3) throw new TypeError('HDate constructor requires 0, 1 or 3 arguments');
        if (arguments.length === 3) {
            // Hebrew day, Hebrew month, Hebrew year
            this.dd = this.mm = 1;
            const yy = typeof year === 'string' ? parseInt(year, 10) : year;
            if (isNaN(yy)) throw new TypeError(`HDate called with bad year: ${year}`);
            this.yy = yy;
            $e7dd728d9f060a75$var$setMonth(this, month); // will throw if we can't parse
            const dd = typeof day === 'string' ? parseInt(day, 10) : day;
            if (isNaN(dd)) throw new TypeError(`HDate called with bad day: ${day}`);
            $e7dd728d9f060a75$var$setDate(this, dd);
        } else {
            // 0 arguments
            if (typeof day === 'undefined' || day === null) day = new Date();
            // 1 argument
            const abs0 = typeof day === 'number' && !isNaN(day) ? day : (0, $95162f6f50e12e59$export$871608497c498473)(day) ? (0, $95162f6f50e12e59$export$5562ed62796cf6a1)(day) : $e7dd728d9f060a75$var$isSimpleHebrewDate(day) ? day : null;
            if (abs0 === null) throw new TypeError(`HDate called with bad arg: ${day}`);
            const isNumber = typeof abs0 === 'number';
            const d = isNumber ? (0, $0118a895d65cebcc$export$6bfe4fc23c10d072)(abs0) : abs0;
            this.yy = d.yy;
            this.mm = d.mm;
            this.dd = d.dd;
            if (isNumber) this.rd = abs0;
        }
    }
    /**
     * Returns the Hebrew year of this Hebrew date
     * @returns an integer >= 1
     * @example
     * const hd = new HDate(new Date(2008, 10, 13)); // 15 Cheshvan 5769
     * hd.getFullYear(); // 5769
     */ getFullYear() {
        return this.yy;
    }
    /**
     * Returns `true` if this Hebrew date occurs during a Hebrew leap year
     * @example
     * const hd = new HDate(new Date(2008, 10, 13)); // 15 Cheshvan 5769
     * hd.isLeapYear(); // false
     */ isLeapYear() {
        return (0, $0118a895d65cebcc$export$553d7fa8e3805fc0)(this.yy);
    }
    /**
     * Returns the Hebrew month (1=NISAN, 7=TISHREI) of this Hebrew date
     * @returns an integer 1-13
     * @example
     * const hd = new HDate(new Date(2008, 10, 13)); // 15 Cheshvan 5769
     * hd.getMonth(); // 8
     */ getMonth() {
        return this.mm;
    }
    /**
     * The Tishrei-based month of this Hebrew date. 1 is Tishrei, 7 is Nisan, 13 is Elul in a leap year
     * @returns an integer 1-13
     * @example
     * const hd = new HDate(new Date(2008, 10, 13)); // 15 Cheshvan 5769
     * hd.getTishreiMonth(); // 2
     */ getTishreiMonth() {
        const nummonths = (0, $0118a895d65cebcc$export$80d7e435f744f319)(this.getFullYear());
        return (this.getMonth() + nummonths - 6) % nummonths || nummonths;
    }
    /**
     * Number of days in the month of this Hebrew date (29 or 30)
     * @returns an integer 29-30
     * @example
     * const hd = new HDate(new Date(2008, 10, 13)); // 15 Cheshvan 5769
     * hd.daysInMonth(); // 29
     */ daysInMonth() {
        return (0, $0118a895d65cebcc$export$4169ecd548fbc13a)(this.getMonth(), this.getFullYear());
    }
    /**
     * Gets the day within the month (1-30)
     * @returns an integer 1-30
     * @example
     * const hd = new HDate(new Date(2008, 10, 13)); // 15 Cheshvan 5769
     * hd.getDate(); // 15
     */ getDate() {
        return this.dd;
    }
    /**
     * Returns the day of the week for this Hebrew date,
     * where 0 represents Sunday, 1 represents Monday, 6 represents Saturday.
     *
     * For the day of the month, see `getDate()`
     * @returns an integer 0-6
     * @example
     * const hd = new HDate(new Date(2008, 10, 13)); // 15 Cheshvan 5769
     * hd.getDate(); // 4
     */ getDay() {
        return $e7dd728d9f060a75$var$mod(this.abs(), 7);
    }
    /**
     * Converts this Hebrew date to the corresponding Gregorian date.
     *
     * The returned `Date` object will be in the local (i.e. host system) time zone.
     * Hours, minutes, seconds and milliseconds will all be zero.
     *
     * Note that this function returns the daytime portion of the date.
     * For example, the 15th of Cheshvan 5769 began at sundown on
     * 12 November 2008 and continues through 13 November 2008. This
     * function would return only the date 13 November 2008.
     * @example
     * const hd = new HDate(15, 'Cheshvan', 5769);
     * const date = hd.greg(); // 13 November 2008
     * const year = date.getFullYear(); // 2008
     * const monthNum = date.getMonth() + 1; // 11
     * const day = date.getDate(); // 13
     */ greg() {
        return (0, $95162f6f50e12e59$export$fa5d0dc73ec17c41)(this.abs());
    }
    /**
     * Converts from Hebrew date representation to R.D. (Rata Die) fixed days.
     * R.D. 1 is the imaginary date Monday, January 1, 1 (Gregorian).
     * Note also that R.D. = Julian Date − 1,721,424.5
     * @see {@link https://en.wikipedia.org/wiki/Rata_Die | Rata Die}
     * @example
     * const hd = new HDate(15, 'Cheshvan', 5769);
     * hd.abs(); // 733359
     */ abs() {
        if (typeof this.rd !== 'number') this.rd = (0, $0118a895d65cebcc$export$b4365e722c971925)(this.yy, this.mm, this.dd);
        return this.rd;
    }
    /**
     * Converts Hebrew date to R.D. (Rata Die) fixed days.
     * R.D. 1 is the imaginary date Monday, January 1, 1 on the Gregorian
     * Calendar.
     * @param year Hebrew year
     * @param month Hebrew month (1=NISAN, 7=TISHREI)
     * @param day Hebrew date (1-30)
     * @example
     * import {HDate, months} from '@hebcal/hdate';
     * HDate.hebrew2abs(5769, months.CHESHVAN, 15); // 733359
     */ static hebrew2abs(year, month, day) {
        return (0, $0118a895d65cebcc$export$b4365e722c971925)(year, month, day);
    }
    /**
     * Returns a transliterated Hebrew month name, e.g. `'Elul'` or `'Cheshvan'`.
     * @example
     * const hd = new HDate(new Date(2008, 10, 13)); // 15 Cheshvan 5769
     * hd.getMonthName(); // 'Cheshvan'
     */ getMonthName() {
        return (0, $0118a895d65cebcc$export$e7af3ee2c84591cc)(this.getMonth(), this.getFullYear());
    }
    /**
     * Renders this Hebrew date as a translated or transliterated string,
     * including ordinal e.g. `'15th of Cheshvan, 5769'`.
     * @example
     * import {HDate, months} from '@hebcal/hdate';
     *
     * const hd = new HDate(15, months.CHESHVAN, 5769);
     * console.log(hd.render('en')); // '15th of Cheshvan, 5769'
     * console.log(hd.render('he')); // '15 חֶשְׁוָן, 5769'
     * console.log(hd.render('en', false)); // '15th of Cheshvan'
     * console.log(hd.render('he', false)); // '15 חֶשְׁוָן'
     * @param [locale] Optional locale name (defaults to active locale).
     * @param [showYear=true] Display year (defaults to true).
     * @see {@link Locale}
     */ render(locale, showYear = true) {
        const locale0 = locale || (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).getLocaleName();
        const day = this.getDate();
        const monthName0 = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext(this.getMonthName(), locale0);
        const monthName = monthName0.replace(/'/g, "\u2019");
        const nth = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).ordinal(day, locale0);
        const dayOf = $e7dd728d9f060a75$var$getDayOfTranslation(locale0);
        const dateStr = `${nth}${dayOf} ${monthName}`;
        if (showYear) {
            const fullYear = this.getFullYear();
            return `${dateStr}, ${fullYear}`;
        } else return dateStr;
    }
    /**
     * Renders this Hebrew date in Hebrew gematriya, regardless of locale.
     * @example
     * import {HDate, months} from '@hebcal/hdate';
     * const hd = new HDate(15, months.CHESHVAN, 5769);
     * hd.renderGematriya(); // 'ט״ו חֶשְׁוָן תשס״ט'
     * hd.renderGematriya(true); // 'ט״ו חשון תשס״ט'
     */ renderGematriya(suppressNikud = false) {
        const d = this.getDate();
        const locale = suppressNikud ? 'he-x-NoNikud' : 'he';
        const m = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext(this.getMonthName(), locale);
        const y = this.getFullYear();
        return (0, $b799e27e1258db2f$export$426b794b832b1254)(d) + ' ' + m + ' ' + (0, $b799e27e1258db2f$export$426b794b832b1254)(y);
    }
    /**
     * Returns an `HDate` corresponding to the specified day of week
     * **before** this Hebrew date
     * @example
     * new HDate(new Date('Wednesday February 19, 2014')).before(6).greg() // Sat Feb 15 2014
     * @param dayOfWeek day of week: Sunday=0, Saturday=6
     */ before(dayOfWeek) {
        return $e7dd728d9f060a75$var$onOrBefore(dayOfWeek, this, -1);
    }
    /**
     * Returns an `HDate` corresponding to the specified day of week
     * **on or before** this Hebrew date
     * @example
     * new HDate(new Date('Wednesday February 19, 2014')).onOrBefore(6).greg() // Sat Feb 15 2014
     * new HDate(new Date('Saturday February 22, 2014')).onOrBefore(6).greg() // Sat Feb 22 2014
     * new HDate(new Date('Sunday February 23, 2014')).onOrBefore(6).greg() // Sat Feb 22 2014
     * @param dayOfWeek day of week: Sunday=0, Saturday=6
     */ onOrBefore(dayOfWeek) {
        return $e7dd728d9f060a75$var$onOrBefore(dayOfWeek, this, 0);
    }
    /**
     * Returns an `HDate` corresponding to the specified day of week
     * **nearest** to this Hebrew date
     * @example
     * new HDate(new Date('Wednesday February 19, 2014')).nearest(6).greg() // Sat Feb 22 2014
     * new HDate(new Date('Tuesday February 18, 2014')).nearest(6).greg() // Sat Feb 15 2014
     * @param dayOfWeek day of week: Sunday=0, Saturday=6
     */ nearest(dayOfWeek) {
        return $e7dd728d9f060a75$var$onOrBefore(dayOfWeek, this, 3);
    }
    /**
     * Returns an `HDate` corresponding to the specified day of week
     * **on or after** this Hebrew date
     * @example
     * new HDate(new Date('Wednesday February 19, 2014')).onOrAfter(6).greg() // Sat Feb 22 2014
     * new HDate(new Date('Saturday February 22, 2014')).onOrAfter(6).greg() // Sat Feb 22 2014
     * new HDate(new Date('Sunday February 23, 2014')).onOrAfter(6).greg() // Sat Mar 01 2014
     * @param dayOfWeek day of week: Sunday=0, Saturday=6
     */ onOrAfter(dayOfWeek) {
        return $e7dd728d9f060a75$var$onOrBefore(dayOfWeek, this, 6);
    }
    /**
     * Returns an `HDate` corresponding to the specified day of week
     * **after** this Hebrew date
     * @example
     * new HDate(new Date('Wednesday February 19, 2014')).after(6).greg() // Sat Feb 22 2014
     * new HDate(new Date('Saturday February 22, 2014')).after(6).greg() // Sat Mar 01 2014
     * new HDate(new Date('Sunday February 23, 2014')).after(6).greg() // Sat Mar 01 2014
     * @param dayOfWeek day of week: Sunday=0, Saturday=6
     */ after(dayOfWeek) {
        return $e7dd728d9f060a75$var$onOrBefore(dayOfWeek, this, 7);
    }
    /**
     * Returns the next Hebrew date
     * @example
     * const hd = new HDate(new Date(2008, 10, 13)); // 15 Cheshvan 5769
     * hd.next(); // '16 Cheshvan 5769'
     */ next() {
        return new $e7dd728d9f060a75$export$8f4940fd510e0848(this.abs() + 1);
    }
    /**
     * Returns the previous Hebrew date
     * @example
     * const hd = new HDate(new Date(2008, 10, 13)); // 15 Cheshvan 5769
     * hd.prev(); // '14 Cheshvan 5769'
     */ prev() {
        return new $e7dd728d9f060a75$export$8f4940fd510e0848(this.abs() - 1);
    }
    /**
     * Returns a cloned `HDate` object with a specified amount of time added
     *
     * Units are case insensitive, and support plural and short forms.
     * Note, short forms are case sensitive.
     *
     * | Unit | Shorthand | Description
     * | --- | --- | --- |
     * | `day` | `d` | days |
     * | `week` | `w` | weeks |
     * | `month` | `M` | months |
     * | `year` | `y` | years |
     */ add(amount, units = 'd') {
        amount = typeof amount === 'string' ? parseInt(amount, 10) : amount;
        if (!amount) return new $e7dd728d9f060a75$export$8f4940fd510e0848(this);
        units = $e7dd728d9f060a75$var$standardizeUnits(units);
        if (units === $e7dd728d9f060a75$var$UNITS_DAY) return new $e7dd728d9f060a75$export$8f4940fd510e0848(this.abs() + amount);
        else if (units === $e7dd728d9f060a75$var$UNITS_WEEK) return new $e7dd728d9f060a75$export$8f4940fd510e0848(this.abs() + 7 * amount);
        else if (units === $e7dd728d9f060a75$var$UNITS_YEAR) return new $e7dd728d9f060a75$export$8f4940fd510e0848(this.getDate(), this.getMonth(), this.getFullYear() + amount);
        else {
            // units === UNITS_MONTH
            let hd = new $e7dd728d9f060a75$export$8f4940fd510e0848(this);
            const sign = amount > 0 ? 1 : -1;
            amount = Math.abs(amount);
            for(let i = 0; i < amount; i++)hd = new $e7dd728d9f060a75$export$8f4940fd510e0848(hd.abs() + sign * hd.daysInMonth());
            return hd;
        }
    }
    /**
     * Returns a cloned `HDate` object with a specified amount of time subracted
     *
     * Units are case insensitive, and support plural and short forms.
     * Note, short forms are case sensitive.
     *
     * | Unit | Shorthand | Description
     * | --- | --- | --- |
     * | `day` | `d` | days |
     * | `week` | `w` | weeks |
     * | `month` | `M` | months |
     * | `year` | `y` | years |
     * @example
     * import {HDate, months} from '@hebcal/hdate';
     *
     * const hd1 = new HDate(15, months.CHESHVAN, 5769);
     * const hd2 = hd1.add(1, 'weeks'); // 7 Kislev 5769
     * const hd3 = hd1.add(-3, 'M'); // 30 Av 5768
     */ subtract(amount, units = 'd') {
        return this.add(amount * -1, units);
    }
    /**
     * Returns the difference in days between the two given HDates.
     *
     * The result is positive if `this` date is comes chronologically
     * after the `other` date, and negative
     * if the order of the two dates is reversed.
     *
     * The result is zero if the two dates are identical.
     * @example
     * import {HDate, months} from '@hebcal/hdate';
     *
     * const hd1 = new HDate(25, months.KISLEV, 5770);
     * const hd2 = new HDate(15, months.CHESHVAN, 5769);
     * const days = hd1.deltaDays(hd2); // 394
     * @param other Hebrew date to compare
     */ deltaDays(other) {
        return this.abs() - other.abs();
    }
    /**
     * Compares this Hebrew date to another date, returning `true` if the dates match.
     * @param other Hebrew date to compare
     * @example
     * const hd1 = new HDate(new Date(2008, 10, 13));
     * const hd2 = new HDate(15, 'Cheshvan', 5769);
     * hd1.isSameDate(hd2); // true
     */ isSameDate(other) {
        return this.yy === other.yy && this.mm === other.mm && this.dd === other.dd;
    }
    /**
     * Returns a string representation of this Hebrew date using English transliterations
     * @example
     * const hd = new HDate(new Date(2008, 10, 13)); // 15 Cheshvan 5769
     * hd.toString(); // '15 Cheshvan 5769'
     */ toString() {
        const day = this.getDate();
        const fullYear = this.getFullYear();
        const monthName = this.getMonthName();
        return `${day} ${monthName} ${fullYear}`;
    }
    /**
     * Returns true if Hebrew year is a leap year
     * @param year Hebrew year
     * @example
     * HDate.isLeapYear(5783); // false
     * HDate.isLeapYear(5784); // true
     */ static isLeapYear(year) {
        return (0, $0118a895d65cebcc$export$553d7fa8e3805fc0)(year);
    }
    /**
     * Number of months in this Hebrew year (either 12 or 13 depending on leap year)
     * @param year Hebrew year
     * @example
     * HDate.monthsInYear(5783); // 12
     * HDate.monthsInYear(5784); // 13
     */ static monthsInYear(year) {
        return (0, $0118a895d65cebcc$export$80d7e435f744f319)(year);
    }
    /**
     * Number of days in Hebrew month in a given year (29 or 30)
     * @param month Hebrew month (e.g. months.TISHREI)
     * @param year Hebrew year
     * @example
     * import {HDate, months} from '@hebcal/hdate';
     * HDate.daysInMonth(months.CHESHVAN, 5769); // 29
     */ static daysInMonth(month, year) {
        return (0, $0118a895d65cebcc$export$4169ecd548fbc13a)(month, year);
    }
    /**
     * Returns a transliterated string name of Hebrew month in year,
     * for example 'Elul' or 'Cheshvan'.
     * @param month Hebrew month (e.g. months.TISHREI)
     * @param year Hebrew year
     * @example
     * import {HDate, months} from '@hebcal/hdate';
     * HDate.getMonthName(months.CHESHVAN, 5769); // 'Cheshvan'
     */ static getMonthName(month, year) {
        return (0, $0118a895d65cebcc$export$e7af3ee2c84591cc)(month, year);
    }
    /**
     * Returns the Hebrew month number (NISAN=1, TISHREI=7)
     * @param month A number, or Hebrew month name string
     * @example
     * import {HDate, months} from '@hebcal/hdate';
     * HDate.monthNum(months.CHESHVAN); // 8
     * HDate.monthNum('Cheshvan'); // 8
     * HDate.monthNum('חשון'); // 8
     */ static monthNum(month) {
        if (typeof month === 'number') {
            if (isNaN(month) || month > 14) throw new RangeError(`bad monthNum: ${month}`);
            return month;
        }
        return month.charCodeAt(0) >= 48 && month.charCodeAt(0) <= 57 /* number */  ? parseInt(month, 10) : $e7dd728d9f060a75$export$8f4940fd510e0848.monthFromName(month);
    }
    /**
     * Number of days in the Hebrew year.
     * Regular years can have 353, 354, or 355 days.
     * Leap years can have 383, 384, or 385 days.
     * @param year Hebrew year
     * @example
     * HDate.daysInYear(5783); // 355
     * HDate.daysInYear(5784); // 383
     */ static daysInYear(year) {
        return (0, $0118a895d65cebcc$export$3913210603d8e9ae)(year);
    }
    /**
     * true if Cheshvan is long in Hebrew year
     * @param year Hebrew year
     * @example
     * HDate.longCheshvan(5783); // true
     * HDate.longCheshvan(5784); // false
     */ static longCheshvan(year) {
        return (0, $0118a895d65cebcc$export$9af239db6913ae90)(year);
    }
    /**
     * true if Kislev is short in Hebrew year
     * @param year Hebrew year
     * @example
     * HDate.shortKislev(5783); // false
     * HDate.shortKislev(5784); // true
     */ static shortKislev(year) {
        return (0, $0118a895d65cebcc$export$cfc9164cd88e25a7)(year);
    }
    /**
     * Converts Hebrew month string name to numeric
     * @example
     * import {HDate, months} from '@hebcal/hdate';
     * HDate.monthFromName(months.CHESHVAN); // 8
     * HDate.monthFromName('Cheshvan'); // 8
     * HDate.monthFromName('חשון'); // 8
     */ static monthFromName(monthName) {
        if (typeof monthName === 'number') {
            if (isNaN(monthName) || monthName < 1 || monthName > 14) throw new RangeError(`bad monthName: ${monthName}`);
            return monthName;
        }
        const name = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).hebrewStripNikkud(monthName);
        return (0, $0118a895d65cebcc$export$613e90e09ea4691e)(name);
    }
    /**
     * Convenience function for determining the R.D. date
     * near a specified R.D. date, corresponding to the specified day of week.
     *
     * Note: Applying this function to d+6 gives us the `dayOfWeek` on or after an
     * absolute day d. Similarly, applying it to d+3 gives the `dayOfWeek` nearest to
     * absolute date d, applying it to d-1 gives the `dayOfWeek` previous to absolute
     * date d, and applying it to d+7 gives the `dayOfWeek` following absolute date d.
     * @param dayOfWeek day of week: Sunday=0, Saturday=6
     */ static dayOnOrBefore(dayOfWeek, absdate) {
        return absdate - (absdate - dayOfWeek) % 7;
    }
    /**
     * Tests if the object is an instance of `HDate`
     * @example
     * HDate.isHDate(new HDate()); // true
     * HDate.isHDate(new Date()); // false
     * HDate.isHDate(null); // false
     * HDate.isHDate(12345); // false
     * HDate.isHDate('15 Cheshvan 5769'); // false
     */ static isHDate(obj) {
        return obj !== null && typeof obj === 'object' && typeof obj.yy === 'number' && typeof obj.mm === 'number' && typeof obj.dd === 'number' && typeof obj.greg === 'function' && typeof obj.abs === 'function';
    }
    /**
     * Construct a new instance of `HDate` from a Gematriya-formatted string
     * @example
     * HDate.fromGematriyaString('כ״ז בְּתַמּוּז תשפ״ג') // 27 Tamuz 5783
     * HDate.fromGematriyaString('כ׳ סיון תש״ד') // 20 Sivan 5704
     * HDate.fromGematriyaString('ה׳ אִיָיר תש״ח') // 5 Iyyar 5708
     */ static fromGematriyaString(str, currentThousands = 5000) {
        const parts = str.split(' ').filter((x)=>x.length !== 0);
        const numParts = parts.length;
        if (numParts !== 3 && numParts !== 4) throw new RangeError(`cannot parse gematriya str: "${str}"`);
        const day = (0, $b799e27e1258db2f$export$56e3bc2b5cadf0a3)(parts[0]);
        const monthStr = numParts === 3 ? parts[1] : parts[1] + ' ' + parts[2];
        const month = $e7dd728d9f060a75$export$8f4940fd510e0848.monthFromName(monthStr);
        const yearStr = numParts === 3 ? parts[2] : parts[3];
        let year = (0, $b799e27e1258db2f$export$56e3bc2b5cadf0a3)(yearStr);
        if (year < 1000) year += currentThousands;
        return new $e7dd728d9f060a75$export$8f4940fd510e0848(day, month, year);
    }
}
function $e7dd728d9f060a75$var$standardizeUnits(units) {
    switch(units){
        case 'd':
            return $e7dd728d9f060a75$var$UNITS_DAY;
        case 'w':
            return $e7dd728d9f060a75$var$UNITS_WEEK;
        case 'M':
            return $e7dd728d9f060a75$var$UNITS_MONTH;
        case 'y':
            return $e7dd728d9f060a75$var$UNITS_YEAR;
    }
    const str = String(units || '').toLowerCase().replace(/s$/, '');
    switch(str){
        case $e7dd728d9f060a75$var$UNITS_DAY:
        case $e7dd728d9f060a75$var$UNITS_WEEK:
        case $e7dd728d9f060a75$var$UNITS_MONTH:
        case $e7dd728d9f060a75$var$UNITS_YEAR:
            return str;
    }
    throw new TypeError(`Invalid units '${units}'`);
}
function $e7dd728d9f060a75$var$getDayOfTranslation(locale) {
    switch(locale){
        case 'en':
        case 's':
        case 'a':
        case 'ashkenazi':
            return ' of';
    }
    const ofStr = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).lookupTranslation('of', locale);
    if (ofStr) return ' ' + ofStr;
    if (locale.startsWith('ashkenazi')) return ' of';
    return '';
}
/**
 * Sets the day of the month of the date. Returns the object it was called upon
 * @private
 * @param month A number, or Hebrew month name string
 */ function $e7dd728d9f060a75$var$setMonth(hd, month) {
    hd.mm = $e7dd728d9f060a75$export$8f4940fd510e0848.monthNum(month);
    $e7dd728d9f060a75$var$fix(hd);
    return hd;
}
function $e7dd728d9f060a75$var$setDate(hd, date) {
    hd.dd = date;
    $e7dd728d9f060a75$var$fix(hd);
    return hd;
}
function $e7dd728d9f060a75$var$fix(hd) {
    $e7dd728d9f060a75$var$fixMonth(hd);
    $e7dd728d9f060a75$var$fixDate(hd);
}
function $e7dd728d9f060a75$var$fixDate(hd) {
    if (hd.dd < 1) {
        if (hd.mm === (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TISHREI) hd.yy -= 1;
        hd.dd += (0, $0118a895d65cebcc$export$4169ecd548fbc13a)(hd.mm, hd.yy);
        hd.mm -= 1;
        $e7dd728d9f060a75$var$fix(hd);
    }
    if (hd.dd > (0, $0118a895d65cebcc$export$4169ecd548fbc13a)(hd.mm, hd.yy)) {
        if (hd.mm === (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ELUL) hd.yy += 1;
        hd.dd -= (0, $0118a895d65cebcc$export$4169ecd548fbc13a)(hd.mm, hd.yy);
        if (hd.mm === (0, $0118a895d65cebcc$export$80d7e435f744f319)(hd.yy)) hd.mm = 1; // rollover to NISAN
        else hd.mm += 1;
        $e7dd728d9f060a75$var$fix(hd);
    }
    $e7dd728d9f060a75$var$fixMonth(hd);
}
function $e7dd728d9f060a75$var$fixMonth(hd) {
    if (hd.mm === (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ADAR_II && !hd.isLeapYear()) {
        hd.mm -= 1; // to Adar I
        $e7dd728d9f060a75$var$fix(hd);
    } else if (hd.mm < 1) {
        hd.mm += (0, $0118a895d65cebcc$export$80d7e435f744f319)(hd.yy);
        hd.yy -= 1;
        $e7dd728d9f060a75$var$fix(hd);
    } else if (hd.mm > (0, $0118a895d65cebcc$export$80d7e435f744f319)(hd.yy)) {
        hd.mm -= (0, $0118a895d65cebcc$export$80d7e435f744f319)(hd.yy);
        hd.yy += 1;
        $e7dd728d9f060a75$var$fix(hd);
    }
    delete hd.rd;
}
function $e7dd728d9f060a75$var$onOrBefore(day, t, offset) {
    return new $e7dd728d9f060a75$export$8f4940fd510e0848($e7dd728d9f060a75$export$8f4940fd510e0848.dayOnOrBefore(day, t.abs() + offset));
}




/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 
/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ var $6439d075bc1e207c$export$2e2bcd8739ae039 = {
    "headers": {
        "plural-forms": "nplurals=2; plural=(n > 1);",
        "language": "en_CA@ashkenazi"
    },
    "contexts": {
        "": {
            "Shabbat": [
                "Shabbos"
            ],
            "Achrei Mot": [
                "Achrei Mos"
            ],
            "Bechukotai": [
                "Bechukosai"
            ],
            "Beha'alotcha": [
                "Beha\u2019aloscha"
            ],
            "Bereshit": [
                "Bereshis"
            ],
            "Chukat": [
                "Chukas"
            ],
            "Erev Shavuot": [
                "Erev Shavuos"
            ],
            "Erev Sukkot": [
                "Erev Sukkos"
            ],
            "Ki Tavo": [
                "Ki Savo"
            ],
            "Ki Teitzei": [
                "Ki Seitzei"
            ],
            "Ki Tisa": [
                "Ki Sisa"
            ],
            "Matot": [
                "Matos"
            ],
            "Purim Katan": [
                "Purim Koton"
            ],
            "Shabbat Chazon": [
                "Shabbos Chazon"
            ],
            "Shabbat HaChodesh": [
                "Shabbos HaChodesh"
            ],
            "Shabbat HaGadol": [
                "Shabbos HaGadol"
            ],
            "Shabbat Nachamu": [
                "Shabbos Nachamu"
            ],
            "Shabbat Parah": [
                "Shabbos Parah"
            ],
            "Shabbat Shekalim": [
                "Shabbos Shekalim"
            ],
            "Shabbat Shuva": [
                "Shabbos Shuvah"
            ],
            "Shabbat Zachor": [
                "Shabbos Zachor"
            ],
            "Shavuot": [
                "Shavuos"
            ],
            "Shavuot I": [
                "Shavuos I"
            ],
            "Shavuot II": [
                "Shavuos II"
            ],
            "Shemot": [
                "Shemos"
            ],
            "Shmini Atzeret": [
                "Shmini Atzeres"
            ],
            "Simchat Torah": [
                "Simchas Torah"
            ],
            "Sukkot": [
                "Sukkos"
            ],
            "Sukkot I": [
                "Sukkos I"
            ],
            "Sukkot II": [
                "Sukkos II"
            ],
            "Sukkot II (CH''M)": [
                "Sukkos II (CH\u2019\u2019M)"
            ],
            "Sukkot III (CH''M)": [
                "Sukkos III (CH\u2019\u2019M)"
            ],
            "Sukkot IV (CH''M)": [
                "Sukkos IV (CH\u2019\u2019M)"
            ],
            "Sukkot V (CH''M)": [
                "Sukkos V (CH\u2019\u2019M)"
            ],
            "Sukkot VI (CH''M)": [
                "Sukkos VI (CH\u2019\u2019M)"
            ],
            "Sukkot VII (Hoshana Raba)": [
                "Sukkos VII (Hoshana Raba)"
            ],
            "Ta'anit Bechorot": [
                "Ta\u2019anis Bechoros"
            ],
            "Ta'anit Esther": [
                "Ta\u2019anis Esther"
            ],
            "Toldot": [
                "Toldos"
            ],
            "Vaetchanan": [
                "Vaeschanan"
            ],
            "Yitro": [
                "Yisro"
            ],
            "Vezot Haberakhah": [
                "Vezos Haberakhah"
            ],
            "Parashat": [
                "Parshas"
            ],
            "Leil Selichot": [
                "Leil Selichos"
            ],
            "Shabbat Mevarchim Chodesh": [
                "Shabbos Mevorchim Chodesh"
            ],
            "Shabbat Shirah": [
                "Shabbos Shirah"
            ],
            "Asara B'Tevet": [
                "Asara B\u2019Teves"
            ],
            "Alot HaShachar": [
                "Alos HaShachar"
            ],
            "Kriat Shema, sof zeman": [
                "Krias Shema, sof zman"
            ],
            "Tefilah, sof zeman": [
                "Tefilah, sof zman"
            ],
            "Kriat Shema, sof zeman (MGA)": [
                "Krias Shema, sof zman (MGA)"
            ],
            "Tefilah, sof zeman (MGA)": [
                "Tefilah, sof zman (MGA)"
            ],
            "Chatzot HaLailah": [
                "Chatzos HaLailah"
            ],
            "Chatzot hayom": [
                "Chatzos"
            ],
            "Tzeit HaKochavim": [
                "Tzeis HaKochavim"
            ],
            "Birkat Hachamah": [
                "Birkas Hachamah"
            ],
            "Shushan Purim Katan": [
                "Shushan Purim Koton"
            ]
        }
    }
};


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ var $3ccc759ec1173f6d$export$2e2bcd8739ae039 = {
    "headers": {
        "plural-forms": "nplurals=2; plural=(n > 1);",
        "language": "he_IL"
    },
    "contexts": {
        "": {
            "Shabbat": [
                "\u05E9\u05B7\u05C1\u05D1\u05B8\u05BC\u05EA"
            ],
            "Daf Yomi": [
                "\u05D3\u05B7\u05E3 \u05D9\u05D5\u05B9\u05DE\u05B4\u05D9"
            ],
            "Parashat": [
                "\u05E4\u05B8\u05BC\u05E8\u05B8\u05E9\u05B7\u05C1\u05EA"
            ],
            "Achrei Mot": [
                "\u05D0\u05B7\u05D7\u05B2\u05E8\u05B5\u05D9 \u05DE\u05D5\u05B9\u05EA"
            ],
            "Balak": [
                "\u05D1\u05B8\u05BC\u05DC\u05B8\u05E7"
            ],
            "Bamidbar": [
                "\u05D1\u05B0\u05BC\u05DE\u05B4\u05D3\u05B0\u05D1\u05B7\u05BC\u05E8"
            ],
            "Bechukotai": [
                "\u05D1\u05B0\u05BC\u05D7\u05BB\u05E7\u05B9\u05BC\u05EA\u05B7\u05D9"
            ],
            "Beha'alotcha": [
                "\u05D1\u05B0\u05BC\u05D4\u05B7\u05E2\u05B2\u05DC\u05B9\u05EA\u05B0\u05DA\u05B8"
            ],
            "Behar": [
                "\u05D1\u05B0\u05BC\u05D4\u05B7\u05E8"
            ],
            "Bereshit": [
                "\u05D1\u05B0\u05BC\u05E8\u05B5\u05D0\u05E9\u05B4\u05C1\u05D9\u05EA"
            ],
            "Beshalach": [
                "\u05D1\u05B0\u05BC\u05E9\u05B7\u05C1\u05DC\u05B7\u05BC\u05D7"
            ],
            "Bo": [
                "\u05D1\u05B9\u05BC\u05D0"
            ],
            "Chayei Sara": [
                "\u05D7\u05B7\u05D9\u05B5\u05BC\u05D9 \u05E9\u05B8\u05B9\u05E8\u05B8\u05D4"
            ],
            "Chukat": [
                "\u05D7\u05BB\u05E7\u05B7\u05BC\u05EA"
            ],
            "Devarim": [
                "\u05D3\u05B0\u05BC\u05D1\u05B8\u05E8\u05B4\u05D9\u05DD"
            ],
            "Eikev": [
                "\u05E2\u05B5\u05E7\u05B6\u05D1"
            ],
            "Emor": [
                "\u05D0\u05B1\u05DE\u05D5\u05B9\u05E8"
            ],
            "Ha'azinu": [
                "\u05D4\u05B7\u05D0\u05B2\u05D6\u05B4\u05D9\u05E0\u05D5\u05BC"
            ],
            "Kedoshim": [
                "\u05E7\u05B0\u05D3\u05E9\u05B4\u05C1\u05D9\u05DD"
            ],
            "Ki Tavo": [
                "\u05DB\u05B4\u05BC\u05D9\u05BE\u05EA\u05B8\u05D1\u05D5\u05B9\u05D0"
            ],
            "Ki Teitzei": [
                "\u05DB\u05B4\u05BC\u05D9\u05BE\u05EA\u05B5\u05E6\u05B5\u05D0"
            ],
            "Ki Tisa": [
                "\u05DB\u05B4\u05BC\u05D9 \u05EA\u05B4\u05E9\u05B8\u05BC\u05C2\u05D0"
            ],
            "Korach": [
                "\u05E7\u05D5\u05B9\u05E8\u05B7\u05D7"
            ],
            "Lech-Lecha": [
                "\u05DC\u05B6\u05DA\u05B0\u05BE\u05DC\u05B0\u05DA\u05B8"
            ],
            "Masei": [
                "\u05DE\u05B7\u05E1\u05B0\u05E2\u05B5\u05D9"
            ],
            "Matot": [
                "\u05DE\u05B7\u05BC\u05D8\u05BC\u05D5\u05B9\u05EA"
            ],
            "Metzora": [
                "\u05DE\u05B0\u05BC\u05E6\u05B9\u05E8\u05B8\u05E2"
            ],
            "Miketz": [
                "\u05DE\u05B4\u05E7\u05B5\u05BC\u05E5"
            ],
            "Mishpatim": [
                "\u05DE\u05B4\u05BC\u05E9\u05B0\u05C1\u05E4\u05B8\u05BC\u05D8\u05B4\u05D9\u05DD"
            ],
            "Nasso": [
                "\u05E0\u05B8\u05E9\u05C2\u05D0"
            ],
            "Nitzavim": [
                "\u05E0\u05B4\u05E6\u05B8\u05BC\u05D1\u05B4\u05D9\u05DD"
            ],
            "Noach": [
                "\u05E0\u05B9\u05D7\u05B7"
            ],
            "Pekudei": [
                "\u05E4\u05B0\u05E7\u05D5\u05BC\u05D3\u05B5\u05D9"
            ],
            "Pinchas": [
                "\u05E4\u05B4\u05BC\u05D9\u05E0\u05B0\u05D7\u05B8\u05E1"
            ],
            "Re'eh": [
                "\u05E8\u05B0\u05D0\u05B5\u05D4"
            ],
            "Sh'lach": [
                "\u05E9\u05B0\u05C1\u05DC\u05B7\u05D7\u05BE\u05DC\u05B0\u05DA\u05B8"
            ],
            "Shemot": [
                "\u05E9\u05B0\u05C1\u05DE\u05D5\u05B9\u05EA"
            ],
            "Shmini": [
                "\u05E9\u05B0\u05BC\u05C1\u05DE\u05B4\u05D9\u05E0\u05B4\u05D9"
            ],
            "Shoftim": [
                "\u05E9\u05C1\u05D5\u05B9\u05E4\u05B0\u05D8\u05B4\u05D9\u05DD"
            ],
            "Tazria": [
                "\u05EA\u05B7\u05D6\u05B0\u05E8\u05B4\u05D9\u05E2\u05B7"
            ],
            "Terumah": [
                "\u05EA\u05B0\u05BC\u05E8\u05D5\u05BC\u05DE\u05B8\u05D4"
            ],
            "Tetzaveh": [
                "\u05EA\u05B0\u05BC\u05E6\u05B7\u05D5\u05B6\u05BC\u05D4"
            ],
            "Toldot": [
                "\u05EA\u05BC\u05D5\u05B9\u05DC\u05B0\u05D3\u05D5\u05B9\u05EA"
            ],
            "Tzav": [
                "\u05E6\u05B7\u05D5"
            ],
            "Vaera": [
                "\u05D5\u05B8\u05D0\u05B5\u05E8\u05B8\u05D0"
            ],
            "Vaetchanan": [
                "\u05D5\u05B8\u05D0\u05B6\u05EA\u05B0\u05D7\u05B7\u05E0\u05B7\u05BC\u05DF"
            ],
            "Vayakhel": [
                "\u05D5\u05B7\u05D9\u05B7\u05BC\u05E7\u05B0\u05D4\u05B5\u05DC"
            ],
            "Vayechi": [
                "\u05D5\u05B7\u05D9\u05B0\u05D7\u05B4\u05D9"
            ],
            "Vayeilech": [
                "\u05D5\u05B7\u05D9\u05B5\u05BC\u05DC\u05B6\u05DA\u05B0"
            ],
            "Vayera": [
                "\u05D5\u05B7\u05D9\u05B5\u05BC\u05E8\u05B8\u05D0"
            ],
            "Vayeshev": [
                "\u05D5\u05B7\u05D9\u05B5\u05BC\u05E9\u05B6\u05C1\u05D1"
            ],
            "Vayetzei": [
                "\u05D5\u05B7\u05D9\u05B5\u05BC\u05E6\u05B5\u05D0"
            ],
            "Vayigash": [
                "\u05D5\u05B7\u05D9\u05B4\u05BC\u05D2\u05B7\u05BC\u05E9\u05C1"
            ],
            "Vayikra": [
                "\u05D5\u05B7\u05D9\u05B4\u05BC\u05E7\u05B0\u05E8\u05B8\u05D0"
            ],
            "Vayishlach": [
                "\u05D5\u05B7\u05D9\u05B4\u05BC\u05E9\u05B0\u05C1\u05DC\u05B7\u05D7"
            ],
            "Vezot Haberakhah": [
                "\u05D5\u05B0\u05D6\u05B9\u05D0\u05EA \u05D4\u05B7\u05D1\u05B0\u05BC\u05E8\u05B8\u05DB\u05B8\u05D4"
            ],
            "Yitro": [
                "\u05D9\u05B4\u05EA\u05B0\u05E8\u05D5\u05B9"
            ],
            "Asara B'Tevet": [
                "\u05E2\u05B2\u05E9\u05B8\u05C2\u05E8\u05B8\u05D4 \u05D1\u05B0\u05BC\u05D8\u05B5\u05D1\u05B5\u05EA"
            ],
            "Candle lighting": [
                "\u05D4\u05B7\u05D3\u05B0\u05DC\u05B8\u05E7\u05B7\u05EA \u05E0\u05B5\u05E8\u05D5\u05B9\u05EA"
            ],
            "Chanukah": [
                "\u05D7\u05B2\u05E0\u05D5\u05BC\u05DB\u05B8\u05BC\u05D4"
            ],
            "Chanukah: 1 Candle": [
                "\u05D7\u05B2\u05E0\u05D5\u05BC\u05DB\u05B8\u05BC\u05D4: \u05D0\u05F3 \u05E0\u05B5\u05E8"
            ],
            "Chanukah: 2 Candles": [
                "\u05D7\u05B2\u05E0\u05D5\u05BC\u05DB\u05B8\u05BC\u05D4: \u05D1\u05F3 \u05E0\u05B5\u05E8\u05D5\u05B9\u05EA"
            ],
            "Chanukah: 3 Candles": [
                "\u05D7\u05B2\u05E0\u05D5\u05BC\u05DB\u05B8\u05BC\u05D4: \u05D2\u05F3 \u05E0\u05B5\u05E8\u05D5\u05B9\u05EA"
            ],
            "Chanukah: 4 Candles": [
                "\u05D7\u05B2\u05E0\u05D5\u05BC\u05DB\u05B8\u05BC\u05D4: \u05D3\u05F3 \u05E0\u05B5\u05E8\u05D5\u05B9\u05EA"
            ],
            "Chanukah: 5 Candles": [
                "\u05D7\u05B2\u05E0\u05D5\u05BC\u05DB\u05B8\u05BC\u05D4: \u05D4\u05F3 \u05E0\u05B5\u05E8\u05D5\u05B9\u05EA"
            ],
            "Chanukah: 6 Candles": [
                "\u05D7\u05B2\u05E0\u05D5\u05BC\u05DB\u05B8\u05BC\u05D4: \u05D5\u05F3 \u05E0\u05B5\u05E8\u05D5\u05B9\u05EA"
            ],
            "Chanukah: 7 Candles": [
                "\u05D7\u05B2\u05E0\u05D5\u05BC\u05DB\u05B8\u05BC\u05D4: \u05D6\u05F3 \u05E0\u05B5\u05E8\u05D5\u05B9\u05EA"
            ],
            "Chanukah: 8 Candles": [
                "\u05D7\u05B2\u05E0\u05D5\u05BC\u05DB\u05B8\u05BC\u05D4: \u05D7\u05F3 \u05E0\u05B5\u05E8\u05D5\u05B9\u05EA"
            ],
            "Chanukah: 8th Day": [
                "\u05D7\u05B2\u05E0\u05D5\u05BC\u05DB\u05B8\u05BC\u05D4: \u05D9\u05D5\u05B9\u05DD \u05D7\u05F3"
            ],
            "Days of the Omer": [
                "\u05E1\u05B0\u05E4\u05B4\u05D9\u05E8\u05B7\u05EA \u05D4\u05B8\u05E2\u05D5\u05B9\u05DE\u05B6\u05E8"
            ],
            "Omer": [
                "\u05E2\u05D5\u05B9\u05DE\u05B6\u05E8"
            ],
            "day of the Omer": [
                "\u05D1\u05B8\u05BC\u05E2\u05D5\u05B9\u05DE\u05B6\u05E8"
            ],
            "Erev Pesach": [
                "\u05E2\u05B6\u05E8\u05B6\u05D1 \u05E4\u05B6\u05BC\u05E1\u05B7\u05D7"
            ],
            "Erev Purim": [
                "\u05E2\u05B6\u05E8\u05B6\u05D1 \u05E4\u05BC\u05D5\u05BC\u05E8\u05B4\u05D9\u05DD"
            ],
            "Erev Rosh Hashana": [
                "\u05E2\u05B6\u05E8\u05B6\u05D1 \u05E8\u05B9\u05D0\u05E9\u05C1 \u05D4\u05B7\u05E9\u05B8\u05BC\u05C1\u05E0\u05B8\u05D4"
            ],
            "Erev Shavuot": [
                "\u05E2\u05B6\u05E8\u05B6\u05D1 \u05E9\u05B8\u05C1\u05D1\u05D5\u05BC\u05E2\u05D5\u05B9\u05EA"
            ],
            "Erev Simchat Torah": [
                "\u05E2\u05B6\u05E8\u05B6\u05D1 \u05E9\u05B4\u05C2\u05DE\u05B0\u05D7\u05B7\u05EA \u05EA\u05BC\u05D5\u05B9\u05E8\u05B8\u05D4"
            ],
            "Erev Sukkot": [
                "\u05E2\u05B6\u05E8\u05B6\u05D1 \u05E1\u05D5\u05BC\u05DB\u05BC\u05D5\u05B9\u05EA"
            ],
            "Erev Tish'a B'Av": [
                "\u05E2\u05B6\u05E8\u05B6\u05D1 \u05EA\u05B4\u05BC\u05E9\u05B0\u05C1\u05E2\u05B8\u05D4 \u05D1\u05B0\u05BC\u05D0\u05B8\u05D1"
            ],
            "Erev Yom Kippur": [
                "\u05E2\u05B6\u05E8\u05B6\u05D1 \u05D9\u05D5\u05B9\u05DD \u05DB\u05B4\u05BC\u05E4\u05BC\u05D5\u05BC\u05E8"
            ],
            "Havdalah": [
                "\u05D4\u05B7\u05D1\u05B0\u05D3\u05B8\u05BC\u05DC\u05B8\u05D4"
            ],
            "Lag BaOmer": [
                "\u05DC\u05F4\u05D2 \u05D1\u05B8\u05BC\u05E2\u05D5\u05B9\u05DE\u05B6\u05E8"
            ],
            "Leil Selichot": [
                "\u05E1\u05DC\u05D9\u05D7\u05D5\u05EA"
            ],
            "Pesach": [
                "\u05E4\u05B6\u05BC\u05E1\u05B7\u05D7"
            ],
            "Pesach I": [
                "\u05E4\u05B6\u05BC\u05E1\u05B7\u05D7 \u05D0\u05F3"
            ],
            "Pesach II": [
                "\u05E4\u05B6\u05BC\u05E1\u05B7\u05D7 \u05D1\u05F3"
            ],
            "Pesach II (CH''M)": [
                "\u05E4\u05B6\u05BC\u05E1\u05B7\u05D7 \u05D1\u05F3 (\u05D7\u05D5\u05D4\u05F4\u05DE)"
            ],
            "Pesach III (CH''M)": [
                "\u05E4\u05B6\u05BC\u05E1\u05B7\u05D7 \u05D2\u05F3 (\u05D7\u05D5\u05D4\u05F4\u05DE)"
            ],
            "Pesach IV (CH''M)": [
                "\u05E4\u05B6\u05BC\u05E1\u05B7\u05D7 \u05D3\u05F3 (\u05D7\u05D5\u05D4\u05F4\u05DE)"
            ],
            "Pesach Sheni": [
                "\u05E4\u05B6\u05BC\u05E1\u05B7\u05D7 \u05E9\u05E0\u05D9"
            ],
            "Pesach V (CH''M)": [
                "\u05E4\u05B6\u05BC\u05E1\u05B7\u05D7 \u05D4\u05F3 (\u05D7\u05D5\u05D4\u05F4\u05DE)"
            ],
            "Pesach VI (CH''M)": [
                "\u05E4\u05B6\u05BC\u05E1\u05B7\u05D7 \u05D5\u05F3 (\u05D7\u05D5\u05D4\u05F4\u05DE)"
            ],
            "Pesach VII": [
                "\u05E4\u05B6\u05BC\u05E1\u05B7\u05D7 \u05D6\u05F3"
            ],
            "Pesach VIII": [
                "\u05E4\u05B6\u05BC\u05E1\u05B7\u05D7 \u05D7\u05F3"
            ],
            "Purim": [
                "\u05E4\u05BC\u05D5\u05BC\u05E8\u05B4\u05D9\u05DD"
            ],
            "Purim Katan": [
                "\u05E4\u05BC\u05D5\u05BC\u05E8\u05B4\u05D9\u05DD \u05E7\u05B8\u05D8\u05B8\u05DF"
            ],
            "Rosh Chodesh %s": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 %s"
            ],
            "Rosh Chodesh": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1"
            ],
            "Rosh Hashana": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D4\u05B7\u05E9\u05B8\u05BC\u05C1\u05E0\u05B8\u05D4"
            ],
            "Rosh Hashana I": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D4\u05B7\u05E9\u05B8\u05BC\u05C1\u05E0\u05B8\u05D4 \u05D0\u05F3"
            ],
            "Rosh Hashana II": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D4\u05B7\u05E9\u05B8\u05BC\u05C1\u05E0\u05B8\u05D4 \u05D1\u05F3"
            ],
            "Shabbat Chazon": [
                "\u05E9\u05B7\u05C1\u05D1\u05B8\u05BC\u05EA \u05D7\u05B2\u05D6\u05D5\u05B9\u05DF"
            ],
            "Shabbat HaChodesh": [
                "\u05E9\u05B7\u05C1\u05D1\u05B8\u05BC\u05EA \u05D4\u05B7\u05D7\u05B9\u05D3\u05B6\u05E9\u05C1"
            ],
            "Shabbat HaGadol": [
                "\u05E9\u05B7\u05C1\u05D1\u05B8\u05BC\u05EA \u05D4\u05B7\u05D2\u05B8\u05BC\u05D3\u05D5\u05B9\u05DC"
            ],
            "Shabbat Nachamu": [
                "\u05E9\u05B7\u05C1\u05D1\u05B8\u05BC\u05EA \u05E0\u05B7\u05D7\u05B2\u05DE\u05D5\u05BC"
            ],
            "Shabbat Parah": [
                "\u05E9\u05B7\u05C1\u05D1\u05B8\u05BC\u05EA \u05E4\u05BC\u05E8\u05D4"
            ],
            "Shabbat Shekalim": [
                "\u05E9\u05B7\u05C1\u05D1\u05B8\u05BC\u05EA \u05E9\u05B0\u05C1\u05E7\u05B8\u05DC\u05B4\u05D9\u05DD"
            ],
            "Shabbat Shuva": [
                "\u05E9\u05B7\u05C1\u05D1\u05B8\u05BC\u05EA \u05E9\u05C1\u05D5\u05BC\u05D1\u05B8\u05D4"
            ],
            "Shabbat Zachor": [
                "\u05E9\u05B7\u05C1\u05D1\u05B8\u05BC\u05EA \u05D6\u05B8\u05DB\u05D5\u05B9\u05E8"
            ],
            "Shavuot": [
                "\u05E9\u05B8\u05C1\u05D1\u05D5\u05BC\u05E2\u05D5\u05B9\u05EA"
            ],
            "Shavuot I": [
                "\u05E9\u05B8\u05C1\u05D1\u05D5\u05BC\u05E2\u05D5\u05B9\u05EA \u05D0\u05F3"
            ],
            "Shavuot II": [
                "\u05E9\u05B8\u05C1\u05D1\u05D5\u05BC\u05E2\u05D5\u05B9\u05EA \u05D1\u05F3"
            ],
            "Shmini Atzeret": [
                "\u05E9\u05B0\u05C1\u05DE\u05B4\u05D9\u05E0\u05B4\u05D9 \u05E2\u05B2\u05E6\u05B6\u05E8\u05B6\u05EA"
            ],
            "Shushan Purim": [
                "\u05E9\u05C1\u05D5\u05BC\u05E9\u05B8\u05C1\u05DF \u05E4\u05BC\u05D5\u05BC\u05E8\u05B4\u05D9\u05DD"
            ],
            "Sigd": [
                "\u05E1\u05D9\u05D2\u05D3"
            ],
            "Simchat Torah": [
                "\u05E9\u05B4\u05C2\u05DE\u05B0\u05D7\u05B7\u05EA \u05EA\u05BC\u05D5\u05B9\u05E8\u05B8\u05D4"
            ],
            "Sukkot": [
                "\u05E1\u05D5\u05BC\u05DB\u05BC\u05D5\u05B9\u05EA"
            ],
            "Sukkot I": [
                "\u05E1\u05D5\u05BC\u05DB\u05BC\u05D5\u05B9\u05EA \u05D0\u05F3"
            ],
            "Sukkot II": [
                "\u05E1\u05D5\u05BC\u05DB\u05BC\u05D5\u05B9\u05EA \u05D1\u05F3"
            ],
            "Sukkot II (CH''M)": [
                "\u05E1\u05D5\u05BC\u05DB\u05BC\u05D5\u05B9\u05EA \u05D1\u05F3 (\u05D7\u05D5\u05D4\u05F4\u05DE)"
            ],
            "Sukkot III (CH''M)": [
                "\u05E1\u05D5\u05BC\u05DB\u05BC\u05D5\u05B9\u05EA \u05D2\u05F3 (\u05D7\u05D5\u05D4\u05F4\u05DE)"
            ],
            "Sukkot IV (CH''M)": [
                "\u05E1\u05D5\u05BC\u05DB\u05BC\u05D5\u05B9\u05EA \u05D3\u05F3 (\u05D7\u05D5\u05D4\u05F4\u05DE)"
            ],
            "Sukkot V (CH''M)": [
                "\u05E1\u05D5\u05BC\u05DB\u05BC\u05D5\u05B9\u05EA \u05D4\u05F3 (\u05D7\u05D5\u05D4\u05F4\u05DE)"
            ],
            "Sukkot VI (CH''M)": [
                "\u05E1\u05D5\u05BC\u05DB\u05BC\u05D5\u05B9\u05EA \u05D5\u05F3 (\u05D7\u05D5\u05D4\u05F4\u05DE)"
            ],
            "Sukkot VII (Hoshana Raba)": [
                "\u05E1\u05D5\u05BC\u05DB\u05BC\u05D5\u05B9\u05EA \u05D6\u05F3 (\u05D4\u05D5\u05B9\u05E9\u05B7\u05C1\u05E2\u05B0\u05E0\u05B8\u05D0 \u05E8\u05B7\u05D1\u05B8\u05BC\u05D4)"
            ],
            "Ta'anit Bechorot": [
                "\u05EA\u05B7\u05BC\u05E2\u05B2\u05E0\u05B4\u05D9\u05EA \u05D1\u05B0\u05BC\u05DB\u05D5\u05B9\u05E8\u05D5\u05B9\u05EA"
            ],
            "Ta'anit Esther": [
                "\u05EA\u05B7\u05BC\u05E2\u05B2\u05E0\u05B4\u05D9\u05EA \u05D0\u05B6\u05E1\u05B0\u05EA\u05B5\u05BC\u05E8"
            ],
            "Tish'a B'Av": [
                "\u05EA\u05B4\u05BC\u05E9\u05B0\u05C1\u05E2\u05B8\u05D4 \u05D1\u05B0\u05BC\u05D0\u05B8\u05D1"
            ],
            "Tu B'Av": [
                "\u05D8\u05D5\u05BC \u05D1\u05B0\u05BC\u05D0\u05B8\u05D1"
            ],
            "Tu BiShvat": [
                "\u05D8\u05D5\u05BC \u05D1\u05B4\u05BC\u05E9\u05B0\u05C1\u05D1\u05B8\u05D8"
            ],
            "Tu B'Shvat": [
                "\u05D8\u05D5\u05BC \u05D1\u05B4\u05BC\u05E9\u05B0\u05C1\u05D1\u05B8\u05D8"
            ],
            "Tzom Gedaliah": [
                "\u05E6\u05D5\u05B9\u05DD \u05D2\u05B0\u05BC\u05D3\u05B7\u05DC\u05B0\u05D9\u05B8\u05D4"
            ],
            "Tzom Tammuz": [
                "\u05E6\u05D5\u05B9\u05DD \u05EA\u05B8\u05BC\u05DE\u05D5\u05BC\u05D6"
            ],
            "Yom HaAtzma'ut": [
                "\u05D9\u05D5\u05B9\u05DD \u05D4\u05B8\u05E2\u05B7\u05E6\u05B0\u05DE\u05B8\u05D0\u05D5\u05BC\u05EA"
            ],
            "Yom HaShoah": [
                "\u05D9\u05D5\u05B9\u05DD \u05D4\u05B7\u05E9\u05BC\u05C1\u05D5\u05B9\u05D0\u05B8\u05D4"
            ],
            "Yom HaZikaron": [
                "\u05D9\u05D5\u05B9\u05DD \u05D4\u05B7\u05D6\u05B4\u05BC\u05DB\u05B8\u05BC\u05E8\u05D5\u05B9\u05DF"
            ],
            "Yom Kippur": [
                "\u05D9\u05D5\u05B9\u05DD \u05DB\u05B4\u05BC\u05E4\u05BC\u05D5\u05BC\u05E8"
            ],
            "Yom Yerushalayim": [
                "\u05D9\u05D5\u05B9\u05DD \u05D9\u05B0\u05E8\u05D5\u05BC\u05E9\u05B8\u05C1\u05DC\u05B7\u05D9\u05B4\u05DD"
            ],
            "Yom HaAliyah": [
                "\u05D9\u05D5\u05B9\u05DD \u05D4\u05B7\u05E2\u05B2\u05DC\u05B4\u05D9\u05B8\u05BC\u05D4"
            ],
            "Yom HaAliyah School Observance": [
                "\u05E9\u05B0\u05C1\u05DE\u05B4\u05D9\u05E8\u05B8\u05EA \u05D1\u05B5\u05BC\u05D9\u05EA \u05D4\u05B7\u05E1\u05B5\u05E4\u05B6\u05E8 \u05DC\u05B0\u05D9\u05D5\u05B9\u05DD \u05D4\u05B7\u05E2\u05B2\u05DC\u05B4\u05D9\u05B8\u05BC\u05D4"
            ],
            "Rosh Chodesh Adar": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 \u05D0\u05B7\u05D3\u05B8\u05E8"
            ],
            "Rosh Chodesh Adar I": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 \u05D0\u05B7\u05D3\u05B8\u05E8 \u05D0\u05F3"
            ],
            "Rosh Chodesh Adar II": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 \u05D0\u05B7\u05D3\u05B8\u05E8 \u05D1\u05F3"
            ],
            "Rosh Chodesh Av": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 \u05D0\u05B8\u05D1"
            ],
            "Rosh Chodesh Cheshvan": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 \u05D7\u05B6\u05E9\u05B0\u05C1\u05D5\u05B8\u05DF"
            ],
            "Rosh Chodesh Elul": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 \u05D0\u05B1\u05DC\u05D5\u05BC\u05DC"
            ],
            "Rosh Chodesh Iyyar": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 \u05D0\u05B4\u05D9\u05B8\u05D9\u05E8"
            ],
            "Rosh Chodesh Kislev": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 \u05DB\u05B4\u05BC\u05E1\u05B0\u05DC\u05B5\u05D5"
            ],
            "Rosh Chodesh Nisan": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 \u05E0\u05B4\u05D9\u05E1\u05B8\u05DF"
            ],
            "Rosh Chodesh Sh'vat": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 \u05E9\u05B0\u05C1\u05D1\u05B8\u05D8"
            ],
            "Rosh Chodesh Sivan": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 \u05E1\u05B4\u05D9\u05D5\u05B8\u05DF"
            ],
            "Rosh Chodesh Tamuz": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 \u05EA\u05B8\u05BC\u05DE\u05D5\u05BC\u05D6"
            ],
            "Rosh Chodesh Tevet": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1 \u05D8\u05B5\u05D1\u05B5\u05EA"
            ],
            "min": [
                "\u05D3\u05B7\u05BC\u05E7\u05BC\u05D5\u05B9\u05EA"
            ],
            "Fast begins": [
                "\u05EA\u05D7\u05D9\u05DC\u05EA \u05D4\u05B7\u05E6\u05D5\u05B9\u05DD"
            ],
            "Fast ends": [
                "\u05E1\u05B4\u05D9\u05BC\u05D5\u05BC\u05DD \u05D4\u05B7\u05E6\u05D5\u05B9\u05DD"
            ],
            "Rosh Hashana LaBehemot": [
                "\u05E8\u05B9\u05D0\u05E9\u05C1 \u05D4\u05B7\u05E9\u05B8\u05BC\u05C1\u05E0\u05B8\u05D4 \u05DC\u05B0\u05DE\u05B7\u05E2\u05B0\u05E9\u05B7\u05C2\u05E8 \u05D1\u05B0\u05BC\u05D4\u05B5\u05DE\u05B8\u05D4"
            ],
            "Tish'a B'Av (observed)": [
                "\u05EA\u05B4\u05BC\u05E9\u05B0\u05C1\u05E2\u05B8\u05D4 \u05D1\u05B0\u05BC\u05D0\u05B8\u05D1 \u05E0\u05B4\u05D3\u05D7\u05B6\u05D4"
            ],
            "Shabbat Mevarchim Chodesh": [
                "\u05E9\u05B7\u05C1\u05D1\u05B8\u05BC\u05EA \u05DE\u05B0\u05D1\u05B8\u05E8\u05B0\u05DB\u05B4\u05D9\u05DD \u05D7\u05D5\u05B9\u05D3\u05B6\u05E9\u05C1"
            ],
            "Shabbat Shirah": [
                "\u05E9\u05B7\u05C1\u05D1\u05B8\u05BC\u05EA \u05E9\u05B4\u05C1\u05D9\u05E8\u05B8\u05D4"
            ],
            "Chatzot HaLailah": [
                "\u05D7\u05B2\u05E6\u05D5\u05B9\u05EA \u05D4\u05B7\u05DC\u05B7\u05D9\u05B0\u05DC\u05B8\u05D4"
            ],
            "Alot haShachar": [
                "\u05E2\u05B2\u05DC\u05D5\u05B9\u05EA \u05D4\u05B7\u05E9\u05B7\u05BC\u05C1\u05D7\u05B7\u05E8"
            ],
            "Misheyakir": [
                "\u05DE\u05B4\u05E9\u05B6\u05BC\u05C1\u05D9\u05B7\u05BC\u05DB\u05B4\u05BC\u05D9\u05E8"
            ],
            "Misheyakir Machmir": [
                "\u05DE\u05B4\u05E9\u05B6\u05BC\u05C1\u05D9\u05B7\u05BC\u05DB\u05B4\u05BC\u05D9\u05E8 \u05DE\u05B7\u05D7\u05DE\u05B4\u05D9\u05E8"
            ],
            "Dawn": [
                "\u05D3\u05B4\u05BC\u05D9\u05DE\u05B0\u05D3\u05BC\u05D5\u05BC\u05DE\u05B5\u05D9 \u05D1\u05BC\u05D5\u05B9\u05E7\u05B5\u05E8"
            ],
            "Sunrise": [
                "\u05D4\u05B7\u05E0\u05B5\u05E5 \u05D4\u05B7\u05D7\u05B7\u05DE\u05B8\u05BC\u05D4"
            ],
            "Kriat Shema, sof zeman": [
                "\u05E1\u05D5\u05B9\u05E3 \u05D6\u05B0\u05DE\u05B7\u05DF \u05E7\u05B0\u05E8\u05B4\u05D9\u05D0\u05B7\u05EA \u05E9\u05B0\u05C1\u05DE\u05B7\u05E2 \u05D2\u05E8\u05F4\u05D0"
            ],
            "Tefilah, sof zeman": [
                "\u05E1\u05D5\u05B9\u05E3 \u05D6\u05B0\u05DE\u05B7\u05DF \u05EA\u05B0\u05BC\u05E4\u05B4\u05DC\u05B8\u05BC\u05D4 \u05D2\u05E8\u05F4\u05D0"
            ],
            "Kriat Shema, sof zeman (MGA)": [
                "\u05E1\u05D5\u05B9\u05E3 \u05D6\u05B0\u05DE\u05B7\u05DF \u05E7\u05B0\u05E8\u05B4\u05D9\u05D0\u05B7\u05EA \u05E9\u05B0\u05C1\u05DE\u05B7\u05E2 \u05DE\u05D2\u05F4\u05D0"
            ],
            "Tefilah, sof zeman (MGA)": [
                "\u05E1\u05D5\u05B9\u05E3 \u05D6\u05B0\u05DE\u05B7\u05DF \u05EA\u05B0\u05BC\u05E4\u05B4\u05DC\u05B8\u05BC\u05D4 \u05DE\u05D2\u05F4\u05D0"
            ],
            "Chatzot hayom": [
                "\u05D7\u05B2\u05E6\u05D5\u05B9\u05EA \u05D4\u05B7\u05D9\u05BC\u05D5\u05B9\u05DD"
            ],
            "Mincha Gedolah": [
                "\u05DE\u05B4\u05E0\u05B0\u05D7\u05B8\u05D4 \u05D2\u05B0\u05BC\u05D3\u05D5\u05B9\u05DC\u05B8\u05D4"
            ],
            "Mincha Ketanah": [
                "\u05DE\u05B4\u05E0\u05B0\u05D7\u05B8\u05D4 \u05E7\u05B0\u05D8\u05B7\u05E0\u05B8\u05BC\u05D4"
            ],
            "Plag HaMincha": [
                "\u05E4\u05B0\u05BC\u05DC\u05B7\u05D2 \u05D4\u05B7\u05DE\u05B4\u05BC\u05E0\u05B0\u05D7\u05B8\u05D4"
            ],
            "Dusk": [
                "\u05D3\u05B4\u05BC\u05D9\u05DE\u05B0\u05D3\u05BC\u05D5\u05BC\u05DE\u05B5\u05D9 \u05E2\u05B6\u05E8\u05B6\u05D1"
            ],
            "Sunset": [
                "\u05E9\u05B0\u05C1\u05E7\u05B4\u05D9\u05E2\u05B8\u05D4"
            ],
            "Nightfall - End of ordained fasts": [
                "\u05DC\u05B7\u05D9\u05B0\u05DC\u05B8\u05D4 - \u05D2\u05DE\u05E8 \u05EA\u05E2\u05E0\u05D9\u05D5\u05EA \u05D3\u05E8\u05D1\u05E0\u05DF"
            ],
            "Tzeit HaKochavim": [
                "\u05E6\u05B5\u05D0\u05EA \u05D4\u05B7\u05DB\u05BC\u05D5\u05B9\u05DB\u05B8\u05D1\u05B4\u05D9\u05DD"
            ],
            "Lovingkindness": [
                "\u05D7\u05B6\u05BD\u05E1\u05B6\u05D3"
            ],
            "Might": [
                "\u05D2\u05B0\u05D1\u05D5\u05BC\u05E8\u05B8\u05D4"
            ],
            "Beauty": [
                "\u05EA\u05B4\u05BC\u05E4\u05D0\u05B6\u05E8\u05B6\u05EA"
            ],
            "Eternity": [
                "\u05E0\u05B6\u05BC\u05BD\u05E6\u05B7\u05D7"
            ],
            "Splendor": [
                "\u05D4\u05D5\u05B9\u05D3"
            ],
            "Foundation": [
                "\u05D9\u05B0\u05BC\u05E1\u05D5\u05B9\u05D3"
            ],
            "Majesty": [
                "\u05DE\u05B7\u05BC\u05DC\u05B0\u05DB\u05D5\u05BC\u05EA"
            ],
            "day": [
                "\u05D9\u05D5\u05B9\u05DD"
            ],
            "Yom Kippur Katan": [
                "\u05D9\u05D5\u05B9\u05DD \u05DB\u05B4\u05BC\u05E4\u05BC\u05D5\u05BC\u05E8 \u05E7\u05B8\u05D8\u05B8\u05DF"
            ],
            "Yizkor": [
                "\u05D9\u05B4\u05D6\u05B0\u05DB\u05BC\u05D5\u05B9\u05E8"
            ],
            "Family Day": [
                "\u05D9\u05D5\u05B9\u05DD \u05D4\u05B7\u05DE\u05B4\u05BC\u05E9\u05C1\u05E4\u05B8\u05BC\u05D7\u05B8\u05D4"
            ],
            "Yitzhak Rabin Memorial Day": [
                "\u05D9\u05D5\u05B9\u05DD \u05D4\u05B7\u05D6\u05B4\u05BC\u05DB\u05B8\u05BC\u05E8\u05D5\u05B9\u05DF \u05DC\u05D9\u05E6\u05D7\u05E7 \u05E8\u05D1\u05D9\u05DF"
            ],
            "Jabotinsky Day": [
                "\u05D9\u05D5\u05B9\u05DD \u05D6\u05F3\u05D1\u05D5\u05D8\u05D9\u05E0\u05E1\u05E7\u05D9"
            ],
            "Herzl Day": [
                "\u05D9\u05D5\u05B9\u05DD \u05D4\u05E8\u05E6\u05DC"
            ],
            "Ben-Gurion Day": [
                "\u05D9\u05D5\u05B9\u05DD \u05D1\u05DF\u05BE\u05D2\u05D5\u05E8\u05D9\u05D5\u05DF"
            ],
            "Hebrew Language Day": [
                "\u05D9\u05D5\u05B9\u05DD \u05D4\u05B7\u05E9\u05B8\u05C2\u05E4\u05B8\u05D4 \u05D4\u05B7\u05E2\u05B4\u05D1\u05E8\u05B4\u05D9\u05EA"
            ],
            "Birkat Hachamah": [
                "\u05D1\u05B4\u05E8\u05B0\u05DB\u05B7\u05BC\u05EA \u05D4\u05B7\u05D7\u05B7\u05DE\u05B8\u05BC\u05D4"
            ],
            "Shushan Purim Katan": [
                "\u05E9\u05C1\u05D5\u05BC\u05E9\u05B8\u05C1\u05DF \u05E4\u05BC\u05D5\u05BC\u05E8\u05B4\u05D9\u05DD \u05E7\u05B8\u05D8\u05B8\u05DF"
            ],
            "Purim Meshulash": [
                "\u05E4\u05BC\u05D5\u05BC\u05E8\u05B4\u05D9\u05DD \u05DE\u05B0\u05E9\u05C1\u05D5\u05BC\u05DC\u05B8\u05BC\u05E9\u05C1"
            ],
            "after sunset": [
                "\u05DC\u05B0\u05D0\u05B7\u05D7\u05B7\u05E8 \u05D4\u05B7\u05E9\u05B0\u05C1\u05E7\u05B4\u05D9\u05E2\u05B8\u05D4"
            ],
            "Yerushalmi": [
                "\u05D9\u05B0\u05E8\u05D5\u05BC\u05E9\u05B7\u05C1\u05DC\u05B0\u05DE\u05B4\u05D9"
            ],
            "Chag HaBanot": [
                "\u05D7\u05B7\u05D2 \u05D4\u05B7\u05D1\u05B8\u05BC\u05E0\u05D5\u05B9\u05EA"
            ],
            "Joshua": [
                "\u05D9\u05B0\u05D4\u05D5\u05B9\u05E9\u05C1\u05D5\u05BC\u05E2\u05B7"
            ],
            "Judges": [
                "\u05E9\u05C1\u05D5\u05B9\u05E4\u05B0\u05D8\u05B4\u05D9\u05DD"
            ],
            "I Samuel": [
                "\u05E9\u05B0\u05C1\u05DE\u05D5\u05BC\u05D0\u05B5\u05DC \u05E8\u05B4\u05D0\u05E9\u05C1\u05D5\u05B9\u05DF"
            ],
            "II Samuel": [
                "\u05E9\u05B0\u05C1\u05DE\u05D5\u05BC\u05D0\u05B5\u05DC \u05E9\u05B5\u05C1\u05E0\u05B4\u05D9"
            ],
            "I Kings": [
                "\u05DE\u05B0\u05DC\u05B8\u05DB\u05B4\u05D9\u05DD \u05E8\u05B4\u05D0\u05E9\u05C1\u05D5\u05B9\u05DF"
            ],
            "II Kings": [
                "\u05DE\u05B0\u05DC\u05B8\u05DB\u05B4\u05D9\u05DD \u05E9\u05B5\u05C1\u05E0\u05B4\u05D9"
            ],
            "Isaiah": [
                "\u05D9\u05B0\u05E9\u05B7\u05C1\u05E2\u05B0\u05D9\u05B8\u05D4\u05D5\u05BC"
            ],
            "Jeremiah": [
                "\u05D9\u05B4\u05E8\u05B0\u05DE\u05B0\u05D9\u05B8\u05D4\u05D5\u05BC"
            ],
            "Ezekiel": [
                "\u05D9\u05B0\u05D7\u05B6\u05D6\u05B0\u05E7\u05B5\u05D0\u05DC"
            ],
            "Hosea": [
                "\u05D4\u05D5\u05B9\u05E9\u05B5\u05C1\u05E2\u05B7"
            ],
            "Joel": [
                "\u05D9\u05D5\u05B9\u05D0\u05B5\u05DC"
            ],
            "Amos": [
                "\u05E2\u05B8\u05DE\u05D5\u05BC\u05E1"
            ],
            "Obadiah": [
                "\u05E2\u05D5\u05B9\u05D1\u05B7\u05D3\u05B0\u05D9\u05B8\u05D4"
            ],
            "Jonah": [
                "\u05D9\u05D5\u05B9\u05E0\u05B8\u05D4"
            ],
            "Micah": [
                "\u05DE\u05B4\u05D9\u05DB\u05B8\u05D4"
            ],
            "Nachum": [
                "\u05E0\u05B7\u05D7\u05D5\u05BC\u05DD"
            ],
            "Habakkuk": [
                "\u05D7\u05B2\u05D1\u05B7\u05E7\u05BC\u05D5\u05BC\u05E7"
            ],
            "Zephaniah": [
                "\u05E6\u05B0\u05E4\u05B7\u05E0\u05B0\u05D9\u05B8\u05D4"
            ],
            "Haggai": [
                "\u05D7\u05B7\u05D2\u05B7\u05BC\u05D9"
            ],
            "Zechariah": [
                "\u05D6\u05B0\u05DB\u05B7\u05E8\u05B0\u05D9\u05B8\u05D4"
            ],
            "Malachi": [
                "\u05DE\u05B7\u05DC\u05B0\u05D0\u05B8\u05DB\u05B4\u05D9"
            ],
            "Psalms": [
                "\u05EA\u05B0\u05BC\u05D4\u05B4\u05DC\u05B4\u05BC\u05D9\u05DD"
            ],
            "Proverbs": [
                "\u05DE\u05B4\u05E9\u05B0\u05C1\u05DC\u05B5\u05D9"
            ],
            "Job": [
                "\u05D0\u05B4\u05D9\u05BC\u05D5\u05B9\u05D1"
            ],
            "Song of Songs": [
                "\u05E9\u05B4\u05C1\u05D9\u05E8 \u05D4\u05B7\u05E9\u05B4\u05BC\u05C1\u05D9\u05E8\u05B4\u05D9\u05DD"
            ],
            "Ruth": [
                "\u05E8\u05D5\u05BC\u05EA"
            ],
            "Lamentations": [
                "\u05D0\u05B5\u05D9\u05DB\u05B8\u05D4"
            ],
            "Ecclesiastes": [
                "\u05E7\u05B9\u05D4\u05B6\u05DC\u05B6\u05EA"
            ],
            "Esther": [
                "\u05D0\u05B6\u05E1\u05B0\u05EA\u05B5\u05BC\u05E8"
            ],
            "Daniel": [
                "\u05D3\u05B8\u05BC\u05E0\u05B4\u05D9\u05B5\u05BC\u05D0\u05DC"
            ],
            "Ezra": [
                "\u05E2\u05B6\u05D6\u05B0\u05E8\u05B8\u05D0"
            ],
            "Nehemiah": [
                "\u05E0\u05B0\u05D7\u05B6\u05DE\u05B0\u05D9\u05B8\u05D4"
            ],
            "I Chronicles": [
                "\u05D3\u05B4\u05D1\u05E8\u05B5\u05D9 \u05D4\u05B7\u05D9\u05B8\u05DE\u05B4\u05D9\u05DD \u05E8\u05B4\u05D0\u05E9\u05C1\u05D5\u05B9\u05DF"
            ],
            "II Chronicles": [
                "\u05D3\u05B4\u05D1\u05E8\u05B5\u05D9 \u05D4\u05B7\u05D9\u05B8\u05DE\u05B4\u05D9\u05DD \u05E9\u05B5\u05C1\u05E0\u05B4\u05D9"
            ],
            "Molad": [
                "\u05DE\u05D5\u05B9\u05DC\u05B8\u05D3 \u05D4\u05B8\u05DC\u05B0\u05BC\u05D1\u05B8\u05E0\u05B8\u05D4"
            ],
            "chalakim": [
                "\u05D7\u05B2\u05DC\u05B8\u05E7\u05B4\u05D9\u05DD"
            ],
            "Pirkei Avot": [
                "\u05E4\u05B4\u05BC\u05E8\u05B0\u05E7\u05B5\u05D9 \u05D0\u05B8\u05D1\u05D5\u05B9\u05EA"
            ]
        }
    }
};


(0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).addTranslations('he', (0, $3ccc759ec1173f6d$export$2e2bcd8739ae039));
(0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).addTranslations('h', (0, $3ccc759ec1173f6d$export$2e2bcd8739ae039));
(0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).addTranslations('ashkenazi', (0, $6439d075bc1e207c$export$2e2bcd8739ae039));
(0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).addTranslations('a', (0, $6439d075bc1e207c$export$2e2bcd8739ae039));
/* Hebrew without nikkud */ const $061fff5c6d31fc6b$var$heStrs = (0, $3ccc759ec1173f6d$export$2e2bcd8739ae039).contexts[''];
const $061fff5c6d31fc6b$var$heNoNikud = {};
for (const [key, val] of Object.entries($061fff5c6d31fc6b$var$heStrs))$061fff5c6d31fc6b$var$heNoNikud[key] = [
    (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).hebrewStripNikkud(val[0])
];
const $061fff5c6d31fc6b$var$poHeNoNikud = {
    headers: (0, $3ccc759ec1173f6d$export$2e2bcd8739ae039).headers,
    contexts: {
        '': $061fff5c6d31fc6b$var$heNoNikud
    }
};
(0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).addTranslations('he-x-NoNikud', $061fff5c6d31fc6b$var$poHeNoNikud);


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 
/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 

/**
 * Holiday flags for Event. These flags are typically
 * combined using bitwise arithmetic to form a mask.
 * @readonly
 * @enum {number}
 */ const $439631353957c387$export$ceac1d294cf61000 = {
    /** Chag, yontiff, yom tov */ CHAG: 0x000001,
    /** Light candles 18 minutes before sundown */ LIGHT_CANDLES: 0x000002,
    /** End of holiday (end of Yom Tov)  */ YOM_TOV_ENDS: 0x000004,
    /** Observed only in the Diaspora (chutz l'aretz)  */ CHUL_ONLY: 0x000008,
    /** Observed only in Israel */ IL_ONLY: 0x000010,
    /** Light candles in the evening at Tzeit time (3 small stars) */ LIGHT_CANDLES_TZEIS: 0x000020,
    /** Candle-lighting for Chanukah */ CHANUKAH_CANDLES: 0x000040,
    /** Rosh Chodesh, beginning of a new Hebrew month */ ROSH_CHODESH: 0x000080,
    /** Minor fasts like Tzom Tammuz, Ta'anit Esther, ... */ MINOR_FAST: 0x000100,
    /** Shabbat Shekalim, Zachor, ... */ SPECIAL_SHABBAT: 0x000200,
    /** Weekly sedrot on Saturdays */ PARSHA_HASHAVUA: 0x000400,
    /** Daily page of Talmud (Bavli) */ DAF_YOMI: 0x000800,
    /** Days of the Omer */ OMER_COUNT: 0x001000,
    /** Yom HaShoah, Yom HaAtzma'ut, ... */ MODERN_HOLIDAY: 0x002000,
    /** Yom Kippur and Tish'a B'Av */ MAJOR_FAST: 0x004000,
    /** On the Saturday before Rosh Chodesh */ SHABBAT_MEVARCHIM: 0x008000,
    /** Molad */ MOLAD: 0x010000,
    /** Yahrzeit or Hebrew Anniversary */ USER_EVENT: 0x020000,
    /** Daily Hebrew date ("11th of Sivan, 5780") */ HEBREW_DATE: 0x040000,
    /** A holiday that's not major, modern, rosh chodesh, or a fast day */ MINOR_HOLIDAY: 0x080000,
    /** Evening before a major or minor holiday */ EREV: 0x100000,
    /** Chol haMoed, intermediate days of Pesach or Sukkot */ CHOL_HAMOED: 0x200000,
    /** Mishna Yomi */ MISHNA_YOMI: 0x400000,
    /** Yom Kippur Katan, minor day of atonement on the day preceeding each Rosh Chodesh */ YOM_KIPPUR_KATAN: 0x800000,
    /** Daily page of Jerusalem Talmud (Yerushalmi) */ YERUSHALMI_YOMI: 0x1000000,
    /** Nach Yomi */ NACH_YOMI: 0x2000000,
    /** Daily Learning */ DAILY_LEARNING: 0x4000000,
    /** Yizkor */ YIZKOR: 0x8000000
};
const $439631353957c387$var$flagToCategory = [
    [
        $439631353957c387$export$ceac1d294cf61000.MAJOR_FAST,
        'holiday',
        'major',
        'fast'
    ],
    [
        $439631353957c387$export$ceac1d294cf61000.CHANUKAH_CANDLES,
        'holiday',
        'major'
    ],
    [
        $439631353957c387$export$ceac1d294cf61000.HEBREW_DATE,
        'hebdate'
    ],
    [
        $439631353957c387$export$ceac1d294cf61000.MINOR_FAST,
        'holiday',
        'fast'
    ],
    [
        $439631353957c387$export$ceac1d294cf61000.MINOR_HOLIDAY,
        'holiday',
        'minor'
    ],
    [
        $439631353957c387$export$ceac1d294cf61000.MODERN_HOLIDAY,
        'holiday',
        'modern'
    ],
    [
        $439631353957c387$export$ceac1d294cf61000.MOLAD,
        'molad'
    ],
    [
        $439631353957c387$export$ceac1d294cf61000.OMER_COUNT,
        'omer'
    ],
    [
        $439631353957c387$export$ceac1d294cf61000.PARSHA_HASHAVUA,
        'parashat'
    ],
    [
        $439631353957c387$export$ceac1d294cf61000.ROSH_CHODESH,
        'roshchodesh'
    ],
    [
        $439631353957c387$export$ceac1d294cf61000.SHABBAT_MEVARCHIM,
        'mevarchim'
    ],
    [
        $439631353957c387$export$ceac1d294cf61000.SPECIAL_SHABBAT,
        'holiday',
        'shabbat'
    ],
    [
        $439631353957c387$export$ceac1d294cf61000.USER_EVENT,
        'user'
    ],
    [
        $439631353957c387$export$ceac1d294cf61000.YIZKOR,
        'yizkor'
    ]
];
/**
 * Represents an Event with a title, date, and flags.
 *
 * Events are used to represent holidays, candle-lighting times,
 * Torah readings, and more.
 *
 * To get the title of the event a language other than English
 * with Sephardic transliterations, use the `render()` method.
 */ class $439631353957c387$export$d61e24a684f9e51 {
    /**
     * Constructs Event
     * @param date Hebrew date event occurs
     * @param desc Description (not translated)
     * @param [mask=0] optional bitmask of holiday flags (see {@link flags})
     * @param [attrs={}] optional additional attributes (e.g. `eventTimeStr`, `cholHaMoedDay`)
     */ constructor(date, desc, mask = 0, attrs){
        if (!(0, $e7dd728d9f060a75$export$8f4940fd510e0848).isHDate(date)) throw new TypeError(`Invalid Event date: ${date}`);
        else if (typeof desc !== 'string') throw new TypeError(`Invalid Event description: ${desc}`);
        this.date = date;
        this.desc = desc;
        this.mask = +mask;
        if (typeof attrs === 'object' && attrs !== null) Object.assign(this, attrs);
    }
    /**
     * Hebrew date of this event
     */ getDate() {
        return this.date;
    }
    /**
     * Untranslated title of this event. Note that these description
     * strings are always in English and will remain stable across releases.
     * To get the title of the event in another language, use the
     * `render()` method.
     */ getDesc() {
        return this.desc;
    }
    /**
     * Bitmask of optional event flags. See {@link flags}
     */ getFlags() {
        return this.mask;
    }
    /**
     * Returns (translated) description of this event
     * @example
     * const ev = new Event(new HDate(6, 'Sivan', 5749), 'Shavuot', flags.CHAG);
     * ev.render('en'); // 'Shavuot'
     * ev.render('he'); // 'שָׁבוּעוֹת'
     * ev.render('ashkenazi'); // 'Shavuos'
     * @param [locale] Optional locale name (defaults to active locale).
     */ render(locale) {
        return (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext(this.desc, locale);
    }
    /**
     * Returns a brief (translated) description of this event.
     * For most events, this is the same as render(). For some events, it procudes
     * a shorter text (e.g. without a time or added description).
     * @param [locale] Optional locale name (defaults to active locale).
     */ renderBrief(locale) {
        return this.render(locale);
    }
    /**
     * Optional holiday-specific Emoji or `null`.
     */ getEmoji() {
        return this.emoji || null;
    }
    /**
     * Returns a simplified (untranslated) description for this event. For example,
     * the `HolidayEvent` class supports
     * "Erev Pesach" => "Pesach", and "Sukkot III (CH''M)" => "Sukkot".
     * For many holidays the basename and the event description are the same.
     */ basename() {
        return this.getDesc();
    }
    /**
     * Returns a URL to hebcal.com or sefaria.org for more detail on the event.
     * Returns `undefined` for events with no detail page.
     */ url() {
        return undefined;
    }
    /**
     * Is this event observed in Israel?
     * @example
     * const ev1 = new Event(new HDate(7, 'Sivan', 5749), 'Shavuot II', flags.CHAG | flags.CHUL_ONLY);
     * ev1.observedInIsrael(); // false
     * const ev2 = new Event(new HDate(26, 'Kislev', 5749), 'Chanukah: 3 Candles', 0);
     * ev2.observedInIsrael(); // true
     */ observedInIsrael() {
        return !(this.mask & $439631353957c387$export$ceac1d294cf61000.CHUL_ONLY);
    }
    /**
     * Is this event observed in the Diaspora?
     * @example
     * const ev1 = new Event(new HDate(7, 'Sivan', 5749), 'Shavuot II', flags.CHAG | flags.CHUL_ONLY);
     * ev1.observedInDiaspora(); // true
     * const ev2 = new Event(new HDate(26, 'Kislev', 5749), 'Chanukah: 3 Candles', 0);
     * ev2.observedInDiaspora(); // true
     */ observedInDiaspora() {
        return !(this.mask & $439631353957c387$export$ceac1d294cf61000.IL_ONLY);
    }
    /**
     * Is this event observed in Israel/Diaspora?
     * @example
     * const ev1 = new Event(new HDate(7, 'Sivan', 5749), 'Shavuot II', flags.CHAG | flags.CHUL_ONLY);
     * ev1.observedIn(false); // true
     * ev1.observedIn(true); // false
     * const ev2 = new Event(new HDate(26, 'Kislev', 5749), 'Chanukah: 3 Candles', 0);
     * ev2.observedIn(false); // true
     * ev2.observedIn(true); // true
     * @param il
     */ observedIn(il) {
        return il ? this.observedInIsrael() : this.observedInDiaspora();
    }
    /**
     * Makes a clone of this Event object
     * @deprecated
     */ clone() {
        const ev = new $439631353957c387$export$d61e24a684f9e51(this.date, this.desc, this.mask);
        // overwrite all enumerable properties
        Object.assign(ev, this);
        return ev;
    }
    /**
     * Returns a list of event categories
     */ getCategories() {
        const mask = this.getFlags();
        for (const attrs of $439631353957c387$var$flagToCategory){
            const attr0 = attrs[0];
            if (mask & attr0) return attrs.slice(1);
        }
        return [
            'unknown'
        ];
    }
}



/** Daily Hebrew date ("11th of Sivan, 5780") */ class $c280aa2ce5054669$export$8b3ae31ab70ccff2 extends (0, $439631353957c387$export$d61e24a684f9e51) {
    /**
     * @param date
     */ constructor(date){
        super(date, date.toString(), (0, $439631353957c387$export$ceac1d294cf61000).HEBREW_DATE);
    }
    /**
     * @param [locale] Optional locale name (defaults to active locale).
     * @example
     * import {HDate, HebrewDateEvent, months} from '@hebcal/core';
     *
     * const hd = new HDate(15, months.CHESHVAN, 5769);
     * const ev = new HebrewDateEvent(hd);
     * console.log(ev.render('en')); // '15th of Cheshvan, 5769'
     * console.log(ev.render('he')); // 'ט״ו חֶשְׁוָן תשס״ט'
     */ render(locale) {
        const locale1 = locale === null || locale === undefined ? undefined : locale.toLowerCase();
        const locale0 = locale1 !== null && locale1 !== undefined ? locale1 : (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).getLocaleName();
        const hd = this.getDate();
        switch(locale0){
            case 'h':
            case 'he':
                return hd.renderGematriya(false);
            case 'he-x-nonikud':
                return hd.renderGematriya(true);
            default:
                return hd.render(locale0, true);
        }
    }
    /**
     * @private
     * @param locale
     */ renderBriefHebrew(locale) {
        const hd = this.getDate();
        const dd = hd.getDate();
        const mm = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext(hd.getMonthName(), locale);
        return (0, $b799e27e1258db2f$export$426b794b832b1254)(dd) + ' ' + mm;
    }
    /**
     * @param [locale] Optional locale name (defaults to active locale).
     * @example
     * import {HDate, HebrewDateEvent, months} from '@hebcal/core';
     *
     * const hd = new HDate(15, months.CHESHVAN, 5769);
     * const ev = new HebrewDateEvent(hd);
     * console.log(ev.renderBrief()); // '15th of Cheshvan'
     * console.log(ev.renderBrief('he')); // 'ט״ו חֶשְׁוָן'
     */ renderBrief(locale) {
        const locale1 = locale === null || locale === undefined ? undefined : locale.toLowerCase();
        const locale0 = locale1 !== null && locale1 !== undefined ? locale1 : (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).getLocaleName();
        const hd = this.getDate();
        if (hd.getMonth() === (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TISHREI && hd.getDate() === 1) return this.render(locale0);
        switch(locale0){
            case 'h':
            case 'he':
            case 'he-x-nonikud':
                return this.renderBriefHebrew(locale0);
            default:
                return hd.render(locale0, false);
        }
    }
}



!function() {
    "use strict";
    function clampProp(props, propName, min, max, overflow) {
        return clampEntity(propName, getDefinedProp(props, propName), min, max, overflow);
    }
    function clampEntity(entityName, num, min, max, overflow, choices) {
        const clamped = clampNumber(num, min, max);
        if (overflow && num !== clamped) throw new RangeError(numberOutOfRange(entityName, num, min, max, choices));
        return clamped;
    }
    function getDefinedProp(props, propName) {
        const propVal = props[propName];
        if (void 0 === propVal) throw new TypeError(missingField(propName));
        return propVal;
    }
    function isObjectLike(arg) {
        return null !== arg && /object|function/.test(typeof arg);
    }
    function memoize(generator, MapClass = Map) {
        const map = new MapClass;
        return (key, ...otherArgs)=>{
            if (map.has(key)) return map.get(key);
            const val = generator(key, ...otherArgs);
            return map.set(key, val), val;
        };
    }
    function createNameDescriptors(name) {
        return createPropDescriptors({
            name: name
        }, 1);
    }
    function createPropDescriptors(propVals, readonly) {
        return mapProps((value)=>({
                value: value,
                configurable: 1,
                writable: !readonly
            }), propVals);
    }
    function createGetterDescriptors(getters) {
        return mapProps((getter)=>({
                get: getter,
                configurable: 1
            }), getters);
    }
    function createStringTagDescriptors(value) {
        return {
            [Symbol.toStringTag]: {
                value: value,
                configurable: 1
            }
        };
    }
    function zipProps(propNamesRev, args) {
        const res = {};
        let i = propNamesRev.length;
        for (const arg of args)res[propNamesRev[--i]] = arg;
        return res;
    }
    function mapProps(transformer, props, extraArg) {
        const res = {};
        for(const propName in props)res[propName] = transformer(props[propName], propName, extraArg);
        return res;
    }
    function mapPropNames(generator, propNames, extraArg) {
        const props = {};
        for(let i = 0; i < propNames.length; i++){
            const propName = propNames[i];
            props[propName] = generator(propName, i, extraArg);
        }
        return props;
    }
    function pluckProps(propNames, props) {
        const res = {};
        for (const propName of propNames)res[propName] = props[propName];
        return res;
    }
    function excludePropsByName(propNames, props) {
        const filteredProps = {};
        for(const propName in props)propNames.has(propName) || (filteredProps[propName] = props[propName]);
        return filteredProps;
    }
    function excludeUndefinedProps(props) {
        props = {
            ...props
        };
        const propNames = Object.keys(props);
        for (const propName of propNames)void 0 === props[propName] && delete props[propName];
        return props;
    }
    function allPropsEqual(propNames, props0, props1) {
        for (const propName of propNames){
            if (props0[propName] !== props1[propName]) return 0;
        }
        return 1;
    }
    function zeroOutProps(propNames, clearUntilI, props) {
        const copy = {
            ...props
        };
        for(let i = 0; i < clearUntilI; i++)copy[propNames[i]] = 0;
        return copy;
    }
    function bindArgs(f, ...boundArgs) {
        return (...dynamicArgs)=>f(...boundArgs, ...dynamicArgs);
    }
    function capitalize(s) {
        return s[0].toUpperCase() + s.substring(1);
    }
    function sortStrings(strs) {
        return strs.slice().sort();
    }
    function padNumber(digits, num) {
        return String(num).padStart(digits, "0");
    }
    function compareNumbers(a, b) {
        return Math.sign(a - b);
    }
    function clampNumber(num, min, max) {
        return Math.min(Math.max(num, min), max);
    }
    function divModFloor(num, divisor) {
        return [
            Math.floor(num / divisor),
            modFloor(num, divisor)
        ];
    }
    function modFloor(num, divisor) {
        return (num % divisor + divisor) % divisor;
    }
    function divModTrunc(num, divisor) {
        return [
            divTrunc(num, divisor),
            modTrunc(num, divisor)
        ];
    }
    function divTrunc(num, divisor) {
        return Math.trunc(num / divisor) || 0;
    }
    function modTrunc(num, divisor) {
        return num % divisor || 0;
    }
    function hasHalf(num) {
        return .5 === Math.abs(num % 1);
    }
    function givenFieldsToBigNano(fields, largestUnit, fieldNames) {
        let timeNano = 0, days = 0;
        for(let unit = 0; unit <= largestUnit; unit++){
            const fieldVal = fields[fieldNames[unit]], unitNano = unitNanoMap[unit], unitInDay = nanoInUtcDay / unitNano, [unitDays, leftoverUnits] = divModTrunc(fieldVal, unitInDay);
            timeNano += leftoverUnits * unitNano, days += unitDays;
        }
        const [timeDays, leftoverNano] = divModTrunc(timeNano, nanoInUtcDay);
        return [
            days + timeDays,
            leftoverNano
        ];
    }
    function nanoToGivenFields(nano, largestUnit, fieldNames) {
        const fields = {};
        for(let unit = largestUnit; unit >= 0; unit--){
            const divisor = unitNanoMap[unit];
            fields[fieldNames[unit]] = divTrunc(nano, divisor), nano = modTrunc(nano, divisor);
        }
        return fields;
    }
    function createBigNano(days, timeNano) {
        let [extraDays, newTimeNano] = divModTrunc(timeNano, nanoInUtcDay), newDays = days + extraDays;
        const newDaysSign = Math.sign(newDays);
        return newDaysSign && newDaysSign === -Math.sign(newTimeNano) && (newDays -= newDaysSign, newTimeNano += newDaysSign * nanoInUtcDay), [
            newDays,
            newTimeNano
        ];
    }
    function addBigNanos(a, b, sign = 1) {
        return createBigNano(a[0] + b[0] * sign, a[1] + b[1] * sign);
    }
    function moveBigNano(a, b) {
        return createBigNano(a[0], a[1] + b);
    }
    function diffBigNanos(a, b) {
        return addBigNanos(b, a, -1);
    }
    function compareBigNanos(a, b) {
        return compareNumbers(a[0], b[0]) || compareNumbers(a[1], b[1]);
    }
    function bigNanoOutside(subject, rangeStart, rangeEndExcl) {
        return -1 === compareBigNanos(subject, rangeStart) || 1 === compareBigNanos(subject, rangeEndExcl);
    }
    function bigIntToBigNano(num, multiplierNano = 1) {
        const wholeInDay = BigInt(nanoInUtcDay / multiplierNano);
        return [
            Number(num / wholeInDay),
            Number(num % wholeInDay) * multiplierNano
        ];
    }
    function numberToBigNano(num, multiplierNano = 1) {
        const wholeInDay = nanoInUtcDay / multiplierNano, [days, remainder] = divModTrunc(num, wholeInDay);
        return [
            days,
            remainder * multiplierNano
        ];
    }
    function bigNanoToBigInt(bigNano, divisorNano = 1) {
        const [days, timeNano] = bigNano, whole = Math.floor(timeNano / divisorNano), wholeInDay = nanoInUtcDay / divisorNano;
        return BigInt(days) * BigInt(wholeInDay) + BigInt(whole);
    }
    function bigNanoToNumber(bigNano, divisorNano = 1, exact) {
        const [days, timeNano] = bigNano, [whole, remainderNano] = divModTrunc(timeNano, divisorNano);
        return days * (nanoInUtcDay / divisorNano) + (whole + (exact ? remainderNano / divisorNano : 0));
    }
    function divModBigNano(bigNano, divisorNano, divModFunc = divModFloor) {
        const [days, timeNano] = bigNano, [whole, remainderNano] = divModFunc(timeNano, divisorNano);
        return [
            days * (nanoInUtcDay / divisorNano) + whole,
            remainderNano
        ];
    }
    function requireIntegerOrUndefined(input) {
        if (void 0 !== input) return requireInteger(input);
    }
    function requirePositiveInteger(arg) {
        return requireNumberIsPositive(requireInteger(arg));
    }
    function requireInteger(arg) {
        return requireNumberIsInteger(requireNumber(arg));
    }
    function requireNonNullish(o) {
        if (null == o) throw new TypeError("Cannot be null or undefined");
        return o;
    }
    function requirePropDefined(optionName, optionVal) {
        if (null == optionVal) throw new RangeError(missingField(optionName));
        return optionVal;
    }
    function requireObjectLike(arg) {
        if (!isObjectLike(arg)) throw new TypeError(invalidObject);
        return arg;
    }
    function requireType(typeName, arg, entityName = typeName) {
        if (typeof arg !== typeName) throw new TypeError(invalidEntity(entityName, arg));
        return arg;
    }
    function requireNumberIsInteger(num, entityName = "number") {
        if (!Number.isInteger(num)) throw new RangeError(expectedInteger(entityName, num));
        return num || 0;
    }
    function requireNumberIsPositive(num, entityName = "number") {
        if (num <= 0) throw new RangeError(expectedPositive(entityName, num));
        return num;
    }
    function toString(arg) {
        if ("symbol" == typeof arg) throw new TypeError(forbiddenSymbolToString);
        return String(arg);
    }
    function toStringViaPrimitive(arg, entityName) {
        return isObjectLike(arg) ? String(arg) : requireString(arg, entityName);
    }
    function toBigInt(bi) {
        if ("string" == typeof bi) return BigInt(bi);
        if ("bigint" != typeof bi) throw new TypeError(invalidBigInt(bi));
        return bi;
    }
    function toNumber(arg, entityName = "number") {
        if ("bigint" == typeof arg) throw new TypeError(forbiddenBigIntToNumber(entityName));
        if (arg = Number(arg), !Number.isFinite(arg)) throw new RangeError(expectedFinite(entityName, arg));
        return arg;
    }
    function toInteger(arg, entityName) {
        return Math.trunc(toNumber(arg, entityName)) || 0;
    }
    function toStrictInteger(arg, entityName) {
        return requireNumberIsInteger(toNumber(arg, entityName), entityName);
    }
    function toPositiveInteger(arg, entityName) {
        return requireNumberIsPositive(toInteger(arg, entityName), entityName);
    }
    function hashIntlFormatParts(intlFormat, epochMilliseconds) {
        const parts = intlFormat.formatToParts(epochMilliseconds), hash = {};
        for (const part of parts)hash[part.type] = part.value;
        return hash;
    }
    function checkIsoYearMonthInBounds(isoFields) {
        return clampProp(isoFields, "isoYear", isoYearMin, isoYearMax, 1), isoFields.isoYear === isoYearMin ? clampProp(isoFields, "isoMonth", 4, 12, 1) : isoFields.isoYear === isoYearMax && clampProp(isoFields, "isoMonth", 1, 9, 1), isoFields;
    }
    function checkIsoDateInBounds(isoFields) {
        return checkIsoDateTimeInBounds({
            ...isoFields,
            ...isoTimeFieldDefaults,
            isoHour: 12
        }), isoFields;
    }
    function checkIsoDateTimeInBounds(isoFields) {
        const isoYear = clampProp(isoFields, "isoYear", isoYearMin, isoYearMax, 1), nudge = isoYear === isoYearMin ? 1 : isoYear === isoYearMax ? -1 : 0;
        return nudge && checkEpochNanoInBounds(isoToEpochNano({
            ...isoFields,
            isoDay: isoFields.isoDay + nudge,
            isoNanosecond: isoFields.isoNanosecond - nudge
        })), isoFields;
    }
    function checkEpochNanoInBounds(epochNano) {
        if (!epochNano || bigNanoOutside(epochNano, epochNanoMin, epochNanoMax)) throw new RangeError(outOfBoundsDate);
        return epochNano;
    }
    function isoTimeFieldsToNano(isoTimeFields) {
        return givenFieldsToBigNano(isoTimeFields, 5, isoTimeFieldNamesAsc)[1];
    }
    function nanoToIsoTimeAndDay(nano) {
        const [dayDelta, timeNano] = divModFloor(nano, nanoInUtcDay);
        return [
            nanoToGivenFields(timeNano, 5, isoTimeFieldNamesAsc),
            dayDelta
        ];
    }
    function epochNanoToSec(epochNano) {
        return epochNanoToSecMod(epochNano)[0];
    }
    function epochNanoToSecMod(epochNano) {
        return divModBigNano(epochNano, nanoInSec);
    }
    function isoToEpochMilli(isoDateTimeFields) {
        return isoArgsToEpochMilli(isoDateTimeFields.isoYear, isoDateTimeFields.isoMonth, isoDateTimeFields.isoDay, isoDateTimeFields.isoHour, isoDateTimeFields.isoMinute, isoDateTimeFields.isoSecond, isoDateTimeFields.isoMillisecond);
    }
    function isoToEpochNano(isoFields) {
        const epochMilli = isoToEpochMilli(isoFields);
        if (void 0 !== epochMilli) {
            const [days, milliRemainder] = divModTrunc(epochMilli, milliInDay);
            return [
                days,
                milliRemainder * nanoInMilli + (isoFields.isoMicrosecond || 0) * nanoInMicro + (isoFields.isoNanosecond || 0)
            ];
        }
    }
    function isoToEpochNanoWithOffset(isoFields, offsetNano) {
        const [newIsoTimeFields, dayDelta] = nanoToIsoTimeAndDay(isoTimeFieldsToNano(isoFields) - offsetNano);
        return checkEpochNanoInBounds(isoToEpochNano({
            ...isoFields,
            isoDay: isoFields.isoDay + dayDelta,
            ...newIsoTimeFields
        }));
    }
    function isoArgsToEpochSec(...args) {
        return isoArgsToEpochMilli(...args) / milliInSec;
    }
    function isoArgsToEpochMilli(...args) {
        const [legacyDate, daysNudged] = isoToLegacyDate(...args), epochMilli = legacyDate.valueOf();
        if (!isNaN(epochMilli)) return epochMilli - daysNudged * milliInDay;
    }
    function isoToLegacyDate(isoYear, isoMonth = 1, isoDay = 1, isoHour = 0, isoMinute = 0, isoSec = 0, isoMilli = 0) {
        const daysNudged = isoYear === isoYearMin ? 1 : isoYear === isoYearMax ? -1 : 0, legacyDate = new Date;
        return legacyDate.setUTCHours(isoHour, isoMinute, isoSec, isoMilli), legacyDate.setUTCFullYear(isoYear, isoMonth - 1, isoDay + daysNudged), [
            legacyDate,
            daysNudged
        ];
    }
    function epochNanoToIso(epochNano, offsetNano) {
        let [days, timeNano] = moveBigNano(epochNano, offsetNano);
        timeNano < 0 && (timeNano += nanoInUtcDay, days -= 1);
        const [timeMilli, nanoRemainder] = divModFloor(timeNano, nanoInMilli), [isoMicrosecond, isoNanosecond] = divModFloor(nanoRemainder, nanoInMicro);
        return epochMilliToIso(days * milliInDay + timeMilli, isoMicrosecond, isoNanosecond);
    }
    function epochMilliToIso(epochMilli, isoMicrosecond = 0, isoNanosecond = 0) {
        const daysOver = Math.ceil(Math.max(0, Math.abs(epochMilli) - maxMilli) / milliInDay) * Math.sign(epochMilli), legacyDate = new Date(epochMilli - daysOver * milliInDay);
        return zipProps(isoDateTimeFieldNamesAsc, [
            legacyDate.getUTCFullYear(),
            legacyDate.getUTCMonth() + 1,
            legacyDate.getUTCDate() + daysOver,
            legacyDate.getUTCHours(),
            legacyDate.getUTCMinutes(),
            legacyDate.getUTCSeconds(),
            legacyDate.getUTCMilliseconds(),
            isoMicrosecond,
            isoNanosecond
        ]);
    }
    function computeIsoDateParts(isoFields) {
        return [
            isoFields.isoYear,
            isoFields.isoMonth,
            isoFields.isoDay
        ];
    }
    function computeIsoMonthsInYear() {
        return isoMonthsInYear;
    }
    function computeIsoDaysInMonth(isoYear, isoMonth) {
        switch(isoMonth){
            case 2:
                return computeIsoInLeapYear(isoYear) ? 29 : 28;
            case 4:
            case 6:
            case 9:
            case 11:
                return 30;
        }
        return 31;
    }
    function computeIsoDaysInYear(isoYear) {
        return computeIsoInLeapYear(isoYear) ? 366 : 365;
    }
    function computeIsoInLeapYear(isoYear) {
        return isoYear % 4 == 0 && (isoYear % 100 != 0 || isoYear % 400 == 0);
    }
    function computeIsoDayOfWeek(isoDateFields) {
        const [legacyDate, daysNudged] = isoToLegacyDate(isoDateFields.isoYear, isoDateFields.isoMonth, isoDateFields.isoDay);
        return modFloor(legacyDate.getUTCDay() - daysNudged, 7) || 7;
    }
    function computeGregoryEraParts({ isoYear: isoYear }) {
        return isoYear < 1 ? [
            "bce",
            1 - isoYear
        ] : [
            "ce",
            isoYear
        ];
    }
    function checkIsoDateTimeFields(isoDateTimeFields) {
        return checkIsoDateFields(isoDateTimeFields), constrainIsoTimeFields(isoDateTimeFields, 1), isoDateTimeFields;
    }
    function checkIsoDateFields(isoInternals) {
        return constrainIsoDateFields(isoInternals, 1), isoInternals;
    }
    function isIsoDateFieldsValid(isoFields) {
        return allPropsEqual(isoDateFieldNamesAsc, isoFields, constrainIsoDateFields(isoFields));
    }
    function constrainIsoDateFields(isoFields, overflow) {
        const { isoYear: isoYear } = isoFields, isoMonth = clampProp(isoFields, "isoMonth", 1, computeIsoMonthsInYear(), overflow);
        return {
            isoYear: isoYear,
            isoMonth: isoMonth,
            isoDay: clampProp(isoFields, "isoDay", 1, computeIsoDaysInMonth(isoYear, isoMonth), overflow)
        };
    }
    function constrainIsoTimeFields(isoTimeFields, overflow) {
        return zipProps(isoTimeFieldNamesAsc, [
            clampProp(isoTimeFields, "isoHour", 0, 23, overflow),
            clampProp(isoTimeFields, "isoMinute", 0, 59, overflow),
            clampProp(isoTimeFields, "isoSecond", 0, 59, overflow),
            clampProp(isoTimeFields, "isoMillisecond", 0, 999, overflow),
            clampProp(isoTimeFields, "isoMicrosecond", 0, 999, overflow),
            clampProp(isoTimeFields, "isoNanosecond", 0, 999, overflow)
        ]);
    }
    function createIntlFieldCache(epochMilliToIntlFields) {
        return memoize((isoDateFields)=>{
            const epochMilli = isoToEpochMilli(isoDateFields);
            return epochMilliToIntlFields(epochMilli);
        }, WeakMap);
    }
    function createIntlYearDataCache(epochMilliToIntlFields) {
        const yearCorrection = epochMilliToIntlFields(0).year - isoEpochOriginYear;
        return memoize((year)=>{
            let intlFields, epochMilli = isoArgsToEpochMilli(year - yearCorrection);
            const millisReversed = [], monthStringsReversed = [];
            do epochMilli += 400 * milliInDay;
            while ((intlFields = epochMilliToIntlFields(epochMilli)).year <= year);
            do epochMilli += (1 - intlFields.day) * milliInDay, intlFields.year === year && (millisReversed.push(epochMilli), monthStringsReversed.push(intlFields.monthString)), epochMilli -= milliInDay;
            while ((intlFields = epochMilliToIntlFields(epochMilli)).year >= year);
            return {
                monthEpochMillis: millisReversed.reverse(),
                monthStringToIndex: mapPropNamesToIndex(monthStringsReversed.reverse())
            };
        });
    }
    function parseIntlYear(intlParts, calendarIdBase) {
        let era, eraYear, year = parseIntlPartsYear(intlParts);
        if (intlParts.era) {
            const eraOrigins = eraOriginsByCalendarId[calendarIdBase];
            void 0 !== eraOrigins && (era = "islamic" === calendarIdBase ? "ah" : intlParts.era.normalize("NFD").toLowerCase().replace(/[^a-z0-9]/g, ""), "bc" === era || "b" === era ? era = "bce" : "ad" !== era && "a" !== era || (era = "ce"), eraYear = year, year = eraYearToYear(eraYear, eraOrigins[era] || 0));
        }
        return {
            era: era,
            eraYear: eraYear,
            year: year
        };
    }
    function parseIntlPartsYear(intlParts) {
        return parseInt(intlParts.relatedYear || intlParts.year);
    }
    function computeIntlDateParts(isoFields) {
        const { year: year, monthString: monthString, day: day } = this.queryFields(isoFields), { monthStringToIndex: monthStringToIndex } = this.queryYearData(year);
        return [
            year,
            monthStringToIndex[monthString] + 1,
            day
        ];
    }
    function computeIntlEpochMilli(year, month = 1, day = 1) {
        return this.queryYearData(year).monthEpochMillis[month - 1] + (day - 1) * milliInDay;
    }
    function computeIntlLeapMonth(year) {
        const currentMonthStrings = queryMonthStrings(this, year), prevMonthStrings = queryMonthStrings(this, year - 1), currentLength = currentMonthStrings.length;
        if (currentLength > prevMonthStrings.length) {
            const leapMonthMeta = getCalendarLeapMonthMeta(this);
            if (leapMonthMeta < 0) return -leapMonthMeta;
            for(let i = 0; i < currentLength; i++){
                if (currentMonthStrings[i] !== prevMonthStrings[i]) return i + 1;
            }
        }
    }
    function computeIntlDaysInYear(year) {
        return diffEpochMilliByDay(computeIntlEpochMilli.call(this, year), computeIntlEpochMilli.call(this, year + 1));
    }
    function computeIntlDaysInMonth(year, month) {
        const { monthEpochMillis: monthEpochMillis } = this.queryYearData(year);
        let nextMonth = month + 1, nextMonthEpochMilli = monthEpochMillis;
        return nextMonth > monthEpochMillis.length && (nextMonth = 1, nextMonthEpochMilli = this.queryYearData(year + 1).monthEpochMillis), diffEpochMilliByDay(monthEpochMillis[month - 1], nextMonthEpochMilli[nextMonth - 1]);
    }
    function computeIntlMonthsInYear(year) {
        return this.queryYearData(year).monthEpochMillis.length;
    }
    function queryMonthStrings(intlCalendar, year) {
        return Object.keys(intlCalendar.queryYearData(year).monthStringToIndex);
    }
    function resolveCalendarId(id) {
        if ((id = id.toLowerCase()) !== isoCalendarId && id !== gregoryCalendarId && computeCalendarIdBase(id) !== computeCalendarIdBase(queryCalendarIntlFormat(id).resolvedOptions().calendar)) throw new RangeError(invalidCalendar(id));
        return id;
    }
    function computeCalendarIdBase(id) {
        return "islamicc" === id && (id = "islamic"), id.split("-")[0];
    }
    function computeNativeWeekOfYear(isoFields) {
        return this.weekParts(isoFields)[0];
    }
    function computeNativeYearOfWeek(isoFields) {
        return this.weekParts(isoFields)[1];
    }
    function computeNativeDayOfYear(isoFields) {
        const [year] = this.dateParts(isoFields);
        return diffEpochMilliByDay(this.epochMilli(year), isoToEpochMilli(isoFields)) + 1;
    }
    function parseMonthCode(monthCode) {
        const m = monthCodeRegExp.exec(monthCode);
        if (!m) throw new RangeError(invalidMonthCode(monthCode));
        return [
            parseInt(m[1]),
            Boolean(m[2])
        ];
    }
    function monthCodeNumberToMonth(monthCodeNumber, isLeapMonth, leapMonth) {
        return monthCodeNumber + (isLeapMonth || leapMonth && monthCodeNumber >= leapMonth ? 1 : 0);
    }
    function monthToMonthCodeNumber(month, leapMonth) {
        return month - (leapMonth && month >= leapMonth ? 1 : 0);
    }
    function eraYearToYear(eraYear, eraOrigin) {
        return (eraOrigin + eraYear) * (Math.sign(eraOrigin) || 1) || 0;
    }
    function getCalendarEraOrigins(native) {
        return eraOriginsByCalendarId[getCalendarIdBase(native)];
    }
    function getCalendarLeapMonthMeta(native) {
        return leapMonthMetas[getCalendarIdBase(native)];
    }
    function getCalendarIdBase(native) {
        return computeCalendarIdBase(native.id || isoCalendarId);
    }
    function refineOverflowOptions(options) {
        return void 0 === options ? 0 : refineOverflow(requireObjectLike(options));
    }
    function refineZonedFieldOptions(options, defaultOffsetDisambig = 0) {
        options = normalizeOptions(options);
        const epochDisambig = refineEpochDisambig(options), offsetDisambig = refineOffsetDisambig(options, defaultOffsetDisambig);
        return [
            refineOverflow(options),
            offsetDisambig,
            epochDisambig
        ];
    }
    function refineEpochDisambigOptions(options) {
        return refineEpochDisambig(normalizeOptions(options));
    }
    function refineDiffOptions(roundingModeInvert, options, defaultLargestUnit, maxUnit = 9, minUnit = 0, defaultRoundingMode = 4) {
        options = normalizeOptions(options);
        let largestUnit = refineLargestUnit(options, maxUnit, minUnit), roundingInc = parseRoundingIncInteger(options), roundingMode = refineRoundingMode(options, defaultRoundingMode);
        const smallestUnit = refineSmallestUnit(options, maxUnit, minUnit, 1);
        return null == largestUnit ? largestUnit = Math.max(defaultLargestUnit, smallestUnit) : checkLargestSmallestUnit(largestUnit, smallestUnit), roundingInc = refineRoundingInc(roundingInc, smallestUnit, 1), roundingModeInvert && (roundingMode = ((roundingMode)=>roundingMode < 4 ? (roundingMode + 2) % 4 : roundingMode)(roundingMode)), [
            largestUnit,
            smallestUnit,
            roundingInc,
            roundingMode
        ];
    }
    function refineRoundingOptions(options, maxUnit = 6, solarMode) {
        let roundingInc = parseRoundingIncInteger(options = normalizeOptionsOrString(options, smallestUnitStr));
        const roundingMode = refineRoundingMode(options, 7);
        let smallestUnit = refineSmallestUnit(options, maxUnit);
        return smallestUnit = requirePropDefined(smallestUnitStr, smallestUnit), roundingInc = refineRoundingInc(roundingInc, smallestUnit, void 0, solarMode), [
            smallestUnit,
            roundingInc,
            roundingMode
        ];
    }
    function refineDateDisplayOptions(options) {
        return refineCalendarDisplay(normalizeOptions(options));
    }
    function refineTimeDisplayOptions(options, maxSmallestUnit) {
        return refineTimeDisplayTuple(normalizeOptions(options), maxSmallestUnit);
    }
    function refineTimeDisplayTuple(options, maxSmallestUnit = 4) {
        const subsecDigits = refineSubsecDigits(options);
        return [
            refineRoundingMode(options, 4),
            ...refineSmallestUnitAndSubsecDigits(refineSmallestUnit(options, maxSmallestUnit), subsecDigits)
        ];
    }
    function refineSmallestUnitAndSubsecDigits(smallestUnit, subsecDigits) {
        return null != smallestUnit ? [
            unitNanoMap[smallestUnit],
            smallestUnit < 4 ? 9 - 3 * smallestUnit : -1
        ] : [
            void 0 === subsecDigits ? 1 : 10 ** (9 - subsecDigits),
            subsecDigits
        ];
    }
    function parseRoundingIncInteger(options) {
        const roundingInc = options[roundingIncName];
        return void 0 === roundingInc ? 1 : toInteger(roundingInc, roundingIncName);
    }
    function refineRoundingInc(roundingInc, smallestUnit, allowManyLargeUnits, solarMode) {
        const upUnitNano = solarMode ? nanoInUtcDay : unitNanoMap[smallestUnit + 1];
        if (upUnitNano) {
            const unitNano = unitNanoMap[smallestUnit];
            if (upUnitNano % ((roundingInc = clampEntity(roundingIncName, roundingInc, 1, upUnitNano / unitNano - (solarMode ? 0 : 1), 1)) * unitNano)) throw new RangeError(invalidEntity(roundingIncName, roundingInc));
        } else roundingInc = clampEntity(roundingIncName, roundingInc, 1, allowManyLargeUnits ? 10 ** 9 : 1, 1);
        return roundingInc;
    }
    function refineSubsecDigits(options) {
        let subsecDigits = options[subsecDigitsName];
        if (void 0 !== subsecDigits) {
            if ("number" != typeof subsecDigits) {
                if ("auto" === toString(subsecDigits)) return;
                throw new RangeError(invalidEntity(subsecDigitsName, subsecDigits));
            }
            subsecDigits = clampEntity(subsecDigitsName, Math.floor(subsecDigits), 0, 9, 1);
        }
        return subsecDigits;
    }
    function normalizeOptions(options) {
        return void 0 === options ? {} : requireObjectLike(options);
    }
    function normalizeOptionsOrString(options, optionName) {
        return "string" == typeof options ? {
            [optionName]: options
        } : requireObjectLike(options);
    }
    function copyOptions(options) {
        if (void 0 !== options) {
            if (isObjectLike(options)) return Object.assign(Object.create(null), options);
            throw new TypeError(invalidObject);
        }
    }
    function overrideOverflowOptions(options, overflow) {
        return options && Object.assign(Object.create(null), options, {
            overflow: overflowMapNames[overflow]
        });
    }
    function refineUnitOption(optionName, options, maxUnit = 9, minUnit = 0, ensureDefined) {
        let unitStr = options[optionName];
        if (void 0 === unitStr) return ensureDefined ? minUnit : void 0;
        if (unitStr = toString(unitStr), "auto" === unitStr) return ensureDefined ? minUnit : null;
        let unit = unitNameMap[unitStr];
        if (void 0 === unit && (unit = durationFieldIndexes[unitStr]), void 0 === unit) throw new RangeError(invalidChoice(optionName, unitStr, unitNameMap));
        return clampEntity(optionName, unit, minUnit, maxUnit, 1, unitNamesAsc), unit;
    }
    function refineChoiceOption(optionName, enumNameMap, options, defaultChoice = 0) {
        const enumArg = options[optionName];
        if (void 0 === enumArg) return defaultChoice;
        const enumStr = toString(enumArg), enumNum = enumNameMap[enumStr];
        if (void 0 === enumNum) throw new RangeError(invalidChoice(optionName, enumStr, enumNameMap));
        return enumNum;
    }
    function checkLargestSmallestUnit(largestUnit, smallestUnit) {
        if (smallestUnit > largestUnit) throw new RangeError(flippedSmallestLargestUnit);
    }
    function createInstantSlots(epochNano) {
        return {
            branding: InstantBranding,
            epochNanoseconds: epochNano
        };
    }
    function createZonedDateTimeSlots(epochNano, timeZone, calendar) {
        return {
            branding: ZonedDateTimeBranding,
            calendar: calendar,
            timeZone: timeZone,
            epochNanoseconds: epochNano
        };
    }
    function createPlainDateTimeSlots(isoFields, calendar = isoFields.calendar) {
        return {
            branding: PlainDateTimeBranding,
            calendar: calendar,
            ...pluckProps(isoDateTimeFieldNamesAlpha, isoFields)
        };
    }
    function createPlainDateSlots(isoFields, calendar = isoFields.calendar) {
        return {
            branding: PlainDateBranding,
            calendar: calendar,
            ...pluckProps(isoDateFieldNamesAlpha, isoFields)
        };
    }
    function createPlainYearMonthSlots(isoFields, calendar = isoFields.calendar) {
        return {
            branding: PlainYearMonthBranding,
            calendar: calendar,
            ...pluckProps(isoDateFieldNamesAlpha, isoFields)
        };
    }
    function createPlainMonthDaySlots(isoFields, calendar = isoFields.calendar) {
        return {
            branding: PlainMonthDayBranding,
            calendar: calendar,
            ...pluckProps(isoDateFieldNamesAlpha, isoFields)
        };
    }
    function createPlainTimeSlots(isoFields) {
        return {
            branding: PlainTimeBranding,
            ...pluckProps(isoTimeFieldNamesAlpha, isoFields)
        };
    }
    function createDurationSlots(durationFields) {
        return {
            branding: DurationBranding,
            sign: computeDurationSign(durationFields),
            ...pluckProps(durationFieldNamesAlpha, durationFields)
        };
    }
    function getEpochMilli(slots) {
        return divModBigNano(slots.epochNanoseconds, nanoInMilli)[0];
    }
    function extractEpochNano(slots) {
        return slots.epochNanoseconds;
    }
    function getId(idLike) {
        return "string" == typeof idLike ? idLike : requireString(idLike.id);
    }
    function isIdLikeEqual(idLike0, idLike1) {
        return idLike0 === idLike1 || getId(idLike0) === getId(idLike1);
    }
    function totalDayTimeDuration(durationFields, totalUnit) {
        return bigNanoToNumber(durationFieldsToBigNano(durationFields), unitNanoMap[totalUnit], 1);
    }
    function clampRelativeDuration(calendarOps, durationFields, clampUnit, clampDistance, marker, markerToEpochNano, moveMarker) {
        const unitName = durationFieldNamesAsc[clampUnit], durationPlusDistance = {
            ...durationFields,
            [unitName]: durationFields[unitName] + clampDistance
        }, marker0 = moveMarker(calendarOps, marker, durationFields), marker1 = moveMarker(calendarOps, marker, durationPlusDistance);
        return [
            markerToEpochNano(marker0),
            markerToEpochNano(marker1)
        ];
    }
    function computeEpochNanoFrac(epochNanoProgress, epochNano0, epochNano1) {
        const denom = bigNanoToNumber(diffBigNanos(epochNano0, epochNano1));
        if (!denom) throw new RangeError(invalidProtocolResults);
        return bigNanoToNumber(diffBigNanos(epochNano0, epochNanoProgress)) / denom;
    }
    function roundDateTime(isoFields, smallestUnit, roundingInc, roundingMode) {
        return roundDateTimeToNano(isoFields, computeNanoInc(smallestUnit, roundingInc), roundingMode);
    }
    function roundDateTimeToNano(isoFields, nanoInc, roundingMode) {
        const [roundedIsoFields, dayDelta] = roundTimeToNano(isoFields, nanoInc, roundingMode);
        return checkIsoDateTimeInBounds({
            ...moveByDays(isoFields, dayDelta),
            ...roundedIsoFields
        });
    }
    function roundTimeToNano(isoFields, nanoInc, roundingMode) {
        return nanoToIsoTimeAndDay(roundByInc(isoTimeFieldsToNano(isoFields), nanoInc, roundingMode));
    }
    function roundToMinute(offsetNano) {
        return roundByInc(offsetNano, nanoInMinute, 7);
    }
    function computeNanoInc(smallestUnit, roundingInc) {
        return unitNanoMap[smallestUnit] * roundingInc;
    }
    function computeDayInterval(isoFields) {
        const isoFields0 = computeDayFloor(isoFields);
        return [
            isoFields0,
            moveByDays(isoFields0, 1)
        ];
    }
    function computeDayFloor(isoFields) {
        return clearIsoFields(6, isoFields);
    }
    function roundDayTimeDurationByInc(durationFields, nanoInc, roundingMode) {
        const maxUnit = Math.min(getMaxDurationUnit(durationFields), 6);
        return nanoToDurationDayTimeFields(roundBigNanoByInc(durationFieldsToBigNano(durationFields, maxUnit), nanoInc, roundingMode), maxUnit);
    }
    function roundRelativeDuration(durationFields, endEpochNano, largestUnit, smallestUnit, roundingInc, roundingMode, calendarOps, marker, markerToEpochNano, moveMarker) {
        if (0 === smallestUnit && 1 === roundingInc) return durationFields;
        const nudgeFunc = isUniformUnit(smallestUnit, marker) ? isZonedEpochSlots(marker) && smallestUnit < 6 && largestUnit >= 6 ? nudgeZonedTimeDuration : nudgeDayTimeDuration : nudgeRelativeDuration;
        let [roundedDurationFields, roundedEpochNano, grewBigUnit] = nudgeFunc(durationFields, endEpochNano, largestUnit, smallestUnit, roundingInc, roundingMode, calendarOps, marker, markerToEpochNano, moveMarker);
        return grewBigUnit && 7 !== smallestUnit && (roundedDurationFields = ((durationFields, endEpochNano, largestUnit, smallestUnit, calendarOps, marker, markerToEpochNano, moveMarker)=>{
            const sign = computeDurationSign(durationFields);
            for(let currentUnit = smallestUnit + 1; currentUnit <= largestUnit; currentUnit++){
                if (7 === currentUnit && 7 !== largestUnit) continue;
                const baseDurationFields = clearDurationFields(currentUnit, durationFields);
                baseDurationFields[durationFieldNamesAsc[currentUnit]] += sign;
                const beyondThresholdNano = bigNanoToNumber(diffBigNanos(markerToEpochNano(moveMarker(calendarOps, marker, baseDurationFields)), endEpochNano));
                if (beyondThresholdNano && Math.sign(beyondThresholdNano) !== sign) break;
                durationFields = baseDurationFields;
            }
            return durationFields;
        })(roundedDurationFields, roundedEpochNano, largestUnit, Math.max(6, smallestUnit), calendarOps, marker, markerToEpochNano, moveMarker)), roundedDurationFields;
    }
    function roundBigNano(bigNano, smallestUnit, roundingInc, roundingMode, useDayOrigin) {
        if (6 === smallestUnit) {
            const daysExact = ((bigNano)=>bigNano[0] + bigNano[1] / nanoInUtcDay)(bigNano);
            return [
                roundByInc(daysExact, roundingInc, roundingMode),
                0
            ];
        }
        return roundBigNanoByInc(bigNano, computeNanoInc(smallestUnit, roundingInc), roundingMode, useDayOrigin);
    }
    function roundBigNanoByInc(bigNano, nanoInc, roundingMode, useDayOrigin) {
        let [days, timeNano] = bigNano;
        useDayOrigin && timeNano < 0 && (timeNano += nanoInUtcDay, days -= 1);
        const [dayDelta, roundedTimeNano] = divModFloor(roundByInc(timeNano, nanoInc, roundingMode), nanoInUtcDay);
        return createBigNano(days + dayDelta, roundedTimeNano);
    }
    function roundByInc(num, inc, roundingMode) {
        return roundWithMode(num / inc, roundingMode) * inc;
    }
    function roundWithMode(num, roundingMode) {
        return roundingModeFuncs[roundingMode](num);
    }
    function nudgeDayTimeDuration(durationFields, endEpochNano, largestUnit, smallestUnit, roundingInc, roundingMode) {
        const sign = computeDurationSign(durationFields), bigNano = durationFieldsToBigNano(durationFields), roundedBigNano = roundBigNano(bigNano, smallestUnit, roundingInc, roundingMode), nanoDiff = diffBigNanos(bigNano, roundedBigNano), expandedBigUnit = Math.sign(roundedBigNano[0] - bigNano[0]) === sign, roundedDayTimeFields = nanoToDurationDayTimeFields(roundedBigNano, Math.min(largestUnit, 6));
        return [
            {
                ...durationFields,
                ...roundedDayTimeFields
            },
            addBigNanos(endEpochNano, nanoDiff),
            expandedBigUnit
        ];
    }
    function nudgeZonedTimeDuration(durationFields, endEpochNano, _largestUnit, smallestUnit, roundingInc, roundingMode, calendarOps, marker, markerToEpochNano, moveMarker) {
        const sign = computeDurationSign(durationFields), timeNano = bigNanoToNumber(durationFieldsToBigNano(durationFields, 5)), nanoInc = computeNanoInc(smallestUnit, roundingInc);
        let roundedTimeNano = roundByInc(timeNano, nanoInc, roundingMode);
        const [dayEpochNano0, dayEpochNano1] = clampRelativeDuration(calendarOps, {
            ...durationFields,
            ...durationTimeFieldDefaults
        }, 6, sign, marker, markerToEpochNano, moveMarker), beyondDayNano = roundedTimeNano - bigNanoToNumber(diffBigNanos(dayEpochNano0, dayEpochNano1));
        let dayDelta = 0;
        beyondDayNano && Math.sign(beyondDayNano) !== sign ? endEpochNano = moveBigNano(dayEpochNano0, roundedTimeNano) : (dayDelta += sign, roundedTimeNano = roundByInc(beyondDayNano, nanoInc, roundingMode), endEpochNano = moveBigNano(dayEpochNano1, roundedTimeNano));
        const durationTimeFields = nanoToDurationTimeFields(roundedTimeNano);
        return [
            {
                ...durationFields,
                ...durationTimeFields,
                days: durationFields.days + dayDelta
            },
            endEpochNano,
            Boolean(dayDelta)
        ];
    }
    function nudgeRelativeDuration(durationFields, endEpochNano, _largestUnit, smallestUnit, roundingInc, roundingMode, calendarOps, marker, markerToEpochNano, moveMarker) {
        const sign = computeDurationSign(durationFields), smallestUnitFieldName = durationFieldNamesAsc[smallestUnit], baseDurationFields = clearDurationFields(smallestUnit, durationFields);
        7 === smallestUnit && (durationFields = {
            ...durationFields,
            weeks: durationFields.weeks + Math.trunc(durationFields.days / 7)
        });
        const truncedVal = divTrunc(durationFields[smallestUnitFieldName], roundingInc) * roundingInc;
        baseDurationFields[smallestUnitFieldName] = truncedVal;
        const [epochNano0, epochNano1] = clampRelativeDuration(calendarOps, baseDurationFields, smallestUnit, roundingInc * sign, marker, markerToEpochNano, moveMarker), exactVal = truncedVal + computeEpochNanoFrac(endEpochNano, epochNano0, epochNano1) * sign * roundingInc, roundedVal = roundByInc(exactVal, roundingInc, roundingMode), expanded = Math.sign(roundedVal - exactVal) === sign;
        return baseDurationFields[smallestUnitFieldName] = roundedVal, [
            baseDurationFields,
            expanded ? epochNano1 : epochNano0,
            expanded
        ];
    }
    function formatInstantIso(refineTimeZoneArg, getTimeZoneOps, instantSlots, options) {
        const [timeZoneArg, roundingMode, nanoInc, subsecDigits] = ((options)=>{
            const timeDisplayTuple = refineTimeDisplayTuple(options = normalizeOptions(options));
            return [
                options.timeZone,
                ...timeDisplayTuple
            ];
        })(options), providedTimeZone = void 0 !== timeZoneArg;
        return ((providedTimeZone, timeZoneOps, epochNano, roundingMode, nanoInc, subsecDigits)=>{
            epochNano = roundBigNanoByInc(epochNano, nanoInc, roundingMode, 1);
            const offsetNano = timeZoneOps.getOffsetNanosecondsFor(epochNano);
            return formatIsoDateTimeFields(epochNanoToIso(epochNano, offsetNano), subsecDigits) + (providedTimeZone ? formatOffsetNano(roundToMinute(offsetNano)) : "Z");
        })(providedTimeZone, getTimeZoneOps(providedTimeZone ? refineTimeZoneArg(timeZoneArg) : utcTimeZoneId), instantSlots.epochNanoseconds, roundingMode, nanoInc, subsecDigits);
    }
    function formatZonedDateTimeIso(getTimeZoneOps, zonedDateTimeSlots0, options) {
        const [a, b, c, d, e, f] = ((options)=>{
            options = normalizeOptions(options);
            const calendarDisplay = refineCalendarDisplay(options), subsecDigits = refineSubsecDigits(options), offsetDisplay = refineOffsetDisplay(options), roundingMode = refineRoundingMode(options, 4), smallestUnit = refineSmallestUnit(options, 4);
            return [
                calendarDisplay,
                refineTimeZoneDisplay(options),
                offsetDisplay,
                roundingMode,
                ...refineSmallestUnitAndSubsecDigits(smallestUnit, subsecDigits)
            ];
        })(options);
        return ((getTimeZoneOps, calendarSlot, timeZoneSlot, epochNano, calendarDisplay, timeZoneDisplay, offsetDisplay, roundingMode, nanoInc, subsecDigits)=>{
            epochNano = roundBigNanoByInc(epochNano, nanoInc, roundingMode, 1);
            const offsetNano = getTimeZoneOps(timeZoneSlot).getOffsetNanosecondsFor(epochNano);
            return formatIsoDateTimeFields(epochNanoToIso(epochNano, offsetNano), subsecDigits) + formatOffsetNano(roundToMinute(offsetNano), offsetDisplay) + ((timeZoneNative, timeZoneDisplay)=>1 !== timeZoneDisplay ? "[" + (2 === timeZoneDisplay ? "!" : "") + getId(timeZoneNative) + "]" : "")(timeZoneSlot, timeZoneDisplay) + formatCalendar(calendarSlot, calendarDisplay);
        })(getTimeZoneOps, zonedDateTimeSlots0.calendar, zonedDateTimeSlots0.timeZone, zonedDateTimeSlots0.epochNanoseconds, a, b, c, d, e, f);
    }
    function formatPlainDateTimeIso(plainDateTimeSlots0, options) {
        const [a, b, c, d] = ((options)=>(options = normalizeOptions(options), [
                refineCalendarDisplay(options),
                ...refineTimeDisplayTuple(options)
            ]))(options);
        var calendarIdLike, calendarDisplay, subsecDigits;
        return calendarIdLike = plainDateTimeSlots0.calendar, calendarDisplay = a, subsecDigits = d, formatIsoDateTimeFields(roundDateTimeToNano(plainDateTimeSlots0, c, b), subsecDigits) + formatCalendar(calendarIdLike, calendarDisplay);
    }
    function formatPlainDateIso(plainDateSlots, options) {
        var calendarIdLike, isoFields, calendarDisplay;
        return calendarIdLike = plainDateSlots.calendar, isoFields = plainDateSlots, calendarDisplay = refineDateDisplayOptions(options), formatIsoDateFields(isoFields) + formatCalendar(calendarIdLike, calendarDisplay);
    }
    function formatPlainYearMonthIso(plainYearMonthSlots, options) {
        return formatDateLikeIso(plainYearMonthSlots.calendar, formatIsoYearMonthFields, plainYearMonthSlots, refineDateDisplayOptions(options));
    }
    function formatPlainMonthDayIso(plainMonthDaySlots, options) {
        return formatDateLikeIso(plainMonthDaySlots.calendar, formatIsoMonthDayFields, plainMonthDaySlots, refineDateDisplayOptions(options));
    }
    function formatPlainTimeIso(slots, options) {
        const [a, b, c] = refineTimeDisplayOptions(options);
        var subsecDigits;
        return subsecDigits = c, formatIsoTimeFields(roundTimeToNano(slots, b, a)[0], subsecDigits);
    }
    function formatDurationIso(slots, options) {
        const [roundingMode, nanoInc, subsecDigits] = refineTimeDisplayOptions(options, 3);
        return nanoInc > 1 && (slots = {
            ...slots,
            ...roundDayTimeDurationByInc(slots, nanoInc, roundingMode)
        }), ((durationSlots, subsecDigits)=>{
            const { sign: sign } = durationSlots, abs = -1 === sign ? negateDurationFields(durationSlots) : durationSlots, { hours: hours, minutes: minutes } = abs, [wholeSec, subsecNano] = divModBigNano(durationFieldsToBigNano(abs, 3), nanoInSec, divModTrunc);
            checkDurationTimeUnit(wholeSec);
            const subsecNanoString = formatSubsecNano(subsecNano, subsecDigits), forceSec = subsecDigits >= 0 || !sign || subsecNanoString;
            return (sign < 0 ? "-" : "") + "P" + formatDurationFragments({
                Y: formatDurationNumber(abs.years),
                M: formatDurationNumber(abs.months),
                W: formatDurationNumber(abs.weeks),
                D: formatDurationNumber(abs.days)
            }) + (hours || minutes || wholeSec || forceSec ? "T" + formatDurationFragments({
                H: formatDurationNumber(hours),
                M: formatDurationNumber(minutes),
                S: formatDurationNumber(wholeSec, forceSec) + subsecNanoString
            }) : "");
        })(slots, subsecDigits);
    }
    function formatDateLikeIso(calendarIdLike, formatSimple, isoFields, calendarDisplay) {
        const calendarId = getId(calendarIdLike), showCalendar = calendarDisplay > 1 || 0 === calendarDisplay && calendarId !== isoCalendarId;
        return 1 === calendarDisplay ? calendarId === isoCalendarId ? formatSimple(isoFields) : formatIsoDateFields(isoFields) : showCalendar ? formatIsoDateFields(isoFields) + formatCalendarId(calendarId, 2 === calendarDisplay) : formatSimple(isoFields);
    }
    function formatDurationFragments(fragObj) {
        const parts = [];
        for(const fragName in fragObj){
            const fragVal = fragObj[fragName];
            fragVal && parts.push(fragVal, fragName);
        }
        return parts.join("");
    }
    function formatIsoDateTimeFields(isoDateTimeFields, subsecDigits) {
        return formatIsoDateFields(isoDateTimeFields) + "T" + formatIsoTimeFields(isoDateTimeFields, subsecDigits);
    }
    function formatIsoDateFields(isoDateFields) {
        return formatIsoYearMonthFields(isoDateFields) + "-" + padNumber2(isoDateFields.isoDay);
    }
    function formatIsoYearMonthFields(isoDateFields) {
        const { isoYear: isoYear } = isoDateFields;
        return (isoYear < 0 || isoYear > 9999 ? getSignStr(isoYear) + padNumber(6, Math.abs(isoYear)) : padNumber(4, isoYear)) + "-" + padNumber2(isoDateFields.isoMonth);
    }
    function formatIsoMonthDayFields(isoDateFields) {
        return padNumber2(isoDateFields.isoMonth) + "-" + padNumber2(isoDateFields.isoDay);
    }
    function formatIsoTimeFields(isoTimeFields, subsecDigits) {
        const parts = [
            padNumber2(isoTimeFields.isoHour),
            padNumber2(isoTimeFields.isoMinute)
        ];
        return -1 !== subsecDigits && parts.push(padNumber2(isoTimeFields.isoSecond) + ((isoMillisecond, isoMicrosecond, isoNanosecond, subsecDigits)=>formatSubsecNano(isoMillisecond * nanoInMilli + isoMicrosecond * nanoInMicro + isoNanosecond, subsecDigits))(isoTimeFields.isoMillisecond, isoTimeFields.isoMicrosecond, isoTimeFields.isoNanosecond, subsecDigits)), parts.join(":");
    }
    function formatOffsetNano(offsetNano, offsetDisplay = 0) {
        if (1 === offsetDisplay) return "";
        const [hour, nanoRemainder0] = divModFloor(Math.abs(offsetNano), nanoInHour), [minute, nanoRemainder1] = divModFloor(nanoRemainder0, nanoInMinute), [second, nanoRemainder2] = divModFloor(nanoRemainder1, nanoInSec);
        return getSignStr(offsetNano) + padNumber2(hour) + ":" + padNumber2(minute) + (second || nanoRemainder2 ? ":" + padNumber2(second) + formatSubsecNano(nanoRemainder2) : "");
    }
    function formatCalendar(calendarIdLike, calendarDisplay) {
        if (1 !== calendarDisplay) {
            const calendarId = getId(calendarIdLike);
            if (calendarDisplay > 1 || 0 === calendarDisplay && calendarId !== isoCalendarId) return formatCalendarId(calendarId, 2 === calendarDisplay);
        }
        return "";
    }
    function formatCalendarId(calendarId, isCritical) {
        return "[" + (isCritical ? "!" : "") + "u-ca=" + calendarId + "]";
    }
    function formatSubsecNano(totalNano, subsecDigits) {
        let s = padNumber(9, totalNano);
        return s = void 0 === subsecDigits ? s.replace(trailingZerosRE, "") : s.slice(0, subsecDigits), s ? "." + s : "";
    }
    function getSignStr(num) {
        return num < 0 ? "-" : "+";
    }
    function formatDurationNumber(n, force) {
        return n || force ? n.toLocaleString("fullwide", {
            useGrouping: 0
        }) : "";
    }
    function getMatchingInstantFor(timeZoneOps, isoFields, offsetNano, offsetDisambig = 0, epochDisambig = 0, epochFuzzy, hasZ) {
        if (void 0 !== offsetNano && 1 === offsetDisambig && (1 === offsetDisambig || hasZ)) return isoToEpochNanoWithOffset(isoFields, offsetNano);
        const possibleEpochNanos = timeZoneOps.getPossibleInstantsFor(isoFields);
        if (void 0 !== offsetNano && 3 !== offsetDisambig) {
            const matchingEpochNano = ((possibleEpochNanos, isoDateTimeFields, offsetNano, fuzzy)=>{
                const zonedEpochNano = isoToEpochNano(isoDateTimeFields);
                fuzzy && (offsetNano = roundToMinute(offsetNano));
                for (const possibleEpochNano of possibleEpochNanos){
                    let possibleOffsetNano = bigNanoToNumber(diffBigNanos(possibleEpochNano, zonedEpochNano));
                    if (fuzzy && (possibleOffsetNano = roundToMinute(possibleOffsetNano)), possibleOffsetNano === offsetNano) return possibleEpochNano;
                }
            })(possibleEpochNanos, isoFields, offsetNano, epochFuzzy);
            if (void 0 !== matchingEpochNano) return matchingEpochNano;
            if (0 === offsetDisambig) throw new RangeError(invalidOffsetForTimeZone);
        }
        return hasZ ? isoToEpochNano(isoFields) : getSingleInstantFor(timeZoneOps, isoFields, epochDisambig, possibleEpochNanos);
    }
    function getSingleInstantFor(timeZoneOps, isoFields, disambig = 0, possibleEpochNanos = timeZoneOps.getPossibleInstantsFor(isoFields)) {
        if (1 === possibleEpochNanos.length) return possibleEpochNanos[0];
        if (1 === disambig) throw new RangeError(ambigOffset);
        if (possibleEpochNanos.length) return possibleEpochNanos[3 === disambig ? 1 : 0];
        const zonedEpochNano = isoToEpochNano(isoFields), gapNano = ((timeZoneOps, zonedEpochNano)=>{
            const startOffsetNano = timeZoneOps.getOffsetNanosecondsFor(moveBigNano(zonedEpochNano, -nanoInUtcDay));
            return validateTimeZoneGap(timeZoneOps.getOffsetNanosecondsFor(moveBigNano(zonedEpochNano, nanoInUtcDay)) - startOffsetNano);
        })(timeZoneOps, zonedEpochNano), shiftNano = gapNano * (2 === disambig ? -1 : 1);
        return (possibleEpochNanos = timeZoneOps.getPossibleInstantsFor(epochNanoToIso(zonedEpochNano, shiftNano)))[2 === disambig ? 0 : possibleEpochNanos.length - 1];
    }
    function validateTimeZoneOffset(offsetNano) {
        if (Math.abs(offsetNano) >= nanoInUtcDay) throw new RangeError(outOfBoundsOffset);
        return offsetNano;
    }
    function validateTimeZoneGap(gapNano) {
        if (gapNano > nanoInUtcDay) throw new RangeError(outOfBoundsDstGap);
        return gapNano;
    }
    function moveInstant(doSubtract, instantSlots, durationSlots) {
        return createInstantSlots(checkEpochNanoInBounds(addBigNanos(instantSlots.epochNanoseconds, ((fields)=>{
            if (durationHasDateParts(fields)) throw new RangeError(invalidLargeUnits);
            return durationFieldsToBigNano(fields, 5);
        })(doSubtract ? negateDurationFields(durationSlots) : durationSlots))));
    }
    function moveZonedDateTime(getCalendarOps, getTimeZoneOps, doSubtract, zonedDateTimeSlots, durationSlots, options = Object.create(null)) {
        const timeZoneOps = getTimeZoneOps(zonedDateTimeSlots.timeZone), calendarOps = getCalendarOps(zonedDateTimeSlots.calendar);
        return {
            ...zonedDateTimeSlots,
            ...moveZonedEpochs(timeZoneOps, calendarOps, zonedDateTimeSlots, doSubtract ? negateDurationFields(durationSlots) : durationSlots, options)
        };
    }
    function movePlainDateTime(getCalendarOps, doSubtract, plainDateTimeSlots, durationSlots, options = Object.create(null)) {
        const { calendar: calendar } = plainDateTimeSlots;
        return createPlainDateTimeSlots(moveDateTime(getCalendarOps(calendar), plainDateTimeSlots, doSubtract ? negateDurationFields(durationSlots) : durationSlots, options), calendar);
    }
    function movePlainDate(getCalendarOps, doSubtract, plainDateSlots, durationSlots, options) {
        const { calendar: calendar } = plainDateSlots;
        return createPlainDateSlots(moveDate(getCalendarOps(calendar), plainDateSlots, doSubtract ? negateDurationFields(durationSlots) : durationSlots, options), calendar);
    }
    function movePlainYearMonth(getCalendarOps, doSubtract, plainYearMonthSlots, durationSlots, options = Object.create(null)) {
        const calendarSlot = plainYearMonthSlots.calendar, calendarOps = getCalendarOps(calendarSlot);
        let isoDateFields = moveToDayOfMonthUnsafe(calendarOps, plainYearMonthSlots);
        doSubtract && (durationSlots = negateDuration(durationSlots)), durationSlots.sign < 0 && (isoDateFields = calendarOps.dateAdd(isoDateFields, {
            ...durationFieldDefaults,
            months: 1
        }), isoDateFields = moveByDays(isoDateFields, -1));
        const movedIsoDateFields = calendarOps.dateAdd(isoDateFields, durationSlots, options);
        return createPlainYearMonthSlots(moveToDayOfMonthUnsafe(calendarOps, movedIsoDateFields), calendarSlot);
    }
    function movePlainTime(doSubtract, slots, durationSlots) {
        return createPlainTimeSlots(moveTime(slots, doSubtract ? negateDurationFields(durationSlots) : durationSlots)[0]);
    }
    function moveZonedEpochs(timeZoneOps, calendarOps, slots, durationFields, options) {
        const timeOnlyNano = durationFieldsToBigNano(durationFields, 5);
        let epochNano = slots.epochNanoseconds;
        if (durationHasDateParts(durationFields)) {
            const isoDateTimeFields = zonedEpochSlotsToIso(slots, timeZoneOps);
            epochNano = addBigNanos(getSingleInstantFor(timeZoneOps, {
                ...moveDate(calendarOps, isoDateTimeFields, {
                    ...durationFields,
                    ...durationTimeFieldDefaults
                }, options),
                ...pluckProps(isoTimeFieldNamesAsc, isoDateTimeFields)
            }), timeOnlyNano);
        } else epochNano = addBigNanos(epochNano, timeOnlyNano), refineOverflowOptions(options);
        return {
            epochNanoseconds: checkEpochNanoInBounds(epochNano)
        };
    }
    function moveDateTime(calendarOps, isoDateTimeFields, durationFields, options) {
        const [movedIsoTimeFields, dayDelta] = moveTime(isoDateTimeFields, durationFields);
        return checkIsoDateTimeInBounds({
            ...moveDate(calendarOps, isoDateTimeFields, {
                ...durationFields,
                ...durationTimeFieldDefaults,
                days: durationFields.days + dayDelta
            }, options),
            ...movedIsoTimeFields
        });
    }
    function moveDate(calendarOps, isoDateFields, durationFields, options) {
        if (durationFields.years || durationFields.months || durationFields.weeks) return calendarOps.dateAdd(isoDateFields, durationFields, options);
        refineOverflowOptions(options);
        const days = durationFields.days + durationFieldsToBigNano(durationFields, 5)[0];
        return days ? checkIsoDateInBounds(moveByDays(isoDateFields, days)) : isoDateFields;
    }
    function moveToDayOfMonthUnsafe(calendarOps, isoFields, dayOfMonth = 1) {
        return moveByDays(isoFields, dayOfMonth - calendarOps.day(isoFields));
    }
    function moveTime(isoFields, durationFields) {
        const [durDays, durTimeNano] = durationFieldsToBigNano(durationFields, 5), [newIsoFields, overflowDays] = nanoToIsoTimeAndDay(isoTimeFieldsToNano(isoFields) + durTimeNano);
        return [
            newIsoFields,
            durDays + overflowDays
        ];
    }
    function moveByDays(isoFields, days) {
        return days ? {
            ...isoFields,
            ...epochMilliToIso(isoToEpochMilli(isoFields) + days * milliInDay)
        } : isoFields;
    }
    function diffInstants(invert, instantSlots0, instantSlots1, options) {
        const optionsTuple = refineDiffOptions(invert, copyOptions(options), 3, 5), durationFields = diffEpochNanos(instantSlots0.epochNanoseconds, instantSlots1.epochNanoseconds, ...optionsTuple);
        return createDurationSlots(invert ? negateDurationFields(durationFields) : durationFields);
    }
    function diffZonedDateTimes(getCalendarOps, getTimeZoneOps, invert, slots0, slots1, options) {
        const calendarSlot = getCommonCalendarSlot(slots0.calendar, slots1.calendar), optionsCopy = copyOptions(options), [largestUnit, smallestUnit, roundingInc, roundingMode] = refineDiffOptions(invert, optionsCopy, 5), epochNano0 = slots0.epochNanoseconds, epochNano1 = slots1.epochNanoseconds, sign = compareBigNanos(epochNano1, epochNano0);
        let durationFields;
        if (sign) {
            if (largestUnit < 6) durationFields = diffEpochNanos(epochNano0, epochNano1, largestUnit, smallestUnit, roundingInc, roundingMode);
            else {
                const timeZoneOps = getTimeZoneOps(((a, b)=>{
                    if (!isTimeZoneSlotsEqual(a, b)) throw new RangeError(mismatchingTimeZones);
                    return a;
                })(slots0.timeZone, slots1.timeZone)), calendarOps = getCalendarOps(calendarSlot);
                durationFields = diffZonedEpochsBig(calendarOps, timeZoneOps, slots0, slots1, sign, largestUnit, optionsCopy), durationFields = roundRelativeDuration(durationFields, epochNano1, largestUnit, smallestUnit, roundingInc, roundingMode, calendarOps, slots0, extractEpochNano, bindArgs(moveZonedEpochs, timeZoneOps));
            }
        } else durationFields = durationFieldDefaults;
        return createDurationSlots(invert ? negateDurationFields(durationFields) : durationFields);
    }
    function diffPlainDateTimes(getCalendarOps, invert, plainDateTimeSlots0, plainDateTimeSlots1, options) {
        const calendarSlot = getCommonCalendarSlot(plainDateTimeSlots0.calendar, plainDateTimeSlots1.calendar), optionsCopy = copyOptions(options), [largestUnit, smallestUnit, roundingInc, roundingMode] = refineDiffOptions(invert, optionsCopy, 6), startEpochNano = isoToEpochNano(plainDateTimeSlots0), endEpochNano = isoToEpochNano(plainDateTimeSlots1), sign = compareBigNanos(endEpochNano, startEpochNano);
        let durationFields;
        if (sign) {
            if (largestUnit <= 6) durationFields = diffEpochNanos(startEpochNano, endEpochNano, largestUnit, smallestUnit, roundingInc, roundingMode);
            else {
                const calendarOps = getCalendarOps(calendarSlot);
                durationFields = diffDateTimesBig(calendarOps, plainDateTimeSlots0, plainDateTimeSlots1, sign, largestUnit, optionsCopy), durationFields = roundRelativeDuration(durationFields, endEpochNano, largestUnit, smallestUnit, roundingInc, roundingMode, calendarOps, plainDateTimeSlots0, isoToEpochNano, moveDateTime);
            }
        } else durationFields = durationFieldDefaults;
        return createDurationSlots(invert ? negateDurationFields(durationFields) : durationFields);
    }
    function diffPlainDates(getCalendarOps, invert, plainDateSlots0, plainDateSlots1, options) {
        const calendarSlot = getCommonCalendarSlot(plainDateSlots0.calendar, plainDateSlots1.calendar), optionsCopy = copyOptions(options);
        return diffDateLike(invert, ()=>getCalendarOps(calendarSlot), plainDateSlots0, plainDateSlots1, ...refineDiffOptions(invert, optionsCopy, 6, 9, 6), optionsCopy);
    }
    function diffPlainYearMonth(getCalendarOps, invert, plainYearMonthSlots0, plainYearMonthSlots1, options) {
        const calendarSlot = getCommonCalendarSlot(plainYearMonthSlots0.calendar, plainYearMonthSlots1.calendar), optionsCopy = copyOptions(options), optionsTuple = refineDiffOptions(invert, optionsCopy, 9, 9, 8), calendarOps = getCalendarOps(calendarSlot);
        return diffDateLike(invert, ()=>calendarOps, moveToDayOfMonthUnsafe(calendarOps, plainYearMonthSlots0), moveToDayOfMonthUnsafe(calendarOps, plainYearMonthSlots1), ...optionsTuple, optionsCopy);
    }
    function diffDateLike(invert, getCalendarOps, startIsoFields, endIsoFields, largestUnit, smallestUnit, roundingInc, roundingMode, origOptions) {
        const startEpochNano = isoToEpochNano(startIsoFields), endEpochNano = isoToEpochNano(endIsoFields);
        let durationFields;
        if (compareBigNanos(endEpochNano, startEpochNano)) {
            if (6 === largestUnit) durationFields = diffEpochNanos(startEpochNano, endEpochNano, largestUnit, smallestUnit, roundingInc, roundingMode);
            else {
                const calendarOps = getCalendarOps();
                durationFields = calendarOps.dateUntil(startIsoFields, endIsoFields, largestUnit, origOptions), 6 === smallestUnit && 1 === roundingInc || (durationFields = roundRelativeDuration(durationFields, endEpochNano, largestUnit, smallestUnit, roundingInc, roundingMode, calendarOps, startIsoFields, isoToEpochNano, moveDate));
            }
        } else durationFields = durationFieldDefaults;
        return createDurationSlots(invert ? negateDurationFields(durationFields) : durationFields);
    }
    function diffPlainTimes(invert, plainTimeSlots0, plainTimeSlots1, options) {
        const optionsCopy = copyOptions(options), [largestUnit, smallestUnit, roundingInc, roundingMode] = refineDiffOptions(invert, optionsCopy, 5, 5), timeDiffNano = roundByInc(diffTimes(plainTimeSlots0, plainTimeSlots1), computeNanoInc(smallestUnit, roundingInc), roundingMode), durationFields = {
            ...durationFieldDefaults,
            ...nanoToDurationTimeFields(timeDiffNano, largestUnit)
        };
        return createDurationSlots(invert ? negateDurationFields(durationFields) : durationFields);
    }
    function diffZonedEpochsExact(timeZoneOps, calendarOps, slots0, slots1, largestUnit, origOptions) {
        const sign = compareBigNanos(slots1.epochNanoseconds, slots0.epochNanoseconds);
        return sign ? largestUnit < 6 ? diffEpochNanosExact(slots0.epochNanoseconds, slots1.epochNanoseconds, largestUnit) : diffZonedEpochsBig(calendarOps, timeZoneOps, slots0, slots1, sign, largestUnit, origOptions) : durationFieldDefaults;
    }
    function diffDateTimesExact(calendarOps, startIsoFields, endIsoFields, largestUnit, origOptions) {
        const startEpochNano = isoToEpochNano(startIsoFields), endEpochNano = isoToEpochNano(endIsoFields), sign = compareBigNanos(endEpochNano, startEpochNano);
        return sign ? largestUnit <= 6 ? diffEpochNanosExact(startEpochNano, endEpochNano, largestUnit) : diffDateTimesBig(calendarOps, startIsoFields, endIsoFields, sign, largestUnit, origOptions) : durationFieldDefaults;
    }
    function diffZonedEpochsBig(calendarOps, timeZoneOps, slots0, slots1, sign, largestUnit, origOptions) {
        const [isoFields0, isoFields1, remainderNano] = ((timeZoneOps, slots0, slots1, sign)=>{
            function updateMid() {
                return midIsoFields = {
                    ...moveByDays(endIsoFields, dayCorrection++ * -sign),
                    ...startIsoTimeFields
                }, midEpochNano = getSingleInstantFor(timeZoneOps, midIsoFields), compareBigNanos(endEpochNano, midEpochNano) === -sign;
            }
            const startIsoFields = zonedEpochSlotsToIso(slots0, timeZoneOps), startIsoTimeFields = pluckProps(isoTimeFieldNamesAsc, startIsoFields), endIsoFields = zonedEpochSlotsToIso(slots1, timeZoneOps), endEpochNano = slots1.epochNanoseconds;
            let dayCorrection = 0;
            const timeDiffNano = diffTimes(startIsoFields, endIsoFields);
            let midIsoFields, midEpochNano;
            if (Math.sign(timeDiffNano) === -sign && dayCorrection++, updateMid() && (-1 === sign || updateMid())) throw new RangeError(invalidProtocolResults);
            const remainderNano = bigNanoToNumber(diffBigNanos(midEpochNano, endEpochNano));
            return [
                startIsoFields,
                midIsoFields,
                remainderNano
            ];
        })(timeZoneOps, slots0, slots1, sign);
        var startIsoFields, endIsoFields;
        return {
            ...6 === largestUnit ? (startIsoFields = isoFields0, endIsoFields = isoFields1, {
                ...durationFieldDefaults,
                days: diffDays(startIsoFields, endIsoFields)
            }) : calendarOps.dateUntil(isoFields0, isoFields1, largestUnit, origOptions),
            ...nanoToDurationTimeFields(remainderNano)
        };
    }
    function diffDateTimesBig(calendarOps, startIsoFields, endIsoFields, sign, largestUnit, origOptions) {
        const [startIsoDate, endIsoDate, timeNano] = ((startIsoDateTime, endIsoDateTime, sign)=>{
            let endIsoDate = endIsoDateTime, timeDiffNano = diffTimes(startIsoDateTime, endIsoDateTime);
            return Math.sign(timeDiffNano) === -sign && (endIsoDate = moveByDays(endIsoDateTime, -sign), timeDiffNano += nanoInUtcDay * sign), [
                startIsoDateTime,
                endIsoDate,
                timeDiffNano
            ];
        })(startIsoFields, endIsoFields, sign);
        return {
            ...calendarOps.dateUntil(startIsoDate, endIsoDate, largestUnit, origOptions),
            ...nanoToDurationTimeFields(timeNano)
        };
    }
    function diffEpochNanos(startEpochNano, endEpochNano, largestUnit, smallestUnit, roundingInc, roundingMode) {
        return {
            ...durationFieldDefaults,
            ...nanoToDurationDayTimeFields(roundBigNano(diffBigNanos(startEpochNano, endEpochNano), smallestUnit, roundingInc, roundingMode), largestUnit)
        };
    }
    function diffEpochNanosExact(startEpochNano, endEpochNano, largestUnit) {
        return {
            ...durationFieldDefaults,
            ...nanoToDurationDayTimeFields(diffBigNanos(startEpochNano, endEpochNano), largestUnit)
        };
    }
    function diffDays(startIsoFields, endIsoFields) {
        return diffEpochMilliByDay(isoToEpochMilli(startIsoFields), isoToEpochMilli(endIsoFields));
    }
    function diffEpochMilliByDay(epochMilli0, epochMilli1) {
        return Math.trunc((epochMilli1 - epochMilli0) / milliInDay);
    }
    function diffTimes(isoTime0, isoTime1) {
        return isoTimeFieldsToNano(isoTime1) - isoTimeFieldsToNano(isoTime0);
    }
    function getCommonCalendarSlot(a, b) {
        if (!isIdLikeEqual(a, b)) throw new RangeError(mismatchingCalendars);
        return a;
    }
    function createMarkerSystem(getCalendarOps, getTimeZoneOps, relativeToSlots) {
        const calendarOps = getCalendarOps(relativeToSlots.calendar);
        return isZonedEpochSlots(relativeToSlots) ? [
            relativeToSlots,
            calendarOps,
            getTimeZoneOps(relativeToSlots.timeZone)
        ] : [
            {
                ...relativeToSlots,
                ...isoTimeFieldDefaults
            },
            calendarOps
        ];
    }
    function createMarkerToEpochNano(timeZoneOps) {
        return timeZoneOps ? extractEpochNano : isoToEpochNano;
    }
    function createMoveMarker(timeZoneOps) {
        return timeZoneOps ? bindArgs(moveZonedEpochs, timeZoneOps) : moveDateTime;
    }
    function createDiffMarkers(timeZoneOps) {
        return timeZoneOps ? bindArgs(diffZonedEpochsExact, timeZoneOps) : diffDateTimesExact;
    }
    function isZonedEpochSlots(marker) {
        return marker && marker.epochNanoseconds;
    }
    function isUniformUnit(unit, marker) {
        return unit <= 6 - (isZonedEpochSlots(marker) ? 1 : 0);
    }
    function addDurations(refineRelativeTo, getCalendarOps, getTimeZoneOps, doSubtract, slots, otherSlots, options) {
        const relativeToSlots = refineRelativeTo(normalizeOptions(options).relativeTo), maxUnit = Math.max(getMaxDurationUnit(slots), getMaxDurationUnit(otherSlots));
        if (isUniformUnit(maxUnit, relativeToSlots)) return createDurationSlots(checkDurationUnits(((a, b, largestUnit, doSubtract)=>{
            const combined = addBigNanos(durationFieldsToBigNano(a), durationFieldsToBigNano(b), doSubtract ? -1 : 1);
            if (!Number.isFinite(combined[0])) throw new RangeError(outOfBoundsDate);
            return {
                ...durationFieldDefaults,
                ...nanoToDurationDayTimeFields(combined, largestUnit)
            };
        })(slots, otherSlots, maxUnit, doSubtract)));
        if (!relativeToSlots) throw new RangeError("Missing relativeTo");
        doSubtract && (otherSlots = negateDurationFields(otherSlots));
        const [marker, calendarOps, timeZoneOps] = createMarkerSystem(getCalendarOps, getTimeZoneOps, relativeToSlots), moveMarker = createMoveMarker(timeZoneOps), diffMarkers = createDiffMarkers(timeZoneOps), midMarker = moveMarker(calendarOps, marker, slots);
        return createDurationSlots(diffMarkers(calendarOps, marker, moveMarker(calendarOps, midMarker, otherSlots), maxUnit));
    }
    function negateDuration(slots) {
        return createDurationSlots(negateDurationFields(slots));
    }
    function negateDurationFields(fields) {
        const res = {};
        for (const fieldName of durationFieldNamesAsc)res[fieldName] = -1 * fields[fieldName] || 0;
        return res;
    }
    function computeDurationSign(fields, fieldNames = durationFieldNamesAsc) {
        let sign = 0;
        for (const fieldName of fieldNames){
            const fieldSign = Math.sign(fields[fieldName]);
            if (fieldSign) {
                if (sign && sign !== fieldSign) throw new RangeError(forbiddenDurationSigns);
                sign = fieldSign;
            }
        }
        return sign;
    }
    function checkDurationUnits(fields) {
        for (const calendarUnit of durationCalendarFieldNamesAsc)clampEntity(calendarUnit, fields[calendarUnit], -maxCalendarUnit, maxCalendarUnit, 1);
        return checkDurationTimeUnit(bigNanoToNumber(durationFieldsToBigNano(fields), nanoInSec)), fields;
    }
    function checkDurationTimeUnit(n) {
        if (!Number.isSafeInteger(n)) throw new RangeError(outOfBoundsDuration);
    }
    function durationFieldsToBigNano(fields, largestUnit = 6) {
        return givenFieldsToBigNano(fields, largestUnit, durationFieldNamesAsc);
    }
    function nanoToDurationDayTimeFields(bigNano, largestUnit = 6) {
        const [days, timeNano] = bigNano, dayTimeFields = nanoToGivenFields(timeNano, largestUnit, durationFieldNamesAsc);
        if (dayTimeFields[durationFieldNamesAsc[largestUnit]] += days * (nanoInUtcDay / unitNanoMap[largestUnit]), !Number.isFinite(dayTimeFields[durationFieldNamesAsc[largestUnit]])) throw new RangeError(outOfBoundsDate);
        return dayTimeFields;
    }
    function nanoToDurationTimeFields(nano, largestUnit = 5) {
        return nanoToGivenFields(nano, largestUnit, durationFieldNamesAsc);
    }
    function durationHasDateParts(fields) {
        return Boolean(computeDurationSign(fields, durationDateFieldNamesAsc));
    }
    function getMaxDurationUnit(fields) {
        let unit = 9;
        for(; unit > 0 && !fields[durationFieldNamesAsc[unit]]; unit--);
        return unit;
    }
    function createSplitTuple(startEpochSec, endEpochSec) {
        return [
            startEpochSec,
            endEpochSec
        ];
    }
    function computePeriod(epochSec) {
        const startEpochSec = Math.floor(epochSec / periodDur) * periodDur;
        return [
            startEpochSec,
            startEpochSec + periodDur
        ];
    }
    function parseOffsetNano(s) {
        const offsetNano = parseOffsetNanoMaybe(s);
        if (void 0 === offsetNano) throw new RangeError(failedParse(s));
        return offsetNano;
    }
    function parsePlainDate(s) {
        const organized = parseDateTimeLike(requireString(s));
        if (!organized || organized.hasZ) throw new RangeError(failedParse(s));
        return createPlainDateSlots(organized.hasTime ? finalizeDateTime(organized) : finalizeDate(organized));
    }
    function requireIsoCalendar(organized) {
        if (organized.calendar !== isoCalendarId) throw new RangeError(invalidSubstring(organized.calendar));
    }
    function finalizeZonedDateTime(organized, offsetNano, offsetDisambig = 0, epochDisambig = 0) {
        const slotId = resolveTimeZoneId(organized.timeZone), timeZoneImpl = queryNativeTimeZone(slotId);
        return createZonedDateTimeSlots(getMatchingInstantFor(timeZoneImpl, checkIsoDateTimeFields(organized), offsetNano, offsetDisambig, epochDisambig, !timeZoneImpl.offsetNano, organized.hasZ), slotId, resolveCalendarId(organized.calendar));
    }
    function finalizeDateTime(organized) {
        return resolveSlotsCalendar(checkIsoDateTimeInBounds(checkIsoDateTimeFields(organized)));
    }
    function finalizeDate(organized) {
        return resolveSlotsCalendar(checkIsoDateInBounds(checkIsoDateFields(organized)));
    }
    function resolveSlotsCalendar(organized) {
        return {
            ...organized,
            calendar: resolveCalendarId(organized.calendar)
        };
    }
    function parseDateTimeLike(s) {
        const parts = dateTimeRegExp.exec(s);
        return parts ? ((parts)=>{
            const zOrOffset = parts[10], hasZ = "Z" === (zOrOffset || "").toUpperCase();
            return {
                isoYear: organizeIsoYearParts(parts),
                isoMonth: parseInt(parts[4]),
                isoDay: parseInt(parts[5]),
                ...organizeTimeParts(parts.slice(5)),
                ...organizeAnnotationParts(parts[16]),
                hasTime: Boolean(parts[6]),
                hasZ: hasZ,
                offset: hasZ ? void 0 : zOrOffset
            };
        })(parts) : void 0;
    }
    function parseYearMonthOnly(s) {
        const parts = yearMonthRegExp.exec(s);
        return parts ? ((parts)=>({
                isoYear: organizeIsoYearParts(parts),
                isoMonth: parseInt(parts[4]),
                isoDay: 1,
                ...organizeAnnotationParts(parts[5])
            }))(parts) : void 0;
    }
    function parseMonthDayOnly(s) {
        const parts = monthDayRegExp.exec(s);
        return parts ? ((parts)=>({
                isoYear: isoEpochFirstLeapYear,
                isoMonth: parseInt(parts[1]),
                isoDay: parseInt(parts[2]),
                ...organizeAnnotationParts(parts[3])
            }))(parts) : void 0;
    }
    function parseOffsetNanoMaybe(s, onlyHourMinute) {
        const parts = offsetRegExp.exec(s);
        return parts ? ((parts, onlyHourMinute)=>{
            const firstSubMinutePart = parts[4] || parts[5];
            if (onlyHourMinute && firstSubMinutePart) throw new RangeError(invalidSubstring(firstSubMinutePart));
            return validateTimeZoneOffset((parseInt0(parts[2]) * nanoInHour + parseInt0(parts[3]) * nanoInMinute + parseInt0(parts[4]) * nanoInSec + parseSubsecNano(parts[5] || "")) * parseSign(parts[1]));
        })(parts, onlyHourMinute) : void 0;
    }
    function organizeIsoYearParts(parts) {
        const yearSign = parseSign(parts[1]), year = parseInt(parts[2] || parts[3]);
        if (yearSign < 0 && !year) throw new RangeError(invalidSubstring(-0));
        return yearSign * year;
    }
    function organizeTimeParts(parts) {
        const isoSecond = parseInt0(parts[3]);
        return {
            ...nanoToIsoTimeAndDay(parseSubsecNano(parts[4] || ""))[0],
            isoHour: parseInt0(parts[1]),
            isoMinute: parseInt0(parts[2]),
            isoSecond: 60 === isoSecond ? 59 : isoSecond
        };
    }
    function organizeAnnotationParts(s) {
        let calendarIsCritical, timeZoneId;
        const calendarIds = [];
        if (s.replace(annotationRegExp, (whole, criticalStr, mainStr)=>{
            const isCritical = Boolean(criticalStr), [val, name] = mainStr.split("=").reverse();
            if (name) {
                if ("u-ca" === name) calendarIds.push(val), calendarIsCritical || (calendarIsCritical = isCritical);
                else if (isCritical || /[A-Z]/.test(name)) throw new RangeError(invalidSubstring(whole));
            } else {
                if (timeZoneId) throw new RangeError(invalidSubstring(whole));
                timeZoneId = val;
            }
            return "";
        }), calendarIds.length > 1 && calendarIsCritical) throw new RangeError(invalidSubstring(s));
        return {
            timeZone: timeZoneId,
            calendar: calendarIds[0] || isoCalendarId
        };
    }
    function parseSubsecNano(fracStr) {
        return parseInt(fracStr.padEnd(9, "0"));
    }
    function createRegExp(meat) {
        return new RegExp(`^${meat}$`, "i");
    }
    function parseSign(s) {
        return s && "+" !== s ? -1 : 1;
    }
    function parseInt0(s) {
        return void 0 === s ? 0 : parseInt(s);
    }
    function resolveTimeZoneId(id) {
        const essence = getTimeZoneEssence(id);
        return "number" == typeof essence ? formatOffsetNano(essence) : essence ? ((id)=>{
            if (icuRegExp.test(id)) throw new RangeError(forbiddenIcuTimeZone);
            return id.toLowerCase().split("/").map((part, partI)=>(part.length <= 3 || /\d/.test(part)) && !/etc|yap/.test(part) ? part.toUpperCase() : part.replace(/baja|dumont|[a-z]+/g, (a, i)=>a.length <= 2 && !partI || "in" === a || "chat" === a ? a.toUpperCase() : a.length > 2 || !i ? capitalize(a).replace(/island|noronha|murdo|rivadavia|urville/, capitalize) : a)).join("/");
        })(id) : utcTimeZoneId;
    }
    function getTimeZoneAtomic(id) {
        const essence = getTimeZoneEssence(id);
        return "number" == typeof essence ? essence : essence ? essence.resolvedOptions().timeZone : utcTimeZoneId;
    }
    function getTimeZoneEssence(id) {
        const offsetNano = parseOffsetNanoMaybe(id = id.toUpperCase(), 1);
        return void 0 !== offsetNano ? offsetNano : id !== utcTimeZoneId ? queryTimeZoneIntlFormat(id) : void 0;
    }
    function compareInstants(instantSlots0, instantSlots1) {
        return compareBigNanos(instantSlots0.epochNanoseconds, instantSlots1.epochNanoseconds);
    }
    function compareZonedDateTimes(zonedDateTimeSlots0, zonedDateTimeSlots1) {
        return compareBigNanos(zonedDateTimeSlots0.epochNanoseconds, zonedDateTimeSlots1.epochNanoseconds);
    }
    function compareIsoDateTimeFields(isoFields0, isoFields1) {
        return compareIsoDateFields(isoFields0, isoFields1) || compareIsoTimeFields(isoFields0, isoFields1);
    }
    function compareIsoDateFields(isoFields0, isoFields1) {
        return compareNumbers(isoToEpochMilli(isoFields0), isoToEpochMilli(isoFields1));
    }
    function compareIsoTimeFields(isoFields0, isoFields1) {
        return compareNumbers(isoTimeFieldsToNano(isoFields0), isoTimeFieldsToNano(isoFields1));
    }
    function isTimeZoneSlotsEqual(a, b) {
        if (a === b) return 1;
        const aId = getId(a), bId = getId(b);
        if (aId === bId) return 1;
        try {
            return getTimeZoneAtomic(aId) === getTimeZoneAtomic(bId);
        } catch (_a) {}
    }
    function refinePlainDateBag(calendarOps, bag, options, requireFields = []) {
        const fields = refineCalendarFields(calendarOps, bag, dateFieldNamesAlpha, requireFields);
        return calendarOps.dateFromFields(fields, options);
    }
    function refinePlainYearMonthBag(calendarOps, bag, options, requireFields) {
        const fields = refineCalendarFields(calendarOps, bag, yearMonthFieldNames, requireFields);
        return calendarOps.yearMonthFromFields(fields, options);
    }
    function refinePlainMonthDayBag(calendarOps, calendarAbsent, bag, options, requireFields = []) {
        const fields = refineCalendarFields(calendarOps, bag, dateFieldNamesAlpha, requireFields);
        return calendarAbsent && void 0 !== fields.month && void 0 === fields.monthCode && void 0 === fields.year && (fields.year = isoEpochFirstLeapYear), calendarOps.monthDayFromFields(fields, options);
    }
    function refineCalendarFields(calendarOps, bag, validFieldNames, requiredFieldNames = [], forcedValidFieldNames = []) {
        return refineFields(bag, [
            ...calendarOps.fields(validFieldNames),
            ...forcedValidFieldNames
        ].sort(), requiredFieldNames);
    }
    function refineFields(bag, validFieldNames, requiredFieldNames, disallowEmpty = !requiredFieldNames) {
        const res = {};
        let prevFieldName, anyMatching = 0;
        for (const fieldName of validFieldNames){
            if (fieldName === prevFieldName) throw new RangeError(duplicateFields(fieldName));
            if ("constructor" === fieldName || "__proto__" === fieldName) throw new RangeError(forbiddenField(fieldName));
            let fieldVal = bag[fieldName];
            if (void 0 !== fieldVal) anyMatching = 1, builtinRefiners[fieldName] && (fieldVal = builtinRefiners[fieldName](fieldVal, fieldName)), res[fieldName] = fieldVal;
            else if (requiredFieldNames) {
                if (requiredFieldNames.includes(fieldName)) throw new TypeError(missingField(fieldName));
                res[fieldName] = timeFieldDefaults[fieldName];
            }
            prevFieldName = fieldName;
        }
        if (disallowEmpty && !anyMatching) throw new TypeError(noValidFields(validFieldNames));
        return res;
    }
    function refineTimeBag(fields, overflow) {
        return constrainIsoTimeFields(timeFieldsToIso({
            ...timeFieldDefaults,
            ...fields
        }), overflow);
    }
    function mergeCalendarFields(calendarOps, obj, bag, validFieldNames, forcedValidFieldNames = [], requiredObjFieldNames = []) {
        const fieldNames = [
            ...calendarOps.fields(validFieldNames),
            ...forcedValidFieldNames
        ].sort();
        let fields = refineFields(obj, fieldNames, requiredObjFieldNames);
        const partialFields = refineFields(bag, fieldNames);
        return fields = calendarOps.mergeFields(fields, partialFields), refineFields(fields, fieldNames, []);
    }
    function convertToPlainMonthDay(calendarOps, input) {
        const fields = refineCalendarFields(calendarOps, input, monthCodeDayFieldNames);
        return calendarOps.monthDayFromFields(fields);
    }
    function convertToPlainYearMonth(calendarOps, input, options) {
        const fields = refineCalendarFields(calendarOps, input, yearMonthCodeFieldNames);
        return calendarOps.yearMonthFromFields(fields, options);
    }
    function convertToIso(calendarOps, input, inputFieldNames, extra, extraFieldNames) {
        input = pluckProps(inputFieldNames = calendarOps.fields(inputFieldNames), input), extra = refineFields(extra, extraFieldNames = calendarOps.fields(extraFieldNames), []);
        let mergedFields = calendarOps.mergeFields(input, extra);
        return mergedFields = refineFields(mergedFields, [
            ...inputFieldNames,
            ...extraFieldNames
        ].sort(), []), calendarOps.dateFromFields(mergedFields);
    }
    function refineYear(calendarNative, fields) {
        let { era: era, eraYear: eraYear, year: year } = fields;
        const eraOrigins = getCalendarEraOrigins(calendarNative);
        if (void 0 !== era || void 0 !== eraYear) {
            if (void 0 === era || void 0 === eraYear) throw new TypeError(mismatchingEraParts);
            if (!eraOrigins) throw new RangeError(forbiddenEraParts);
            const eraOrigin = eraOrigins[era];
            if (void 0 === eraOrigin) throw new RangeError(invalidEra(era));
            const yearByEra = eraYearToYear(eraYear, eraOrigin);
            if (void 0 !== year && year !== yearByEra) throw new RangeError(mismatchingYearAndEra);
            year = yearByEra;
        } else if (void 0 === year) throw new TypeError(missingYear(eraOrigins));
        return year;
    }
    function refineMonth(calendarNative, fields, year, overflow) {
        let { month: month, monthCode: monthCode } = fields;
        if (void 0 !== monthCode) {
            const monthByCode = ((calendarNative, monthCode, year, overflow)=>{
                const leapMonth = calendarNative.leapMonth(year), [monthCodeNumber, wantsLeapMonth] = parseMonthCode(monthCode);
                let month = monthCodeNumberToMonth(monthCodeNumber, wantsLeapMonth, leapMonth);
                if (wantsLeapMonth) {
                    const leapMonthMeta = getCalendarLeapMonthMeta(calendarNative);
                    if (void 0 === leapMonthMeta) throw new RangeError(invalidLeapMonth);
                    if (leapMonthMeta > 0) {
                        if (month > leapMonthMeta) throw new RangeError(invalidLeapMonth);
                        if (void 0 === leapMonth) {
                            if (1 === overflow) throw new RangeError(invalidLeapMonth);
                            month--;
                        }
                    } else {
                        if (month !== -leapMonthMeta) throw new RangeError(invalidLeapMonth);
                        if (void 0 === leapMonth && 1 === overflow) throw new RangeError(invalidLeapMonth);
                    }
                }
                return month;
            })(calendarNative, monthCode, year, overflow);
            if (void 0 !== month && month !== monthByCode) throw new RangeError(mismatchingMonthAndCode);
            month = monthByCode, overflow = 1;
        } else if (void 0 === month) throw new TypeError(missingMonth);
        return clampEntity("month", month, 1, calendarNative.monthsInYearPart(year), overflow);
    }
    function refineDay(calendarNative, fields, month, year, overflow) {
        return clampProp(fields, "day", 1, calendarNative.daysInMonthParts(year, month), overflow);
    }
    function spliceFields(dest, additional, allPropNames, deletablePropNames) {
        let anyMatching = 0;
        const nonMatchingPropNames = [];
        for (const propName of allPropNames)void 0 !== additional[propName] ? anyMatching = 1 : nonMatchingPropNames.push(propName);
        if (Object.assign(dest, additional), anyMatching) for (const deletablePropName of deletablePropNames || nonMatchingPropNames)delete dest[deletablePropName];
    }
    function instantToZonedDateTime(instantSlots, timeZoneSlot, calendarSlot = isoCalendarId) {
        return createZonedDateTimeSlots(instantSlots.epochNanoseconds, timeZoneSlot, calendarSlot);
    }
    function zonedDateTimeToPlainDateTime(getTimeZoneOps, zonedDateTimeSlots0) {
        return createPlainDateTimeSlots(zonedEpochSlotsToIso(zonedDateTimeSlots0, getTimeZoneOps));
    }
    function zonedDateTimeToPlainDate(getTimeZoneOps, zonedDateTimeSlots0) {
        return createPlainDateSlots(zonedEpochSlotsToIso(zonedDateTimeSlots0, getTimeZoneOps));
    }
    function zonedDateTimeToPlainTime(getTimeZoneOps, zonedDateTimeSlots0) {
        return createPlainTimeSlots(zonedEpochSlotsToIso(zonedDateTimeSlots0, getTimeZoneOps));
    }
    function slotsWithCalendar(slots, calendarSlot) {
        return {
            ...slots,
            calendar: calendarSlot
        };
    }
    function getPreferredCalendarSlot(a, b) {
        if (a === b) return a;
        const aId = getId(a), bId = getId(b);
        if (aId === bId || aId === isoCalendarId) return b;
        if (bId === isoCalendarId) return a;
        throw new RangeError(mismatchingCalendars);
    }
    function createOptionsTransformer(standardNames, fallbacks, exclusions) {
        const excludedNameSet = new Set(exclusions);
        return (options)=>(((props, names)=>{
                for (const name of names){
                    if (name in props) return 1;
                }
                return 0;
            })(options = excludePropsByName(excludedNameSet, options), standardNames) || Object.assign(options, fallbacks), exclusions && (options.timeZone = utcTimeZoneId, [
                "full",
                "long"
            ].includes(options.timeStyle) && (options.timeStyle = "medium")), options);
    }
    function createFormatPrepper(config, queryFormat = createFormatForPrep) {
        const [transformOptions, , , getForcedTimeZoneId] = config;
        return (locales, options = emptyOptions, ...slotsList)=>{
            const subformat = queryFormat(getForcedTimeZoneId && getForcedTimeZoneId(...slotsList), locales, options, transformOptions), resolvedOptions = subformat.resolvedOptions();
            return [
                subformat,
                ...toEpochMillis(config, resolvedOptions, slotsList)
            ];
        };
    }
    function createFormatForPrep(forcedTimeZoneId, locales, options, transformOptions) {
        if (options = transformOptions(options), forcedTimeZoneId) {
            if (void 0 !== options.timeZone) throw new TypeError(forbiddenFormatTimeZone);
            options.timeZone = forcedTimeZoneId;
        }
        return new RawDateTimeFormat(locales, options);
    }
    function toEpochMillis(config, resolvedOptions, slotsList) {
        const [, slotsToEpochMilli, strictCalendarCheck] = config;
        return slotsList.map((slots)=>(slots.calendar && ((internalCalendarId, resolvedCalendarId, strictCalendarCheck)=>{
                if ((strictCalendarCheck || internalCalendarId !== isoCalendarId) && internalCalendarId !== resolvedCalendarId) throw new RangeError(mismatchingCalendars);
            })(getId(slots.calendar), resolvedOptions.calendar, strictCalendarCheck), slotsToEpochMilli(slots, resolvedOptions)));
    }
    function createSlotClass(branding, construct, getters, methods, staticMethods) {
        function Class(...args) {
            if (!(this instanceof Class)) throw new TypeError("Invalid calling context");
            setSlots(this, construct(...args));
        }
        function bindMethod(method, methodName) {
            return Object.defineProperties(function(...args) {
                return method.call(this, getSpecificSlots(this), ...args);
            }, createNameDescriptors(methodName));
        }
        function getSpecificSlots(obj) {
            const slots = getSlots(obj);
            if (!slots || slots.branding !== branding) throw new TypeError("Invalid calling context");
            return slots;
        }
        return Object.defineProperties(Class.prototype, {
            ...createGetterDescriptors(mapProps(bindMethod, getters)),
            ...createPropDescriptors(mapProps(bindMethod, methods)),
            ...createStringTagDescriptors("Temporal." + branding)
        }), Object.defineProperties(Class, {
            ...createPropDescriptors(staticMethods),
            ...createNameDescriptors(branding)
        }), [
            Class,
            (slots)=>{
                const instance = Object.create(Class.prototype);
                return setSlots(instance, slots), instance;
            },
            getSpecificSlots
        ];
    }
    function createProtocolValidator(propNames) {
        return propNames = propNames.concat("id").sort(), (obj)=>{
            if (!((props, names)=>{
                for (const name of names){
                    if (!(name in props)) return 0;
                }
                return 1;
            })(obj, propNames)) throw new TypeError("Invalid protocol");
            return obj;
        };
    }
    function rejectInvalidBag(bag) {
        if (getSlots(bag) || void 0 !== bag.calendar || void 0 !== bag.timeZone) throw new TypeError("Invalid bag");
        return bag;
    }
    function createCalendarFieldMethods(methodNameMap, alsoAccept) {
        const methods = {};
        for(const methodName in methodNameMap)methods[methodName] = ({ native: native }, dateArg)=>{
            const argSlots = getSlots(dateArg) || {}, { branding: branding } = argSlots, refinedSlots = branding === PlainDateBranding || alsoAccept.includes(branding) ? argSlots : toPlainDateSlots(dateArg);
            return native[methodName](refinedSlots);
        };
        return methods;
    }
    function createCalendarGetters(methodNameMap) {
        const methods = {};
        for(const methodName in methodNameMap)methods[methodName] = (slots)=>{
            const { calendar: calendar } = slots;
            var calendarSlot, calendarProtocol;
            return (calendarSlot = calendar, "string" == typeof calendarSlot ? createNativeStandardOps(calendarSlot) : (calendarProtocol = calendarSlot, Object.assign(Object.create(adapterSimpleOps), {
                calendarProtocol: calendarProtocol
            })))[methodName](slots);
        };
        return methods;
    }
    function neverValueOf() {
        throw new TypeError("Cannot use valueOf");
    }
    function createCalendarFromSlots({ calendar: calendar }) {
        return "string" == typeof calendar ? new Calendar(calendar) : calendar;
    }
    function toPlainMonthDaySlots(arg, options) {
        if (options = copyOptions(options), isObjectLike(arg)) {
            const slots = getSlots(arg);
            if (slots && slots.branding === PlainMonthDayBranding) return refineOverflowOptions(options), slots;
            const calendarMaybe = extractCalendarSlotFromBag(arg);
            return refinePlainMonthDayBag(createMonthDayRefineOps(calendarMaybe || isoCalendarId), !calendarMaybe, arg, options);
        }
        const res = ((getCalendarOps, s)=>{
            const organized = parseMonthDayOnly(requireString(s));
            if (organized) return requireIsoCalendar(organized), createPlainMonthDaySlots(checkIsoDateFields(organized));
            const dateSlots = parsePlainDate(s), { calendar: calendar } = dateSlots, calendarOps = getCalendarOps(calendar), [origYear, origMonth, day] = calendarOps.dateParts(dateSlots), [monthCodeNumber, isLeapMonth] = calendarOps.monthCodeParts(origYear, origMonth), [year, month] = calendarOps.yearMonthForMonthDay(monthCodeNumber, isLeapMonth, day);
            return createPlainMonthDaySlots(checkIsoDateInBounds(calendarOps.isoFields(year, month, day)), calendar);
        })(createNativeStandardOps, arg);
        return refineOverflowOptions(options), res;
    }
    function getOffsetNanosecondsForAdapter(timeZoneProtocol, getOffsetNanosecondsFor, epochNano) {
        return validateTimeZoneOffset(requireInteger(getOffsetNanosecondsFor.call(timeZoneProtocol, createInstant(createInstantSlots(epochNano)))));
    }
    function createAdapterOps(timeZoneProtocol, adapterFuncs = timeZoneAdapters) {
        const keys = Object.keys(adapterFuncs).sort(), boundFuncs = {};
        for (const key of keys)boundFuncs[key] = bindArgs(adapterFuncs[key], timeZoneProtocol, requireFunction(timeZoneProtocol[key]));
        return boundFuncs;
    }
    function getImplTransition(direction, impl, instantArg) {
        const epochNano = impl.getTransition(toInstantSlots(instantArg).epochNanoseconds, direction);
        return epochNano ? createInstant(createInstantSlots(epochNano)) : null;
    }
    function refineTimeZoneSlot(arg) {
        return isObjectLike(arg) ? (getSlots(arg) || {}).timeZone || validateTimeZoneProtocol(arg) : ((arg)=>resolveTimeZoneId(((s)=>{
                const parsed = parseDateTimeLike(s);
                return parsed && (parsed.timeZone || parsed.hasZ && utcTimeZoneId || parsed.offset) || s;
            })(requireString(arg))))(arg);
    }
    function createTimeZoneOps(timeZoneSlot, adapterFuncs) {
        return "string" == typeof timeZoneSlot ? queryNativeTimeZone(timeZoneSlot) : createAdapterOps(timeZoneSlot, adapterFuncs);
    }
    function createTimeZoneOffsetOps(timeZoneSlot) {
        return createTimeZoneOps(timeZoneSlot, simpleTimeZoneAdapters);
    }
    function toPlainYearMonthSlots(arg, options) {
        if (options = copyOptions(options), isObjectLike(arg)) {
            const slots = getSlots(arg);
            return slots && slots.branding === PlainYearMonthBranding ? (refineOverflowOptions(options), slots) : refinePlainYearMonthBag(createYearMonthRefineOps(getCalendarSlotFromBag(arg)), arg, options);
        }
        const res = ((getCalendarOps, s)=>{
            const organized = parseYearMonthOnly(requireString(s));
            if (organized) return requireIsoCalendar(organized), createPlainYearMonthSlots(checkIsoYearMonthInBounds(checkIsoDateFields(organized)));
            const isoSlots = parsePlainDate(s);
            return createPlainYearMonthSlots(moveToDayOfMonthUnsafe(getCalendarOps(isoSlots.calendar), isoSlots));
        })(createNativeStandardOps, arg);
        return refineOverflowOptions(options), res;
    }
    function toZonedDateTimeSlots(arg, options) {
        if (options = copyOptions(options), isObjectLike(arg)) {
            const slots = getSlots(arg);
            if (slots && slots.branding === ZonedDateTimeBranding) return refineZonedFieldOptions(options), slots;
            const calendarSlot = getCalendarSlotFromBag(arg);
            return ((refineTimeZoneArg, getTimeZoneOps, calendarOps, calendarSlot, bag, options)=>{
                const fields = refineCalendarFields(calendarOps, bag, dateFieldNamesAlpha, timeZoneFieldNames, timeAndZoneFieldNames), timeZoneSlot = refineTimeZoneArg(fields.timeZone), [overflow, offsetDisambig, epochDisambig] = refineZonedFieldOptions(options), isoDateFields = calendarOps.dateFromFields(fields, overrideOverflowOptions(options, overflow)), isoTimeFields = refineTimeBag(fields, overflow);
                return createZonedDateTimeSlots(getMatchingInstantFor(getTimeZoneOps(timeZoneSlot), {
                    ...isoDateFields,
                    ...isoTimeFields
                }, void 0 !== fields.offset ? parseOffsetNano(fields.offset) : void 0, offsetDisambig, epochDisambig), timeZoneSlot, calendarSlot);
            })(refineTimeZoneSlot, createTimeZoneOps, createDateRefineOps(calendarSlot), calendarSlot, arg, options);
        }
        return ((s, options)=>{
            const organized = parseDateTimeLike(requireString(s));
            if (!organized || !organized.timeZone) throw new RangeError(failedParse(s));
            const { offset: offset } = organized, offsetNano = offset ? parseOffsetNano(offset) : void 0, [, offsetDisambig, epochDisambig] = refineZonedFieldOptions(options);
            return finalizeZonedDateTime(organized, offsetNano, offsetDisambig, epochDisambig);
        })(arg, options);
    }
    function adaptDateMethods(methods) {
        return mapProps((method)=>(slots)=>method(slotsToIso(slots)), methods);
    }
    function slotsToIso(slots) {
        return zonedEpochSlotsToIso(slots, createTimeZoneOffsetOps);
    }
    function toPlainTimeSlots(arg, options) {
        if (isObjectLike(arg)) {
            const slots = getSlots(arg) || {};
            switch(slots.branding){
                case PlainTimeBranding:
                    return refineOverflowOptions(options), slots;
                case PlainDateTimeBranding:
                    return refineOverflowOptions(options), createPlainTimeSlots(slots);
                case ZonedDateTimeBranding:
                    return refineOverflowOptions(options), zonedDateTimeToPlainTime(createTimeZoneOffsetOps, slots);
            }
            return ((bag, options)=>{
                const overflow = refineOverflowOptions(options);
                return createPlainTimeSlots(refineTimeBag(refineFields(bag, timeFieldNamesAlpha, [], 1), overflow));
            })(arg, options);
        }
        return refineOverflowOptions(options), ((s)=>{
            let altParsed, organized = ((s)=>{
                const parts = timeRegExp.exec(s);
                return parts ? (organizeAnnotationParts(parts[10]), organizeTimeParts(parts)) : void 0;
            })(requireString(s));
            if (!organized) {
                if (organized = parseDateTimeLike(s), !organized) throw new RangeError(failedParse(s));
                if (!organized.hasTime) throw new RangeError(failedParse(s));
                if (organized.hasZ) throw new RangeError(invalidSubstring("Z"));
                requireIsoCalendar(organized);
            }
            if ((altParsed = parseYearMonthOnly(s)) && isIsoDateFieldsValid(altParsed)) throw new RangeError(failedParse(s));
            if ((altParsed = parseMonthDayOnly(s)) && isIsoDateFieldsValid(altParsed)) throw new RangeError(failedParse(s));
            return createPlainTimeSlots(constrainIsoTimeFields(organized, 1));
        })(arg);
    }
    function optionalToPlainTimeFields(timeArg) {
        return void 0 === timeArg ? void 0 : toPlainTimeSlots(timeArg);
    }
    function toPlainDateTimeSlots(arg, options) {
        if (options = copyOptions(options), isObjectLike(arg)) {
            const slots = getSlots(arg) || {};
            switch(slots.branding){
                case PlainDateTimeBranding:
                    return refineOverflowOptions(options), slots;
                case PlainDateBranding:
                    return refineOverflowOptions(options), createPlainDateTimeSlots({
                        ...slots,
                        ...isoTimeFieldDefaults
                    });
                case ZonedDateTimeBranding:
                    return refineOverflowOptions(options), zonedDateTimeToPlainDateTime(createTimeZoneOffsetOps, slots);
            }
            return ((calendarOps, bag, options)=>{
                const fields = refineCalendarFields(calendarOps, bag, dateFieldNamesAlpha, [], timeFieldNamesAsc), overflow = refineOverflowOptions(options);
                return createPlainDateTimeSlots(checkIsoDateTimeInBounds({
                    ...calendarOps.dateFromFields(fields, overrideOverflowOptions(options, overflow)),
                    ...refineTimeBag(fields, overflow)
                }));
            })(createDateRefineOps(getCalendarSlotFromBag(arg)), arg, options);
        }
        const res = ((s)=>{
            const organized = parseDateTimeLike(requireString(s));
            if (!organized || organized.hasZ) throw new RangeError(failedParse(s));
            return createPlainDateTimeSlots(finalizeDateTime(organized));
        })(arg);
        return refineOverflowOptions(options), res;
    }
    function toPlainDateSlots(arg, options) {
        if (options = copyOptions(options), isObjectLike(arg)) {
            const slots = getSlots(arg) || {};
            switch(slots.branding){
                case PlainDateBranding:
                    return refineOverflowOptions(options), slots;
                case PlainDateTimeBranding:
                    return refineOverflowOptions(options), createPlainDateSlots(slots);
                case ZonedDateTimeBranding:
                    return refineOverflowOptions(options), zonedDateTimeToPlainDate(createTimeZoneOffsetOps, slots);
            }
            return refinePlainDateBag(createDateRefineOps(getCalendarSlotFromBag(arg)), arg, options);
        }
        const res = parsePlainDate(arg);
        return refineOverflowOptions(options), res;
    }
    function dayAdapter(calendarProtocol, dayMethod, isoFields) {
        return requirePositiveInteger(dayMethod.call(calendarProtocol, createPlainDate(createPlainDateSlots(isoFields, calendarProtocol))));
    }
    function createCompoundOpsCreator(adapterFuncs) {
        return (calendarSlot)=>"string" == typeof calendarSlot ? createNativeStandardOps(calendarSlot) : ((calendarProtocol, adapterFuncs)=>{
                const keys = Object.keys(adapterFuncs).sort(), boundFuncs = {};
                for (const key of keys)boundFuncs[key] = bindArgs(adapterFuncs[key], calendarProtocol, calendarProtocol[key]);
                return boundFuncs;
            })(calendarSlot, adapterFuncs);
    }
    function toDurationSlots(arg) {
        if (isObjectLike(arg)) {
            const slots = getSlots(arg);
            return slots && slots.branding === DurationBranding ? slots : ((bag)=>{
                const durationFields = refineFields(bag, durationFieldNamesAlpha);
                return createDurationSlots(checkDurationUnits({
                    ...durationFieldDefaults,
                    ...durationFields
                }));
            })(arg);
        }
        return ((s)=>{
            const parsed = ((s)=>{
                const parts = durationRegExp.exec(s);
                return parts ? ((parts)=>{
                    function parseUnit(wholeStr, fracStr, timeUnit) {
                        let leftoverUnits = 0, wholeUnits = 0;
                        if (timeUnit && ([leftoverUnits, leftoverNano] = divModFloor(leftoverNano, unitNanoMap[timeUnit])), void 0 !== wholeStr) {
                            if (hasAnyFrac) throw new RangeError(invalidSubstring(wholeStr));
                            wholeUnits = ((s)=>{
                                const n = parseInt(s);
                                if (!Number.isFinite(n)) throw new RangeError(invalidSubstring(s));
                                return n;
                            })(wholeStr), hasAny = 1, fracStr && (leftoverNano = parseSubsecNano(fracStr) * (unitNanoMap[timeUnit] / nanoInSec), hasAnyFrac = 1);
                        }
                        return leftoverUnits + wholeUnits;
                    }
                    let hasAny = 0, hasAnyFrac = 0, leftoverNano = 0, durationFields = {
                        ...zipProps(durationFieldNamesAsc, [
                            parseUnit(parts[2]),
                            parseUnit(parts[3]),
                            parseUnit(parts[4]),
                            parseUnit(parts[5]),
                            parseUnit(parts[6], parts[7], 5),
                            parseUnit(parts[8], parts[9], 4),
                            parseUnit(parts[10], parts[11], 3)
                        ]),
                        ...nanoToGivenFields(leftoverNano, 2, durationFieldNamesAsc)
                    };
                    if (!hasAny) throw new RangeError(noValidFields(durationFieldNamesAsc));
                    return parseSign(parts[1]) < 0 && (durationFields = negateDurationFields(durationFields)), durationFields;
                })(parts) : void 0;
            })(requireString(s));
            if (!parsed) throw new RangeError(failedParse(s));
            return createDurationSlots(checkDurationUnits(parsed));
        })(arg);
    }
    function refinePublicRelativeTo(relativeTo) {
        if (void 0 !== relativeTo) {
            if (isObjectLike(relativeTo)) {
                const slots = getSlots(relativeTo) || {};
                switch(slots.branding){
                    case ZonedDateTimeBranding:
                    case PlainDateBranding:
                        return slots;
                    case PlainDateTimeBranding:
                        return createPlainDateSlots(slots);
                }
                const calendar = getCalendarSlotFromBag(relativeTo);
                return {
                    ...((refineTimeZoneArg, getTimeZoneOps, calendarOps, bag)=>{
                        const fields = refineCalendarFields(calendarOps, bag, dateFieldNamesAlpha, [], timeAndZoneFieldNames);
                        if (void 0 !== fields.timeZone) {
                            const isoDateFields = calendarOps.dateFromFields(fields), isoTimeFields = refineTimeBag(fields), timeZoneSlot = refineTimeZoneArg(fields.timeZone);
                            return {
                                epochNanoseconds: getMatchingInstantFor(getTimeZoneOps(timeZoneSlot), {
                                    ...isoDateFields,
                                    ...isoTimeFields
                                }, void 0 !== fields.offset ? parseOffsetNano(fields.offset) : void 0),
                                timeZone: timeZoneSlot
                            };
                        }
                        return {
                            ...calendarOps.dateFromFields(fields),
                            ...isoTimeFieldDefaults
                        };
                    })(refineTimeZoneSlot, createTimeZoneOps, createDateRefineOps(calendar), relativeTo),
                    calendar: calendar
                };
            }
            return ((s)=>{
                const organized = parseDateTimeLike(requireString(s));
                if (!organized) throw new RangeError(failedParse(s));
                if (organized.timeZone) return finalizeZonedDateTime(organized, organized.offset ? parseOffsetNano(organized.offset) : void 0);
                if (organized.hasZ) throw new RangeError(failedParse(s));
                return finalizeDate(organized);
            })(relativeTo);
        }
    }
    function getCalendarSlotFromBag(bag) {
        return extractCalendarSlotFromBag(bag) || isoCalendarId;
    }
    function extractCalendarSlotFromBag(bag) {
        const { calendar: calendar } = bag;
        if (void 0 !== calendar) return refineCalendarSlot(calendar);
    }
    function refineCalendarSlot(arg) {
        return isObjectLike(arg) ? (getSlots(arg) || {}).calendar || validateCalendarProtocol(arg) : ((arg)=>resolveCalendarId(((s)=>{
                const res = parseDateTimeLike(s) || parseYearMonthOnly(s) || parseMonthDayOnly(s);
                return res ? res.calendar : s;
            })(requireString(arg))))(arg);
    }
    function toInstantSlots(arg) {
        if (isObjectLike(arg)) {
            const slots = getSlots(arg);
            if (slots) switch(slots.branding){
                case InstantBranding:
                    return slots;
                case ZonedDateTimeBranding:
                    return createInstantSlots(slots.epochNanoseconds);
            }
        }
        return ((s)=>{
            const organized = parseDateTimeLike(s = toStringViaPrimitive(s));
            if (!organized) throw new RangeError(failedParse(s));
            let offsetNano;
            if (organized.hasZ) offsetNano = 0;
            else {
                if (!organized.offset) throw new RangeError(failedParse(s));
                offsetNano = parseOffsetNano(organized.offset);
            }
            return organized.timeZone && parseOffsetNanoMaybe(organized.timeZone, 1), createInstantSlots(isoToEpochNanoWithOffset(checkIsoDateTimeFields(organized), offsetNano));
        })(arg);
    }
    function createFormatMethod(methodName) {
        return function(...formattables) {
            const prepFormat = internalsMap.get(this), [format, ...rawFormattables] = prepFormat(...formattables);
            return format[methodName](...rawFormattables);
        };
    }
    function createProxiedMethod(methodName) {
        return function(...args) {
            return internalsMap.get(this).rawFormat[methodName](...args);
        };
    }
    function createFormatPrepperForBranding(branding) {
        const config = classFormatConfigs[branding];
        if (!config) throw new TypeError(invalidFormatType(branding));
        return createFormatPrepper(config, memoize(createFormatForPrep));
    }
    function getCurrentIsoDateTime(timeZoneOps) {
        const epochNano = getCurrentEpochNano();
        return epochNanoToIso(epochNano, timeZoneOps.getOffsetNanosecondsFor(epochNano));
    }
    function getCurrentEpochNano() {
        return numberToBigNano(Date.now(), nanoInMilli);
    }
    function getCurrentTimeZoneId() {
        return currentTimeZoneId || (currentTimeZoneId = (new RawDateTimeFormat).resolvedOptions().timeZone);
    }
    const expectedInteger = (entityName, num)=>`Non-integer ${entityName}: ${num}`, expectedPositive = (entityName, num)=>`Non-positive ${entityName}: ${num}`, expectedFinite = (entityName, num)=>`Non-finite ${entityName}: ${num}`, forbiddenBigIntToNumber = (entityName)=>`Cannot convert bigint to ${entityName}`, invalidBigInt = (arg)=>`Invalid bigint: ${arg}`, forbiddenSymbolToString = "Cannot convert Symbol to string", invalidObject = "Invalid object", numberOutOfRange = (entityName, val, min, max, choices)=>choices ? numberOutOfRange(entityName, choices[val], choices[min], choices[max]) : invalidEntity(entityName, val) + `; must be between ${min}-${max}`, invalidEntity = (fieldName, val)=>`Invalid ${fieldName}: ${val}`, missingField = (fieldName)=>`Missing ${fieldName}`, forbiddenField = (fieldName)=>`Invalid field ${fieldName}`, duplicateFields = (fieldName)=>`Duplicate field ${fieldName}`, noValidFields = (validFields)=>"No valid fields: " + validFields.join(), invalidChoice = (fieldName, val, choiceMap)=>invalidEntity(fieldName, val) + "; must be " + Object.keys(choiceMap).join(), forbiddenEraParts = "Forbidden era/eraYear", mismatchingEraParts = "Mismatching era/eraYear", mismatchingYearAndEra = "Mismatching year/eraYear", invalidEra = (era)=>`Invalid era: ${era}`, missingYear = (allowEra)=>"Missing year" + (allowEra ? "/era/eraYear" : ""), invalidMonthCode = (monthCode)=>`Invalid monthCode: ${monthCode}`, mismatchingMonthAndCode = "Mismatching month/monthCode", missingMonth = "Missing month/monthCode", invalidLeapMonth = "Invalid leap month", invalidProtocolResults = "Invalid protocol results", mismatchingCalendars = "Mismatching Calendars", invalidCalendar = (calendarId)=>`Invalid Calendar: ${calendarId}`, mismatchingTimeZones = "Mismatching TimeZones", forbiddenIcuTimeZone = "Forbidden ICU TimeZone", outOfBoundsOffset = "Out-of-bounds offset", outOfBoundsDstGap = "Out-of-bounds TimeZone gap", invalidOffsetForTimeZone = "Invalid TimeZone offset", ambigOffset = "Ambiguous offset", outOfBoundsDate = "Out-of-bounds date", outOfBoundsDuration = "Out-of-bounds duration", forbiddenDurationSigns = "Cannot mix duration signs", invalidLargeUnits = "Cannot use large units", flippedSmallestLargestUnit = "smallestUnit > largestUnit", failedParse = (s)=>`Cannot parse: ${s}`, invalidSubstring = (substring)=>`Invalid substring: ${substring}`, invalidFormatType = (branding)=>`Cannot format ${branding}`, forbiddenFormatTimeZone = "Cannot specify TimeZone", mapPropNamesToIndex = bindArgs(mapPropNames, (_propVal, i)=>i), mapPropNamesToConstant = bindArgs(mapPropNames, (_propVal, _i, constant)=>constant), padNumber2 = bindArgs(padNumber, 2), unitNameMap = {
        nanosecond: 0,
        microsecond: 1,
        millisecond: 2,
        second: 3,
        minute: 4,
        hour: 5,
        day: 6,
        week: 7,
        month: 8,
        year: 9
    }, unitNamesAsc = Object.keys(unitNameMap), milliInDay = 864e5, milliInSec = 1e3, nanoInMicro = 1e3, nanoInMilli = 1e6, nanoInSec = 1e9, nanoInMinute = 6e10, nanoInHour = 36e11, nanoInUtcDay = 864e11, unitNanoMap = [
        1,
        nanoInMicro,
        nanoInMilli,
        nanoInSec,
        nanoInMinute,
        nanoInHour,
        nanoInUtcDay
    ], requireString = bindArgs(requireType, "string"), requireBoolean = bindArgs(requireType, "boolean"), requireNumber = bindArgs(requireType, "number"), requireFunction = bindArgs(requireType, "function"), durationFieldNamesAsc = unitNamesAsc.map((unitName)=>unitName + "s"), durationFieldNamesAlpha = sortStrings(durationFieldNamesAsc), durationTimeFieldNamesAsc = durationFieldNamesAsc.slice(0, 6), durationDateFieldNamesAsc = durationFieldNamesAsc.slice(6), durationCalendarFieldNamesAsc = durationDateFieldNamesAsc.slice(1), durationFieldIndexes = mapPropNamesToIndex(durationFieldNamesAsc), durationFieldDefaults = mapPropNamesToConstant(durationFieldNamesAsc, 0), durationTimeFieldDefaults = mapPropNamesToConstant(durationTimeFieldNamesAsc, 0), clearDurationFields = bindArgs(zeroOutProps, durationFieldNamesAsc), timeFieldNamesAsc = unitNamesAsc.slice(0, 6), timeFieldNamesAlpha = sortStrings(timeFieldNamesAsc), offsetFieldNames = [
        "offset"
    ], timeZoneFieldNames = [
        "timeZone"
    ], timeAndOffsetFieldNames = [
        ...timeFieldNamesAsc,
        ...offsetFieldNames
    ], timeAndZoneFieldNames = [
        ...timeAndOffsetFieldNames,
        ...timeZoneFieldNames
    ], eraYearFieldNames = [
        "era",
        "eraYear"
    ], allYearFieldNames = [
        ...eraYearFieldNames,
        "year"
    ], yearFieldNames = [
        "year"
    ], monthCodeFieldNames = [
        "monthCode"
    ], monthFieldNames = [
        "month",
        ...monthCodeFieldNames
    ], dayFieldNames = [
        "day"
    ], yearMonthFieldNames = [
        ...monthFieldNames,
        ...yearFieldNames
    ], yearMonthCodeFieldNames = [
        ...monthCodeFieldNames,
        ...yearFieldNames
    ], dateFieldNamesAlpha = [
        ...dayFieldNames,
        ...yearMonthFieldNames
    ], monthDayFieldNames = [
        ...dayFieldNames,
        ...monthFieldNames
    ], monthCodeDayFieldNames = [
        ...dayFieldNames,
        ...monthCodeFieldNames
    ], timeFieldDefaults = mapPropNamesToConstant(timeFieldNamesAsc, 0), isoCalendarId = "iso8601", gregoryCalendarId = "gregory", eraOriginsByCalendarId = {
        [gregoryCalendarId]: {
            bce: -1,
            ce: 0
        },
        japanese: {
            bce: -1,
            ce: 0,
            meiji: 1867,
            taisho: 1911,
            showa: 1925,
            heisei: 1988,
            reiwa: 2018
        },
        ethioaa: {
            era0: 0
        },
        ethiopic: {
            era0: 0,
            era1: 5500
        },
        coptic: {
            era0: -1,
            era1: 0
        },
        roc: {
            beforeroc: -1,
            minguo: 0
        },
        buddhist: {
            be: 0
        },
        islamic: {
            ah: 0
        },
        indian: {
            saka: 0
        },
        persian: {
            ap: 0
        }
    }, leapMonthMetas = {
        chinese: 13,
        dangi: 13,
        hebrew: -6
    }, RawDateTimeFormat = Intl.DateTimeFormat, isoTimeFieldNamesAsc = [
        "isoNanosecond",
        "isoMicrosecond",
        "isoMillisecond",
        "isoSecond",
        "isoMinute",
        "isoHour"
    ], isoDateFieldNamesAsc = [
        "isoDay",
        "isoMonth",
        "isoYear"
    ], isoDateTimeFieldNamesAsc = [
        ...isoTimeFieldNamesAsc,
        ...isoDateFieldNamesAsc
    ], isoDateFieldNamesAlpha = sortStrings(isoDateFieldNamesAsc), isoTimeFieldNamesAlpha = sortStrings(isoTimeFieldNamesAsc), isoDateTimeFieldNamesAlpha = sortStrings(isoDateTimeFieldNamesAsc), isoTimeFieldDefaults = mapPropNamesToConstant(isoTimeFieldNamesAlpha, 0), clearIsoFields = bindArgs(zeroOutProps, isoDateTimeFieldNamesAsc), maxMilli = 1e8 * milliInDay, epochNanoMax = [
        1e8,
        0
    ], epochNanoMin = [
        -100000000,
        0
    ], isoYearMax = 275760, isoYearMin = -271821, isoEpochOriginYear = 1970, isoEpochFirstLeapYear = 1972, isoMonthsInYear = 12, primaryJapaneseEraMilli = isoArgsToEpochMilli(1868, 9, 8), queryJapaneseEraParts = memoize((isoFields)=>{
        const epochMilli = isoToEpochMilli(isoFields);
        if (epochMilli < primaryJapaneseEraMilli) return computeGregoryEraParts(isoFields);
        const intlParts = hashIntlFormatParts(queryCalendarIntlFormat("japanese"), epochMilli), { era: era, eraYear: eraYear } = parseIntlYear(intlParts, "japanese");
        return [
            era,
            eraYear
        ];
    }, WeakMap), utcTimeZoneId = "UTC", periodDur = 5184e3, minPossibleTransition = isoArgsToEpochSec(1847), maxPossibleTransition = isoArgsToEpochSec((new Date).getUTCFullYear() + 10), queryIntlCalendar = memoize((calendarId)=>{
        function epochMilliToIntlFields(epochMilli) {
            return ((intlParts, calendarIdBase)=>({
                    ...parseIntlYear(intlParts, calendarIdBase),
                    monthString: intlParts.month,
                    day: parseInt(intlParts.day)
                }))(hashIntlFormatParts(intlFormat, epochMilli), calendarIdBase);
        }
        const intlFormat = queryCalendarIntlFormat(calendarId), calendarIdBase = computeCalendarIdBase(calendarId);
        return {
            id: calendarId,
            queryFields: createIntlFieldCache(epochMilliToIntlFields),
            queryYearData: createIntlYearDataCache(epochMilliToIntlFields)
        };
    }), queryCalendarIntlFormat = memoize((id)=>new RawDateTimeFormat("en-GB", {
            calendar: id,
            timeZone: utcTimeZoneId,
            era: "short",
            year: "numeric",
            month: "short",
            day: "numeric"
        })), monthCodeRegExp = /^M(\d{2})(L?)$/, smallestUnitStr = "smallestUnit", roundingIncName = "roundingIncrement", subsecDigitsName = "fractionalSecondDigits", overflowMap = {
        constrain: 0,
        reject: 1
    }, overflowMapNames = Object.keys(overflowMap), refineSmallestUnit = bindArgs(refineUnitOption, smallestUnitStr), refineLargestUnit = bindArgs(refineUnitOption, "largestUnit"), refineTotalUnit = bindArgs(refineUnitOption, "unit"), refineOverflow = bindArgs(refineChoiceOption, "overflow", overflowMap), refineEpochDisambig = bindArgs(refineChoiceOption, "disambiguation", {
        compatible: 0,
        reject: 1,
        earlier: 2,
        later: 3
    }), refineOffsetDisambig = bindArgs(refineChoiceOption, "offset", {
        reject: 0,
        use: 1,
        prefer: 2,
        ignore: 3
    }), refineCalendarDisplay = bindArgs(refineChoiceOption, "calendarName", {
        auto: 0,
        never: 1,
        critical: 2,
        always: 3
    }), refineTimeZoneDisplay = bindArgs(refineChoiceOption, "timeZoneName", {
        auto: 0,
        never: 1,
        critical: 2
    }), refineOffsetDisplay = bindArgs(refineChoiceOption, "offset", {
        auto: 0,
        never: 1
    }), refineRoundingMode = bindArgs(refineChoiceOption, "roundingMode", {
        floor: 0,
        halfFloor: 1,
        ceil: 2,
        halfCeil: 3,
        trunc: 4,
        halfTrunc: 5,
        expand: 6,
        halfExpand: 7,
        halfEven: 8
    }), PlainYearMonthBranding = "PlainYearMonth", PlainMonthDayBranding = "PlainMonthDay", PlainDateBranding = "PlainDate", PlainDateTimeBranding = "PlainDateTime", PlainTimeBranding = "PlainTime", ZonedDateTimeBranding = "ZonedDateTime", InstantBranding = "Instant", DurationBranding = "Duration", roundingModeFuncs = [
        Math.floor,
        (num)=>hasHalf(num) ? Math.floor(num) : Math.round(num),
        Math.ceil,
        (num)=>hasHalf(num) ? Math.ceil(num) : Math.round(num),
        Math.trunc,
        (num)=>hasHalf(num) ? Math.trunc(num) || 0 : Math.round(num),
        (num)=>num < 0 ? Math.floor(num) : Math.ceil(num),
        (num)=>Math.sign(num) * Math.round(Math.abs(num)) || 0,
        (num)=>hasHalf(num) ? (num = Math.trunc(num) || 0) + num % 2 : Math.round(num)
    ], trailingZerosRE = /0+$/, zonedEpochSlotsToIso = memoize((slots, getTimeZoneOps)=>{
        const { epochNanoseconds: epochNanoseconds } = slots, offsetNanoseconds = (getTimeZoneOps.getOffsetNanosecondsFor ? getTimeZoneOps : getTimeZoneOps(slots.timeZone)).getOffsetNanosecondsFor(epochNanoseconds), isoDateTimeFields = epochNanoToIso(epochNanoseconds, offsetNanoseconds);
        return {
            calendar: slots.calendar,
            ...isoDateTimeFields,
            offsetNanoseconds: offsetNanoseconds
        };
    }, WeakMap), maxCalendarUnit = 2 ** 32 - 1, queryNativeTimeZone = memoize((slotId)=>{
        const essence = getTimeZoneEssence(slotId);
        return "object" == typeof essence ? new IntlTimeZone(essence) : new FixedTimeZone(essence || 0);
    });
    class FixedTimeZone {
        constructor(offsetNano){
            this.offsetNano = offsetNano;
        }
        getOffsetNanosecondsFor() {
            return this.offsetNano;
        }
        getPossibleInstantsFor(isoDateTimeFields) {
            return [
                isoToEpochNanoWithOffset(isoDateTimeFields, this.offsetNano)
            ];
        }
        getTransition() {}
    }
    class IntlTimeZone {
        constructor(format){
            this.tzStore = ((computeOffsetSec)=>{
                function getOffsetSec(epochSec) {
                    const clampedEpochSec = clampNumber(epochSec, minTransition, maxTransition), [startEpochSec, endEpochSec] = computePeriod(clampedEpochSec), startOffsetSec = getSample(startEpochSec), endOffsetSec = getSample(endEpochSec);
                    return startOffsetSec === endOffsetSec ? startOffsetSec : pinch(getSplit(startEpochSec, endEpochSec), startOffsetSec, endOffsetSec, epochSec);
                }
                function pinch(split, startOffsetSec, endOffsetSec, forEpochSec) {
                    let offsetSec, splitDurSec;
                    for(; (void 0 === forEpochSec || void 0 === (offsetSec = forEpochSec < split[0] ? startOffsetSec : forEpochSec >= split[1] ? endOffsetSec : void 0)) && (splitDurSec = split[1] - split[0]);){
                        const middleEpochSec = split[0] + Math.floor(splitDurSec / 2);
                        computeOffsetSec(middleEpochSec) === endOffsetSec ? split[1] = middleEpochSec : split[0] = middleEpochSec + 1;
                    }
                    return offsetSec;
                }
                const getSample = memoize(computeOffsetSec), getSplit = memoize(createSplitTuple);
                let minTransition = minPossibleTransition, maxTransition = maxPossibleTransition;
                return {
                    getPossibleEpochSec (zonedEpochSec) {
                        const wideOffsetSec0 = getOffsetSec(zonedEpochSec - 86400), wideOffsetSec1 = getOffsetSec(zonedEpochSec + 86400), wideUtcEpochSec0 = zonedEpochSec - wideOffsetSec0, wideUtcEpochSec1 = zonedEpochSec - wideOffsetSec1;
                        if (wideOffsetSec0 === wideOffsetSec1) return [
                            wideUtcEpochSec0
                        ];
                        const narrowOffsetSec0 = getOffsetSec(wideUtcEpochSec0);
                        return narrowOffsetSec0 === getOffsetSec(wideUtcEpochSec1) ? [
                            zonedEpochSec - narrowOffsetSec0
                        ] : wideOffsetSec0 > wideOffsetSec1 ? [
                            wideUtcEpochSec0,
                            wideUtcEpochSec1
                        ] : [];
                    },
                    getOffsetSec: getOffsetSec,
                    getTransition (epochSec, direction) {
                        const clampedEpochSec = clampNumber(epochSec, minTransition, maxTransition);
                        let [startEpochSec, endEpochSec] = computePeriod(clampedEpochSec);
                        const inc = periodDur * direction, inBounds = direction < 0 ? ()=>endEpochSec > minTransition || (minTransition = clampedEpochSec, 0) : ()=>startEpochSec < maxTransition || (maxTransition = clampedEpochSec, 0);
                        for(; inBounds();){
                            const startOffsetSec = getSample(startEpochSec), endOffsetSec = getSample(endEpochSec);
                            if (startOffsetSec !== endOffsetSec) {
                                const split = getSplit(startEpochSec, endEpochSec);
                                pinch(split, startOffsetSec, endOffsetSec);
                                const transitionEpochSec = split[0];
                                if ((compareNumbers(transitionEpochSec, epochSec) || 1) === direction) return transitionEpochSec;
                            }
                            startEpochSec += inc, endEpochSec += inc;
                        }
                    }
                };
            })(((format)=>(epochSec)=>{
                    const intlParts = hashIntlFormatParts(format, epochSec * milliInSec);
                    return isoArgsToEpochSec(parseIntlPartsYear(intlParts), parseInt(intlParts.month), parseInt(intlParts.day), parseInt(intlParts.hour), parseInt(intlParts.minute), parseInt(intlParts.second)) - epochSec;
                })(format));
        }
        getOffsetNanosecondsFor(epochNano) {
            return this.tzStore.getOffsetSec(epochNanoToSec(epochNano)) * nanoInSec;
        }
        getPossibleInstantsFor(isoFields) {
            const [zonedEpochSec, subsecNano] = [
                isoArgsToEpochSec((isoDateTimeFields = isoFields).isoYear, isoDateTimeFields.isoMonth, isoDateTimeFields.isoDay, isoDateTimeFields.isoHour, isoDateTimeFields.isoMinute, isoDateTimeFields.isoSecond),
                isoDateTimeFields.isoMillisecond * nanoInMilli + isoDateTimeFields.isoMicrosecond * nanoInMicro + isoDateTimeFields.isoNanosecond
            ];
            var isoDateTimeFields;
            return this.tzStore.getPossibleEpochSec(zonedEpochSec).map((epochSec)=>checkEpochNanoInBounds(moveBigNano(numberToBigNano(epochSec, nanoInSec), subsecNano)));
        }
        getTransition(epochNano, direction) {
            const [epochSec, subsecNano] = epochNanoToSecMod(epochNano), resEpochSec = this.tzStore.getTransition(epochSec + (direction > 0 || subsecNano ? 1 : 0), direction);
            if (void 0 !== resEpochSec) return numberToBigNano(resEpochSec, nanoInSec);
        }
    }
    const timeRegExpStr = "(\\d{2})(?::?(\\d{2})(?::?(\\d{2})(?:[.,](\\d{1,9}))?)?)?", offsetRegExpStr = "([+\u2212-])" + timeRegExpStr, dateTimeRegExpStr = "(?:(?:([+\u2212-])(\\d{6}))|(\\d{4}))-?(\\d{2})-?(\\d{2})(?:[T ]" + timeRegExpStr + "(Z|" + offsetRegExpStr + ")?)?", yearMonthRegExp = createRegExp("(?:(?:([+\u2212-])(\\d{6}))|(\\d{4}))-?(\\d{2})((?:\\[(!?)([^\\]]*)\\]){0,9})"), monthDayRegExp = createRegExp("(?:--)?(\\d{2})-?(\\d{2})((?:\\[(!?)([^\\]]*)\\]){0,9})"), dateTimeRegExp = createRegExp(dateTimeRegExpStr + "((?:\\[(!?)([^\\]]*)\\]){0,9})"), timeRegExp = createRegExp("T?" + timeRegExpStr + "(?:" + offsetRegExpStr + ")?((?:\\[(!?)([^\\]]*)\\]){0,9})"), offsetRegExp = createRegExp(offsetRegExpStr), annotationRegExp = new RegExp("\\[(!?)([^\\]]*)\\]", "g"), durationRegExp = createRegExp("([+\u2212-])?P(\\d+Y)?(\\d+M)?(\\d+W)?(\\d+D)?(?:T(?:(\\d+)(?:[.,](\\d{1,9}))?H)?(?:(\\d+)(?:[.,](\\d{1,9}))?M)?(?:(\\d+)(?:[.,](\\d{1,9}))?S)?)?"), queryTimeZoneIntlFormat = memoize((id)=>new RawDateTimeFormat("en-GB", {
            timeZone: id,
            era: "short",
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        })), icuRegExp = /^(AC|AE|AG|AR|AS|BE|BS|CA|CN|CS|CT|EA|EC|IE|IS|JS|MI|NE|NS|PL|PN|PR|PS|SS|VS)T$/, builtinRefiners = {
        era: toStringViaPrimitive,
        eraYear: toInteger,
        year: toInteger,
        month: toPositiveInteger,
        monthCode: toStringViaPrimitive,
        day: toPositiveInteger,
        ...mapPropNamesToConstant(timeFieldNamesAsc, toInteger),
        ...mapPropNamesToConstant(durationFieldNamesAsc, toStrictInteger),
        offset: toStringViaPrimitive
    }, timeFieldsToIso = bindArgs((oldNames, newNames, oldProps)=>{
        const newProps = {};
        for(let i = 0; i < oldNames.length; i++)newProps[newNames[i]] = oldProps[oldNames[i]];
        return newProps;
    }, timeFieldNamesAsc, isoTimeFieldNamesAsc), nativeStandardBase = {
        dateAdd (isoDateFields, durationFields, options) {
            const overflow = refineOverflowOptions(options);
            let epochMilli, { years: years, months: months, weeks: weeks, days: days } = durationFields;
            if (days += durationFieldsToBigNano(durationFields, 5)[0], years || months) epochMilli = ((moveOps, isoDateFields, years, months, overflow)=>{
                let [year, month, day] = moveOps.dateParts(isoDateFields);
                if (years) {
                    const [monthCodeNumber, isLeapMonth] = moveOps.monthCodeParts(year, month);
                    year += years, month = monthCodeNumberToMonth(monthCodeNumber, isLeapMonth, moveOps.leapMonth(year)), month = clampEntity("month", month, 1, moveOps.monthsInYearPart(year), overflow);
                }
                return months && ([year, month] = moveOps.monthAdd(year, month, months)), day = clampEntity("day", day, 1, moveOps.daysInMonthParts(year, month), overflow), moveOps.epochMilli(year, month, day);
            })(this, isoDateFields, years, months, overflow);
            else {
                if (!weeks && !days) return isoDateFields;
                epochMilli = isoToEpochMilli(isoDateFields);
            }
            return epochMilli += (7 * weeks + days) * milliInDay, checkIsoDateInBounds(epochMilliToIso(epochMilli));
        },
        dateUntil (startIsoFields, endIsoFields, largestUnit) {
            if (largestUnit <= 7) {
                let weeks = 0, days = diffDays({
                    ...startIsoFields,
                    ...isoTimeFieldDefaults
                }, {
                    ...endIsoFields,
                    ...isoTimeFieldDefaults
                });
                return 7 === largestUnit && ([weeks, days] = divModTrunc(days, 7)), {
                    ...durationFieldDefaults,
                    weeks: weeks,
                    days: days
                };
            }
            const yearMonthDayStart = this.dateParts(startIsoFields), yearMonthDayEnd = this.dateParts(endIsoFields);
            let [years, months, days] = ((calendarNative, year0, month0, day0, year1, month1, day1)=>{
                let yearDiff = year1 - year0, monthDiff = month1 - month0, dayDiff = day1 - day0;
                if (yearDiff || monthDiff) {
                    const sign = Math.sign(yearDiff || monthDiff);
                    let daysInMonth1 = calendarNative.daysInMonthParts(year1, month1), dayCorrect = 0;
                    if (Math.sign(dayDiff) === -sign) {
                        const origDaysInMonth1 = daysInMonth1;
                        [year1, month1] = calendarNative.monthAdd(year1, month1, -sign), yearDiff = year1 - year0, monthDiff = month1 - month0, daysInMonth1 = calendarNative.daysInMonthParts(year1, month1), dayCorrect = sign < 0 ? -origDaysInMonth1 : daysInMonth1;
                    }
                    if (dayDiff = day1 - Math.min(day0, daysInMonth1) + dayCorrect, yearDiff) {
                        const [monthCodeNumber0, isLeapYear0] = calendarNative.monthCodeParts(year0, month0), [monthCodeNumber1, isLeapYear1] = calendarNative.monthCodeParts(year1, month1);
                        if (monthDiff = monthCodeNumber1 - monthCodeNumber0 || Number(isLeapYear1) - Number(isLeapYear0), Math.sign(monthDiff) === -sign) {
                            const monthCorrect = sign < 0 && -calendarNative.monthsInYearPart(year1);
                            yearDiff = (year1 -= sign) - year0, monthDiff = month1 - monthCodeNumberToMonth(monthCodeNumber0, isLeapYear0, calendarNative.leapMonth(year1)) + (monthCorrect || calendarNative.monthsInYearPart(year1));
                        }
                    }
                }
                return [
                    yearDiff,
                    monthDiff,
                    dayDiff
                ];
            })(this, ...yearMonthDayStart, ...yearMonthDayEnd);
            return 8 === largestUnit && (months += this.monthsInYearSpan(years, yearMonthDayStart[0]), years = 0), {
                ...durationFieldDefaults,
                years: years,
                months: months,
                days: days
            };
        },
        dateFromFields (fields, options) {
            const overflow = refineOverflowOptions(options), year = refineYear(this, fields), month = refineMonth(this, fields, year, overflow), day = refineDay(this, fields, month, year, overflow);
            return createPlainDateSlots(checkIsoDateInBounds(this.isoFields(year, month, day)), this.id || isoCalendarId);
        },
        yearMonthFromFields (fields, options) {
            const overflow = refineOverflowOptions(options), year = refineYear(this, fields), month = refineMonth(this, fields, year, overflow);
            return createPlainYearMonthSlots(checkIsoYearMonthInBounds(this.isoFields(year, month, 1)), this.id || isoCalendarId);
        },
        monthDayFromFields (fields, options) {
            const overflow = refineOverflowOptions(options), isIso = !this.id, { monthCode: monthCode, year: year, month: month } = fields;
            let monthCodeNumber, isLeapMonth, normalYear, normalMonth, normalDay;
            if (void 0 !== monthCode) {
                [monthCodeNumber, isLeapMonth] = parseMonthCode(monthCode), normalDay = getDefinedProp(fields, "day");
                const res = this.yearMonthForMonthDay(monthCodeNumber, isLeapMonth, normalDay);
                if (!res) throw new RangeError("Cannot guess year");
                if ([normalYear, normalMonth] = res, void 0 !== month && month !== normalMonth) throw new RangeError(mismatchingMonthAndCode);
                isIso && (normalMonth = clampEntity("month", normalMonth, 1, isoMonthsInYear, 1), normalDay = clampEntity("day", normalDay, 1, computeIsoDaysInMonth(void 0 !== year ? year : normalYear, normalMonth), overflow));
            } else {
                normalYear = void 0 === year && isIso ? isoEpochFirstLeapYear : refineYear(this, fields), normalMonth = refineMonth(this, fields, normalYear, overflow), normalDay = refineDay(this, fields, normalMonth, normalYear, overflow);
                const leapMonth = this.leapMonth(normalYear);
                isLeapMonth = normalMonth === leapMonth, monthCodeNumber = monthToMonthCodeNumber(normalMonth, leapMonth);
                const res = this.yearMonthForMonthDay(monthCodeNumber, isLeapMonth, normalDay);
                if (!res) throw new RangeError("Cannot guess year");
                [normalYear, normalMonth] = res;
            }
            return createPlainMonthDaySlots(checkIsoDateInBounds(this.isoFields(normalYear, normalMonth, normalDay)), this.id || isoCalendarId);
        },
        fields (fieldNames) {
            return getCalendarEraOrigins(this) && fieldNames.includes("year") ? [
                ...fieldNames,
                ...eraYearFieldNames
            ] : fieldNames;
        },
        mergeFields (baseFields, additionalFields) {
            const merged = Object.assign(Object.create(null), baseFields);
            return spliceFields(merged, additionalFields, monthFieldNames), getCalendarEraOrigins(this) && (spliceFields(merged, additionalFields, allYearFieldNames), "japanese" === this.id && spliceFields(merged, additionalFields, monthDayFieldNames, eraYearFieldNames)), merged;
        },
        inLeapYear (isoFields) {
            const [year] = this.dateParts(isoFields);
            return this.inLeapYearPart(year);
        },
        monthsInYear (isoFields) {
            const [year] = this.dateParts(isoFields);
            return this.monthsInYearPart(year);
        },
        daysInMonth (isoFields) {
            const [year, month] = this.dateParts(isoFields);
            return this.daysInMonthParts(year, month);
        },
        daysInYear (isoFields) {
            const [year] = this.dateParts(isoFields);
            return this.daysInYearPart(year);
        },
        dayOfYear: computeNativeDayOfYear,
        era (isoFields) {
            return this.eraParts(isoFields)[0];
        },
        eraYear (isoFields) {
            return this.eraParts(isoFields)[1];
        },
        monthCode (isoFields) {
            const [year, month] = this.dateParts(isoFields), [monthCodeNumber, isLeapMonth] = this.monthCodeParts(year, month);
            return ((monthCodeNumber, isLeapMonth)=>"M" + padNumber2(monthCodeNumber) + (isLeapMonth ? "L" : ""))(monthCodeNumber, isLeapMonth);
        },
        dayOfWeek: computeIsoDayOfWeek,
        daysInWeek () {
            return 7;
        }
    }, isoWeekOps = {
        dayOfYear: computeNativeDayOfYear,
        dateParts: computeIsoDateParts,
        epochMilli: isoArgsToEpochMilli,
        weekOfYear: computeNativeWeekOfYear,
        yearOfWeek: computeNativeYearOfWeek,
        weekParts (isoDateFields) {
            function computeWeekShift(yDayOfWeek) {
                return (7 - yDayOfWeek < minDaysInWeek ? 7 : 0) - yDayOfWeek;
            }
            function computeWeeksInYear(delta) {
                const daysInYear = computeIsoDaysInYear(yearOfWeek + delta), sign = delta || 1, y1WeekShift = computeWeekShift(modFloor(y0DayOfWeek + daysInYear * sign, 7));
                return weeksInYear = (daysInYear + (y1WeekShift - y0WeekShift) * sign) / 7;
            }
            const minDaysInWeek = this.id ? 1 : 4, isoDayOfWeek = computeIsoDayOfWeek(isoDateFields), isoDayOfYear = this.dayOfYear(isoDateFields), dayOfWeek = modFloor(isoDayOfWeek - 1, 7), dayOfYear = isoDayOfYear - 1, y0DayOfWeek = modFloor(dayOfWeek - dayOfYear, 7), y0WeekShift = computeWeekShift(y0DayOfWeek);
            let weeksInYear, weekOfYear = Math.floor((dayOfYear - y0WeekShift) / 7) + 1, yearOfWeek = isoDateFields.isoYear;
            return weekOfYear ? weekOfYear > computeWeeksInYear(0) && (weekOfYear = 1, yearOfWeek++) : (weekOfYear = computeWeeksInYear(-1), yearOfWeek--), [
                weekOfYear,
                yearOfWeek,
                weeksInYear
            ];
        }
    }, isoStandardOps = {
        ...nativeStandardBase,
        ...isoWeekOps,
        dateParts: computeIsoDateParts,
        eraParts (isoFields) {
            return this.id === gregoryCalendarId ? computeGregoryEraParts(isoFields) : "japanese" === this.id ? queryJapaneseEraParts(isoFields) : [];
        },
        monthCodeParts (_isoYear, isoMonth) {
            return [
                isoMonth,
                0
            ];
        },
        yearMonthForMonthDay (monthCodeNumber, isLeapMonth) {
            if (!isLeapMonth) return [
                isoEpochFirstLeapYear,
                monthCodeNumber
            ];
        },
        inLeapYearPart: computeIsoInLeapYear,
        leapMonth () {},
        monthsInYearPart: computeIsoMonthsInYear,
        monthsInYearSpan: (yearDelta)=>yearDelta * isoMonthsInYear,
        daysInMonthParts: computeIsoDaysInMonth,
        daysInYearPart: computeIsoDaysInYear,
        isoFields (year, month, day) {
            return {
                isoYear: year,
                isoMonth: month,
                isoDay: day
            };
        },
        epochMilli: isoArgsToEpochMilli,
        monthAdd (year, month, monthDelta) {
            return year += divTrunc(monthDelta, isoMonthsInYear), (month += modTrunc(monthDelta, isoMonthsInYear)) < 1 ? (year--, month += isoMonthsInYear) : month > isoMonthsInYear && (year++, month -= isoMonthsInYear), [
                year,
                month
            ];
        },
        year (isoFields) {
            return isoFields.isoYear;
        },
        month (isoFields) {
            return isoFields.isoMonth;
        },
        day: (isoFields)=>isoFields.isoDay
    }, intlWeekOps = {
        dayOfYear: computeNativeDayOfYear,
        dateParts: computeIntlDateParts,
        epochMilli: computeIntlEpochMilli,
        weekOfYear: computeNativeWeekOfYear,
        yearOfWeek: computeNativeYearOfWeek,
        weekParts () {
            return [];
        }
    }, intlStandardOps = {
        ...nativeStandardBase,
        ...intlWeekOps,
        dateParts: computeIntlDateParts,
        eraParts (isoFields) {
            const intlFields = this.queryFields(isoFields);
            return [
                intlFields.era,
                intlFields.eraYear
            ];
        },
        monthCodeParts (year, month) {
            const leapMonth = computeIntlLeapMonth.call(this, year);
            return [
                monthToMonthCodeNumber(month, leapMonth),
                leapMonth === month
            ];
        },
        yearMonthForMonthDay (monthCodeNumber, isLeapMonth, day) {
            let [startYear, startMonth, startDay] = computeIntlDateParts.call(this, {
                isoYear: isoEpochFirstLeapYear,
                isoMonth: isoMonthsInYear,
                isoDay: 31
            });
            const startYearLeapMonth = computeIntlLeapMonth.call(this, startYear), startMonthIsLeap = startMonth === startYearLeapMonth;
            1 === (compareNumbers(monthCodeNumber, monthToMonthCodeNumber(startMonth, startYearLeapMonth)) || compareNumbers(Number(isLeapMonth), Number(startMonthIsLeap)) || compareNumbers(day, startDay)) && startYear--;
            for(let yearMove = 0; yearMove < 100; yearMove++){
                const tryYear = startYear - yearMove, tryLeapMonth = computeIntlLeapMonth.call(this, tryYear), tryMonth = monthCodeNumberToMonth(monthCodeNumber, isLeapMonth, tryLeapMonth);
                if (isLeapMonth === (tryMonth === tryLeapMonth) && day <= computeIntlDaysInMonth.call(this, tryYear, tryMonth)) return [
                    tryYear,
                    tryMonth
                ];
            }
        },
        inLeapYearPart (year) {
            const days = computeIntlDaysInYear.call(this, year);
            return days > computeIntlDaysInYear.call(this, year - 1) && days > computeIntlDaysInYear.call(this, year + 1);
        },
        leapMonth: computeIntlLeapMonth,
        monthsInYearPart: computeIntlMonthsInYear,
        monthsInYearSpan (yearDelta, yearStart) {
            const yearEnd = yearStart + yearDelta, yearSign = Math.sign(yearDelta), yearCorrection = yearSign < 0 ? -1 : 0;
            let months = 0;
            for(let year = yearStart; year !== yearEnd; year += yearSign)months += computeIntlMonthsInYear.call(this, year + yearCorrection);
            return months;
        },
        daysInMonthParts: computeIntlDaysInMonth,
        daysInYearPart: computeIntlDaysInYear,
        isoFields (year, month, day) {
            return epochMilliToIso(computeIntlEpochMilli.call(this, year, month, day));
        },
        epochMilli: computeIntlEpochMilli,
        monthAdd (year, month, monthDelta) {
            if (monthDelta) {
                if (month += monthDelta, !Number.isSafeInteger(month)) throw new RangeError(outOfBoundsDate);
                if (monthDelta < 0) for(; month < 1;)month += computeIntlMonthsInYear.call(this, --year);
                else {
                    let monthsInYear;
                    for(; month > (monthsInYear = computeIntlMonthsInYear.call(this, year));)month -= monthsInYear, year++;
                }
            }
            return [
                year,
                month
            ];
        },
        year (isoFields) {
            return this.queryFields(isoFields).year;
        },
        month (isoFields) {
            const { year: year, monthString: monthString } = this.queryFields(isoFields), { monthStringToIndex: monthStringToIndex } = this.queryYearData(year);
            return monthStringToIndex[monthString] + 1;
        },
        day (isoFields) {
            return this.queryFields(isoFields).day;
        }
    }, createNativeStandardOps = (isoOps = isoStandardOps, intlOps = intlStandardOps, (calendarId)=>calendarId === isoCalendarId ? isoOps : calendarId === gregoryCalendarId || "japanese" === calendarId ? Object.assign(Object.create(isoOps), {
            id: calendarId
        }) : Object.assign(Object.create(intlOps), queryIntlCalendar(calendarId)));
    var isoOps, intlOps;
    const timeZoneNameStrs = [
        "timeZoneName"
    ], monthDayFallbacks = {
        month: "numeric",
        day: "numeric"
    }, yearMonthFallbacks = {
        year: "numeric",
        month: "numeric"
    }, dateFallbacks = {
        ...yearMonthFallbacks,
        day: "numeric"
    }, timeFallbacks = {
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    }, dateTimeFallbacks = {
        ...dateFallbacks,
        ...timeFallbacks
    }, zonedFallbacks = {
        ...dateTimeFallbacks,
        timeZoneName: "short"
    }, yearMonthFallbackNames = Object.keys(yearMonthFallbacks), monthDayFallbackNames = Object.keys(monthDayFallbacks), dateFallbackNames = Object.keys(dateFallbacks), timeFallbackNames = Object.keys(timeFallbacks), dateStyleNames = [
        "dateStyle"
    ], yearMonthStandardNames = [
        ...yearMonthFallbackNames,
        ...dateStyleNames
    ], monthDayStandardNames = [
        ...monthDayFallbackNames,
        ...dateStyleNames
    ], dateStandardNames = [
        ...dateFallbackNames,
        ...dateStyleNames,
        "weekday"
    ], timeStandardNames = [
        ...timeFallbackNames,
        "dayPeriod",
        "timeStyle"
    ], dateTimeStandardNames = [
        ...dateStandardNames,
        ...timeStandardNames
    ], zonedStandardNames = [
        ...dateTimeStandardNames,
        ...timeZoneNameStrs
    ], dateExclusions = [
        ...timeZoneNameStrs,
        ...timeStandardNames
    ], timeExclusions = [
        ...timeZoneNameStrs,
        ...dateStandardNames
    ], yearMonthExclusions = [
        ...timeZoneNameStrs,
        "day",
        "weekday",
        ...timeStandardNames
    ], monthDayExclusions = [
        ...timeZoneNameStrs,
        "year",
        "weekday",
        ...timeStandardNames
    ], transformInstantOptions = createOptionsTransformer(dateTimeStandardNames, dateTimeFallbacks), transformZonedOptions = createOptionsTransformer(zonedStandardNames, zonedFallbacks), transformDateTimeOptions = createOptionsTransformer(dateTimeStandardNames, dateTimeFallbacks, timeZoneNameStrs), transformDateOptions = createOptionsTransformer(dateStandardNames, dateFallbacks, dateExclusions), transformTimeOptions = createOptionsTransformer(timeStandardNames, timeFallbacks, timeExclusions), transformYearMonthOptions = createOptionsTransformer(yearMonthStandardNames, yearMonthFallbacks, yearMonthExclusions), transformMonthDayOptions = createOptionsTransformer(monthDayStandardNames, monthDayFallbacks, monthDayExclusions), emptyOptions = {}, instantConfig = [
        transformInstantOptions,
        getEpochMilli
    ], zonedConfig = [
        transformZonedOptions,
        getEpochMilli,
        0,
        (slots0, slots1)=>{
            const timeZoneId = getId(slots0.timeZone);
            if (slots1 && getId(slots1.timeZone) !== timeZoneId) throw new RangeError(mismatchingTimeZones);
            return timeZoneId;
        }
    ], dateTimeConfig = [
        transformDateTimeOptions,
        isoToEpochMilli
    ], dateConfig = [
        transformDateOptions,
        isoToEpochMilli
    ], timeConfig = [
        transformTimeOptions,
        (isoFields)=>isoTimeFieldsToNano(isoFields) / nanoInMilli
    ], yearMonthConfig = [
        transformYearMonthOptions,
        isoToEpochMilli,
        1
    ], monthDayConfig = [
        transformMonthDayOptions,
        isoToEpochMilli,
        1
    ], classFormatConfigs = {
        Instant: instantConfig,
        PlainDateTime: dateTimeConfig,
        PlainDate: dateConfig,
        PlainTime: timeConfig,
        PlainYearMonth: yearMonthConfig,
        PlainMonthDay: monthDayConfig
    }, prepInstantFormat = createFormatPrepper(instantConfig), prepZonedDateTimeFormat = createFormatPrepper(zonedConfig), prepPlainDateTimeFormat = createFormatPrepper(dateTimeConfig), prepPlainDateFormat = createFormatPrepper(dateConfig), prepPlainTimeFormat = createFormatPrepper(timeConfig), prepPlainYearMonthFormat = createFormatPrepper(yearMonthConfig), prepPlainMonthDayFormat = createFormatPrepper(monthDayConfig), yearMonthOnlyRefiners = {
        era (input) {
            if (void 0 !== input) return requireString(input);
        },
        eraYear: requireIntegerOrUndefined,
        year: requireInteger,
        month: requirePositiveInteger,
        daysInMonth: requirePositiveInteger,
        daysInYear: requirePositiveInteger,
        inLeapYear: requireBoolean,
        monthsInYear: requirePositiveInteger
    }, monthOnlyRefiners = {
        monthCode: requireString
    }, dayOnlyRefiners = {
        day: requirePositiveInteger
    }, dateOnlyRefiners = {
        dayOfWeek: requirePositiveInteger,
        dayOfYear: requirePositiveInteger,
        weekOfYear (input) {
            if (void 0 !== input) return requirePositiveInteger(input);
        },
        yearOfWeek: requireIntegerOrUndefined,
        daysInWeek: requirePositiveInteger
    }, dateRefiners = {
        ...yearMonthOnlyRefiners,
        ...monthOnlyRefiners,
        ...dayOnlyRefiners,
        ...dateOnlyRefiners
    }, slotsMap = new WeakMap, getSlots = slotsMap.get.bind(slotsMap), setSlots = slotsMap.set.bind(slotsMap), calendarFieldMethods = {
        ...createCalendarFieldMethods(yearMonthOnlyRefiners, [
            PlainYearMonthBranding
        ]),
        ...createCalendarFieldMethods(dateOnlyRefiners, []),
        ...createCalendarFieldMethods(monthOnlyRefiners, [
            PlainYearMonthBranding,
            PlainMonthDayBranding
        ]),
        ...createCalendarFieldMethods(dayOnlyRefiners, [
            PlainMonthDayBranding
        ])
    }, dateGetters = createCalendarGetters(dateRefiners), yearMonthGetters = createCalendarGetters({
        ...yearMonthOnlyRefiners,
        ...monthOnlyRefiners
    }), monthDayGetters = createCalendarGetters({
        ...monthOnlyRefiners,
        ...dayOnlyRefiners
    }), calendarIdGetters = {
        calendarId: (slots)=>getId(slots.calendar)
    }, adapterSimpleOps = mapProps((refiner, methodName)=>function(isoFields) {
            const { calendarProtocol: calendarProtocol } = this;
            return refiner(calendarProtocol[methodName](createPlainDate(createPlainDateSlots(isoFields, calendarProtocol))));
        }, dateRefiners), durationGetters = mapPropNames((propName)=>(slots)=>slots[propName], durationFieldNamesAsc.concat("sign")), timeGetters = mapPropNames((_name, i)=>(slots)=>slots[isoTimeFieldNamesAsc[i]], timeFieldNamesAsc), epochGetters = {
        epochSeconds (slots) {
            return epochNanoToSec(slots.epochNanoseconds);
        },
        epochMilliseconds: getEpochMilli,
        epochMicroseconds (slots) {
            return bigNanoToBigInt(slots.epochNanoseconds, nanoInMicro);
        },
        epochNanoseconds (slots) {
            return bigNanoToBigInt(slots.epochNanoseconds);
        }
    }, removeBranding = bindArgs(excludePropsByName, new Set([
        "branding"
    ])), [PlainMonthDay, createPlainMonthDay, getPlainMonthDaySlots] = createSlotClass(PlainMonthDayBranding, bindArgs((refineCalendarArg, isoMonth, isoDay, calendar = isoCalendarId, referenceIsoYear = isoEpochFirstLeapYear)=>{
        const isoMonthInt = toInteger(isoMonth), isoDayInt = toInteger(isoDay), calendarSlot = refineCalendarArg(calendar);
        return createPlainMonthDaySlots(checkIsoDateInBounds(checkIsoDateFields({
            isoYear: toInteger(referenceIsoYear),
            isoMonth: isoMonthInt,
            isoDay: isoDayInt
        })), calendarSlot);
    }, refineCalendarSlot), {
        ...calendarIdGetters,
        ...monthDayGetters
    }, {
        getISOFields: removeBranding,
        getCalendar: createCalendarFromSlots,
        with (slots, mod, options) {
            return createPlainMonthDay(((getCalendarOps, plainMonthDaySlots, initialFields, modFields, options)=>{
                const optionsCopy = copyOptions(options);
                return ((calendarOps, initialFields, modFields, options)=>{
                    const fields = mergeCalendarFields(calendarOps, initialFields, modFields, dateFieldNamesAlpha);
                    return calendarOps.monthDayFromFields(fields, options);
                })(getCalendarOps(plainMonthDaySlots.calendar), initialFields, modFields, optionsCopy);
            })(createMonthDayModOps, slots, this, rejectInvalidBag(mod), options));
        },
        equals (slots, otherArg) {
            var plainMonthDaySlots0, plainMonthDaySlots1;
            return !compareIsoDateFields(plainMonthDaySlots0 = slots, plainMonthDaySlots1 = toPlainMonthDaySlots(otherArg)) && isIdLikeEqual(plainMonthDaySlots0.calendar, plainMonthDaySlots1.calendar);
        },
        toPlainDate (slots, bag) {
            return createPlainDate(((getCalendarOps, plainMonthDaySlots, plainMonthDayFields, bag)=>((calendarOps, input, bag)=>convertToIso(calendarOps, input, monthCodeDayFieldNames, requireObjectLike(bag), yearFieldNames))(getCalendarOps(plainMonthDaySlots.calendar), plainMonthDayFields, bag))(createDateModOps, slots, this, bag));
        },
        toLocaleString (slots, locales, options) {
            const [format, epochMilli] = prepPlainMonthDayFormat(locales, options, slots);
            return format.format(epochMilli);
        },
        toString: formatPlainMonthDayIso,
        toJSON: (slots)=>formatPlainMonthDayIso(slots),
        valueOf: neverValueOf
    }, {
        from: (arg, options)=>createPlainMonthDay(toPlainMonthDaySlots(arg, options))
    }), timeZoneAdapters = {
        getOffsetNanosecondsFor: getOffsetNanosecondsForAdapter,
        getPossibleInstantsFor (timeZoneProtocol, getPossibleInstantsFor, isoFields) {
            const epochNanos = [
                ...getPossibleInstantsFor.call(timeZoneProtocol, createPlainDateTime(createPlainDateTimeSlots(isoFields, isoCalendarId)))
            ].map((instant)=>getInstantSlots(instant).epochNanoseconds), epochNanoLen = epochNanos.length;
            return epochNanoLen > 1 && (epochNanos.sort(compareBigNanos), validateTimeZoneGap(bigNanoToNumber(diffBigNanos(epochNanos[0], epochNanos[epochNanoLen - 1])))), epochNanos;
        }
    }, simpleTimeZoneAdapters = {
        getOffsetNanosecondsFor: getOffsetNanosecondsForAdapter
    }, [TimeZone, createTimeZone] = createSlotClass("TimeZone", (id)=>{
        const slotId = ((id)=>resolveTimeZoneId(requireString(id)))(id);
        return {
            branding: "TimeZone",
            id: slotId,
            native: queryNativeTimeZone(slotId)
        };
    }, {
        id: (slots)=>slots.id
    }, {
        getPossibleInstantsFor: ({ native: native }, plainDateTimeArg)=>native.getPossibleInstantsFor(toPlainDateTimeSlots(plainDateTimeArg)).map((epochNano)=>createInstant(createInstantSlots(epochNano))),
        getOffsetNanosecondsFor: ({ native: native }, instantArg)=>native.getOffsetNanosecondsFor(toInstantSlots(instantArg).epochNanoseconds),
        getOffsetStringFor (_slots, instantArg) {
            const epochNano = toInstantSlots(instantArg).epochNanoseconds;
            return formatOffsetNano(createAdapterOps(this, simpleTimeZoneAdapters).getOffsetNanosecondsFor(epochNano));
        },
        getPlainDateTimeFor (_slots, instantArg, calendarArg = isoCalendarId) {
            const epochNano = toInstantSlots(instantArg).epochNanoseconds, offsetNano = createAdapterOps(this, simpleTimeZoneAdapters).getOffsetNanosecondsFor(epochNano);
            return createPlainDateTime(createPlainDateTimeSlots(epochNanoToIso(epochNano, offsetNano), refineCalendarSlot(calendarArg)));
        },
        getInstantFor (_slots, plainDateTimeArg, options) {
            const isoFields = toPlainDateTimeSlots(plainDateTimeArg), epochDisambig = refineEpochDisambigOptions(options), calendarOps = createAdapterOps(this);
            return createInstant(createInstantSlots(getSingleInstantFor(calendarOps, isoFields, epochDisambig)));
        },
        getNextTransition: ({ native: native }, instantArg)=>getImplTransition(1, native, instantArg),
        getPreviousTransition: ({ native: native }, instantArg)=>getImplTransition(-1, native, instantArg),
        equals (_slots, otherArg) {
            return !!isTimeZoneSlotsEqual(this, refineTimeZoneSlot(otherArg));
        },
        toString: (slots)=>slots.id,
        toJSON: (slots)=>slots.id
    }, {
        from (arg) {
            const timeZoneSlot = refineTimeZoneSlot(arg);
            return "string" == typeof timeZoneSlot ? new TimeZone(timeZoneSlot) : timeZoneSlot;
        }
    }), validateTimeZoneProtocol = createProtocolValidator(Object.keys(timeZoneAdapters)), [PlainYearMonth, createPlainYearMonth, getPlainYearMonthSlots] = createSlotClass(PlainYearMonthBranding, bindArgs((refineCalendarArg, isoYear, isoMonth, calendar = isoCalendarId, referenceIsoDay = 1)=>{
        const isoYearInt = toInteger(isoYear), isoMonthInt = toInteger(isoMonth), calendarSlot = refineCalendarArg(calendar);
        return createPlainYearMonthSlots(checkIsoYearMonthInBounds(checkIsoDateFields({
            isoYear: isoYearInt,
            isoMonth: isoMonthInt,
            isoDay: toInteger(referenceIsoDay)
        })), calendarSlot);
    }, refineCalendarSlot), {
        ...calendarIdGetters,
        ...yearMonthGetters
    }, {
        getISOFields: removeBranding,
        getCalendar: createCalendarFromSlots,
        with (slots, mod, options) {
            return createPlainYearMonth(((getCalendarOps, plainYearMonthSlots, initialFields, modFields, options)=>{
                const optionsCopy = copyOptions(options);
                return createPlainYearMonthSlots(((calendarOps, initialFields, modFields, options)=>{
                    const fields = mergeCalendarFields(calendarOps, initialFields, modFields, yearMonthFieldNames);
                    return calendarOps.yearMonthFromFields(fields, options);
                })(getCalendarOps(plainYearMonthSlots.calendar), initialFields, modFields, optionsCopy));
            })(createYearMonthModOps, slots, this, rejectInvalidBag(mod), options));
        },
        add: (slots, durationArg, options)=>createPlainYearMonth(movePlainYearMonth(createYearMonthMoveOps, 0, slots, toDurationSlots(durationArg), options)),
        subtract: (slots, durationArg, options)=>createPlainYearMonth(movePlainYearMonth(createYearMonthMoveOps, 1, slots, toDurationSlots(durationArg), options)),
        until: (slots, otherArg, options)=>createDuration(diffPlainYearMonth(createYearMonthDiffOps, 0, slots, toPlainYearMonthSlots(otherArg), options)),
        since: (slots, otherArg, options)=>createDuration(diffPlainYearMonth(createYearMonthDiffOps, 1, slots, toPlainYearMonthSlots(otherArg), options)),
        equals (slots, otherArg) {
            var plainYearMonthSlots0, plainYearMonthSlots1;
            return !compareIsoDateFields(plainYearMonthSlots0 = slots, plainYearMonthSlots1 = toPlainYearMonthSlots(otherArg)) && isIdLikeEqual(plainYearMonthSlots0.calendar, plainYearMonthSlots1.calendar);
        },
        toPlainDate (slots, bag) {
            return createPlainDate(((getCalendarOps, plainYearMonthSlots, plainYearMonthFields, bag)=>((calendarOps, input, bag)=>convertToIso(calendarOps, input, yearMonthCodeFieldNames, requireObjectLike(bag), dayFieldNames))(getCalendarOps(plainYearMonthSlots.calendar), plainYearMonthFields, bag))(createDateModOps, slots, this, bag));
        },
        toLocaleString (slots, locales, options) {
            const [format, epochMilli] = prepPlainYearMonthFormat(locales, options, slots);
            return format.format(epochMilli);
        },
        toString: formatPlainYearMonthIso,
        toJSON: (slots)=>formatPlainYearMonthIso(slots),
        valueOf: neverValueOf
    }, {
        from: (arg, options)=>createPlainYearMonth(toPlainYearMonthSlots(arg, options)),
        compare: (arg0, arg1)=>compareIsoDateFields(toPlainYearMonthSlots(arg0), toPlainYearMonthSlots(arg1))
    }), [ZonedDateTime, createZonedDateTime] = createSlotClass(ZonedDateTimeBranding, bindArgs((refineCalendarArg, refineTimeZoneArg, epochNano, timeZoneArg, calendarArg = isoCalendarId)=>createZonedDateTimeSlots(checkEpochNanoInBounds(bigIntToBigNano(toBigInt(epochNano))), refineTimeZoneArg(timeZoneArg), refineCalendarArg(calendarArg)), refineCalendarSlot, refineTimeZoneSlot), {
        ...epochGetters,
        ...calendarIdGetters,
        ...adaptDateMethods(dateGetters),
        ...adaptDateMethods(timeGetters),
        offset: (slots)=>formatOffsetNano(slotsToIso(slots).offsetNanoseconds),
        offsetNanoseconds: (slots)=>slotsToIso(slots).offsetNanoseconds,
        timeZoneId: (slots)=>getId(slots.timeZone),
        hoursInDay: (slots)=>((getTimeZoneOps, slots)=>{
                const timeZoneOps = getTimeZoneOps(slots.timeZone), isoFields = zonedEpochSlotsToIso(slots, timeZoneOps), [isoFields0, isoFields1] = computeDayInterval(isoFields), hoursExact = bigNanoToNumber(diffBigNanos(getSingleInstantFor(timeZoneOps, isoFields0), getSingleInstantFor(timeZoneOps, isoFields1)), nanoInHour, 1);
                if (hoursExact <= 0) throw new RangeError(invalidProtocolResults);
                return hoursExact;
            })(createTimeZoneOps, slots)
    }, {
        getISOFields: (slots)=>((getTimeZoneOps, zonedDateTimeSlots)=>{
                const isoFields = zonedEpochSlotsToIso(zonedDateTimeSlots, getTimeZoneOps);
                return {
                    calendar: zonedDateTimeSlots.calendar,
                    ...pluckProps(isoDateTimeFieldNamesAlpha, isoFields),
                    offset: formatOffsetNano(isoFields.offsetNanoseconds),
                    timeZone: zonedDateTimeSlots.timeZone
                };
            })(createTimeZoneOffsetOps, slots),
        getCalendar: createCalendarFromSlots,
        getTimeZone: ({ timeZone: timeZone })=>"string" == typeof timeZone ? new TimeZone(timeZone) : timeZone,
        with (slots, mod, options) {
            return createZonedDateTime(((getCalendarOps, getTimeZoneOps, zonedDateTimeSlots, initialFields, modFields, options)=>{
                const optionsCopy = copyOptions(options), { calendar: calendar, timeZone: timeZone } = zonedDateTimeSlots;
                return createZonedDateTimeSlots(((calendarOps, timeZoneOps, initialFields, modFields, options)=>{
                    const fields = mergeCalendarFields(calendarOps, initialFields, modFields, dateFieldNamesAlpha, timeAndOffsetFieldNames, offsetFieldNames), [overflow, offsetDisambig, epochDisambig] = refineZonedFieldOptions(options, 2);
                    return getMatchingInstantFor(timeZoneOps, {
                        ...calendarOps.dateFromFields(fields, overrideOverflowOptions(options, overflow)),
                        ...refineTimeBag(fields, overflow)
                    }, parseOffsetNano(fields.offset), offsetDisambig, epochDisambig);
                })(getCalendarOps(calendar), getTimeZoneOps(timeZone), initialFields, modFields, optionsCopy), timeZone, calendar);
            })(createDateModOps, createTimeZoneOps, slots, this, rejectInvalidBag(mod), options));
        },
        withCalendar: (slots, calendarArg)=>createZonedDateTime(slotsWithCalendar(slots, refineCalendarSlot(calendarArg))),
        withTimeZone: (slots, timeZoneArg)=>createZonedDateTime(((slots, timeZoneSlot)=>({
                    ...slots,
                    timeZone: timeZoneSlot
                }))(slots, refineTimeZoneSlot(timeZoneArg))),
        withPlainDate: (slots, plainDateArg)=>createZonedDateTime(((getTimeZoneOps, zonedDateTimeSlots, plainDateSlots)=>{
                const timeZoneSlot = zonedDateTimeSlots.timeZone, timeZoneOps = getTimeZoneOps(timeZoneSlot), isoFields = {
                    ...zonedEpochSlotsToIso(zonedDateTimeSlots, timeZoneOps),
                    ...plainDateSlots
                }, calendar = getPreferredCalendarSlot(zonedDateTimeSlots.calendar, plainDateSlots.calendar);
                return createZonedDateTimeSlots(getMatchingInstantFor(timeZoneOps, isoFields, isoFields.offsetNanoseconds, 2), timeZoneSlot, calendar);
            })(createTimeZoneOps, slots, toPlainDateSlots(plainDateArg))),
        withPlainTime: (slots, plainTimeArg)=>createZonedDateTime(((getTimeZoneOps, zonedDateTimeSlots, plainTimeSlots = isoTimeFieldDefaults)=>{
                const timeZoneSlot = zonedDateTimeSlots.timeZone, timeZoneOps = getTimeZoneOps(timeZoneSlot), isoFields = {
                    ...zonedEpochSlotsToIso(zonedDateTimeSlots, timeZoneOps),
                    ...plainTimeSlots
                };
                return createZonedDateTimeSlots(getMatchingInstantFor(timeZoneOps, isoFields, isoFields.offsetNanoseconds, 2), timeZoneSlot, zonedDateTimeSlots.calendar);
            })(createTimeZoneOps, slots, optionalToPlainTimeFields(plainTimeArg))),
        add: (slots, durationArg, options)=>createZonedDateTime(moveZonedDateTime(createMoveOps, createTimeZoneOps, 0, slots, toDurationSlots(durationArg), options)),
        subtract: (slots, durationArg, options)=>createZonedDateTime(moveZonedDateTime(createMoveOps, createTimeZoneOps, 1, slots, toDurationSlots(durationArg), options)),
        until: (slots, otherArg, options)=>createDuration(createDurationSlots(diffZonedDateTimes(createDiffOps, createTimeZoneOps, 0, slots, toZonedDateTimeSlots(otherArg), options))),
        since: (slots, otherArg, options)=>createDuration(createDurationSlots(diffZonedDateTimes(createDiffOps, createTimeZoneOps, 1, slots, toZonedDateTimeSlots(otherArg), options))),
        round: (slots, options)=>createZonedDateTime(((getTimeZoneOps, slots, options)=>{
                let { epochNanoseconds: epochNanoseconds, timeZone: timeZone, calendar: calendar } = slots;
                const [smallestUnit, roundingInc, roundingMode] = refineRoundingOptions(options);
                if (0 === smallestUnit && 1 === roundingInc) return slots;
                const timeZoneOps = getTimeZoneOps(timeZone);
                if (6 === smallestUnit) epochNanoseconds = ((computeInterval, timeZoneOps, slots, roundingMode)=>{
                    const isoSlots = zonedEpochSlotsToIso(slots, timeZoneOps), [isoFields0, isoFields1] = computeInterval(isoSlots), epochNano = slots.epochNanoseconds, epochNano0 = getSingleInstantFor(timeZoneOps, isoFields0), epochNano1 = getSingleInstantFor(timeZoneOps, isoFields1);
                    if (bigNanoOutside(epochNano, epochNano0, epochNano1)) throw new RangeError(invalidProtocolResults);
                    return roundWithMode(computeEpochNanoFrac(epochNano, epochNano0, epochNano1), roundingMode) ? epochNano1 : epochNano0;
                })(computeDayInterval, timeZoneOps, slots, roundingMode);
                else {
                    const offsetNano = timeZoneOps.getOffsetNanosecondsFor(epochNanoseconds);
                    epochNanoseconds = getMatchingInstantFor(timeZoneOps, roundDateTime(epochNanoToIso(epochNanoseconds, offsetNano), smallestUnit, roundingInc, roundingMode), offsetNano, 2, 0, 1);
                }
                return createZonedDateTimeSlots(epochNanoseconds, timeZone, calendar);
            })(createTimeZoneOps, slots, options)),
        startOfDay: (slots)=>createZonedDateTime(((getTimeZoneOps, slots)=>{
                const { timeZone: timeZone, calendar: calendar } = slots, epochNano1 = ((computeAlignment, timeZoneOps, slots)=>getSingleInstantFor(timeZoneOps, computeAlignment(zonedEpochSlotsToIso(slots, timeZoneOps))))(computeDayFloor, getTimeZoneOps(timeZone), slots);
                return createZonedDateTimeSlots(epochNano1, timeZone, calendar);
            })(createTimeZoneOps, slots)),
        equals (slots, otherArg) {
            var zonedDateTimeSlots0, zonedDateTimeSlots1;
            return !compareZonedDateTimes(zonedDateTimeSlots0 = slots, zonedDateTimeSlots1 = toZonedDateTimeSlots(otherArg)) && !!isTimeZoneSlotsEqual(zonedDateTimeSlots0.timeZone, zonedDateTimeSlots1.timeZone) && isIdLikeEqual(zonedDateTimeSlots0.calendar, zonedDateTimeSlots1.calendar);
        },
        toInstant: (slots)=>createInstant(createInstantSlots(slots.epochNanoseconds)),
        toPlainDateTime: (slots)=>createPlainDateTime(zonedDateTimeToPlainDateTime(createTimeZoneOffsetOps, slots)),
        toPlainDate: (slots)=>createPlainDate(zonedDateTimeToPlainDate(createTimeZoneOffsetOps, slots)),
        toPlainTime: (slots)=>createPlainTime(zonedDateTimeToPlainTime(createTimeZoneOffsetOps, slots)),
        toPlainYearMonth (slots) {
            return createPlainYearMonth(convertToPlainYearMonth(createYearMonthRefineOps(slots.calendar), this));
        },
        toPlainMonthDay (slots) {
            return createPlainMonthDay(convertToPlainMonthDay(createMonthDayRefineOps(slots.calendar), this));
        },
        toLocaleString (slots, locales, options = {}) {
            const [format, epochMilli] = prepZonedDateTimeFormat(locales, options, slots);
            return format.format(epochMilli);
        },
        toString: (slots, options)=>formatZonedDateTimeIso(createTimeZoneOffsetOps, slots, options),
        toJSON: (slots)=>formatZonedDateTimeIso(createTimeZoneOffsetOps, slots),
        valueOf: neverValueOf
    }, {
        from: (arg, options)=>createZonedDateTime(toZonedDateTimeSlots(arg, options)),
        compare: (arg0, arg1)=>compareZonedDateTimes(toZonedDateTimeSlots(arg0), toZonedDateTimeSlots(arg1))
    }), [PlainTime, createPlainTime] = createSlotClass(PlainTimeBranding, (isoHour = 0, isoMinute = 0, isoSecond = 0, isoMillisecond = 0, isoMicrosecond = 0, isoNanosecond = 0)=>createPlainTimeSlots(constrainIsoTimeFields(mapProps(toInteger, zipProps(isoTimeFieldNamesAsc, [
            isoHour,
            isoMinute,
            isoSecond,
            isoMillisecond,
            isoMicrosecond,
            isoNanosecond
        ])), 1)), timeGetters, {
        getISOFields: removeBranding,
        with (_slots, mod, options) {
            return createPlainTime(((initialFields, mod, options)=>createPlainTimeSlots(((initialFields, modFields, options)=>{
                    const overflow = refineOverflowOptions(options);
                    return refineTimeBag({
                        ...pluckProps(timeFieldNamesAlpha, initialFields),
                        ...refineFields(modFields, timeFieldNamesAlpha)
                    }, overflow);
                })(initialFields, mod, options)))(this, rejectInvalidBag(mod), options));
        },
        add: (slots, durationArg)=>createPlainTime(movePlainTime(0, slots, toDurationSlots(durationArg))),
        subtract: (slots, durationArg)=>createPlainTime(movePlainTime(1, slots, toDurationSlots(durationArg))),
        until: (slots, otherArg, options)=>createDuration(diffPlainTimes(0, slots, toPlainTimeSlots(otherArg), options)),
        since: (slots, otherArg, options)=>createDuration(diffPlainTimes(1, slots, toPlainTimeSlots(otherArg), options)),
        round: (slots, options)=>createPlainTime(((slots, options)=>{
                const [a, b, c] = refineRoundingOptions(options, 5);
                var roundingMode;
                return createPlainTimeSlots((roundingMode = c, roundTimeToNano(slots, computeNanoInc(a, b), roundingMode)[0]));
            })(slots, options)),
        equals (slots, other) {
            return !compareIsoTimeFields(slots, toPlainTimeSlots(other));
        },
        toZonedDateTime: (slots, options)=>createZonedDateTime(((refineTimeZoneArg, refinePlainDateArg, getTimeZoneOps, slots, options)=>{
                const refinedOptions = requireObjectLike(options), plainDateSlots = refinePlainDateArg(refinedOptions.plainDate), timeZoneSlot = refineTimeZoneArg(refinedOptions.timeZone);
                return createZonedDateTimeSlots(getSingleInstantFor(getTimeZoneOps(timeZoneSlot), {
                    ...plainDateSlots,
                    ...slots
                }), timeZoneSlot, plainDateSlots.calendar);
            })(refineTimeZoneSlot, toPlainDateSlots, createTimeZoneOps, slots, options)),
        toPlainDateTime (slots, plainDateArg) {
            var plainTimeSlots0, plainDateSlots1;
            return createPlainDateTime((plainTimeSlots0 = slots, plainDateSlots1 = toPlainDateSlots(plainDateArg), createPlainDateTimeSlots(checkIsoDateTimeInBounds({
                ...plainTimeSlots0,
                ...plainDateSlots1
            }))));
        },
        toLocaleString (slots, locales, options) {
            const [format, epochMilli] = prepPlainTimeFormat(locales, options, slots);
            return format.format(epochMilli);
        },
        toString: formatPlainTimeIso,
        toJSON: (slots)=>formatPlainTimeIso(slots),
        valueOf: neverValueOf
    }, {
        from: (arg, options)=>createPlainTime(toPlainTimeSlots(arg, options)),
        compare: (arg0, arg1)=>compareIsoTimeFields(toPlainTimeSlots(arg0), toPlainTimeSlots(arg1))
    }), [PlainDateTime, createPlainDateTime] = createSlotClass(PlainDateTimeBranding, bindArgs((refineCalendarArg, isoYear, isoMonth, isoDay, isoHour = 0, isoMinute = 0, isoSecond = 0, isoMillisecond = 0, isoMicrosecond = 0, isoNanosecond = 0, calendarArg = isoCalendarId)=>createPlainDateTimeSlots(checkIsoDateTimeInBounds(checkIsoDateTimeFields(mapProps(toInteger, zipProps(isoDateTimeFieldNamesAsc, [
            isoYear,
            isoMonth,
            isoDay,
            isoHour,
            isoMinute,
            isoSecond,
            isoMillisecond,
            isoMicrosecond,
            isoNanosecond
        ])))), refineCalendarArg(calendarArg)), refineCalendarSlot), {
        ...calendarIdGetters,
        ...dateGetters,
        ...timeGetters
    }, {
        getISOFields: removeBranding,
        getCalendar: createCalendarFromSlots,
        with (slots, mod, options) {
            return createPlainDateTime(((getCalendarOps, plainDateTimeSlots, initialFields, modFields, options)=>{
                const optionsCopy = copyOptions(options);
                return createPlainDateTimeSlots(((calendarOps, initialFields, modFields, options)=>{
                    const fields = mergeCalendarFields(calendarOps, initialFields, modFields, dateFieldNamesAlpha, timeFieldNamesAsc), overflow = refineOverflowOptions(options);
                    return checkIsoDateTimeInBounds({
                        ...calendarOps.dateFromFields(fields, overrideOverflowOptions(options, overflow)),
                        ...refineTimeBag(fields, overflow)
                    });
                })(getCalendarOps(plainDateTimeSlots.calendar), initialFields, modFields, optionsCopy));
            })(createDateModOps, slots, this, rejectInvalidBag(mod), options));
        },
        withCalendar: (slots, calendarArg)=>createPlainDateTime(slotsWithCalendar(slots, refineCalendarSlot(calendarArg))),
        withPlainDate (slots, plainDateArg) {
            var plainDateTimeSlots, plainDateSlots;
            return createPlainDateTime((plainDateTimeSlots = slots, plainDateSlots = toPlainDateSlots(plainDateArg), createPlainDateTimeSlots({
                ...plainDateTimeSlots,
                ...plainDateSlots
            }, getPreferredCalendarSlot(plainDateTimeSlots.calendar, plainDateSlots.calendar))));
        },
        withPlainTime: (slots, plainTimeArg)=>createPlainDateTime(((plainDateTimeSlots, plainTimeSlots = isoTimeFieldDefaults)=>createPlainDateTimeSlots({
                    ...plainDateTimeSlots,
                    ...plainTimeSlots
                }))(slots, optionalToPlainTimeFields(plainTimeArg))),
        add: (slots, durationArg, options)=>createPlainDateTime(movePlainDateTime(createMoveOps, 0, slots, toDurationSlots(durationArg), options)),
        subtract: (slots, durationArg, options)=>createPlainDateTime(movePlainDateTime(createMoveOps, 1, slots, toDurationSlots(durationArg), options)),
        until: (slots, otherArg, options)=>createDuration(diffPlainDateTimes(createDiffOps, 0, slots, toPlainDateTimeSlots(otherArg), options)),
        since: (slots, otherArg, options)=>createDuration(diffPlainDateTimes(createDiffOps, 1, slots, toPlainDateTimeSlots(otherArg), options)),
        round: (slots, options)=>createPlainDateTime(((slots, options)=>createPlainDateTimeSlots(roundDateTime(slots, ...refineRoundingOptions(options)), slots.calendar))(slots, options)),
        equals (slots, otherArg) {
            var plainDateTimeSlots0, plainDateTimeSlots1;
            return !compareIsoDateTimeFields(plainDateTimeSlots0 = slots, plainDateTimeSlots1 = toPlainDateTimeSlots(otherArg)) && isIdLikeEqual(plainDateTimeSlots0.calendar, plainDateTimeSlots1.calendar);
        },
        toZonedDateTime: (slots, timeZoneArg, options)=>createZonedDateTime(((getTimeZoneOps, plainDateTimeSlots, timeZoneSlot, options)=>{
                const epochNano = ((getTimeZoneOps, timeZoneSlot, isoFields, options)=>{
                    const epochDisambig = refineEpochDisambigOptions(options);
                    return getSingleInstantFor(getTimeZoneOps(timeZoneSlot), isoFields, epochDisambig);
                })(getTimeZoneOps, timeZoneSlot, plainDateTimeSlots, options);
                return createZonedDateTimeSlots(checkEpochNanoInBounds(epochNano), timeZoneSlot, plainDateTimeSlots.calendar);
            })(createTimeZoneOps, slots, refineTimeZoneSlot(timeZoneArg), options)),
        toPlainDate: (slots)=>createPlainDate(createPlainDateSlots(slots)),
        toPlainTime: (slots)=>createPlainTime(createPlainTimeSlots(slots)),
        toPlainYearMonth (slots) {
            return createPlainYearMonth(((getCalendarOps, plainDateTimeSlots, plainDateFields)=>{
                const calendarOps = getCalendarOps(plainDateTimeSlots.calendar);
                return createPlainYearMonthSlots({
                    ...plainDateTimeSlots,
                    ...convertToPlainYearMonth(calendarOps, plainDateFields)
                });
            })(createYearMonthRefineOps, slots, this));
        },
        toPlainMonthDay (slots) {
            return createPlainMonthDay(convertToPlainMonthDay(createMonthDayRefineOps(slots.calendar), this));
        },
        toLocaleString (slots, locales, options) {
            const [format, epochMilli] = prepPlainDateTimeFormat(locales, options, slots);
            return format.format(epochMilli);
        },
        toString: formatPlainDateTimeIso,
        toJSON: (slots)=>formatPlainDateTimeIso(slots),
        valueOf: neverValueOf
    }, {
        from: (arg, options)=>createPlainDateTime(toPlainDateTimeSlots(arg, options)),
        compare: (arg0, arg1)=>compareIsoDateTimeFields(toPlainDateTimeSlots(arg0), toPlainDateTimeSlots(arg1))
    }), [PlainDate, createPlainDate, getPlainDateSlots] = createSlotClass(PlainDateBranding, bindArgs((refineCalendarArg, isoYear, isoMonth, isoDay, calendarArg = isoCalendarId)=>createPlainDateSlots(checkIsoDateInBounds(checkIsoDateFields(mapProps(toInteger, {
            isoYear: isoYear,
            isoMonth: isoMonth,
            isoDay: isoDay
        }))), refineCalendarArg(calendarArg)), refineCalendarSlot), {
        ...calendarIdGetters,
        ...dateGetters
    }, {
        getISOFields: removeBranding,
        getCalendar: createCalendarFromSlots,
        with (slots, mod, options) {
            return createPlainDate(((getCalendarOps, plainDateSlots, initialFields, modFields, options)=>{
                const optionsCopy = copyOptions(options);
                return ((calendarOps, initialFields, modFields, options)=>{
                    const fields = mergeCalendarFields(calendarOps, initialFields, modFields, dateFieldNamesAlpha);
                    return calendarOps.dateFromFields(fields, options);
                })(getCalendarOps(plainDateSlots.calendar), initialFields, modFields, optionsCopy);
            })(createDateModOps, slots, this, rejectInvalidBag(mod), options));
        },
        withCalendar: (slots, calendarArg)=>createPlainDate(slotsWithCalendar(slots, refineCalendarSlot(calendarArg))),
        add: (slots, durationArg, options)=>createPlainDate(movePlainDate(createMoveOps, 0, slots, toDurationSlots(durationArg), options)),
        subtract: (slots, durationArg, options)=>createPlainDate(movePlainDate(createMoveOps, 1, slots, toDurationSlots(durationArg), options)),
        until: (slots, otherArg, options)=>createDuration(diffPlainDates(createDiffOps, 0, slots, toPlainDateSlots(otherArg), options)),
        since: (slots, otherArg, options)=>createDuration(diffPlainDates(createDiffOps, 1, slots, toPlainDateSlots(otherArg), options)),
        equals (slots, otherArg) {
            var plainDateSlots0, plainDateSlots1;
            return !compareIsoDateFields(plainDateSlots0 = slots, plainDateSlots1 = toPlainDateSlots(otherArg)) && isIdLikeEqual(plainDateSlots0.calendar, plainDateSlots1.calendar);
        },
        toZonedDateTime (slots, options) {
            const optionsObj = !isObjectLike(options) || options instanceof TimeZone ? {
                timeZone: options
            } : options;
            return createZonedDateTime(((refineTimeZoneArg, refinePlainTimeArg, getTimeZoneOps, plainDateSlots, options)=>{
                const timeZoneSlot = refineTimeZoneArg(options.timeZone), plainTimeArg = options.plainTime, isoTimeFields = void 0 !== plainTimeArg ? refinePlainTimeArg(plainTimeArg) : isoTimeFieldDefaults;
                return createZonedDateTimeSlots(getSingleInstantFor(getTimeZoneOps(timeZoneSlot), {
                    ...plainDateSlots,
                    ...isoTimeFields
                }), timeZoneSlot, plainDateSlots.calendar);
            })(refineTimeZoneSlot, toPlainTimeSlots, createTimeZoneOps, slots, optionsObj));
        },
        toPlainDateTime: (slots, plainTimeArg)=>createPlainDateTime(((plainDateSlots, plainTimeFields = isoTimeFieldDefaults)=>createPlainDateTimeSlots(checkIsoDateTimeInBounds({
                    ...plainDateSlots,
                    ...plainTimeFields
                })))(slots, optionalToPlainTimeFields(plainTimeArg))),
        toPlainYearMonth (slots) {
            return createPlainYearMonth(convertToPlainYearMonth(createYearMonthRefineOps(slots.calendar), this));
        },
        toPlainMonthDay (slots) {
            return createPlainMonthDay(convertToPlainMonthDay(createMonthDayRefineOps(slots.calendar), this));
        },
        toLocaleString (slots, locales, options) {
            const [format, epochMilli] = prepPlainDateFormat(locales, options, slots);
            return format.format(epochMilli);
        },
        toString: formatPlainDateIso,
        toJSON: (slots)=>formatPlainDateIso(slots),
        valueOf: neverValueOf
    }, {
        from: (arg, options)=>createPlainDate(toPlainDateSlots(arg, options)),
        compare: (arg0, arg1)=>compareIsoDateFields(toPlainDateSlots(arg0), toPlainDateSlots(arg1))
    }), refineAdapters = {
        fields (calendarProtocol, fieldsMethod, fieldNames) {
            return [
                ...fieldsMethod.call(calendarProtocol, fieldNames)
            ];
        }
    }, dateRefineAdapters = {
        dateFromFields (calendarProtocol, dateFromFields, fields, options) {
            return getPlainDateSlots(dateFromFields.call(calendarProtocol, Object.assign(Object.create(null), fields), options));
        },
        ...refineAdapters
    }, yearMonthRefineAdapters = {
        yearMonthFromFields (calendarProtocol, yearMonthFromFields, fields, options) {
            return getPlainYearMonthSlots(yearMonthFromFields.call(calendarProtocol, Object.assign(Object.create(null), fields), options));
        },
        ...refineAdapters
    }, monthDayRefineAdapters = {
        monthDayFromFields (calendarProtocol, monthDayFromFields, fields, options) {
            return getPlainMonthDaySlots(monthDayFromFields.call(calendarProtocol, Object.assign(Object.create(null), fields), options));
        },
        ...refineAdapters
    }, modAdapters = {
        mergeFields (calendarProtocol, mergeFields, fields, additionalFields) {
            return requireObjectLike(mergeFields.call(calendarProtocol, Object.assign(Object.create(null), fields), Object.assign(Object.create(null), additionalFields)));
        }
    }, dateModAdapters = {
        ...dateRefineAdapters,
        ...modAdapters
    }, yearMonthModAdapters = {
        ...yearMonthRefineAdapters,
        ...modAdapters
    }, monthDayModAdapters = {
        ...monthDayRefineAdapters,
        ...modAdapters
    }, moveAdapters = {
        dateAdd (calendarProtocol, dateAdd, isoFields, durationFields, options) {
            return getPlainDateSlots(dateAdd.call(calendarProtocol, createPlainDate(createPlainDateSlots(isoFields, calendarProtocol)), createDuration(createDurationSlots(durationFields)), options));
        }
    }, diffAdapters = {
        ...moveAdapters,
        dateUntil (calendarProtocol, dateUntil, isoFields0, isoFields1, largestUnit, origOptions) {
            return getDurationSlots(dateUntil.call(calendarProtocol, createPlainDate(createPlainDateSlots(isoFields0, calendarProtocol)), createPlainDate(createPlainDateSlots(isoFields1, calendarProtocol)), Object.assign(Object.create(null), origOptions, {
                largestUnit: unitNamesAsc[largestUnit]
            })));
        }
    }, yearMonthMoveAdapters = {
        ...moveAdapters,
        day: dayAdapter
    }, yearMonthDiffAdapters = {
        ...diffAdapters,
        day: dayAdapter
    }, createYearMonthRefineOps = createCompoundOpsCreator(yearMonthRefineAdapters), createDateRefineOps = createCompoundOpsCreator(dateRefineAdapters), createMonthDayRefineOps = createCompoundOpsCreator(monthDayRefineAdapters), createYearMonthModOps = createCompoundOpsCreator(yearMonthModAdapters), createDateModOps = createCompoundOpsCreator(dateModAdapters), createMonthDayModOps = createCompoundOpsCreator(monthDayModAdapters), createMoveOps = createCompoundOpsCreator(moveAdapters), createDiffOps = createCompoundOpsCreator(diffAdapters), createYearMonthMoveOps = createCompoundOpsCreator(yearMonthMoveAdapters), createYearMonthDiffOps = createCompoundOpsCreator(yearMonthDiffAdapters), [Duration, createDuration, getDurationSlots] = createSlotClass(DurationBranding, (years = 0, months = 0, weeks = 0, days = 0, hours = 0, minutes = 0, seconds = 0, milliseconds = 0, microseconds = 0, nanoseconds = 0)=>createDurationSlots(checkDurationUnits(mapProps(toStrictInteger, zipProps(durationFieldNamesAsc, [
            years,
            months,
            weeks,
            days,
            hours,
            minutes,
            seconds,
            milliseconds,
            microseconds,
            nanoseconds
        ])))), {
        ...durationGetters,
        blank (slots) {
            return !slots.sign;
        }
    }, {
        with: (slots, mod)=>createDuration(((slots, fields)=>{
                var initialFields, modFields;
                return createDurationSlots((initialFields = slots, modFields = fields, checkDurationUnits({
                    ...initialFields,
                    ...refineFields(modFields, durationFieldNamesAlpha)
                })));
            })(slots, mod)),
        negated: (slots)=>createDuration(negateDuration(slots)),
        abs: (slots)=>createDuration(((slots)=>-1 === slots.sign ? negateDuration(slots) : slots)(slots)),
        add: (slots, otherArg, options)=>createDuration(addDurations(refinePublicRelativeTo, createDiffOps, createTimeZoneOps, 0, slots, toDurationSlots(otherArg), options)),
        subtract: (slots, otherArg, options)=>createDuration(addDurations(refinePublicRelativeTo, createDiffOps, createTimeZoneOps, 1, slots, toDurationSlots(otherArg), options)),
        round: (slots, options)=>createDuration(((refineRelativeTo, getCalendarOps, getTimeZoneOps, slots, options)=>{
                const durationLargestUnit = getMaxDurationUnit(slots), [largestUnit, smallestUnit, roundingInc, roundingMode, relativeToSlots] = ((options, defaultLargestUnit, refineRelativeTo)=>{
                    options = normalizeOptionsOrString(options, smallestUnitStr);
                    let largestUnit = refineLargestUnit(options);
                    const relativeToInternals = refineRelativeTo(options.relativeTo);
                    let roundingInc = parseRoundingIncInteger(options);
                    const roundingMode = refineRoundingMode(options, 7);
                    let smallestUnit = refineSmallestUnit(options);
                    if (void 0 === largestUnit && void 0 === smallestUnit) throw new RangeError("Required smallestUnit or largestUnit");
                    return null == smallestUnit && (smallestUnit = 0), null == largestUnit && (largestUnit = Math.max(smallestUnit, defaultLargestUnit)), checkLargestSmallestUnit(largestUnit, smallestUnit), roundingInc = refineRoundingInc(roundingInc, smallestUnit, 1), [
                        largestUnit,
                        smallestUnit,
                        roundingInc,
                        roundingMode,
                        relativeToInternals
                    ];
                })(options, durationLargestUnit, refineRelativeTo), maxUnit = Math.max(durationLargestUnit, largestUnit);
                if (!isZonedEpochSlots(relativeToSlots) && maxUnit <= 6) return createDurationSlots(checkDurationUnits(((durationFields, largestUnit, smallestUnit, roundingInc, roundingMode)=>{
                    const roundedBigNano = roundBigNano(durationFieldsToBigNano(durationFields), smallestUnit, roundingInc, roundingMode);
                    return {
                        ...durationFieldDefaults,
                        ...nanoToDurationDayTimeFields(roundedBigNano, largestUnit)
                    };
                })(slots, largestUnit, smallestUnit, roundingInc, roundingMode)));
                if (!relativeToSlots) throw new RangeError("Missing relativeTo");
                const [marker, calendarOps, timeZoneOps] = createMarkerSystem(getCalendarOps, getTimeZoneOps, relativeToSlots), markerToEpochNano = createMarkerToEpochNano(timeZoneOps), moveMarker = createMoveMarker(timeZoneOps), diffMarkers = createDiffMarkers(timeZoneOps), endMarker = moveMarker(calendarOps, marker, slots);
                let balancedDuration = diffMarkers(calendarOps, marker, endMarker, largestUnit);
                const origSign = slots.sign, balancedSign = computeDurationSign(balancedDuration);
                if (origSign && balancedSign && origSign !== balancedSign) throw new RangeError(invalidProtocolResults);
                return balancedSign && (balancedDuration = roundRelativeDuration(balancedDuration, markerToEpochNano(endMarker), largestUnit, smallestUnit, roundingInc, roundingMode, calendarOps, marker, markerToEpochNano, moveMarker)), createDurationSlots(balancedDuration);
            })(refinePublicRelativeTo, createDiffOps, createTimeZoneOps, slots, options)),
        total: (slots, options)=>((refineRelativeTo, getCalendarOps, getTimeZoneOps, slots, options)=>{
                const maxDurationUnit = getMaxDurationUnit(slots), [totalUnit, relativeToSlots] = ((options, refineRelativeTo)=>{
                    const relativeToInternals = refineRelativeTo((options = normalizeOptionsOrString(options, "unit")).relativeTo);
                    let totalUnit = refineTotalUnit(options);
                    return totalUnit = requirePropDefined("unit", totalUnit), [
                        totalUnit,
                        relativeToInternals
                    ];
                })(options, refineRelativeTo);
                if (isUniformUnit(Math.max(totalUnit, maxDurationUnit), relativeToSlots)) return totalDayTimeDuration(slots, totalUnit);
                if (!relativeToSlots) throw new RangeError("Missing relativeTo");
                const [marker, calendarOps, timeZoneOps] = createMarkerSystem(getCalendarOps, getTimeZoneOps, relativeToSlots), markerToEpochNano = createMarkerToEpochNano(timeZoneOps), moveMarker = createMoveMarker(timeZoneOps), diffMarkers = createDiffMarkers(timeZoneOps), endMarker = moveMarker(calendarOps, marker, slots), balancedDuration = diffMarkers(calendarOps, marker, endMarker, totalUnit);
                return isUniformUnit(totalUnit, relativeToSlots) ? totalDayTimeDuration(balancedDuration, totalUnit) : ((durationFields, endEpochNano, totalUnit, calendarOps, marker, markerToEpochNano, moveMarker)=>{
                    const sign = computeDurationSign(durationFields), [epochNano0, epochNano1] = clampRelativeDuration(calendarOps, clearDurationFields(totalUnit, durationFields), totalUnit, sign, marker, markerToEpochNano, moveMarker), frac = computeEpochNanoFrac(endEpochNano, epochNano0, epochNano1);
                    return durationFields[durationFieldNamesAsc[totalUnit]] + frac * sign;
                })(balancedDuration, markerToEpochNano(endMarker), totalUnit, calendarOps, marker, markerToEpochNano, moveMarker);
            })(refinePublicRelativeTo, createDiffOps, createTimeZoneOps, slots, options),
        toLocaleString (slots, locales, options) {
            return Intl.DurationFormat ? new Intl.DurationFormat(locales, options).format(this) : formatDurationIso(slots);
        },
        toString: formatDurationIso,
        toJSON: (slots)=>formatDurationIso(slots),
        valueOf: neverValueOf
    }, {
        from: (arg)=>createDuration(toDurationSlots(arg)),
        compare: (durationArg0, durationArg1, options)=>((refineRelativeTo, getCalendarOps, getTimeZoneOps, durationSlots0, durationSlots1, options)=>{
                const relativeToSlots = refineRelativeTo(normalizeOptions(options).relativeTo), maxUnit = Math.max(getMaxDurationUnit(durationSlots0), getMaxDurationUnit(durationSlots1));
                if (allPropsEqual(durationFieldNamesAsc, durationSlots0, durationSlots1)) return 0;
                if (isUniformUnit(maxUnit, relativeToSlots)) return compareBigNanos(durationFieldsToBigNano(durationSlots0), durationFieldsToBigNano(durationSlots1));
                if (!relativeToSlots) throw new RangeError("Missing relativeTo");
                const [marker, calendarOps, timeZoneOps] = createMarkerSystem(getCalendarOps, getTimeZoneOps, relativeToSlots), markerToEpochNano = createMarkerToEpochNano(timeZoneOps), moveMarker = createMoveMarker(timeZoneOps);
                return compareBigNanos(markerToEpochNano(moveMarker(calendarOps, marker, durationSlots0)), markerToEpochNano(moveMarker(calendarOps, marker, durationSlots1)));
            })(refinePublicRelativeTo, createMoveOps, createTimeZoneOps, toDurationSlots(durationArg0), toDurationSlots(durationArg1), options)
    }), calendarMethods = {
        toString: (slots)=>slots.id,
        toJSON: (slots)=>slots.id,
        ...calendarFieldMethods,
        dateAdd: ({ id: id, native: native }, plainDateArg, durationArg, options)=>createPlainDate(createPlainDateSlots(native.dateAdd(toPlainDateSlots(plainDateArg), toDurationSlots(durationArg), options), id)),
        dateUntil: ({ native: native }, plainDateArg0, plainDateArg1, options)=>createDuration(createDurationSlots(native.dateUntil(toPlainDateSlots(plainDateArg0), toPlainDateSlots(plainDateArg1), ((options)=>(options = normalizeOptions(options), refineLargestUnit(options, 9, 6, 1)))(options)))),
        dateFromFields: ({ id: id, native: native }, fields, options)=>createPlainDate(refinePlainDateBag(native, fields, options, id === isoCalendarId ? [
                "year",
                "day"
            ] : [])),
        yearMonthFromFields: ({ id: id, native: native }, fields, options)=>createPlainYearMonth(refinePlainYearMonthBag(native, fields, options, id === isoCalendarId ? yearFieldNames : [])),
        monthDayFromFields: ({ id: id, native: native }, fields, options)=>createPlainMonthDay(refinePlainMonthDayBag(native, 0, fields, options, id === isoCalendarId ? dayFieldNames : [])),
        fields ({ native: native }, fieldNames) {
            const allowed = new Set(dateFieldNamesAlpha), fieldNamesArray = [];
            for (const fieldName of fieldNames){
                if (requireString(fieldName), !allowed.has(fieldName)) throw new RangeError(forbiddenField(fieldName));
                allowed.delete(fieldName), fieldNamesArray.push(fieldName);
            }
            return native.fields(fieldNamesArray);
        },
        mergeFields: ({ native: native }, fields0, fields1)=>native.mergeFields(excludeUndefinedProps(requireNonNullish(fields0)), excludeUndefinedProps(requireNonNullish(fields1)))
    }, [Calendar] = createSlotClass("Calendar", (id)=>{
        const slotId = ((id)=>resolveCalendarId(requireString(id)))(id);
        return {
            branding: "Calendar",
            id: slotId,
            native: createNativeStandardOps(slotId)
        };
    }, {
        id: (slots)=>slots.id
    }, calendarMethods, {
        from (arg) {
            const calendarSlot = refineCalendarSlot(arg);
            return "string" == typeof calendarSlot ? new Calendar(calendarSlot) : calendarSlot;
        }
    }), validateCalendarProtocol = createProtocolValidator(Object.keys(calendarMethods).slice(4)), [Instant, createInstant, getInstantSlots] = createSlotClass(InstantBranding, (epochNano)=>createInstantSlots(checkEpochNanoInBounds(bigIntToBigNano(toBigInt(epochNano)))), epochGetters, {
        add: (slots, durationArg)=>createInstant(moveInstant(0, slots, toDurationSlots(durationArg))),
        subtract: (slots, durationArg)=>createInstant(moveInstant(1, slots, toDurationSlots(durationArg))),
        until: (slots, otherArg, options)=>createDuration(diffInstants(0, slots, toInstantSlots(otherArg), options)),
        since: (slots, otherArg, options)=>createDuration(diffInstants(1, slots, toInstantSlots(otherArg), options)),
        round: (slots, options)=>createInstant(((instantSlots, options)=>{
                const [smallestUnit, roundingInc, roundingMode] = refineRoundingOptions(options, 5, 1);
                return createInstantSlots(roundBigNano(instantSlots.epochNanoseconds, smallestUnit, roundingInc, roundingMode, 1));
            })(slots, options)),
        equals (slots, otherArg) {
            return !compareInstants(slots, toInstantSlots(otherArg));
        },
        toZonedDateTime (slots, options) {
            const refinedObj = requireObjectLike(options);
            return createZonedDateTime(instantToZonedDateTime(slots, refineTimeZoneSlot(refinedObj.timeZone), refineCalendarSlot(refinedObj.calendar)));
        },
        toZonedDateTimeISO: (slots, timeZoneArg)=>createZonedDateTime(instantToZonedDateTime(slots, refineTimeZoneSlot(timeZoneArg))),
        toLocaleString (slots, locales, options) {
            const [format, epochMilli] = prepInstantFormat(locales, options, slots);
            return format.format(epochMilli);
        },
        toString: (slots, options)=>formatInstantIso(refineTimeZoneSlot, createTimeZoneOffsetOps, slots, options),
        toJSON: (slots)=>formatInstantIso(refineTimeZoneSlot, createTimeZoneOffsetOps, slots),
        valueOf: neverValueOf
    }, {
        from: (arg)=>createInstant(toInstantSlots(arg)),
        fromEpochSeconds: (epochSec)=>createInstant(((epochSec)=>createInstantSlots(checkEpochNanoInBounds(numberToBigNano(epochSec, nanoInSec))))(epochSec)),
        fromEpochMilliseconds: (epochMilli)=>createInstant(((epochMilli)=>createInstantSlots(checkEpochNanoInBounds(numberToBigNano(epochMilli, nanoInMilli))))(epochMilli)),
        fromEpochMicroseconds: (epochMicro)=>createInstant(((epochMicro)=>createInstantSlots(checkEpochNanoInBounds(bigIntToBigNano(toBigInt(epochMicro), nanoInMicro))))(epochMicro)),
        fromEpochNanoseconds: (epochNano)=>createInstant(((epochNano)=>createInstantSlots(checkEpochNanoInBounds(bigIntToBigNano(toBigInt(epochNano)))))(epochNano)),
        compare: (a, b)=>compareInstants(toInstantSlots(a), toInstantSlots(b))
    }), DateTimeFormat = function() {
        const members = RawDateTimeFormat.prototype, memberDescriptors = Object.getOwnPropertyDescriptors(members), classDescriptors = Object.getOwnPropertyDescriptors(RawDateTimeFormat), DateTimeFormat = function(locales, options = {}) {
            if (!(this instanceof DateTimeFormat)) return new DateTimeFormat(locales, options);
            internalsMap.set(this, ((locales, options = {})=>{
                const rawFormat = new RawDateTimeFormat(locales, options), resolveOptions = rawFormat.resolvedOptions(), resolvedLocale = resolveOptions.locale, copiedOptions = pluckProps(Object.keys(options), resolveOptions), queryFormatPrepperForBranding = memoize(createFormatPrepperForBranding), prepFormat = (...formattables)=>{
                    let branding;
                    const slotsList = formattables.map((formattable, i)=>{
                        const slots = getSlots(formattable), slotsBranding = (slots || {}).branding;
                        if (i && branding && branding !== slotsBranding) throw new TypeError("Mismatching types for formatting");
                        return branding = slotsBranding, slots;
                    });
                    return branding ? queryFormatPrepperForBranding(branding)(resolvedLocale, copiedOptions, ...slotsList) : [
                        rawFormat,
                        ...formattables
                    ];
                };
                return prepFormat.rawFormat = rawFormat, prepFormat;
            })(locales, options));
        };
        for(const memberName in memberDescriptors){
            const memberDescriptor = memberDescriptors[memberName], formatLikeMethod = memberName.startsWith("format") && createFormatMethod(memberName);
            "function" == typeof memberDescriptor.value ? memberDescriptor.value = "constructor" === memberName ? DateTimeFormat : formatLikeMethod || createProxiedMethod(memberName) : formatLikeMethod && (memberDescriptor.get = function() {
                return formatLikeMethod.bind(this);
            });
        }
        return classDescriptors.prototype.value = Object.create(members, memberDescriptors), Object.defineProperties(DateTimeFormat, classDescriptors), DateTimeFormat;
    }(), internalsMap = new WeakMap;
    let currentTimeZoneId;
    const Now = Object.defineProperties({}, {
        ...createStringTagDescriptors("Temporal.Now"),
        ...createPropDescriptors({
            timeZoneId: ()=>getCurrentTimeZoneId(),
            instant: ()=>createInstant(createInstantSlots(getCurrentEpochNano())),
            zonedDateTime: (calendar, timeZone = getCurrentTimeZoneId())=>createZonedDateTime(createZonedDateTimeSlots(getCurrentEpochNano(), refineTimeZoneSlot(timeZone), refineCalendarSlot(calendar))),
            zonedDateTimeISO: (timeZone = getCurrentTimeZoneId())=>createZonedDateTime(createZonedDateTimeSlots(getCurrentEpochNano(), refineTimeZoneSlot(timeZone), isoCalendarId)),
            plainDateTime: (calendar, timeZone = getCurrentTimeZoneId())=>createPlainDateTime(createPlainDateTimeSlots(getCurrentIsoDateTime(createTimeZoneOffsetOps(refineTimeZoneSlot(timeZone))), refineCalendarSlot(calendar))),
            plainDateTimeISO: (timeZone = getCurrentTimeZoneId())=>createPlainDateTime(createPlainDateTimeSlots(getCurrentIsoDateTime(createTimeZoneOffsetOps(refineTimeZoneSlot(timeZone))), isoCalendarId)),
            plainDate: (calendar, timeZone = getCurrentTimeZoneId())=>createPlainDate(createPlainDateSlots(getCurrentIsoDateTime(createTimeZoneOffsetOps(refineTimeZoneSlot(timeZone))), refineCalendarSlot(calendar))),
            plainDateISO: (timeZone = getCurrentTimeZoneId())=>createPlainDate(createPlainDateSlots(getCurrentIsoDateTime(createTimeZoneOffsetOps(refineTimeZoneSlot(timeZone))), isoCalendarId)),
            plainTimeISO: (timeZone = getCurrentTimeZoneId())=>createPlainTime(createPlainTimeSlots(getCurrentIsoDateTime(createTimeZoneOffsetOps(refineTimeZoneSlot(timeZone)))))
        })
    }), Temporal = Object.defineProperties({}, {
        ...createStringTagDescriptors("Temporal"),
        ...createPropDescriptors({
            PlainYearMonth: PlainYearMonth,
            PlainMonthDay: PlainMonthDay,
            PlainDate: PlainDate,
            PlainTime: PlainTime,
            PlainDateTime: PlainDateTime,
            ZonedDateTime: ZonedDateTime,
            Instant: Instant,
            Calendar: Calendar,
            TimeZone: TimeZone,
            Duration: Duration,
            Now: Now
        })
    });
    Object.defineProperties(globalThis, createPropDescriptors({
        Temporal: Temporal
    })), Object.defineProperties(Intl, createPropDescriptors({
        DateTimeFormat: DateTimeFormat
    })), Object.defineProperties(Date.prototype, createPropDescriptors({
        toTemporalInstant () {
            return createInstant(createInstantSlots(numberToBigNano(this.valueOf(), nanoInMilli)));
        }
    }));
}();


/**
 * java.lang.Math.toRadians
 * @private
 * @param degrees
 */ function $af23a9f03297d4dc$var$degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
}
/**
 * java.lang.Math.toDegrees
 * @private
 * @param radians
 */ function $af23a9f03297d4dc$var$radiansToDegrees(radians) {
    return radians * 180 / Math.PI;
}
class $af23a9f03297d4dc$export$476ba50ca24afb42 {
    /**
     * GeoLocation constructor with parameters for all required fields.
     *
     * @param {string} name
     *            The location name for display use such as &quot;Lakewood, NJ&quot;
     * @param {number} latitude
     *            the latitude in a double format such as 40.095965 for Lakewood, NJ.
     *            <b>Note: </b> For latitudes south of the equator, a negative value should be used.
     * @param {number} longitude
     *            double the longitude in a double format such as -74.222130 for Lakewood, NJ.
     *            <b>Note: </b> For longitudes west of the <a href="http://en.wikipedia.org/wiki/Prime_Meridian">Prime
     *            Meridian </a> (Greenwich), a negative value should be used.
     * @param {number} elevation
     *            the elevation above sea level in Meters. Elevation is not used in most algorithms used for calculating
     *            sunrise and set.
     * @param {string} timeZoneId
     *            the <code>TimeZone</code> for the location.
     */ constructor(name, latitude, longitude, elevation, timeZoneId){
        /**
         * @private
         */ this.locationName = null;
        this.setLocationName(name);
        this.setLatitude(latitude);
        this.setLongitude(longitude);
        this.setElevation(elevation);
        this.setTimeZone(timeZoneId);
    }
    /**
     * Method to get the elevation in Meters.
     *
     * @return {number} Returns the elevation in Meters.
     */ getElevation() {
        return this.elevation;
    }
    /**
     * Method to set the elevation in Meters <b>above </b> sea level.
     *
     * @param {number} elevation
     *            The elevation to set in Meters. An Error will be thrown if the value is a negative.
     */ setElevation(elevation) {
        if (typeof elevation !== 'number') throw new TypeError('Invalid elevation');
        if (elevation < 0) throw new RangeError(`elevation ${elevation} must be zero or positive`);
        this.elevation = elevation;
    }
    setLatitude(latitude) {
        if (typeof latitude !== 'number') throw new TypeError('Invalid latitude');
        if (latitude < -90 || latitude > 90) throw new RangeError(`Latitude ${latitude} out of range [-90,90]`);
        this.latitude = latitude;
    }
    /**
     * @return {number} Returns the latitude.
     */ getLatitude() {
        return this.latitude;
    }
    setLongitude(longitude) {
        if (typeof longitude !== 'number') throw new TypeError('Invalid longitude');
        if (longitude < -180 || longitude > 180) throw new RangeError(`Longitude ${longitude} out of range [-180,180]`);
        this.longitude = longitude;
    }
    /**
     * @return {number} Returns the longitude.
     */ getLongitude() {
        return this.longitude;
    }
    /**
     * @return {string|null} Returns the location name.
     */ getLocationName() {
        return this.locationName;
    }
    /**
     * @param {string|null} name
     *            The setter method for the display name.
     */ setLocationName(name) {
        this.locationName = name;
    }
    /**
     * @return {string} Returns the timeZone.
     */ getTimeZone() {
        return this.timeZoneId;
    }
    /**
     * Method to set the TimeZone.
     * @param {string} timeZoneId
     *            The timeZone to set.
     */ setTimeZone(timeZoneId) {
        this.timeZoneId = timeZoneId;
    }
}
/**
 * The commonly used average solar refraction. Calendrical Calculations lists a more accurate global average of
 * 34.478885263888294
 * @private
 */ const $af23a9f03297d4dc$var$refraction = 34 / 60;
// private double refraction = 34.478885263888294 / 60d;
/**
 * The commonly used average solar radius in minutes of a degree.
 * @private
 */ const $af23a9f03297d4dc$var$solarRadius = 16 / 60;
/**
 * The commonly used average earth radius in KM. At this time, this only affects elevation adjustment and not the
 * sunrise and sunset calculations. The value currently defaults to 6356.9 KM.
 * @private
 */ const $af23a9f03297d4dc$var$earthRadius = 6356.9; // in KM
class $af23a9f03297d4dc$export$a5e4bf7f397ddef3 {
    /**
     * A constructor that takes in <a href="http://en.wikipedia.org/wiki/Geolocation">geolocation</a> information as a
     * parameter.
     *
     * @param {GeoLocation} geoLocation
     *            The location information used for calculating astronomical sun times.
     * @param {Temporal.PlainDate} date
     */ constructor(geoLocation, date){
        this.date = date;
        this.geoLocation = geoLocation;
    }
    /**
     * The getSunrise method Returns a `Date` representing the
     * {@link getElevationAdjustment elevation adjusted} sunrise time. The zenith used
     * for the calculation uses {@link GEOMETRIC_ZENITH geometric zenith} of 90&deg; plus
     * {@link getElevationAdjustment}. This is adjusted
     * to add approximately 50/60 of a degree to account for 34 archminutes of refraction
     * and 16 archminutes for the sun's radius for a total of {@link adjustZenith 90.83333&deg;}.
     *
     * @return {Temporal.ZonedDateTime | null} the `Date` representing the exact sunrise time. If the calculation can't be computed such as
     *         in the Arctic Circle where there is at least one day a year where the sun does not rise, and one where it
     *         does not set, a null will be returned. See detailed explanation on top of the page.
     * @see adjustZenith
     * @see getSeaLevelSunrise()
     * @see getUTCSunrise
     */ getSunrise() {
        const sunrise = this.getUTCSunrise0($af23a9f03297d4dc$export$a5e4bf7f397ddef3.GEOMETRIC_ZENITH);
        if (isNaN(sunrise)) return null;
        return this.getDateFromTime(sunrise, true);
    }
    /**
     * A method that returns the sunrise without {@link getElevationAdjustment elevation
     * adjustment}. Non-sunrise and sunset calculations such as dawn and dusk, depend on the amount of visible light,
     * something that is not affected by elevation. This method returns sunrise calculated at sea level. This forms the
     * base for dawn calculations that are calculated as a dip below the horizon before sunrise.
     *
     * @return {Temporal.ZonedDateTime | null} the `Date` representing the exact sea-level sunrise time. If the calculation can't be computed
     *         such as in the Arctic Circle where there is at least one day a year where the sun does not rise, and one
     *         where it does not set, a null will be returned. See detailed explanation on top of the page.
     * @see getSunrise
     * @see getUTCSeaLevelSunrise
     * @see getSeaLevelSunset()
     */ getSeaLevelSunrise() {
        const sunrise = this.getUTCSeaLevelSunrise($af23a9f03297d4dc$export$a5e4bf7f397ddef3.GEOMETRIC_ZENITH);
        if (isNaN(sunrise)) return null;
        return this.getDateFromTime(sunrise, true);
    }
    /**
     * A method that returns the beginning of civil twilight (dawn) using a zenith of {@link CIVIL_ZENITH 96&deg;}.
     *
     * @return {Temporal.ZonedDateTime | null} The `Date` of the beginning of civil twilight using a zenith of 96&deg;. If the calculation
     *         can't be computed, null will be returned. See detailed explanation on top of the page.
     * @see CIVIL_ZENITH
     */ getBeginCivilTwilight() {
        return this.getSunriseOffsetByDegrees($af23a9f03297d4dc$export$a5e4bf7f397ddef3.CIVIL_ZENITH);
    }
    /**
     * A method that returns the beginning of nautical twilight using a zenith of {@link NAUTICAL_ZENITH 102&deg;}.
     *
     * @return {Temporal.ZonedDateTime | null} The `Date` of the beginning of nautical twilight using a zenith of 102&deg;. If the
     *         calculation can't be computed null will be returned. See detailed explanation on top of the page.
     * @see NAUTICAL_ZENITH
     */ getBeginNauticalTwilight() {
        return this.getSunriseOffsetByDegrees($af23a9f03297d4dc$export$a5e4bf7f397ddef3.NAUTICAL_ZENITH);
    }
    /**
     * A method that returns the beginning of astronomical twilight using a zenith of {@link ASTRONOMICAL_ZENITH
     * 108&deg;}.
     *
     * @return {Temporal.ZonedDateTime | null} The `Date` of the beginning of astronomical twilight using a zenith of 108&deg;. If the
     *         calculation can't be computed, null will be returned. See detailed explanation on top of the page.
     * @see ASTRONOMICAL_ZENITH
     */ getBeginAstronomicalTwilight() {
        return this.getSunriseOffsetByDegrees($af23a9f03297d4dc$export$a5e4bf7f397ddef3.ASTRONOMICAL_ZENITH);
    }
    /**
     * The getSunset method Returns a `Date` representing the
     * {@link getElevationAdjustment elevation adjusted} sunset time. The zenith used for
     * the calculation uses {@link GEOMETRIC_ZENITH geometric zenith} of 90&deg; plus
     * {@link getElevationAdjustment}. This is adjusted
     * to add approximately 50/60 of a degree to account for 34 archminutes of refraction
     * and 16 archminutes for the sun's radius for a total of {@link adjustZenith 90.83333&deg;}.
     * Note:
     * In certain cases the calculates sunset will occur before sunrise. This will typically happen when a timezone
     * other than the local timezone is used (calculating Los Angeles sunset using a GMT timezone for example). In this
     * case the sunset date will be incremented to the following date.
     *
     * @return {Temporal.ZonedDateTime | null} The `Date` representing the exact sunset time. If the calculation can't be computed such as in
     *         the Arctic Circle where there is at least one day a year where the sun does not rise, and one where it
     *         does not set, a null will be returned. See detailed explanation on top of the page.
     * @see adjustZenith
     * @see getSeaLevelSunset()
     * @see getUTCSunset
     */ getSunset() {
        const sunset = this.getUTCSunset0($af23a9f03297d4dc$export$a5e4bf7f397ddef3.GEOMETRIC_ZENITH);
        if (isNaN(sunset)) return null;
        return this.getDateFromTime(sunset, false);
    }
    /**
     * A method that returns the sunset without {@link getElevationAdjustment elevation
     * adjustment}. Non-sunrise and sunset calculations such as dawn and dusk, depend on the amount of visible light,
     * something that is not affected by elevation. This method returns sunset calculated at sea level. This forms the
     * base for dusk calculations that are calculated as a dip below the horizon after sunset.
     *
     * @return {Temporal.ZonedDateTime | null} The `Date` representing the exact sea-level sunset time. If the calculation can't be computed
     *         such as in the Arctic Circle where there is at least one day a year where the sun does not rise, and one
     *         where it does not set, a null will be returned. See detailed explanation on top of the page.
     * @see getSunset
     * @see getUTCSeaLevelSunset
     */ getSeaLevelSunset() {
        const sunset = this.getUTCSeaLevelSunset($af23a9f03297d4dc$export$a5e4bf7f397ddef3.GEOMETRIC_ZENITH);
        if (isNaN(sunset)) return null;
        return this.getDateFromTime(sunset, false);
    }
    /**
     * A method that returns the end of civil twilight using a zenith of {@link CIVIL_ZENITH 96&deg;}.
     *
     * @return {Temporal.ZonedDateTime | null} The `Date` of the end of civil twilight using a zenith of {@link CIVIL_ZENITH 96&deg;}. If
     *         the calculation can't be computed, null will be returned. See detailed explanation on top of the page.
     * @see CIVIL_ZENITH
     */ getEndCivilTwilight() {
        return this.getSunsetOffsetByDegrees($af23a9f03297d4dc$export$a5e4bf7f397ddef3.CIVIL_ZENITH);
    }
    /**
     * A method that returns the end of nautical twilight using a zenith of {@link NAUTICAL_ZENITH 102&deg;}.
     *
     * @return {Temporal.ZonedDateTime | null} The `Date` of the end of nautical twilight using a zenith of {@link NAUTICAL_ZENITH 102&deg;}
     *         . If the calculation can't be computed, null will be returned. See detailed explanation on top of the
     *         page.
     * @see NAUTICAL_ZENITH
     */ getEndNauticalTwilight() {
        return this.getSunsetOffsetByDegrees($af23a9f03297d4dc$export$a5e4bf7f397ddef3.NAUTICAL_ZENITH);
    }
    /**
     * A method that returns the end of astronomical twilight using a zenith of {@link ASTRONOMICAL_ZENITH 108&deg;}.
     *
     * @return {Temporal.ZonedDateTime | null} The `Date` of the end of astronomical twilight using a zenith of {@link ASTRONOMICAL_ZENITH
     *         108&deg;}. If the calculation can't be computed, null will be returned. See detailed explanation on top
     *         of the page.
     * @see ASTRONOMICAL_ZENITH
     */ getEndAstronomicalTwilight() {
        return this.getSunsetOffsetByDegrees($af23a9f03297d4dc$export$a5e4bf7f397ddef3.ASTRONOMICAL_ZENITH);
    }
    /**
     * A utility method that returns a date offset by the offset time passed in. Please note that the level of light
     * during twilight is not affected by elevation, so if this is being used to calculate an offset before sunrise or
     * after sunset with the intent of getting a rough "level of light" calculation, the sunrise or sunset time passed
     * to this method should be sea level sunrise and sunset.
     *
     * @param {Temporal.ZonedDateTime | null} time
     *            the start time
     * @param {number} offset
     *            the offset in milliseconds to add to the time.
     * @return {Temporal.ZonedDateTime | null} the `Date` with the offset in milliseconds added to it
     */ static getTimeOffset(time, offset) {
        if (time === null || isNaN(offset)) return null;
        return time.add({
            milliseconds: offset
        });
    }
    /**
     * A utility method that returns the time of an offset by degrees below or above the horizon of
     * {@link getSunrise() sunrise}. Note that the degree offset is from the vertical, so for a calculation of 14&deg;
     * before sunrise, an offset of 14 + {@link GEOMETRIC_ZENITH} = 104 would have to be passed as a parameter.
     *
     * @param {number} offsetZenith
     *            the degrees before {@link getSunrise} to use in the calculation. For time after sunrise use
     *            negative numbers. Note that the degree offset is from the vertical, so for a calculation of 14&deg;
     *            before sunrise, an offset of 14 + {@link GEOMETRIC_ZENITH} = 104 would have to be passed as a
     *            parameter.
     * @return {Temporal.ZonedDateTime | null} The `Date` of the offset after (or before) {@link getSunrise}. If the calculation
     *         can't be computed such as in the Arctic Circle where there is at least one day a year where the sun does
     *         not rise, and one where it does not set, a null will be returned. See detailed explanation on top of the
     *         page.
     */ getSunriseOffsetByDegrees(offsetZenith) {
        const dawn = this.getUTCSunrise0(offsetZenith);
        if (isNaN(dawn)) return null;
        return this.getDateFromTime(dawn, true);
    }
    /**
     * A utility method that returns the time of an offset by degrees below or above the horizon of {@link getSunset()
     * sunset}. Note that the degree offset is from the vertical, so for a calculation of 14&deg; after sunset, an
     * offset of 14 + {@link GEOMETRIC_ZENITH} = 104 would have to be passed as a parameter.
     *
     * @param {number} offsetZenith
     *            the degrees after {@link getSunset} to use in the calculation. For time before sunset use negative
     *            numbers. Note that the degree offset is from the vertical, so for a calculation of 14&deg; after
     *            sunset, an offset of 14 + {@link GEOMETRIC_ZENITH} = 104 would have to be passed as a parameter.
     * @return {Temporal.ZonedDateTime | null} The `Date`of the offset after (or before) {@link getSunset}. If the calculation can't
     *         be computed such as in the Arctic Circle where there is at least one day a year where the sun does not
     *         rise, and one where it does not set, a null will be returned. See detailed explanation on top of the
     *         page.
     */ getSunsetOffsetByDegrees(offsetZenith) {
        const sunset = this.getUTCSunset0(offsetZenith);
        if (isNaN(sunset)) return null;
        return this.getDateFromTime(sunset, false);
    }
    /**
     * A method that returns the sunrise in UTC time without correction for time zone offset from GMT and without using
     * daylight savings time.
     *
     * @param {number} zenith
     *            the degrees below the horizon. For time after sunrise use negative numbers.
     * @return {number} The time in the format: 18.75 for 18:45:00 UTC/GMT. If the calculation can't be computed such as in the
     *         Arctic Circle where there is at least one day a year where the sun does not rise, and one where it does
     *         not set, `NaN` will be returned. See detailed explanation on top of the page.
     */ getUTCSunrise0(zenith) {
        return this.getUTCSunrise(this.getAdjustedDate(), this.geoLocation, zenith, true);
    }
    /**
     * A method that returns the sunrise in UTC time without correction for time zone offset from GMT and without using
     * daylight savings time. Non-sunrise and sunset calculations such as dawn and dusk, depend on the amount of visible
     * light, something that is not affected by elevation. This method returns UTC sunrise calculated at sea level. This
     * forms the base for dawn calculations that are calculated as a dip below the horizon before sunrise.
     *
     * @param {number} zenith
     *            the degrees below the horizon. For time after sunrise use negative numbers.
     * @return {number} The time in the format: 18.75 for 18:45:00 UTC/GMT. If the calculation can't be computed such as in the
     *         Arctic Circle where there is at least one day a year where the sun does not rise, and one where it does
     *         not set, `NaN` will be returned. See detailed explanation on top of the page.
     * @see getUTCSunrise
     * @see getUTCSeaLevelSunset
     */ getUTCSeaLevelSunrise(zenith) {
        return this.getUTCSunrise(this.getAdjustedDate(), this.geoLocation, zenith, false);
    }
    /**
     * A method that returns the sunset in UTC time without correction for time zone offset from GMT and without using
     * daylight savings time.
     *
     * @param {number} zenith
     *            the degrees below the horizon. For time after sunset use negative numbers.
     * @return {number} The time in the format: 18.75 for 18:45:00 UTC/GMT. If the calculation can't be computed such as in the
     *         Arctic Circle where there is at least one day a year where the sun does not rise, and one where it does
     *         not set, `NaN` will be returned. See detailed explanation on top of the page.
     * @see getUTCSeaLevelSunset
     */ getUTCSunset0(zenith) {
        return this.getUTCSunset(this.getAdjustedDate(), this.geoLocation, zenith, true);
    }
    /**
     * A method that returns the sunset in UTC time without correction for elevation, time zone offset from GMT and
     * without using daylight savings time. Non-sunrise and sunset calculations such as dawn and dusk, depend on the
     * amount of visible light, something that is not affected by elevation. This method returns UTC sunset calculated
     * at sea level. This forms the base for dusk calculations that are calculated as a dip below the horizon after
     * sunset.
     *
     * @param {number} zenith
     *            the degrees below the horizon. For time before sunset use negative numbers.
     * @return {number} The time in the format: 18.75 for 18:45:00 UTC/GMT. If the calculation can't be computed such as in the
     *         Arctic Circle where there is at least one day a year where the sun does not rise, and one where it does
     *         not set, `NaN` will be returned. See detailed explanation on top of the page.
     * @see getUTCSunset
     * @see getUTCSeaLevelSunrise
     */ getUTCSeaLevelSunset(zenith) {
        return this.getUTCSunset(this.getAdjustedDate(), this.geoLocation, zenith, false);
    }
    /**
     * Adjusts the <code>Calendar</code> to deal with edge cases where the location crosses the antimeridian.
     * @private
     * @see GeoLocation#getAntimeridianAdjustment()
     * @return the adjusted Calendar
     */ getAdjustedDate() {
        return this.date;
    }
    /**
     * Method to return the adjustment to the zenith required to account for the elevation. Since a person at a higher
     * elevation can see farther below the horizon, the calculation for sunrise / sunset is calculated below the horizon
     * used at sea level. This is only used for sunrise and sunset and not times before or after it such as
     * {@link getBeginNauticalTwilight() nautical twilight} since those
     * calculations are based on the level of available light at the given dip below the horizon, something that is not
     * affected by elevation, the adjustment should only made if the zenith == 90&deg; {@link adjustZenith adjusted}
     * for refraction and solar radius. The algorithm used is
     *
     * <pre>
     * elevationAdjustment = Math.toDegrees(Math.acos(earthRadiusInMeters / (earthRadiusInMeters + elevationMeters)));
     * </pre>
     *
     * The source of this algorithm is <a href="http://www.calendarists.com">Calendrical Calculations</a> by Edward M.
     * Reingold and Nachum Dershowitz. An alternate algorithm that produces an almost identical (but not accurate)
     * result found in Ma'aglay Tzedek by Moishe Kosower and other sources is:
     *
     * <pre>
     * elevationAdjustment = 0.0347 * Math.sqrt(elevationMeters);
     * </pre>
     *
     * @param {number} elevation
     *            elevation in Meters.
     * @return {number} the adjusted zenith
     */ getElevationAdjustment(elevation) {
        // double elevationAdjustment = 0.0347 * Math.sqrt(elevation);
        const elevationAdjustment = $af23a9f03297d4dc$var$radiansToDegrees(Math.acos($af23a9f03297d4dc$var$earthRadius / ($af23a9f03297d4dc$var$earthRadius + elevation / 1000)));
        return elevationAdjustment;
    }
    /**
     * Adjusts the zenith of astronomical sunrise and sunset to account for solar refraction, solar radius and
     * elevation. The value for Sun's zenith and true rise/set Zenith (used in this class and subclasses) is the angle
     * that the center of the Sun makes to a line perpendicular to the Earth's surface. If the Sun were a point and the
     * Earth were without an atmosphere, true sunset and sunrise would correspond to a 90&deg; zenith. Because the Sun
     * is not a point, and because the atmosphere refracts light, this 90&deg; zenith does not, in fact, correspond to
     * true sunset or sunrise, instead the centre of the Sun's disk must lie just below the horizon for the upper edge
     * to be obscured. This means that a zenith of just above 90&deg; must be used. The Sun subtends an angle of 16
     * minutes of arc, and atmospheric refraction
     * accounts for 34 minutes or so, giving a total
     * of 50 arcminutes. The total value for ZENITH is 90+(5/6) or 90.8333333&deg; for true sunrise/sunset. Since a
     * person at an elevation can see blow the horizon of a person at sea level, this will also adjust the zenith to
     * account for elevation if available. Note that this will only adjust the value if the zenith is exactly 90 degrees.
     * For values below and above this no correction is done. As an example, astronomical twilight is when the sun is
     * 18&deg; below the horizon or {@link ASTRONOMICAL_ZENITH 108&deg;
     * below the zenith}. This is traditionally calculated with none of the above mentioned adjustments. The same goes
     * for various <em>tzais</em> and <em>alos</em> times such as the
     * {@link ZmanimCalendar#ZENITH_16_POINT_1 16.1&deg;} dip used in
     * {@link ComplexZmanimCalendar#getAlos16Point1Degrees}.
     *
     * @param {number} zenith
     *            the azimuth below the vertical zenith of 90&deg;. For sunset typically the {@link adjustZenith
     *            zenith} used for the calculation uses geometric zenith of 90&deg; and {@link adjustZenith adjusts}
     *            this slightly to account for solar refraction and the sun's radius. Another example would be
     *            {@link getEndNauticalTwilight} that passes
     *            {@link NAUTICAL_ZENITH} to this method.
     * @param {number} elevation
     *            elevation in Meters.
     * @return {number} The zenith adjusted to include the sun's radius, refracton
     *         and {@link getElevationAdjustment elevation} adjustment. This will only be adjusted for
     *         sunrise and sunset (if the zenith == 90&deg;)
     * @see getElevationAdjustment
     */ adjustZenith(zenith, elevation) {
        let adjustedZenith = zenith;
        if (zenith === $af23a9f03297d4dc$export$a5e4bf7f397ddef3.GEOMETRIC_ZENITH) // only adjust if it is exactly sunrise or sunset
        adjustedZenith = zenith + ($af23a9f03297d4dc$var$solarRadius + $af23a9f03297d4dc$var$refraction + this.getElevationAdjustment(elevation));
        return adjustedZenith;
    }
    /**
     * A method that calculates UTC sunrise as well as any time based on an angle above or below sunrise.
     * @param date
     *            Used to calculate day of year.
     * @param geoLocation
     *            The location information used for astronomical calculating sun times.
     * @param zenith
     *            the azimuth below the vertical zenith of 90 degrees. for sunrise typically the {@link adjustZenith
     *            zenith} used for the calculation uses geometric zenith of 90&deg; and {@link adjustZenith adjusts}
     *            this slightly to account for solar refraction and the sun's radius. Another example would be
     *            {@link getBeginNauticalTwilight} that passes
     *            {@link NAUTICAL_ZENITH} to this method.
     * @param adjustForElevation
     *            Should the time be adjusted for elevation
     * @return The UTC time of sunrise in 24 hour format. 5:45:00 AM will return 5.75.0. If an error was encountered in
     *         the calculation (expected behavior for some locations such as near the poles,
     *         `NaN` will be returned.
     */ getUTCSunrise(date, geoLocation, zenith, adjustForElevation) {
        const elevation = adjustForElevation ? geoLocation.getElevation() : 0;
        const adjustedZenith = this.adjustZenith(zenith, elevation);
        let sunrise = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunriseUTC($af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianDay(date), geoLocation.getLatitude(), -geoLocation.getLongitude(), adjustedZenith);
        sunrise = sunrise / 60;
        // ensure that the time is >= 0 and < 24
        while(sunrise < 0)sunrise += 24;
        while(sunrise >= 24)sunrise -= 24;
        return sunrise;
    }
    /**
     * A method that calculates UTC sunset as well as any time based on an angle above or below sunset.
     * @param date
     *            Used to calculate day of year.
     * @param geoLocation
     *            The location information used for astronomical calculating sun times.
     * @param zenith
     *            the azimuth below the vertical zenith of 90&deg;. For sunset typically the {@link adjustZenith
     *            zenith} used for the calculation uses geometric zenith of 90&deg; and {@link adjustZenith adjusts}
     *            this slightly to account for solar refraction and the sun's radius. Another example would be
     *            {@link getEndNauticalTwilight} that passes
     *            {@link NAUTICAL_ZENITH} to this method.
     * @param adjustForElevation
     *            Should the time be adjusted for elevation
     * @return The UTC time of sunset in 24 hour format. 5:45:00 AM will return 5.75.0. If an error was encountered in
     *         the calculation (expected behavior for some locations such as near the poles,
     *         `NaN` will be returned.
     */ getUTCSunset(date, geoLocation, zenith, adjustForElevation) {
        const elevation = adjustForElevation ? geoLocation.getElevation() : 0;
        const adjustedZenith = this.adjustZenith(zenith, elevation);
        let sunset = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunsetUTC($af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianDay(date), geoLocation.getLatitude(), -geoLocation.getLongitude(), adjustedZenith);
        sunset = sunset / 60;
        // ensure that the time is >= 0 and < 24
        while(sunset < 0)sunset += 24;
        while(sunset >= 24)sunset -= 24;
        return sunset;
    }
    /**
     * A utility method that will allow the calculation of a temporal (solar) hour based on the sunrise and sunset
     * passed as parameters to this method. An example of the use of this method would be the calculation of a
     * non-elevation adjusted temporal hour by passing in {@link getSeaLevelSunrise() sea level sunrise} and
     * {@link getSeaLevelSunset() sea level sunset} as parameters.
     *
     * @param {Temporal.ZonedDateTime | null} startOfDay
     *            The start of the day.
     * @param {Temporal.ZonedDateTime | null} endOfDay
     *            The end of the day.
     *
     * @return {number} the <code>long</code> millisecond length of the temporal hour. If the calculation can't be computed a
     *         `NaN` will be returned. See detailed explanation on top of the page.
     *
     * @see getTemporalHour()
     */ getTemporalHour(startOfDay = this.getSeaLevelSunrise(), endOfDay = this.getSeaLevelSunset()) {
        if (startOfDay === null || endOfDay === null) return NaN;
        const delta = endOfDay.epochMilliseconds - startOfDay.epochMilliseconds;
        return Math.floor(delta / 12);
    }
    /**
     * A method that returns sundial or solar noon. It occurs when the Sun is <a href
     * ="http://en.wikipedia.org/wiki/Transit_%28astronomy%29">transiting</a> the <a
     * href="http://en.wikipedia.org/wiki/Meridian_%28astronomy%29">celestial meridian</a>. In this class it is
     * calculated as halfway between the sunrise and sunset passed to this method. This time can be slightly off the
     * real transit time due to changes in declination (the lengthening or shortening day).
     *
     * @param {Temporal.ZonedDateTime | null} startOfDay
     *            the start of day for calculating the sun's transit. This can be sea level sunrise, visual sunrise (or
     *            any arbitrary start of day) passed to this method.
     * @param {Temporal.ZonedDateTime | null} endOfDay
     *            the end of day for calculating the sun's transit. This can be sea level sunset, visual sunset (or any
     *            arbitrary end of day) passed to this method.
     *
     * @return {Temporal.ZonedDateTime | null} The `Date` representing Sun's transit. If the calculation can't be computed such as in the
     *         Arctic Circle where there is at least one day a year where the sun does not rise, and one where it does
     *         not set, null will be returned. See detailed explanation on top of the page.
     */ getSunTransit(startOfDay = this.getSeaLevelSunrise(), endOfDay = this.getSeaLevelSunset()) {
        const temporalHour = this.getTemporalHour(startOfDay, endOfDay);
        return $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getTimeOffset(startOfDay, temporalHour * 6);
    }
    /**
     * A method that returns a `Date` from the time passed in as a parameter.
     * @protected
     * @param {number} time
     *            The time to be set as the time for the `Date`. The time expected is in the format: 18.75
     *            for 6:45:00 PM.
     * @param {boolean} isSunrise true if the time is sunrise, and false if it is sunset
     * @return {Temporal.ZonedDateTime | null} The Date.
     */ getDateFromTime(time, isSunrise) {
        if (isNaN(time)) return null;
        let calculatedTime = time;
        let cal = this.getAdjustedDate();
        //    let cal = new Temporal.PlainDate(adj.year, adj.month, adj.day);
        const hours = Math.trunc(calculatedTime); // retain only the hours
        calculatedTime -= hours;
        const minutes = Math.trunc(calculatedTime *= 60); // retain only the minutes
        calculatedTime -= minutes;
        const seconds = Math.trunc(calculatedTime *= 60); // retain only the seconds
        calculatedTime -= seconds; // remaining milliseconds
        // Check if a date transition has occurred, or is about to occur - this indicates the date of the event is
        // actually not the target date, but the day prior or after
        const localTimeHours = Math.trunc(this.geoLocation.getLongitude() / 15);
        if (isSunrise && localTimeHours + hours > 18) cal = cal.add({
            days: -1
        });
        else if (!isSunrise && localTimeHours + hours < 6) cal = cal.add({
            days: 1
        });
        return cal.toZonedDateTime({
            timeZone: 'UTC',
            plainTime: new Temporal.PlainTime(hours, minutes, seconds, Math.trunc(calculatedTime * 1000))
        }).withTimeZone(this.geoLocation.getTimeZone());
    }
    /**
     * Return the <a href="http://en.wikipedia.org/wiki/Julian_day">Julian day</a> from a Java Calendar
     * @private
     * @param {Temporal.ZonedDateTime} date
     *            The Java Calendar
     * @return the Julian day corresponding to the date Note: Number is returned for start of day. Fractional days
     *         should be added later.
     */ static getJulianDay(date) {
        let { year: year, month: month } = date;
        const { day: day } = date;
        if (month <= 2) {
            year -= 1;
            month += 12;
        }
        const a = Math.trunc(year / 100);
        const b = Math.trunc(2 - a + a / 4);
        return Math.floor(365.25 * (year + 4716)) + Math.floor(30.6001 * (month + 1)) + day + b - 1524.5;
    }
    /**
     * Convert <a href="http://en.wikipedia.org/wiki/Julian_day">Julian day</a> to centuries since J2000.0.
     * @private
     * @param julianDay
     *            the Julian Day to convert
     * @return the centuries since 2000 Julian corresponding to the Julian Day
     */ static getJulianCenturiesFromJulianDay(julianDay) {
        return (julianDay - $af23a9f03297d4dc$export$a5e4bf7f397ddef3.JULIAN_DAY_JAN_1_2000) / $af23a9f03297d4dc$export$a5e4bf7f397ddef3.JULIAN_DAYS_PER_CENTURY;
    }
    /**
     * Convert centuries since J2000.0 to <a href="http://en.wikipedia.org/wiki/Julian_day">Julian day</a>.
     * @private
     * @param julianCenturies
     *            the number of Julian centuries since J2000.0
     * @return the Julian Day corresponding to the Julian centuries passed in
     */ static getJulianDayFromJulianCenturies(julianCenturies) {
        return julianCenturies * $af23a9f03297d4dc$export$a5e4bf7f397ddef3.JULIAN_DAYS_PER_CENTURY + $af23a9f03297d4dc$export$a5e4bf7f397ddef3.JULIAN_DAY_JAN_1_2000;
    }
    /**
     * Returns the Geometric <a href="http://en.wikipedia.org/wiki/Mean_longitude">Mean Longitude</a> of the Sun.
     * @private
     * @param julianCenturies
     *            the number of Julian centuries since J2000.0
     * @return the Geometric Mean Longitude of the Sun in degrees
     */ static getSunGeometricMeanLongitude(julianCenturies) {
        let longitude = 280.46646 + julianCenturies * (36000.76983 + 0.0003032 * julianCenturies);
        while(longitude > 360)longitude -= 360;
        while(longitude < 0)longitude += 360;
        return longitude; // in degrees
    }
    /**
     * Returns the Geometric <a href="http://en.wikipedia.org/wiki/Mean_anomaly">Mean Anomaly</a> of the Sun.
     * @private
     * @param julianCenturies
     *            the number of Julian centuries since J2000.0
     * @return the Geometric Mean Anomaly of the Sun in degrees
     */ static getSunGeometricMeanAnomaly(julianCenturies) {
        return 357.52911 + julianCenturies * (35999.05029 - 0.0001537 * julianCenturies); // in degrees
    }
    /**
     * Return the <a href="http://en.wikipedia.org/wiki/Eccentricity_%28orbit%29">eccentricity of earth's orbit</a>.
     * @private
     * @param julianCenturies
     *            the number of Julian centuries since J2000.0
     * @return the unitless eccentricity
     */ static getEarthOrbitEccentricity(julianCenturies) {
        return 0.016708634 - julianCenturies * (0.000042037 + 0.0000001267 * julianCenturies); // unitless
    }
    /**
     * Returns the <a href="http://en.wikipedia.org/wiki/Equation_of_the_center">equation of center</a> for the sun.
     * @private
     * @param julianCenturies
     *            the number of Julian centuries since J2000.0
     * @return the equation of center for the sun in degrees
     */ static getSunEquationOfCenter(julianCenturies) {
        const m = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunGeometricMeanAnomaly(julianCenturies);
        const mrad = $af23a9f03297d4dc$var$degreesToRadians(m);
        const sinm = Math.sin(mrad);
        const sin2m = Math.sin(mrad + mrad);
        const sin3m = Math.sin(mrad + mrad + mrad);
        return sinm * (1.914602 - julianCenturies * (0.004817 + 0.000014 * julianCenturies)) + sin2m * (0.019993 - 0.000101 * julianCenturies) + sin3m * 0.000289; // in degrees
    }
    /**
     * Return the true longitude of the sun
     * @private
     * @param julianCenturies
     *            the number of Julian centuries since J2000.0
     * @return the sun's true longitude in degrees
     */ static getSunTrueLongitude(julianCenturies) {
        const sunLongitude = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunGeometricMeanLongitude(julianCenturies);
        const center = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunEquationOfCenter(julianCenturies);
        return sunLongitude + center; // in degrees
    }
    /**
     * Return the apparent longitude of the sun
     * @private
     * @param julianCenturies
     *            the number of Julian centuries since J2000.0
     * @return sun's apparent longitude in degrees
     */ static getSunApparentLongitude(julianCenturies) {
        const sunTrueLongitude = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunTrueLongitude(julianCenturies);
        const omega = 125.04 - 1934.136 * julianCenturies;
        const lambda = sunTrueLongitude - 0.00569 - 0.00478 * Math.sin($af23a9f03297d4dc$var$degreesToRadians(omega));
        return lambda; // in degrees
    }
    /**
     * Returns the mean <a href="http://en.wikipedia.org/wiki/Axial_tilt">obliquity of the ecliptic</a> (Axial tilt).
     * @private
     * @param julianCenturies
     *            the number of Julian centuries since J2000.0
     * @return the mean obliquity in degrees
     */ static getMeanObliquityOfEcliptic(julianCenturies) {
        const seconds = 21.448 - julianCenturies * (46.815 + julianCenturies * (0.00059 - julianCenturies * 0.001813));
        return 23 + (26 + seconds / 60) / 60; // in degrees
    }
    /**
     * Returns the corrected <a href="http://en.wikipedia.org/wiki/Axial_tilt">obliquity of the ecliptic</a> (Axial
     * tilt).
     * @private
     * @param julianCenturies
     *            the number of Julian centuries since J2000.0
     * @return the corrected obliquity in degrees
     */ static getObliquityCorrection(julianCenturies) {
        const obliquityOfEcliptic = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getMeanObliquityOfEcliptic(julianCenturies);
        const omega = 125.04 - 1934.136 * julianCenturies;
        return obliquityOfEcliptic + 0.00256 * Math.cos($af23a9f03297d4dc$var$degreesToRadians(omega)); // in degrees
    }
    /**
     * Return the <a href="http://en.wikipedia.org/wiki/Declination">declination</a> of the sun.
     * @private
     * @param julianCenturies
     *            the number of Julian centuries since J2000.0
     * @return
     *            the sun's declination in degrees
     */ static getSunDeclination(julianCenturies) {
        const obliquityCorrection = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getObliquityCorrection(julianCenturies);
        const lambda = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunApparentLongitude(julianCenturies);
        const sint = Math.sin($af23a9f03297d4dc$var$degreesToRadians(obliquityCorrection)) * Math.sin($af23a9f03297d4dc$var$degreesToRadians(lambda));
        const theta = $af23a9f03297d4dc$var$radiansToDegrees(Math.asin(sint));
        return theta; // in degrees
    }
    /**
     * Return the <a href="http://en.wikipedia.org/wiki/Equation_of_time">Equation of Time</a> - the difference between
     * true solar time and mean solar time
     * @private
     * @param julianCenturies
     *            the number of Julian centuries since J2000.0
     * @return equation of time in minutes of time
     */ static getEquationOfTime(julianCenturies) {
        const epsilon = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getObliquityCorrection(julianCenturies);
        const geomMeanLongSun = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunGeometricMeanLongitude(julianCenturies);
        const eccentricityEarthOrbit = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getEarthOrbitEccentricity(julianCenturies);
        const geomMeanAnomalySun = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunGeometricMeanAnomaly(julianCenturies);
        let y = Math.tan($af23a9f03297d4dc$var$degreesToRadians(epsilon) / 2);
        y *= y;
        const sin2l0 = Math.sin(2 * $af23a9f03297d4dc$var$degreesToRadians(geomMeanLongSun));
        const sinm = Math.sin($af23a9f03297d4dc$var$degreesToRadians(geomMeanAnomalySun));
        const cos2l0 = Math.cos(2 * $af23a9f03297d4dc$var$degreesToRadians(geomMeanLongSun));
        const sin4l0 = Math.sin(4 * $af23a9f03297d4dc$var$degreesToRadians(geomMeanLongSun));
        const sin2m = Math.sin(2 * $af23a9f03297d4dc$var$degreesToRadians(geomMeanAnomalySun));
        const equationOfTime = y * sin2l0 - 2 * eccentricityEarthOrbit * sinm + 4 * eccentricityEarthOrbit * y * sinm * cos2l0 - 0.5 * y * y * sin4l0 - 1.25 * eccentricityEarthOrbit * eccentricityEarthOrbit * sin2m;
        return $af23a9f03297d4dc$var$radiansToDegrees(equationOfTime) * 4; // in minutes of time
    }
    /**
     * Return the <a href="http://en.wikipedia.org/wiki/Hour_angle">hour angle</a> of the sun at sunrise for the
     * latitude.
     * @private
     * @param {number} lat
     *            , the latitude of observer in degrees
     * @param solarDec
     *            the declination angle of sun in degrees
     * @param {number} zenith
     *            the zenith
     * @return hour angle of sunrise in radians
     */ static getSunHourAngleAtSunrise(lat, solarDec, zenith) {
        const latRad = $af23a9f03297d4dc$var$degreesToRadians(lat);
        const sdRad = $af23a9f03297d4dc$var$degreesToRadians(solarDec);
        return Math.acos(Math.cos($af23a9f03297d4dc$var$degreesToRadians(zenith)) / (Math.cos(latRad) * Math.cos(sdRad)) - Math.tan(latRad) * Math.tan(sdRad)); // in radians
    }
    /**
     * Returns the <a href="http://en.wikipedia.org/wiki/Hour_angle">hour angle</a> of the sun at sunset for the
     * latitude.
     * @private
     * @param {number} lat
     *            the latitude of observer in degrees
     * @param solarDec
     *            the declination angle of sun in degrees
     * @param {number} zenith
     *            the zenith
     * @return the hour angle of sunset in radians
     */ static getSunHourAngleAtSunset(lat, solarDec, zenith) {
        const latRad = $af23a9f03297d4dc$var$degreesToRadians(lat);
        const sdRad = $af23a9f03297d4dc$var$degreesToRadians(solarDec);
        const hourAngle = Math.acos(Math.cos($af23a9f03297d4dc$var$degreesToRadians(zenith)) / (Math.cos(latRad) * Math.cos(sdRad)) - Math.tan(latRad) * Math.tan(sdRad));
        return -hourAngle; // in radians
    }
    /**
     * Return the <a href="http://en.wikipedia.org/wiki/Celestial_coordinate_system">Solar Elevation</a> for the
     * horizontal coordinate system at the given location at the given time. Can be negative if the sun is below the
     * horizon. Not corrected for altitude.
     *
     * @param {Temporal.ZonedDateTime} date
     *            time of calculation
     * @param {number} lat
     *            latitude of location for calculation
     * @param {number} lon
     *            longitude of location for calculation
     * @return {number} solar elevation in degrees - horizon is 0 degrees, civil twilight is -6 degrees
     */ static getSolarElevation(date, lat, lon) {
        const julianDay = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianDay(date.toPlainDate());
        const julianCenturies = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianCenturiesFromJulianDay(julianDay);
        const equationOfTime = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getEquationOfTime(julianCenturies);
        let longitude = date.hour + 12 + (date.minute + equationOfTime + date.second / 60) / 60;
        longitude = -(longitude * 360 / 24) % 360;
        const hourAngleRad = $af23a9f03297d4dc$var$degreesToRadians(lon - longitude);
        const declination = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunDeclination(julianCenturies);
        const decRad = $af23a9f03297d4dc$var$degreesToRadians(declination);
        const latRad = $af23a9f03297d4dc$var$degreesToRadians(lat);
        return $af23a9f03297d4dc$var$radiansToDegrees(Math.asin(Math.sin(latRad) * Math.sin(decRad) + Math.cos(latRad) * Math.cos(decRad) * Math.cos(hourAngleRad)));
    }
    /**
     * Return the <a href="http://en.wikipedia.org/wiki/Celestial_coordinate_system">Solar Azimuth</a> for the
     * horizontal coordinate system at the given location at the given time. Not corrected for altitude. True south is 0
     * degrees.
     *
     * @param {Temporal.ZonedDateTime} date
     *            time of calculation
     * @param {number} latitude
     *            latitude of location for calculation
     * @param {number} lon
     *            longitude of location for calculation
     * @return {number}
     */ static getSolarAzimuth(date, latitude, lon) {
        const julianDay = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianDay(date.toPlainDate());
        const julianCenturies = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianCenturiesFromJulianDay(julianDay);
        const equationOfTime = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getEquationOfTime(julianCenturies);
        let longitude = date.hour + 12 + (date.minute + equationOfTime + date.second / 60) / 60;
        longitude = -(longitude * 360 / 24) % 360;
        const hourAngleRad = $af23a9f03297d4dc$var$degreesToRadians(lon - longitude);
        const declination = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunDeclination(julianCenturies);
        const decRad = $af23a9f03297d4dc$var$degreesToRadians(declination);
        const latRad = $af23a9f03297d4dc$var$degreesToRadians(latitude);
        return $af23a9f03297d4dc$var$radiansToDegrees(Math.atan(Math.sin(hourAngleRad) / (Math.cos(hourAngleRad) * Math.sin(latRad) - Math.tan(decRad) * Math.cos(latRad)))) + 180;
    }
    /**
     * Return the <a href="http://en.wikipedia.org/wiki/Universal_Coordinated_Time">Universal Coordinated Time</a> (UTC)
     * of sunrise for the given day at the given location on earth
     * @private
     * @param julianDay
     *            the Julian day
     * @param {number} latitude
     *            the latitude of observer in degrees
     * @param {number} longitude
     *            the longitude of observer in degrees
     * @param {number} zenith
     *            the zenith
     * @return the time in minutes from zero UTC
     */ static getSunriseUTC(julianDay, latitude, longitude, zenith) {
        const julianCenturies = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianCenturiesFromJulianDay(julianDay);
        // Find the time of solar noon at the location, and use that declination. This is better than start of the
        // Julian day
        const noonmin = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSolarNoonUTC(julianCenturies, longitude);
        const tnoon = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianCenturiesFromJulianDay(julianDay + noonmin / 1440);
        // First pass to approximate sunrise (using solar noon)
        let eqTime = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getEquationOfTime(tnoon);
        let solarDec = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunDeclination(tnoon);
        let hourAngle = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunHourAngleAtSunrise(latitude, solarDec, zenith);
        let delta = longitude - $af23a9f03297d4dc$var$radiansToDegrees(hourAngle);
        let timeDiff = 4 * delta; // in minutes of time
        let timeUTC = 720 + timeDiff - eqTime; // in minutes
        // Second pass includes fractional Julian Day in gamma calc
        const newt = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianCenturiesFromJulianDay($af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianDayFromJulianCenturies(julianCenturies) + timeUTC / 1440);
        eqTime = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getEquationOfTime(newt);
        solarDec = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunDeclination(newt);
        hourAngle = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunHourAngleAtSunrise(latitude, solarDec, zenith);
        delta = longitude - $af23a9f03297d4dc$var$radiansToDegrees(hourAngle);
        timeDiff = 4 * delta;
        timeUTC = 720 + timeDiff - eqTime; // in minutes
        return timeUTC;
    }
    /**
     * Return the <a href="http://en.wikipedia.org/wiki/Universal_Coordinated_Time">Universal Coordinated Time</a> (UTC)
     * of <a href="http://en.wikipedia.org/wiki/Noon#Solar_noon">solar noon</a> for the given day at the given location
     * on earth.
     * @private
     * @param julianCenturies
     *            the number of Julian centuries since J2000.0
     * @param {number} longitude
     *            the longitude of observer in degrees
     * @return the time in minutes from zero UTC
     */ static getSolarNoonUTC(julianCenturies, longitude) {
        // First pass uses approximate solar noon to calculate eqtime
        const tnoon = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianCenturiesFromJulianDay($af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianDayFromJulianCenturies(julianCenturies) + longitude / 360);
        let eqTime = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getEquationOfTime(tnoon);
        const solNoonUTC = 720 + longitude * 4 - eqTime; // min
        const newt = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianCenturiesFromJulianDay($af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianDayFromJulianCenturies(julianCenturies) - 0.5 + solNoonUTC / 1440);
        eqTime = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getEquationOfTime(newt);
        return 720 + longitude * 4 - eqTime; // min
    }
    /**
     * Return the <a href="http://en.wikipedia.org/wiki/Universal_Coordinated_Time">Universal Coordinated Time</a> (UTC)
     * of sunset for the given day at the given location on earth
     * @private
     * @param julianDay
     *            the Julian day
     * @param {number} latitude
     *            the latitude of observer in degrees
     * @param {number} longitude
     *            : longitude of observer in degrees
     * @param {number} zenith
     *            the zenith
     * @return the time in minutes from zero Universal Coordinated Time (UTC)
     */ static getSunsetUTC(julianDay, latitude, longitude, zenith) {
        const julianCenturies = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianCenturiesFromJulianDay(julianDay);
        // Find the time of solar noon at the location, and use that declination. This is better than start of the
        // Julian day
        const noonmin = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSolarNoonUTC(julianCenturies, longitude);
        const tnoon = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianCenturiesFromJulianDay(julianDay + noonmin / 1440);
        // First calculates sunrise and approx length of day
        let eqTime = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getEquationOfTime(tnoon);
        let solarDec = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunDeclination(tnoon);
        let hourAngle = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunHourAngleAtSunset(latitude, solarDec, zenith);
        let delta = longitude - $af23a9f03297d4dc$var$radiansToDegrees(hourAngle);
        let timeDiff = 4 * delta;
        let timeUTC = 720 + timeDiff - eqTime;
        // Second pass includes fractional Julian Day in gamma calc
        const newt = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianCenturiesFromJulianDay($af23a9f03297d4dc$export$a5e4bf7f397ddef3.getJulianDayFromJulianCenturies(julianCenturies) + timeUTC / 1440);
        eqTime = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getEquationOfTime(newt);
        solarDec = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunDeclination(newt);
        hourAngle = $af23a9f03297d4dc$export$a5e4bf7f397ddef3.getSunHourAngleAtSunset(latitude, solarDec, zenith);
        delta = longitude - $af23a9f03297d4dc$var$radiansToDegrees(hourAngle);
        timeDiff = 4 * delta;
        timeUTC = 720 + timeDiff - eqTime; // in minutes
        return timeUTC;
    }
}
/**
 * The zenith of astronomical sunrise and sunset. The sun is 90&deg; from the vertical 0&deg;
 * @private
 */ $af23a9f03297d4dc$export$a5e4bf7f397ddef3.GEOMETRIC_ZENITH = 90;
/**
 * Default value for Sun's zenith and true rise/set Zenith (used in this class and subclasses) is the angle that the
 * center of the Sun makes to a line perpendicular to the Earth's surface. If the Sun were a point and the Earth
 * were without an atmosphere, true sunset and sunrise would correspond to a 90&deg; zenith. Because the Sun is not
 * a point, and because the atmosphere refracts light, this 90&deg; zenith does not, in fact, correspond to true
 * sunset or sunrise, instead the center of the Sun's disk must lie just below the horizon for the upper edge to be
 * obscured. This means that a zenith of just above 90&deg; must be used. The Sun subtends an angle of 16 minutes of
 * arc, and atmospheric refraction accounts for
 * 34 minutes or so, giving a total of 50
 * arcminutes. The total value for ZENITH is 90+(5/6) or 90.8333333&deg; for true sunrise/sunset.
 */ // const ZENITH: number = GEOMETRIC_ZENITH + 5.0 / 6.0;
/** Sun's zenith at civil twilight (96&deg;). */ $af23a9f03297d4dc$export$a5e4bf7f397ddef3.CIVIL_ZENITH = 96;
/** Sun's zenith at nautical twilight (102&deg;). */ $af23a9f03297d4dc$export$a5e4bf7f397ddef3.NAUTICAL_ZENITH = 102;
/** Sun's zenith at astronomical twilight (108&deg;). */ $af23a9f03297d4dc$export$a5e4bf7f397ddef3.ASTRONOMICAL_ZENITH = 108;
/**
 * The <a href="http://en.wikipedia.org/wiki/Julian_day">Julian day</a> of January 1, 2000
 * @private
 */ $af23a9f03297d4dc$export$a5e4bf7f397ddef3.JULIAN_DAY_JAN_1_2000 = 2451545;
/**
 * Julian days per century
 * @private
 */ $af23a9f03297d4dc$export$a5e4bf7f397ddef3.JULIAN_DAYS_PER_CENTURY = 36525;


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 
/*
    Hebcal - A Jewish Calendar Generator
    Copyright (c) 1994-2020 Danny Sadinoff
    Portions copyright Eyal Schachter and Michael J. Radwin

    https://github.com/hebcal/hebcal-es6

    This program is free software; you can redistribute it and/or
    modify it under the terms of the GNU General Public License
    as published by the Free Software Foundation; either version 2
    of the License, or (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program. If not, see <http://www.gnu.org/licenses/>.
 */ const $2f64a42ff459546f$var$classicCities0 = [
    [
        'Ashdod',
        'IL',
        31.79213,
        34.64966,
        'Asia/Jerusalem',
        27
    ],
    [
        'Atlanta',
        'US',
        33.749,
        -84.38798,
        'America/New_York',
        336
    ],
    [
        'Austin',
        'US',
        30.26715,
        -97.74306,
        'America/Chicago',
        165
    ],
    [
        'Baghdad',
        'IQ',
        33.34058,
        44.40088,
        'Asia/Baghdad',
        41
    ],
    [
        'Beer Sheva',
        'IL',
        31.25181,
        34.7913,
        'Asia/Jerusalem',
        285
    ],
    [
        'Berlin',
        'DE',
        52.52437,
        13.41053,
        'Europe/Berlin',
        43
    ],
    [
        'Baltimore',
        'US',
        39.29038,
        -76.61219,
        'America/New_York',
        35
    ],
    [
        'Bogota',
        'CO',
        4.60971,
        -74.08175,
        'America/Bogota',
        2582
    ],
    [
        'Boston',
        'US',
        42.35843,
        -71.05977,
        'America/New_York',
        38
    ],
    [
        'Budapest',
        'HU',
        47.49801,
        19.03991,
        'Europe/Budapest',
        104
    ],
    [
        'Buenos Aires',
        'AR',
        -34.61315,
        -58.37723,
        'America/Argentina/Buenos_Aires',
        31
    ],
    [
        'Buffalo',
        'US',
        42.88645,
        -78.87837,
        'America/New_York',
        191
    ],
    [
        'Chicago',
        'US',
        41.85003,
        -87.65005,
        'America/Chicago',
        180
    ],
    [
        'Cincinnati',
        'US',
        39.162,
        -84.45689,
        'America/New_York',
        267
    ],
    [
        'Cleveland',
        'US',
        41.4995,
        -81.69541,
        'America/New_York',
        204
    ],
    [
        'Dallas',
        'US',
        32.78306,
        -96.80667,
        'America/Chicago',
        139
    ],
    [
        'Denver',
        'US',
        39.73915,
        -104.9847,
        'America/Denver',
        1636
    ],
    [
        'Detroit',
        'US',
        42.33143,
        -83.04575,
        'America/Detroit',
        192
    ],
    [
        'Eilat',
        'IL',
        29.55805,
        34.94821,
        'Asia/Jerusalem',
        63
    ],
    [
        'Gibraltar',
        'GI',
        36.14474,
        -5.35257,
        'Europe/Gibraltar',
        11
    ],
    [
        'Haifa',
        'IL',
        32.81841,
        34.9885,
        'Asia/Jerusalem',
        40
    ],
    [
        'Hawaii',
        'US',
        21.30694,
        -157.85833,
        'Pacific/Honolulu',
        18
    ],
    [
        'Helsinki',
        'FI',
        60.16952,
        24.93545,
        'Europe/Helsinki',
        26
    ],
    [
        'Houston',
        'US',
        29.76328,
        -95.36327,
        'America/Chicago',
        30
    ],
    [
        'Jerusalem',
        'IL',
        31.76904,
        35.21633,
        'Asia/Jerusalem',
        786
    ],
    [
        'Johannesburg',
        'ZA',
        -26.20227,
        28.04363,
        'Africa/Johannesburg',
        1767
    ],
    [
        'Kiev',
        'UA',
        50.45466,
        30.5238,
        'Europe/Kiev',
        187
    ],
    [
        'La Paz',
        'BO',
        -16.5,
        -68.15,
        'America/La_Paz',
        3782
    ],
    [
        'Livingston',
        'US',
        40.79593,
        -74.31487,
        'America/New_York',
        98
    ],
    [
        'Las Vegas',
        'US',
        36.17497,
        -115.13722,
        'America/Los_Angeles',
        613
    ],
    [
        'London',
        'GB',
        51.50853,
        -0.12574,
        'Europe/London',
        25
    ],
    [
        'Los Angeles',
        'US',
        34.05223,
        -118.24368,
        'America/Los_Angeles',
        96
    ],
    [
        'Marseilles',
        'FR',
        43.29695,
        5.38107,
        'Europe/Paris',
        28
    ],
    [
        'Miami',
        'US',
        25.77427,
        -80.19366,
        'America/New_York',
        25
    ],
    [
        'Minneapolis',
        'US',
        44.97997,
        -93.26384,
        'America/Chicago',
        262
    ],
    [
        'Melbourne',
        'AU',
        -37.814,
        144.96332,
        'Australia/Melbourne',
        25
    ],
    [
        'Mexico City',
        'MX',
        19.42847,
        -99.12766,
        'America/Mexico_City',
        2240
    ],
    [
        'Montreal',
        'CA',
        45.50884,
        -73.58781,
        'America/Toronto',
        216
    ],
    [
        'Moscow',
        'RU',
        55.75222,
        37.61556,
        'Europe/Moscow',
        144
    ],
    [
        'New York',
        'US',
        40.71427,
        -74.00597,
        'America/New_York',
        57
    ],
    [
        'Omaha',
        'US',
        41.25861,
        -95.93779,
        'America/Chicago',
        315
    ],
    [
        'Ottawa',
        'CA',
        45.41117,
        -75.69812,
        'America/Toronto',
        71
    ],
    [
        'Panama City',
        'PA',
        8.9936,
        -79.51973,
        'America/Panama',
        17
    ],
    [
        'Paris',
        'FR',
        48.85341,
        2.3488,
        'Europe/Paris',
        42
    ],
    [
        'Pawtucket',
        'US',
        41.87871,
        -71.38256,
        'America/New_York',
        0
    ],
    [
        'Petach Tikvah',
        'IL',
        32.08707,
        34.88747,
        'Asia/Jerusalem',
        54
    ],
    [
        'Philadelphia',
        'US',
        39.95233,
        -75.16379,
        'America/New_York',
        8
    ],
    [
        'Phoenix',
        'US',
        33.44838,
        -112.07404,
        'America/Phoenix',
        366
    ],
    [
        'Pittsburgh',
        'US',
        40.44062,
        -79.99589,
        'America/New_York',
        239
    ],
    [
        'Providence',
        'US',
        41.82399,
        -71.41283,
        'America/New_York',
        0
    ],
    [
        'Portland',
        'US',
        45.52345,
        -122.67621,
        'America/Los_Angeles',
        15
    ],
    [
        'Saint Louis',
        'US',
        38.62727,
        -90.19789,
        'America/Chicago',
        149
    ],
    [
        'Saint Petersburg',
        'RU',
        59.93863,
        30.31413,
        'Europe/Moscow',
        11
    ],
    [
        'San Diego',
        'US',
        32.71533,
        -117.15726,
        'America/Los_Angeles',
        20
    ],
    [
        'San Francisco',
        'US',
        37.77493,
        -122.41942,
        'America/Los_Angeles',
        28
    ],
    [
        'Sao Paulo',
        'BR',
        -23.5475,
        -46.63611,
        'America/Sao_Paulo',
        769
    ],
    [
        'Seattle',
        'US',
        47.60621,
        -122.33207,
        'America/Los_Angeles',
        56
    ],
    [
        'Sydney',
        'AU',
        -33.86785,
        151.20732,
        'Australia/Sydney',
        58
    ],
    [
        'Tel Aviv',
        'IL',
        32.08088,
        34.78057,
        'Asia/Jerusalem',
        15
    ],
    [
        'Tiberias',
        'IL',
        32.79221,
        35.53124,
        'Asia/Jerusalem',
        0
    ],
    [
        'Toronto',
        'CA',
        43.70011,
        -79.4163,
        'America/Toronto',
        175
    ],
    [
        'Vancouver',
        'CA',
        49.24966,
        -123.11934,
        'America/Vancouver',
        70
    ],
    [
        'White Plains',
        'US',
        41.03399,
        -73.76291,
        'America/New_York',
        82
    ],
    [
        'Washington DC',
        'US',
        38.89511,
        -77.03637,
        'America/New_York',
        6
    ],
    [
        'Worcester',
        'US',
        42.26259,
        -71.80229,
        'America/New_York',
        164
    ]
];
const $2f64a42ff459546f$var$classicCities = new Map();
// Zip-Codes.com TimeZone IDs
const $2f64a42ff459546f$var$ZIPCODES_TZ_MAP = {
    '0': 'UTC',
    '4': 'America/Puerto_Rico',
    '5': 'America/New_York',
    '6': 'America/Chicago',
    '7': 'America/Denver',
    '8': 'America/Los_Angeles',
    '9': 'America/Anchorage',
    '10': 'Pacific/Honolulu',
    '11': 'Pacific/Pago_Pago',
    '13': 'Pacific/Funafuti',
    '14': 'Pacific/Guam',
    '15': 'Pacific/Palau',
    '16': 'Pacific/Chuuk'
};
/** @private */ const $2f64a42ff459546f$var$timeFormatCache = new Map();
/**
 * Gets a 24-hour time formatter (e.g. 07:41 or 20:03) from cache
 * or makes a new one if needed
 * @private
 */ function $2f64a42ff459546f$var$getFormatter(tzid) {
    const fmt = $2f64a42ff459546f$var$timeFormatCache.get(tzid);
    if (fmt) return fmt;
    const f = new Intl.DateTimeFormat('en-US', {
        timeZone: tzid,
        hour: 'numeric',
        minute: 'numeric',
        hour12: false
    });
    $2f64a42ff459546f$var$timeFormatCache.set(tzid, f);
    return f;
}
/** Class representing Location */ class $2f64a42ff459546f$export$18a2be9195644f38 extends (0, $af23a9f03297d4dc$export$476ba50ca24afb42) {
    /**
     * Initialize a Location instance
     * @param latitude - Latitude as a decimal, valid range -90 thru +90 (e.g. 41.85003)
     * @param longitude - Longitude as a decimal, valid range -180 thru +180 (e.g. -87.65005)
     * @param il - in Israel (true) or Diaspora (false)
     * @param tzid - Olson timezone ID, e.g. "America/Chicago"
     * @param [cityName] - optional descriptive city name
     * @param [countryCode] - ISO 3166 alpha-2 country code (e.g. "FR")
     * @param [geoid] - optional string or numeric geographic ID
     * @param [elevation] - in meters (default `0`)
     */ constructor(latitude, longitude, il, tzid, cityName, countryCode, geoid, elevation){
        const lat = typeof latitude === 'number' ? latitude : parseFloat(latitude);
        if (isNaN(lat) || lat < -90 || lat > 90) throw new RangeError(`Latitude ${latitude} out of range [-90,90]`);
        const long = typeof longitude === 'number' ? longitude : parseFloat(longitude);
        if (isNaN(long) || long < -180 || long > 180) throw new RangeError(`Longitude ${longitude} out of range [-180,180]`);
        const elev = typeof elevation === 'number' && elevation > 0 ? elevation : 0;
        super(cityName || null, lat, long, elev, tzid);
        this.il = Boolean(il);
        this.cc = countryCode;
        this.geoid = geoid;
    }
    getIsrael() {
        return this.il;
    }
    getName() {
        return this.getLocationName();
    }
    /**
     * Returns the location name, up to the first comma
     */ getShortName() {
        const name = this.getLocationName();
        if (!name) return name;
        const comma = name.indexOf(', ');
        if (comma === -1) return name;
        if (this.cc === 'US' && name[comma + 2] === 'D') {
            if (name[comma + 3] === 'C') return name.substring(0, comma + 4);
            else if (name[comma + 3] === '.' && name[comma + 4] === 'C') return name.substring(0, comma + 6);
        }
        return name.substring(0, comma);
    }
    getCountryCode() {
        return this.cc;
    }
    getTzid() {
        return this.getTimeZone();
    }
    /**
     * Gets a 24-hour time formatter (e.g. 07:41 or 20:03) for this location
     */ getTimeFormatter() {
        return $2f64a42ff459546f$var$getFormatter(this.getTimeZone());
    }
    getGeoId() {
        return this.geoid;
    }
    /**
     * Creates a location object from one of 60 "classic" Hebcal city names.
     * The following city names are supported:
     * 'Ashdod', 'Atlanta', 'Austin', 'Baghdad', 'Beer Sheva',
     * 'Berlin', 'Baltimore', 'Bogota', 'Boston', 'Budapest',
     * 'Buenos Aires', 'Buffalo', 'Chicago', 'Cincinnati', 'Cleveland',
     * 'Dallas', 'Denver', 'Detroit', 'Eilat', 'Gibraltar', 'Haifa',
     * 'Hawaii', 'Helsinki', 'Houston', 'Jerusalem', 'Johannesburg',
     * 'Kiev', 'La Paz', 'Livingston', 'Las Vegas', 'London', 'Los Angeles',
     * 'Marseilles', 'Miami', 'Minneapolis', 'Melbourne', 'Mexico City',
     * 'Montreal', 'Moscow', 'New York', 'Omaha', 'Ottawa', 'Panama City',
     * 'Paris', 'Pawtucket', 'Petach Tikvah', 'Philadelphia', 'Phoenix',
     * 'Pittsburgh', 'Providence', 'Portland', 'Saint Louis', 'Saint Petersburg',
     * 'San Diego', 'San Francisco', 'Sao Paulo', 'Seattle', 'Sydney',
     * 'Tel Aviv', 'Tiberias', 'Toronto', 'Vancouver', 'White Plains',
     * 'Washington DC', 'Worcester'
     * @param name
     */ static lookup(name) {
        return $2f64a42ff459546f$var$classicCities.get(name.toLowerCase());
    }
    toString() {
        return JSON.stringify(this);
    }
    /**
     * Converts legacy Hebcal timezone to a standard Olson tzid.
     * @param tz integer, GMT offset in hours
     * @param dst 'none', 'eu', 'usa', or 'israel'
     */ static legacyTzToTzid(tz, dst) {
        tz = +tz;
        if (dst === 'none') {
            if (tz === 0) return 'UTC';
            else {
                const plus = tz > 0 ? '+' : '';
                return `Etc/GMT${plus}${tz}`;
            }
        } else if (tz === 2 && dst === 'israel') return 'Asia/Jerusalem';
        else if (dst === 'eu') switch(tz){
            case -2:
                return 'Atlantic/Cape_Verde';
            case -1:
                return 'Atlantic/Azores';
            case 0:
                return 'Europe/London';
            case 1:
                return 'Europe/Paris';
            case 2:
                return 'Europe/Athens';
        }
        else if (dst === 'usa') return $2f64a42ff459546f$var$ZIPCODES_TZ_MAP[String(tz * -1)];
        return undefined;
    }
    /**
     * Converts timezone info from Zip-Codes.com to a standard Olson tzid.
     * @example
     * Location.getUsaTzid('AZ', 7, 'Y') // 'America/Denver'
     * @param state two-letter all-caps US state abbreviation like 'CA'
     * @param tz positive number, 5=America/New_York, 8=America/Los_Angeles
     * @param dst single char 'Y' or 'N'
     */ static getUsaTzid(state, tz, dst) {
        tz = +tz;
        if (tz === 10 && state === 'AK') return 'America/Adak';
        else if (tz === 7 && state === 'AZ') return dst === 'Y' ? 'America/Denver' : 'America/Phoenix';
        else return $2f64a42ff459546f$var$ZIPCODES_TZ_MAP[tz];
    }
    /**
     * Adds a location name for `Location.lookup()` only if the name isn't
     * already being used. Returns `false` if the name is already taken
     * and `true` if successfully added.
     */ static addLocation(cityName, location) {
        const name = cityName.toLowerCase();
        if ($2f64a42ff459546f$var$classicCities.has(name)) return false;
        $2f64a42ff459546f$var$classicCities.set(name, location);
        return true;
    }
}
for (const city of $2f64a42ff459546f$var$classicCities0){
    const location = new $2f64a42ff459546f$export$18a2be9195644f38(city[2], city[3], city[1] === 'IL', city[4], city[0], city[1], undefined, city[5]);
    $2f64a42ff459546f$export$18a2be9195644f38.addLocation(city[0], location);
}


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 


/**
 * @private
 */ function $dcc49aa98f3628f5$var$zdtToDate(zdt) {
    if (zdt === null) return new Date(NaN);
    const res = new Date(zdt.epochMilliseconds);
    res.setMilliseconds(0);
    return res;
}
function $dcc49aa98f3628f5$var$getDate(date) {
    if ((0, $95162f6f50e12e59$export$871608497c498473)(date)) return date;
    if ((0, $e7dd728d9f060a75$export$8f4940fd510e0848).isHDate(date)) return date.greg();
    throw new TypeError(`invalid date: ${date}`);
}
/**
 * Calculate halachic times (zmanim / זְמַנִּים) for a given day and location.
 * Calculations are available for tzeit / tzais (nightfall),
 * shkiah (sunset) and more.
 *
 * Zmanim are estimated using an algorithm published by the US National Oceanic
 * and Atmospheric Administration. The NOAA solar calculator is based on equations
 * from _Astronomical Algorithms_ by Jean Meeus.
 *
 * The sunrise and sunset results are theoretically accurate to within a minute for
 * locations between +/- 72° latitude, and within 10 minutes outside of those latitudes.
 * However, due to variations in atmospheric composition, temperature, pressure and
 * conditions, observed values may vary from calculations.
 * https://gml.noaa.gov/grad/solcalc/calcdetails.html
 *
 * @example
 * const {GeoLocation, Zmanim} = require('@hebcal/core');
 * const latitude = 41.822232;
 * const longitude = -71.448292;
 * const tzid = 'America/New_York';
 * const friday = new Date(2023, 8, 8);
 * const gloc = new GeoLocation(null, latitude, longitude, 0, tzid);
 * const zmanim = new Zmanim(gloc, friday, false);
 * const candleLighting = zmanim.sunsetOffset(-18, true);
 * const timeStr = Zmanim.formatISOWithTimeZone(tzid, candleLighting);
 */ class $dcc49aa98f3628f5$export$c5e94b89b957f48e {
    /**
     * Initialize a Zmanim instance.
     * @param gloc GeoLocation including latitude, longitude, and timezone
     * @param date Regular or Hebrew Date. If `date` is a regular `Date`,
     *    hours, minutes, seconds and milliseconds are ignored.
     * @param useElevation use elevation for calculations (default `false`).
     *    If `true`, use elevation to affect the calculation of all sunrise/sunset based
     *    zmanim. Note: there are some zmanim such as degree-based zmanim that are driven
     *    by the amount of light in the sky and are not impacted by elevation.
     *    These zmanim intentionally do not support elevation adjustment.
     */ constructor(gloc, date, useElevation){
        const dt = $dcc49aa98f3628f5$var$getDate(date);
        this.date = dt;
        this.gloc = gloc;
        const plainDate = Temporal.PlainDate.from({
            year: dt.getFullYear(),
            month: dt.getMonth() + 1,
            day: dt.getDate()
        });
        this.noaa = new (0, $af23a9f03297d4dc$export$a5e4bf7f397ddef3)(gloc, plainDate);
        this.useElevation = Boolean(useElevation);
    }
    /**
     * Returns `true` if elevation adjustment is enabled
     * for zmanim support elevation adjustment
     */ getUseElevation() {
        return this.useElevation;
    }
    /**
     * Enables or disables elevation adjustment for zmanim support elevation adjustment
     * @param useElevation
     */ setUseElevation(useElevation) {
        this.useElevation = useElevation;
    }
    /**
     * Convenience function to get the time when sun is above or below the horizon
     * for a certain angle (in degrees).
     * This function does not support elevation adjustment.
     * @param angle
     * @param rising
     */ timeAtAngle(angle, rising) {
        const offsetZenith = 90 + angle;
        const zdt = rising ? this.noaa.getSunriseOffsetByDegrees(offsetZenith) : this.noaa.getSunsetOffsetByDegrees(offsetZenith);
        return $dcc49aa98f3628f5$var$zdtToDate(zdt);
    }
    /**
     * Upper edge of the Sun appears over the eastern horizon in the morning (0.833° above horizon)
     * If elevation is enabled, this function will include elevation in the calculation.
     */ sunrise() {
        const zdt = this.useElevation ? this.noaa.getSunrise() : this.noaa.getSeaLevelSunrise();
        return $dcc49aa98f3628f5$var$zdtToDate(zdt);
    }
    /**
     * Upper edge of the Sun appears over the eastern horizon in the morning (0.833° above horizon).
     * This function does not support elevation adjustment.
     */ seaLevelSunrise() {
        const zdt = this.noaa.getSeaLevelSunrise();
        return $dcc49aa98f3628f5$var$zdtToDate(zdt);
    }
    /**
     * When the upper edge of the Sun disappears below the horizon (0.833° below horizon).
     * If elevation is enabled, this function will include elevation in the calculation.
     */ sunset() {
        const zdt = this.useElevation ? this.noaa.getSunset() : this.noaa.getSeaLevelSunset();
        return $dcc49aa98f3628f5$var$zdtToDate(zdt);
    }
    /**
     * When the upper edge of the Sun disappears below the horizon (0.833° below horizon).
     * This function does not support elevation adjustment.
     */ seaLevelSunset() {
        const zdt = this.noaa.getSeaLevelSunset();
        return $dcc49aa98f3628f5$var$zdtToDate(zdt);
    }
    /**
     * Civil dawn; Sun is 6° below the horizon in the morning.
     * Because degree-based functions estimate the amount of light in the sky,
     * the result is not impacted by elevation.
     */ dawn() {
        const zdt = this.noaa.getBeginCivilTwilight();
        return $dcc49aa98f3628f5$var$zdtToDate(zdt);
    }
    /**
     * Civil dusk; Sun is 6° below the horizon in the evening.
     * Because degree-based functions estimate the amount of light in the sky,
     * the result is not impacted by elevation.
     */ dusk() {
        const zdt = this.noaa.getEndCivilTwilight();
        return $dcc49aa98f3628f5$var$zdtToDate(zdt);
    }
    /**
     * Returns sunset for the previous day.
     * If elevation is enabled, this function will include elevation in the calculation.
     */ gregEve() {
        const prev = new Date(this.date);
        prev.setDate(prev.getDate() - 1);
        const zman = new $dcc49aa98f3628f5$export$c5e94b89b957f48e(this.gloc, prev, this.useElevation);
        return zman.sunset();
    }
    /**
     * @private
     */ nightHour() {
        return (this.sunrise().getTime() - this.gregEve().getTime()) / 12; // ms in hour
    }
    /**
     * Midday – Chatzot; Sunrise plus 6 halachic hours
     */ chatzot() {
        const startOfDay = this.noaa.getSeaLevelSunrise();
        const endOfDay = this.noaa.getSeaLevelSunset();
        const zdt = this.noaa.getSunTransit(startOfDay, endOfDay);
        return $dcc49aa98f3628f5$var$zdtToDate(zdt);
    }
    /**
     * Midnight – Chatzot; Sunset plus 6 halachic hours.
     * If elevation is enabled, this function will include elevation in the calculation.
     */ chatzotNight() {
        return new Date(this.sunrise().getTime() - this.nightHour() * 6);
    }
    /**
     * Dawn – Alot haShachar; Sun is 16.1° below the horizon in the morning.
     * Because degree-based functions estimate the amount of light in the sky,
     * the result is not impacted by elevation.
     */ alotHaShachar() {
        return this.timeAtAngle(16.1, true);
    }
    /**
     * Earliest talis & tefillin – Misheyakir; Sun is 11.5° below the horizon in the morning.
     * Because degree-based functions estimate the amount of light in the sky,
     * the result is not impacted by elevation.
     */ misheyakir() {
        return this.timeAtAngle(11.5, true);
    }
    /**
     * Earliest talis & tefillin – Misheyakir Machmir; Sun is 10.2° below the horizon in the morning.
     * Because degree-based functions estimate the amount of light in the sky,
     * the result is not impacted by elevation.
     */ misheyakirMachmir() {
        return this.timeAtAngle(10.2, true);
    }
    /**
     * Utility method for using elevation-aware sunrise/sunset
     * @private
     * @param hours
     */ getShaahZmanisBasedZman(hours) {
        const startOfDay = this.useElevation ? this.noaa.getSunrise() : this.noaa.getSeaLevelSunrise();
        const endOfDay = this.useElevation ? this.noaa.getSunset() : this.noaa.getSeaLevelSunset();
        const temporalHour = this.noaa.getTemporalHour(startOfDay, endOfDay);
        const offset = Math.round(temporalHour * hours);
        const zdt = (0, $af23a9f03297d4dc$export$a5e4bf7f397ddef3).getTimeOffset(startOfDay, offset);
        return $dcc49aa98f3628f5$var$zdtToDate(zdt);
    }
    /**
     * Latest Shema (Gra); Sunrise plus 3 halachic hours, according to the Gra.
     * If elevation is enabled, this function will include elevation in the calculation.
     */ sofZmanShma() {
        // Gra
        return this.getShaahZmanisBasedZman(3);
    }
    /**
     * Latest Shacharit (Gra); Sunrise plus 4 halachic hours, according to the Gra.
     *
     * This method returns the latest *zman tfila* (time to recite shema in the morning)
     * that is 4 *shaos zmaniyos* (solar hours) after sunrise or sea level sunrise
     * (depending on the `useElevation` setting), according
     * to the [GRA](https://en.wikipedia.org/wiki/Vilna_Gaon).
     *
     * If elevation is enabled, this function will include elevation in the calculation.
     */ sofZmanTfilla() {
        // Gra
        return this.getShaahZmanisBasedZman(4);
    }
    /**
     * Returns an array with alot (Date) and ms in hour (number)
     * @private
     */ getTemporalHour72(forceSeaLevel) {
        const alot72 = this.sunriseOffset(-72, false, forceSeaLevel);
        const tzeit72 = this.sunsetOffset(72, false, forceSeaLevel);
        const temporalHour = (tzeit72.getTime() - alot72.getTime()) / 12;
        return [
            alot72,
            temporalHour
        ];
    }
    /**
     * Returns an array with alot (Date) and ms in hour (number)
     * @private
     */ getTemporalHourByDeg(angle) {
        const alot = this.timeAtAngle(angle, true);
        const tzeit = this.timeAtAngle(angle, false);
        const temporalHour = (tzeit.getTime() - alot.getTime()) / 12;
        return [
            alot,
            temporalHour
        ];
    }
    /**
     * Latest Shema (MGA); Sunrise plus 3 halachic hours, according to Magen Avraham.
     * Based on the opinion of the MGA that the day is calculated from
     * dawn being fixed 72 minutes before sea-level sunrise, and nightfall is fixed
     * 72 minutes after sea-level sunset.
     */ sofZmanShmaMGA() {
        // Magen Avraham
        const [alot72, temporalHour] = this.getTemporalHour72(true);
        const offset = Math.floor(3 * temporalHour);
        return new Date(alot72.getTime() + offset);
    }
    /**
     * Latest Shema (MGA); Sunrise plus 3 halachic hours, according to Magen Avraham.
     * Based on the opinion of the MGA that the day is calculated from
     * dawn to nightfall with both being 16.1° below the horizon.
     */ sofZmanShmaMGA16Point1() {
        const [alot, temporalHour] = this.getTemporalHourByDeg(16.1);
        const offset = Math.floor(3 * temporalHour);
        return new Date(alot.getTime() + offset);
    }
    /**
     * Latest Shema (MGA); Sunrise plus 3 halachic hours, according to Magen Avraham.
     * Based on the opinion of the MGA that the day is calculated from
     * dawn to nightfall with both being 19.8° below the horizon.
     *
     * This calculation is based on the position of the sun 90 minutes after sunset in Jerusalem
     * around the equinox / equilux which calculates to 19.8° below geometric zenith.
     * https://kosherjava.com/2022/01/12/equinox-vs-equilux-zmanim-calculations/
     */ sofZmanShmaMGA19Point8() {
        const [alot, temporalHour] = this.getTemporalHourByDeg(19.8);
        const offset = Math.floor(3 * temporalHour);
        return new Date(alot.getTime() + offset);
    }
    /**
     * Latest Shacharit (MGA); Sunrise plus 4 halachic hours, according to Magen Avraham
     */ sofZmanTfillaMGA() {
        // Magen Avraham
        const [alot72, temporalHour] = this.getTemporalHour72(true);
        const offset = Math.floor(4 * temporalHour);
        return new Date(alot72.getTime() + offset);
    }
    /**
     * Latest Shacharit (MGA); Sunrise plus 4 halachic hours, according to Magen Avraham.
     * Based on the opinion of the MGA that the day is calculated from
     * dawn to nightfall with both being 16.1° below the horizon.
     */ sofZmanTfillaMGA16Point1() {
        const [alot, temporalHour] = this.getTemporalHourByDeg(16.1);
        const offset = Math.floor(4 * temporalHour);
        return new Date(alot.getTime() + offset);
    }
    /**
     * Latest Shacharit (MGA); Sunrise plus 4 halachic hours, according to Magen Avraham.
     * Based on the opinion of the MGA that the day is calculated from
     * dawn to nightfall with both being 19.8° below the horizon.
     *
     * This calculation is based on the position of the sun 90 minutes after sunset in Jerusalem
     * around the equinox / equilux which calculates to 19.8° below geometric zenith.
     * https://kosherjava.com/2022/01/12/equinox-vs-equilux-zmanim-calculations/
     */ sofZmanTfillaMGA19Point8() {
        const [alot, temporalHour] = this.getTemporalHourByDeg(19.8);
        const offset = Math.floor(4 * temporalHour);
        return new Date(alot.getTime() + offset);
    }
    /**
     * Earliest Mincha – Mincha Gedola (GRA); Sunrise plus 6.5 halachic hours.
     * If elevation is enabled, this function will include elevation in the calculation.
     *
     * This method returns the latest mincha gedola, the earliest time one can pray mincha
     * that is 6.5 shaos zmaniyos (solar hours) after sunrise or sea level sunrise
     * (depending on the `useElevation` setting), according
     * to the [GRA](https://en.wikipedia.org/wiki/Vilna_Gaon).
     *
     * The Ramba"m is of the opinion that it is better to delay *mincha* until
     * *mincha ketana* while the Ra"sh, Tur, GRA and others are of the
     * opinion that *mincha* can be prayed *lechatchila* starting at *mincha gedola*.
     */ minchaGedola() {
        return this.getShaahZmanisBasedZman(6.5);
    }
    /**
     * Earliest Mincha – Mincha Gedola (MGA); Sunrise plus 6.5 halachic hours.
     * If elevation is enabled, this function will include elevation in the calculation.
     *
     * This method returns the time of *mincha gedola* according to the Magen Avraham
     * with the day starting 72 minutes before sunrise and ending 72 minutes after sunset.
     * This is the earliest time to pray *mincha*.
     */ minchaGedolaMGA() {
        const [alot72, temporalHour] = this.getTemporalHour72(false);
        const offset = Math.floor(6.5 * temporalHour);
        return new Date(alot72.getTime() + offset);
    }
    /**
     * Preferable earliest time to recite Minchah – Mincha Ketana; Sunrise plus 9.5 halachic hours.
     * If elevation is enabled, this function will include elevation in the calculation.
     *
     * This method returns *mincha ketana*, the preferred earliest time to pray *mincha* in the
     * opinion of the [Rambam](https://en.wikipedia.org/wiki/Maimonides) and others,
     * that is 9.5 *shaos zmaniyos* (solar hours) after sunrise or sea level sunrise
     * (depending on the `useElevation` setting), according
     * to the [GRA](https://en.wikipedia.org/wiki/Vilna_Gaon).
     */ minchaKetana() {
        return this.getShaahZmanisBasedZman(9.5);
    }
    /**
     * This method returns the time of *mincha ketana* according to the Magen Avraham
     * with the day starting 72 minutes before sunrise and ending 72 minutes after sunset.
     * This is the preferred earliest time to pray *mincha* according to the opinion of
     * the [Rambam](https://en.wikipedia.org/wiki/Maimonides) and others.
     *
     * If elevation is enabled, this function will include elevation in the calculation.
     */ minchaKetanaMGA() {
        const [alot72, temporalHour] = this.getTemporalHour72(false);
        return new Date(alot72.getTime() + Math.floor(9.5 * temporalHour));
    }
    /**
     * Plag haMincha; Sunrise plus 10.75 halachic hours.
     * If elevation is enabled, this function will include elevation in the calculation.
     */ plagHaMincha() {
        return this.getShaahZmanisBasedZman(10.75);
    }
    /**
     * @param [angle=8.5] optional time for solar depression.
     *   Default is 8.5 degrees for 3 small stars, use 7.083 degrees for 3 medium-sized stars.
     * Because degree-based functions estimate the amount of light in the sky,
     * the result is not impacted by elevation.
     */ tzeit(angle = 8.5) {
        return this.timeAtAngle(angle, false);
    }
    /**
     * Alias for sunrise
     */ neitzHaChama() {
        return this.sunrise();
    }
    /**
     * Alias for sunset
     */ shkiah() {
        return this.sunset();
    }
    /**
     * Rabbeinu Tam holds that bein hashmashos is a specific time
     * between sunset and tzeis hakochavim.
     * One opinion on how to calculate this time is that
     * it is 13.5 minutes before tzies 7.083.
     * Because degree-based functions estimate the amount of light in the sky,
     * the result is not impacted by elevation.
     */ beinHaShmashos() {
        const tzeit = this.tzeit(7.083);
        const millis = tzeit.getTime();
        if (isNaN(millis)) return tzeit;
        return new Date(millis - 810000);
    }
    /**
     * Uses timeFormat to return a date like '20:34'
     */ static formatTime(dt, timeFormat) {
        const time = timeFormat.format(dt);
        const hm = time.split(':');
        if (hm[0] === '24') return '00:' + hm[1];
        return time;
    }
    /**
     * Discards seconds, rounding to nearest minute.
     * @param dt
     */ static roundTime(dt) {
        const millis = dt.getTime();
        if (isNaN(millis)) return dt;
        // Round up to next minute if needed
        const millisOnly = dt.getMilliseconds();
        const seconds = dt.getSeconds();
        if (seconds === 0 && millisOnly === 0) return dt;
        const secAndMillis = seconds * 1000 + millisOnly;
        const delta = secAndMillis >= 30000 ? 60000 - secAndMillis : -1 * secAndMillis;
        return new Date(millis + delta);
    }
    /**
     * Get offset string (like "+05:00" or "-08:00") from tzid (like "Europe/Moscow")
     * @param tzid
     * @param date
     */ static timeZoneOffset(tzid, date) {
        const offset = (0, $55283cdbe290c27d$export$4c9db454e2785fd9)(tzid, date);
        const offsetAbs = Math.abs(offset);
        const hours = Math.floor(offsetAbs / 60);
        const minutes = offsetAbs % 60;
        return (offset < 0 ? '+' : '-') + (0, $37c4ce66a03a0eab$export$9decc9dc70e2c76f)(hours) + ':' + (0, $37c4ce66a03a0eab$export$9decc9dc70e2c76f)(minutes);
    }
    /**
     * Returns a string like "2022-04-01T13:06:00-11:00"
     * @param tzid
     * @param date
     */ static formatISOWithTimeZone(tzid, date) {
        if (isNaN(date.getTime())) return '0000-00-00T00:00:00Z';
        return (0, $55283cdbe290c27d$export$b9e305b33626b6ff)(tzid, date).substring(0, 19) + $dcc49aa98f3628f5$export$c5e94b89b957f48e.timeZoneOffset(tzid, date);
    }
    /**
     * Returns sunrise + `offset` minutes (either positive or negative).
     * If elevation is enabled, this function will include elevation in the calculation
     *  unless `forceSeaLevel` is `true`.
     * @param offset minutes
     * @param roundMinute round time to nearest minute (default true)
     * @param forceSeaLevel use sea-level sunrise (default false)
     */ sunriseOffset(offset, roundMinute = true, forceSeaLevel = false) {
        const sunrise = forceSeaLevel ? this.seaLevelSunrise() : this.sunrise();
        if (isNaN(sunrise.getTime())) return sunrise;
        if (roundMinute) {
            // For positive offsets only, round up to next minute if needed
            if (offset > 0 && sunrise.getSeconds() >= 30) offset++;
            sunrise.setSeconds(0, 0);
        }
        return new Date(sunrise.getTime() + offset * 60000);
    }
    /**
     * Returns sunset + `offset` minutes (either positive or negative).
     * If elevation is enabled, this function will include elevation in the calculation
     *  unless `forceSeaLevel` is `true`.
     * @param offset minutes
     * @param roundMinute round time to nearest minute (default true)
     * @param forceSeaLevel use sea-level sunset (default false)
     */ sunsetOffset(offset, roundMinute = true, forceSeaLevel = false) {
        const sunset = forceSeaLevel ? this.seaLevelSunset() : this.sunset();
        if (isNaN(sunset.getTime())) return sunset;
        if (roundMinute) {
            // For Havdalah only, round up to next minute if needed
            if (offset > 0 && sunset.getSeconds() >= 30) offset++;
            sunset.setSeconds(0, 0);
        }
        return new Date(sunset.getTime() + offset * 60000);
    }
    /**
     * Returns the Hebrew date relative to the specified location and Gregorian date,
     * taking into consideration whether the time is before or after sunset.
     *
     * For example, if the given date and is `2024-09-22T10:35` (before sunset), and
     * sunset for the specified location is **19:04**, then this function would
     * return a Hebrew date of `19th of Elul, 5784`.
     * If the given date is the same Gregorian day after sunset
     * (for example `2024-09-22T20:07`), this function would return a
     * Hebrew date of `20th of Elul, 5784`.
     * @example
     * const {GeoLocation, Zmanim, HDate} = require('@hebcal/core');
     * const latitude = 48.85341;
     * const longitude = 2.3488;
     * const timezone = 'Europe/Paris';
     * const gloc = new GeoLocation(null, latitude, longitude, 0, timezone);
     * const before = Zmanim.makeSunsetAwareHDate(gloc, new Date('2024-09-22T17:38:46.123Z'), false);
     * console.log(before.toString()); // '19 Elul 5784'
     * const after = Zmanim.makeSunsetAwareHDate(gloc, new Date('2024-09-22T23:45:18.345Z'), false);
     * console.log(after.toString()); // '20 Elul 5784'
     */ static makeSunsetAwareHDate(gloc, date, useElevation) {
        const zmanim = new $dcc49aa98f3628f5$export$c5e94b89b957f48e(gloc, date, useElevation);
        const sunset = zmanim.sunset();
        let hd = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(date);
        const sunsetMillis = sunset.getTime();
        if (isNaN(sunsetMillis)) return hd;
        if (date.getTime() >= sunsetMillis) hd = hd.next();
        return hd;
    }
}


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 

/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ const $572415ff68b4de58$var$hour12cc = {
    US: 1,
    CA: 1,
    BR: 1,
    AU: 1,
    NZ: 1,
    DO: 1,
    PR: 1,
    GR: 1,
    IN: 1,
    KR: 1,
    NP: 1,
    ZA: 1
};
/**
 * @private
 * @param timeStr - original time like "20:30"
 * @param suffix - "p" or "pm" or " P.M.". Add leading space if you want it
 * @param options
 */ function $572415ff68b4de58$export$9a72b7ab20a8c09d(timeStr, suffix, options) {
    var _a;
    if (typeof timeStr !== 'string') throw new TypeError(`Bad timeStr: ${timeStr}`);
    const cc = ((_a = options === null || options === undefined ? undefined : options.location) === null || _a === undefined ? undefined : _a.getCountryCode()) || ((options === null || options === undefined ? undefined : options.il) ? 'IL' : 'US');
    const hour12 = options === null || options === undefined ? undefined : options.hour12;
    if (typeof hour12 !== 'undefined' && !hour12) return timeStr;
    if (!hour12 && typeof $572415ff68b4de58$var$hour12cc[cc] === 'undefined') return timeStr;
    const hm = timeStr.split(':');
    let hour = parseInt(hm[0], 10);
    if (hour < 12 && suffix) {
        suffix = suffix.replace('p', 'a').replace('P', 'A');
        if (hour === 0) hour = 12;
    } else if (hour > 12) hour = hour % 12;
    else if (hour === 0) hour = '00';
    return `${hour}:${hm[1]}${suffix}`;
}




/** An event that has an `eventTime` and `eventTimeStr` */ class $f048777e58045d14$export$3d559cec8623ed88 extends (0, $439631353957c387$export$d61e24a684f9e51) {
    /**
     * @param desc Description (not translated)
     */ constructor(date, desc, mask, eventTime, location, linkedEvent, options){
        super(date, desc, mask);
        this.eventTime = (0, $dcc49aa98f3628f5$export$c5e94b89b957f48e).roundTime(eventTime);
        this.location = location;
        const timeFormat = location.getTimeFormatter();
        this.eventTimeStr = (0, $dcc49aa98f3628f5$export$c5e94b89b957f48e).formatTime(this.eventTime, timeFormat);
        const opts = Object.assign(Object.assign({}, options), {
            location: location
        });
        this.fmtTime = (0, $572415ff68b4de58$export$9a72b7ab20a8c09d)(this.eventTimeStr, 'pm', opts);
        if (typeof linkedEvent !== 'undefined') this.linkedEvent = linkedEvent;
    }
    /**
     * @param [locale] Optional locale name (defaults to active locale).
     */ render(locale) {
        return (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext(this.getDesc(), locale) + ': ' + this.fmtTime;
    }
    /**
     * Returns translation of "Candle lighting" without the time.
     * @param [locale] Optional locale name (defaults to active locale).
     */ renderBrief(locale) {
        return (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext(this.getDesc(), locale);
    }
    getCategories() {
        const desc = this.getDesc();
        switch(desc){
            // LIGHT_CANDLES or LIGHT_CANDLES_TZEIS
            case 'Candle lighting':
                return [
                    'candles'
                ];
            // YOM_TOV_ENDS
            case 'Havdalah':
                return [
                    'havdalah'
                ];
            // flags.MINOR_FAST or flags.MAJOR_FAST
            case 'Fast begins':
            case 'Fast ends':
                return [
                    'zmanim',
                    'fast'
                ];
        }
        /* NOTREACHED */ return [
            'unknown'
        ];
    }
}
/** Candle lighting before Shabbat or holiday */ class $f048777e58045d14$export$52911af90e169491 extends $f048777e58045d14$export$3d559cec8623ed88 {
    constructor(date, mask, eventTime, location, linkedEvent, options){
        super(date, 'Candle lighting', mask, eventTime, location, linkedEvent, options);
    }
    getEmoji() {
        return "\uD83D\uDD6F\uFE0F";
    }
}
/** Havdalah after Shabbat or holiday */ class $f048777e58045d14$export$3cc96e2f983407bc extends $f048777e58045d14$export$3d559cec8623ed88 {
    constructor(date, mask, eventTime, location, havdalahMins, linkedEvent, options){
        super(date, 'Havdalah', mask, eventTime, location, linkedEvent, options);
        if (havdalahMins) this.havdalahMins = havdalahMins;
    }
    /**
     * @param [locale] Optional locale name (defaults to active locale).
     */ render(locale) {
        return this.renderBrief(locale) + ': ' + this.fmtTime;
    }
    /**
     * Returns translation of "Havdalah" without the time.
     * @param [locale] Optional locale name (defaults to active locale).
     */ renderBrief(locale) {
        let str = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext(this.getDesc(), locale);
        if (this.havdalahMins) {
            const min = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext('min', locale);
            str += ` (${this.havdalahMins} ${min})`;
        }
        return str;
    }
    getEmoji() {
        return "\u2728";
    }
}


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 

/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 

/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 

const $cf7ca2f841f82e34$var$Nisan = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).NISAN;
const $cf7ca2f841f82e34$var$Iyyar = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).IYYAR;
const $cf7ca2f841f82e34$var$Sivan = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).SIVAN;
const $cf7ca2f841f82e34$var$Tamuz = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TAMUZ;
const $cf7ca2f841f82e34$var$Av = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).AV;
const $cf7ca2f841f82e34$var$Elul = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ELUL;
const $cf7ca2f841f82e34$var$Tishrei = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TISHREI;
const $cf7ca2f841f82e34$var$Cheshvan = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).CHESHVAN;
const $cf7ca2f841f82e34$var$Kislev = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).KISLEV;
const $cf7ca2f841f82e34$var$Shvat = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).SHVAT;
const $cf7ca2f841f82e34$var$Adar2 = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ADAR_II;
const $cf7ca2f841f82e34$var$CHAG = (0, $439631353957c387$export$ceac1d294cf61000).CHAG;
const $cf7ca2f841f82e34$var$LIGHT_CANDLES = (0, $439631353957c387$export$ceac1d294cf61000).LIGHT_CANDLES;
const $cf7ca2f841f82e34$var$YOM_TOV_ENDS = (0, $439631353957c387$export$ceac1d294cf61000).YOM_TOV_ENDS;
const $cf7ca2f841f82e34$var$CHUL_ONLY = (0, $439631353957c387$export$ceac1d294cf61000).CHUL_ONLY;
const $cf7ca2f841f82e34$var$IL_ONLY = (0, $439631353957c387$export$ceac1d294cf61000).IL_ONLY;
const $cf7ca2f841f82e34$var$LIGHT_CANDLES_TZEIS = (0, $439631353957c387$export$ceac1d294cf61000).LIGHT_CANDLES_TZEIS;
const $cf7ca2f841f82e34$var$CHANUKAH_CANDLES = (0, $439631353957c387$export$ceac1d294cf61000).CHANUKAH_CANDLES;
const $cf7ca2f841f82e34$var$MAJOR_FAST = (0, $439631353957c387$export$ceac1d294cf61000).MAJOR_FAST;
const $cf7ca2f841f82e34$var$MINOR_HOLIDAY = (0, $439631353957c387$export$ceac1d294cf61000).MINOR_HOLIDAY;
const $cf7ca2f841f82e34$var$EREV = (0, $439631353957c387$export$ceac1d294cf61000).EREV;
const $cf7ca2f841f82e34$var$CHOL_HAMOED = (0, $439631353957c387$export$ceac1d294cf61000).CHOL_HAMOED;
const $cf7ca2f841f82e34$var$emojiPesach = "\uD83E\uDED3";
const $cf7ca2f841f82e34$var$emojiSukkot = "\uD83C\uDF3F\uD83C\uDF4B";
const $cf7ca2f841f82e34$var$ROSH_HASHANA_II = 'Rosh Hashana II';
const $cf7ca2f841f82e34$var$EREV_YOM_KIPPUR = 'Erev Yom Kippur';
const $cf7ca2f841f82e34$var$YOM_KIPPUR = 'Yom Kippur';
const $cf7ca2f841f82e34$var$EREV_SUKKOT = 'Erev Sukkot';
const $cf7ca2f841f82e34$var$SUKKOT_I = 'Sukkot I';
const $cf7ca2f841f82e34$var$SUKKOT_II = 'Sukkot II';
const $cf7ca2f841f82e34$var$SUKKOT_III_CHM = "Sukkot III (CH''M)";
const $cf7ca2f841f82e34$var$SUKKOT_IV_CHM = "Sukkot IV (CH''M)";
const $cf7ca2f841f82e34$var$SUKKOT_V_CHM = "Sukkot V (CH''M)";
const $cf7ca2f841f82e34$var$SUKKOT_VI_CHM = "Sukkot VI (CH''M)";
const $cf7ca2f841f82e34$var$SHMINI_ATZERET = 'Shmini Atzeret';
const $cf7ca2f841f82e34$var$SIMCHAT_TORAH = 'Simchat Torah';
const $cf7ca2f841f82e34$var$SUKKOT_II_CHM = "Sukkot II (CH''M)";
const $cf7ca2f841f82e34$var$SUKKOT_VII_HOSHANA_RABA = 'Sukkot VII (Hoshana Raba)';
const $cf7ca2f841f82e34$var$CHANUKAH_1_CANDLE = 'Chanukah: 1 Candle';
const $cf7ca2f841f82e34$var$TU_BISHVAT = 'Tu BiShvat';
const $cf7ca2f841f82e34$var$EREV_PURIM = 'Erev Purim';
const $cf7ca2f841f82e34$var$PURIM = 'Purim';
const $cf7ca2f841f82e34$var$SHUSHAN_PURIM = 'Shushan Purim';
const $cf7ca2f841f82e34$var$EREV_PESACH = 'Erev Pesach';
const $cf7ca2f841f82e34$var$PESACH_I = 'Pesach I';
const $cf7ca2f841f82e34$var$PESACH_II = 'Pesach II';
const $cf7ca2f841f82e34$var$PESACH_II_CHM = "Pesach II (CH''M)";
const $cf7ca2f841f82e34$var$PESACH_III_CHM = "Pesach III (CH''M)";
const $cf7ca2f841f82e34$var$PESACH_IV_CHM = "Pesach IV (CH''M)";
const $cf7ca2f841f82e34$var$PESACH_V_CHM = "Pesach V (CH''M)";
const $cf7ca2f841f82e34$var$PESACH_VI_CHM = "Pesach VI (CH''M)";
const $cf7ca2f841f82e34$var$PESACH_VII = 'Pesach VII';
const $cf7ca2f841f82e34$var$PESACH_VIII = 'Pesach VIII';
const $cf7ca2f841f82e34$var$PESACH_SHENI = 'Pesach Sheni';
const $cf7ca2f841f82e34$var$LAG_BAOMER = 'Lag BaOmer';
const $cf7ca2f841f82e34$var$EREV_SHAVUOT = 'Erev Shavuot';
const $cf7ca2f841f82e34$var$SHAVUOT = 'Shavuot';
const $cf7ca2f841f82e34$var$SHAVUOT_I = 'Shavuot I';
const $cf7ca2f841f82e34$var$SHAVUOT_II = 'Shavuot II';
const $cf7ca2f841f82e34$var$TU_BAV = "Tu B'Av";
const $cf7ca2f841f82e34$var$ROSH_HASHANA_LABEHEMOT = 'Rosh Hashana LaBehemot';
const $cf7ca2f841f82e34$var$EREV_ROSH_HASHANA = 'Erev Rosh Hashana';
const $cf7ca2f841f82e34$var$YOM_YERUSHALAYIM = 'Yom Yerushalayim';
const $cf7ca2f841f82e34$var$BEN_GURION_DAY = 'Ben-Gurion Day';
const $cf7ca2f841f82e34$var$FAMILY_DAY = 'Family Day';
const $cf7ca2f841f82e34$var$YITZHAK_RABIN_MEMORIAL_DAY = 'Yitzhak Rabin Memorial Day';
const $cf7ca2f841f82e34$var$HERZL_DAY = 'Herzl Day';
const $cf7ca2f841f82e34$var$JABOTINSKY_DAY = 'Jabotinsky Day';
const $cf7ca2f841f82e34$var$SIGD = 'Sigd';
const $cf7ca2f841f82e34$var$YOM_HAALIYAH = 'Yom HaAliyah';
const $cf7ca2f841f82e34$var$YOM_HAALIYAH_SCHOOL_OBSERVANCE = 'Yom HaAliyah School Observance';
const $cf7ca2f841f82e34$var$HEBREW_LANGUAGE_DAY = 'Hebrew Language Day';
/**
 * Transliterated names of holidays, used by `Event.getDesc()`
 * @readonly
 * @enum {string}
 */ const $cf7ca2f841f82e34$export$bdd04469d771cf34 = {
    /** Asara B'Tevet */ ASARA_BTEVET: "Asara B'Tevet",
    /** Birkat Hachamah */ BIRKAT_HACHAMAH: 'Birkat Hachamah',
    /** Chag HaBanot */ CHAG_HABANOT: 'Chag HaBanot',
    /** Chanukah: 8th Day */ CHANUKAH_8TH_DAY: 'Chanukah: 8th Day',
    /** Erev Tish'a B'Av */ EREV_TISHA_BAV: "Erev Tish'a B'Av",
    /** Leil Selichot */ LEIL_SELICHOT: 'Leil Selichot',
    /** Purim Katan */ PURIM_KATAN: 'Purim Katan',
    /** Purim Meshulash */ PURIM_MESHULASH: 'Purim Meshulash',
    /** Shabbat Chazon */ SHABBAT_CHAZON: 'Shabbat Chazon',
    /** Shabbat HaChodesh */ SHABBAT_HACHODESH: 'Shabbat HaChodesh',
    /** Shabbat HaGadol */ SHABBAT_HAGADOL: 'Shabbat HaGadol',
    /** Shabbat Nachamu */ SHABBAT_NACHAMU: 'Shabbat Nachamu',
    /** Shabbat Parah */ SHABBAT_PARAH: 'Shabbat Parah',
    /** Shabbat Shekalim */ SHABBAT_SHEKALIM: 'Shabbat Shekalim',
    /** Shabbat Shirah */ SHABBAT_SHIRAH: 'Shabbat Shirah',
    /** Shabbat Shuva */ SHABBAT_SHUVA: 'Shabbat Shuva',
    /** Shabbat Zachor */ SHABBAT_ZACHOR: 'Shabbat Zachor',
    /** Shushan Purim Katan */ SHUSHAN_PURIM_KATAN: 'Shushan Purim Katan',
    /** Ta'anit Bechorot */ TAANIT_BECHOROT: "Ta'anit Bechorot",
    /** Ta'anit Esther */ TAANIT_ESTHER: "Ta'anit Esther",
    /** Tish'a B'Av */ TISHA_BAV: "Tish'a B'Av",
    /** Tzom Gedaliah */ TZOM_GEDALIAH: 'Tzom Gedaliah',
    /** Tzom Tammuz */ TZOM_TAMMUZ: 'Tzom Tammuz',
    /** Yom HaAtzma'ut */ YOM_HAATZMA_UT: "Yom HaAtzma'ut",
    /** Yom HaShoah */ YOM_HASHOAH: 'Yom HaShoah',
    /** Yom HaZikaron */ YOM_HAZIKARON: 'Yom HaZikaron',
    BEN_GURION_DAY: /** Ben-Gurion Day */ $cf7ca2f841f82e34$var$BEN_GURION_DAY,
    CHANUKAH_1_CANDLE: /** Chanukah: 1 Candle */ $cf7ca2f841f82e34$var$CHANUKAH_1_CANDLE,
    EREV_PESACH: /** Erev Pesach */ $cf7ca2f841f82e34$var$EREV_PESACH,
    EREV_PURIM: /** Erev Purim */ $cf7ca2f841f82e34$var$EREV_PURIM,
    EREV_ROSH_HASHANA: /** Erev Rosh Hashana */ $cf7ca2f841f82e34$var$EREV_ROSH_HASHANA,
    EREV_SHAVUOT: /** Erev Shavuot */ $cf7ca2f841f82e34$var$EREV_SHAVUOT,
    EREV_SUKKOT: /** Erev Sukkot */ $cf7ca2f841f82e34$var$EREV_SUKKOT,
    EREV_YOM_KIPPUR: /** Erev Yom Kippur */ $cf7ca2f841f82e34$var$EREV_YOM_KIPPUR,
    FAMILY_DAY: /** Family Day */ $cf7ca2f841f82e34$var$FAMILY_DAY,
    HEBREW_LANGUAGE_DAY: /** Hebrew Language Day */ $cf7ca2f841f82e34$var$HEBREW_LANGUAGE_DAY,
    HERZL_DAY: /** Herzl Day */ $cf7ca2f841f82e34$var$HERZL_DAY,
    JABOTINSKY_DAY: /** Jabotinsky Day */ $cf7ca2f841f82e34$var$JABOTINSKY_DAY,
    LAG_BAOMER: /** Lag BaOmer */ $cf7ca2f841f82e34$var$LAG_BAOMER,
    PESACH_I: /** Pesach I */ $cf7ca2f841f82e34$var$PESACH_I,
    PESACH_II: /** Pesach II */ $cf7ca2f841f82e34$var$PESACH_II,
    PESACH_III_CHM: /** Pesach III (CH''M) */ $cf7ca2f841f82e34$var$PESACH_III_CHM,
    PESACH_II_CHM: /** Pesach II (CH''M) */ $cf7ca2f841f82e34$var$PESACH_II_CHM,
    PESACH_IV_CHM: /** Pesach IV (CH''M) */ $cf7ca2f841f82e34$var$PESACH_IV_CHM,
    PESACH_SHENI: /** Pesach Sheni */ $cf7ca2f841f82e34$var$PESACH_SHENI,
    PESACH_VII: /** Pesach VII */ $cf7ca2f841f82e34$var$PESACH_VII,
    PESACH_VIII: /** Pesach VIII */ $cf7ca2f841f82e34$var$PESACH_VIII,
    PESACH_VI_CHM: /** Pesach VI (CH''M) */ $cf7ca2f841f82e34$var$PESACH_VI_CHM,
    PESACH_V_CHM: /** Pesach V (CH''M) */ $cf7ca2f841f82e34$var$PESACH_V_CHM,
    PURIM: /** Purim */ $cf7ca2f841f82e34$var$PURIM,
    ROSH_HASHANA_II: /** Rosh Hashana II */ $cf7ca2f841f82e34$var$ROSH_HASHANA_II,
    ROSH_HASHANA_LABEHEMOT: /** Rosh Hashana LaBehemot */ $cf7ca2f841f82e34$var$ROSH_HASHANA_LABEHEMOT,
    SHAVUOT: /** Shavuot */ $cf7ca2f841f82e34$var$SHAVUOT,
    SHAVUOT_I: /** Shavuot I */ $cf7ca2f841f82e34$var$SHAVUOT_I,
    SHAVUOT_II: /** Shavuot II */ $cf7ca2f841f82e34$var$SHAVUOT_II,
    SHMINI_ATZERET: /** Shmini Atzeret */ $cf7ca2f841f82e34$var$SHMINI_ATZERET,
    SHUSHAN_PURIM: /** Shushan Purim */ $cf7ca2f841f82e34$var$SHUSHAN_PURIM,
    SIGD: /** Sigd */ $cf7ca2f841f82e34$var$SIGD,
    SIMCHAT_TORAH: /** Simchat Torah */ $cf7ca2f841f82e34$var$SIMCHAT_TORAH,
    SUKKOT_I: /** Sukkot I */ $cf7ca2f841f82e34$var$SUKKOT_I,
    SUKKOT_II: /** Sukkot II */ $cf7ca2f841f82e34$var$SUKKOT_II,
    SUKKOT_III_CHM: /** Sukkot III (CH''M) */ $cf7ca2f841f82e34$var$SUKKOT_III_CHM,
    SUKKOT_II_CHM: /** Sukkot II (CH''M) */ $cf7ca2f841f82e34$var$SUKKOT_II_CHM,
    SUKKOT_IV_CHM: /** Sukkot IV (CH''M) */ $cf7ca2f841f82e34$var$SUKKOT_IV_CHM,
    SUKKOT_VII_HOSHANA_RABA: /** Sukkot VII (Hoshana Raba) */ $cf7ca2f841f82e34$var$SUKKOT_VII_HOSHANA_RABA,
    SUKKOT_VI_CHM: /** Sukkot VI (CH''M) */ $cf7ca2f841f82e34$var$SUKKOT_VI_CHM,
    SUKKOT_V_CHM: /** Sukkot V (CH''M) */ $cf7ca2f841f82e34$var$SUKKOT_V_CHM,
    TU_BAV: /** Tu B\'Av */ $cf7ca2f841f82e34$var$TU_BAV,
    TU_BISHVAT: /** Tu BiShvat */ $cf7ca2f841f82e34$var$TU_BISHVAT,
    YITZHAK_RABIN_MEMORIAL_DAY: /** Yitzhak Rabin Memorial Day */ $cf7ca2f841f82e34$var$YITZHAK_RABIN_MEMORIAL_DAY,
    YOM_HAALIYAH: /** Yom HaAliyah */ $cf7ca2f841f82e34$var$YOM_HAALIYAH,
    YOM_HAALIYAH_SCHOOL_OBSERVANCE: /** Yom HaAliyah School Observance */ $cf7ca2f841f82e34$var$YOM_HAALIYAH_SCHOOL_OBSERVANCE,
    YOM_KIPPUR: /** Yom Kippur */ $cf7ca2f841f82e34$var$YOM_KIPPUR,
    YOM_YERUSHALAYIM: /** Yom Yerushalayim */ $cf7ca2f841f82e34$var$YOM_YERUSHALAYIM
};
const $cf7ca2f841f82e34$export$b4a8c98d57f3cbba = [
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 2,
        desc: $cf7ca2f841f82e34$var$ROSH_HASHANA_II,
        flags: $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$YOM_TOV_ENDS,
        emoji: "\uD83C\uDF4F\uD83C\uDF6F"
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 9,
        desc: $cf7ca2f841f82e34$var$EREV_YOM_KIPPUR,
        flags: $cf7ca2f841f82e34$var$EREV | $cf7ca2f841f82e34$var$LIGHT_CANDLES
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 10,
        desc: $cf7ca2f841f82e34$var$YOM_KIPPUR,
        flags: $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$MAJOR_FAST | $cf7ca2f841f82e34$var$YOM_TOV_ENDS
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 14,
        desc: $cf7ca2f841f82e34$var$EREV_SUKKOT,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$EREV | $cf7ca2f841f82e34$var$LIGHT_CANDLES,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 15,
        desc: $cf7ca2f841f82e34$var$SUKKOT_I,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$LIGHT_CANDLES_TZEIS,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 16,
        desc: $cf7ca2f841f82e34$var$SUKKOT_II,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$YOM_TOV_ENDS,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 17,
        desc: $cf7ca2f841f82e34$var$SUKKOT_III_CHM,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 1,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 18,
        desc: $cf7ca2f841f82e34$var$SUKKOT_IV_CHM,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 2,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 19,
        desc: $cf7ca2f841f82e34$var$SUKKOT_V_CHM,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 3,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 20,
        desc: $cf7ca2f841f82e34$var$SUKKOT_VI_CHM,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 4,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 22,
        desc: $cf7ca2f841f82e34$var$SHMINI_ATZERET,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$LIGHT_CANDLES_TZEIS
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 23,
        desc: $cf7ca2f841f82e34$var$SIMCHAT_TORAH,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$YOM_TOV_ENDS
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 14,
        desc: $cf7ca2f841f82e34$var$EREV_SUKKOT,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$EREV | $cf7ca2f841f82e34$var$LIGHT_CANDLES,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 15,
        desc: $cf7ca2f841f82e34$var$SUKKOT_I,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$YOM_TOV_ENDS,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 16,
        desc: $cf7ca2f841f82e34$var$SUKKOT_II_CHM,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 1,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 17,
        desc: $cf7ca2f841f82e34$var$SUKKOT_III_CHM,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 2,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 18,
        desc: $cf7ca2f841f82e34$var$SUKKOT_IV_CHM,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 3,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 19,
        desc: $cf7ca2f841f82e34$var$SUKKOT_V_CHM,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 4,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 20,
        desc: $cf7ca2f841f82e34$var$SUKKOT_VI_CHM,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 5,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 22,
        desc: $cf7ca2f841f82e34$var$SHMINI_ATZERET,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$YOM_TOV_ENDS
    },
    {
        mm: $cf7ca2f841f82e34$var$Tishrei,
        dd: 21,
        desc: $cf7ca2f841f82e34$var$SUKKOT_VII_HOSHANA_RABA,
        flags: $cf7ca2f841f82e34$var$LIGHT_CANDLES | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: -1,
        emoji: $cf7ca2f841f82e34$var$emojiSukkot
    },
    {
        mm: $cf7ca2f841f82e34$var$Kislev,
        dd: 24,
        desc: $cf7ca2f841f82e34$var$CHANUKAH_1_CANDLE,
        flags: $cf7ca2f841f82e34$var$EREV | $cf7ca2f841f82e34$var$MINOR_HOLIDAY | $cf7ca2f841f82e34$var$CHANUKAH_CANDLES,
        emoji: "\uD83D\uDD4E1\uFE0F\u20E3"
    },
    {
        mm: $cf7ca2f841f82e34$var$Shvat,
        dd: 15,
        desc: $cf7ca2f841f82e34$var$TU_BISHVAT,
        flags: $cf7ca2f841f82e34$var$MINOR_HOLIDAY,
        emoji: "\uD83C\uDF33"
    },
    {
        mm: $cf7ca2f841f82e34$var$Adar2,
        dd: 13,
        desc: $cf7ca2f841f82e34$var$EREV_PURIM,
        flags: $cf7ca2f841f82e34$var$EREV | $cf7ca2f841f82e34$var$MINOR_HOLIDAY,
        emoji: "\uD83C\uDFAD\uFE0F\uD83D\uDCDC"
    },
    {
        mm: $cf7ca2f841f82e34$var$Adar2,
        dd: 14,
        desc: $cf7ca2f841f82e34$var$PURIM,
        flags: $cf7ca2f841f82e34$var$MINOR_HOLIDAY,
        emoji: "\uD83C\uDFAD\uFE0F\uD83D\uDCDC"
    },
    {
        mm: $cf7ca2f841f82e34$var$Adar2,
        dd: 15,
        desc: $cf7ca2f841f82e34$var$SHUSHAN_PURIM,
        flags: $cf7ca2f841f82e34$var$MINOR_HOLIDAY,
        emoji: "\uD83C\uDFAD\uFE0F\uD83D\uDCDC"
    },
    // Pesach Israel
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 14,
        desc: $cf7ca2f841f82e34$var$EREV_PESACH,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$EREV | $cf7ca2f841f82e34$var$LIGHT_CANDLES,
        emoji: "\uD83E\uDED3\uD83C\uDF77"
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 15,
        desc: $cf7ca2f841f82e34$var$PESACH_I,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$YOM_TOV_ENDS,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 16,
        desc: $cf7ca2f841f82e34$var$PESACH_II_CHM,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 1,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 17,
        desc: $cf7ca2f841f82e34$var$PESACH_III_CHM,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 2,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 18,
        desc: $cf7ca2f841f82e34$var$PESACH_IV_CHM,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 3,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 19,
        desc: $cf7ca2f841f82e34$var$PESACH_V_CHM,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 4,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 20,
        desc: $cf7ca2f841f82e34$var$PESACH_VI_CHM,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED | $cf7ca2f841f82e34$var$LIGHT_CANDLES,
        chmDay: 5,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 21,
        desc: $cf7ca2f841f82e34$var$PESACH_VII,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$YOM_TOV_ENDS,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    // Pesach chutz l'aretz
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 14,
        desc: $cf7ca2f841f82e34$var$EREV_PESACH,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$EREV | $cf7ca2f841f82e34$var$LIGHT_CANDLES,
        emoji: "\uD83E\uDED3\uD83C\uDF77"
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 15,
        desc: $cf7ca2f841f82e34$var$PESACH_I,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$LIGHT_CANDLES_TZEIS,
        emoji: "\uD83E\uDED3\uD83C\uDF77"
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 16,
        desc: $cf7ca2f841f82e34$var$PESACH_II,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$YOM_TOV_ENDS,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 17,
        desc: $cf7ca2f841f82e34$var$PESACH_III_CHM,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 1,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 18,
        desc: $cf7ca2f841f82e34$var$PESACH_IV_CHM,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 2,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 19,
        desc: $cf7ca2f841f82e34$var$PESACH_V_CHM,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED,
        chmDay: 3,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 20,
        desc: $cf7ca2f841f82e34$var$PESACH_VI_CHM,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHOL_HAMOED | $cf7ca2f841f82e34$var$LIGHT_CANDLES,
        chmDay: 4,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 21,
        desc: $cf7ca2f841f82e34$var$PESACH_VII,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$LIGHT_CANDLES_TZEIS,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    {
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 22,
        desc: $cf7ca2f841f82e34$var$PESACH_VIII,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$YOM_TOV_ENDS,
        emoji: $cf7ca2f841f82e34$var$emojiPesach
    },
    {
        mm: $cf7ca2f841f82e34$var$Iyyar,
        dd: 14,
        desc: $cf7ca2f841f82e34$var$PESACH_SHENI,
        flags: $cf7ca2f841f82e34$var$MINOR_HOLIDAY
    },
    {
        mm: $cf7ca2f841f82e34$var$Iyyar,
        dd: 18,
        desc: $cf7ca2f841f82e34$var$LAG_BAOMER,
        flags: $cf7ca2f841f82e34$var$MINOR_HOLIDAY,
        emoji: "\uD83D\uDD25"
    },
    {
        mm: $cf7ca2f841f82e34$var$Sivan,
        dd: 5,
        desc: $cf7ca2f841f82e34$var$EREV_SHAVUOT,
        flags: $cf7ca2f841f82e34$var$EREV | $cf7ca2f841f82e34$var$LIGHT_CANDLES,
        emoji: "\u26F0\uFE0F\uD83C\uDF38"
    },
    {
        mm: $cf7ca2f841f82e34$var$Sivan,
        dd: 6,
        desc: $cf7ca2f841f82e34$var$SHAVUOT,
        flags: $cf7ca2f841f82e34$var$IL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$YOM_TOV_ENDS,
        emoji: "\u26F0\uFE0F\uD83C\uDF38"
    },
    {
        mm: $cf7ca2f841f82e34$var$Sivan,
        dd: 6,
        desc: $cf7ca2f841f82e34$var$SHAVUOT_I,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$LIGHT_CANDLES_TZEIS,
        emoji: "\u26F0\uFE0F\uD83C\uDF38"
    },
    {
        mm: $cf7ca2f841f82e34$var$Sivan,
        dd: 7,
        desc: $cf7ca2f841f82e34$var$SHAVUOT_II,
        flags: $cf7ca2f841f82e34$var$CHUL_ONLY | $cf7ca2f841f82e34$var$CHAG | $cf7ca2f841f82e34$var$YOM_TOV_ENDS,
        emoji: "\u26F0\uFE0F\uD83C\uDF38"
    },
    {
        mm: $cf7ca2f841f82e34$var$Av,
        dd: 15,
        desc: $cf7ca2f841f82e34$var$TU_BAV,
        flags: $cf7ca2f841f82e34$var$MINOR_HOLIDAY,
        emoji: "\u2764\uFE0F"
    },
    {
        mm: $cf7ca2f841f82e34$var$Elul,
        dd: 1,
        desc: $cf7ca2f841f82e34$var$ROSH_HASHANA_LABEHEMOT,
        flags: $cf7ca2f841f82e34$var$MINOR_HOLIDAY,
        emoji: "\uD83D\uDC11"
    },
    {
        mm: $cf7ca2f841f82e34$var$Elul,
        dd: 29,
        desc: $cf7ca2f841f82e34$var$EREV_ROSH_HASHANA,
        flags: $cf7ca2f841f82e34$var$EREV | $cf7ca2f841f82e34$var$LIGHT_CANDLES,
        emoji: "\uD83C\uDF4F\uD83C\uDF6F"
    }
];
const $cf7ca2f841f82e34$export$93a085f73ed96ba6 = [
    {
        firstYear: 5727,
        mm: $cf7ca2f841f82e34$var$Iyyar,
        dd: 28,
        desc: $cf7ca2f841f82e34$var$YOM_YERUSHALAYIM,
        chul: true
    },
    {
        firstYear: 5737,
        mm: $cf7ca2f841f82e34$var$Kislev,
        dd: 6,
        desc: $cf7ca2f841f82e34$var$BEN_GURION_DAY,
        satPostponeToSun: true,
        friPostponeToSun: true
    },
    {
        firstYear: 5750,
        mm: $cf7ca2f841f82e34$var$Shvat,
        dd: 30,
        desc: $cf7ca2f841f82e34$var$FAMILY_DAY
    },
    {
        firstYear: 5758,
        mm: $cf7ca2f841f82e34$var$Cheshvan,
        dd: 12,
        desc: $cf7ca2f841f82e34$var$YITZHAK_RABIN_MEMORIAL_DAY,
        friSatMovetoThu: true
    },
    {
        firstYear: 5764,
        mm: $cf7ca2f841f82e34$var$Iyyar,
        dd: 10,
        desc: $cf7ca2f841f82e34$var$HERZL_DAY,
        satPostponeToSun: true
    },
    {
        firstYear: 5765,
        mm: $cf7ca2f841f82e34$var$Tamuz,
        dd: 29,
        desc: $cf7ca2f841f82e34$var$JABOTINSKY_DAY,
        satPostponeToSun: true
    },
    {
        firstYear: 5769,
        mm: $cf7ca2f841f82e34$var$Cheshvan,
        dd: 29,
        desc: $cf7ca2f841f82e34$var$SIGD,
        chul: true,
        suppressEmoji: true,
        friSatMovetoThu: true
    },
    {
        firstYear: 5777,
        mm: $cf7ca2f841f82e34$var$Nisan,
        dd: 10,
        desc: $cf7ca2f841f82e34$var$YOM_HAALIYAH,
        chul: true
    },
    {
        firstYear: 5777,
        mm: $cf7ca2f841f82e34$var$Cheshvan,
        dd: 7,
        desc: $cf7ca2f841f82e34$var$YOM_HAALIYAH_SCHOOL_OBSERVANCE
    },
    // https://www.gov.il/he/departments/policies/2012_des5234
    {
        firstYear: 5773,
        mm: (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TEVET,
        dd: 21,
        desc: $cf7ca2f841f82e34$var$HEBREW_LANGUAGE_DAY,
        friSatMovetoThu: true
    }
];



/** Represents a built-in holiday like Pesach, Purim or Tu BiShvat */ class $35e955bca89ef86b$export$a950670998c93dc extends (0, $439631353957c387$export$d61e24a684f9e51) {
    basename() {
        return this.getDesc().replace(/ \d{4}$/, '').replace(/ \(CH''M\)$/, '').replace(/ \(observed\)$/, '').replace(/ \(Hoshana Raba\)$/, '').replace(/ [IV]+$/, '').replace(/: \d Candles?$/, '').replace(/: 8th Day$/, '').replace(/^Erev /, '');
    }
    url() {
        const year = this.getDate().greg().getFullYear();
        if (year < 100) return undefined;
        const url = 'https://www.hebcal.com/holidays/' + this.basename().toLowerCase().replace(/'/g, '').replace(/ /g, '-') + '-' + this.urlDateSuffix();
        return this.getFlags() & (0, $439631353957c387$export$ceac1d294cf61000).IL_ONLY ? url + '?i=on' : url;
    }
    urlDateSuffix() {
        const year = this.getDate().greg().getFullYear();
        return String(year);
    }
    getEmoji() {
        if (this.emoji) return this.emoji;
        else if (this.getFlags() & (0, $439631353957c387$export$ceac1d294cf61000).SPECIAL_SHABBAT) return "\uD83D\uDD4D";
        else return "\u2721\uFE0F";
    }
    getCategories() {
        if (this.cholHaMoedDay) return [
            'holiday',
            'major',
            'cholhamoed'
        ];
        const cats = super.getCategories();
        if (cats[0] !== 'unknown') return cats;
        // Don't depend on flags.MINOR_HOLIDAY always being set. Look for minor holidays.
        const desc = this.getDesc();
        switch(desc){
            case (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).LAG_BAOMER:
            case (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).LEIL_SELICHOT:
            case (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).PESACH_SHENI:
            case (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).EREV_PURIM:
            case (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).PURIM_KATAN:
            case (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).SHUSHAN_PURIM:
            case (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).TU_BAV:
            case (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).TU_BISHVAT:
            case (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).ROSH_HASHANA_LABEHEMOT:
                return [
                    'holiday',
                    'minor'
                ];
        }
        return [
            'holiday',
            'major'
        ];
    }
    /**
     * Returns (translated) description of this event
     * @param [locale] Optional locale name (defaults to active locale).
     */ render(locale) {
        const str = super.render(locale);
        return str.replace(/'/g, "\u2019");
    }
    /**
     * Returns a brief (translated) description of this event.
     * For most events, this is the same as render(). For some events, it procudes
     * a shorter text (e.g. without a time or added description).
     * @param [locale] Optional locale name (defaults to active locale).
     */ renderBrief(locale) {
        const str = super.renderBrief(locale);
        return str.replace(/'/g, "\u2019");
    }
    /**
     * Makes a clone of this Event object
     * @deprecated
     */ clone() {
        const ev = new $35e955bca89ef86b$export$a950670998c93dc(this.date, this.desc, this.mask);
        // overwrite all enumerable properties
        Object.assign(ev, this);
        return ev;
    }
}
/**
 * Because Asara B'Tevet often occurs twice in the same Gregorian year,
 * we subclass HolidayEvent to generate the correct URL.
 */ class $35e955bca89ef86b$export$4b00f1bf0e95af6c extends $35e955bca89ef86b$export$a950670998c93dc {
    urlDateSuffix() {
        const isoDate = (0, $55283cdbe290c27d$export$1155ec213071851)(this.getDate().greg());
        return isoDate.replace(/-/g, '');
    }
}
/**
 * Because Chanukah sometimes starts in December and ends in January,
 * we subclass HolidayEvent to generate the correct URL.
 */ class $35e955bca89ef86b$export$71b4c478965bbe86 extends $35e955bca89ef86b$export$a950670998c93dc {
    urlDateSuffix() {
        const dt = this.getDate().greg();
        let year = dt.getFullYear();
        if (dt.getMonth() === 0) year--;
        return String(year);
    }
}
/** Represents Rosh Hashana, the Jewish New Year */ class $35e955bca89ef86b$export$4b23eca099a2aa7d extends $35e955bca89ef86b$export$a950670998c93dc {
    /**
     * @private
     * @param date Hebrew date event occurs
     * @param hyear Hebrew year
     * @param mask optional holiday flags
     */ constructor(date, hyear, mask){
        super(date, `Rosh Hashana ${hyear}`, mask);
        this.hyear = hyear;
    }
    /**
     * Returns (translated) description of this event
     * @param [locale] Optional locale name (defaults to active locale).
     */ render(locale) {
        return (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext('Rosh Hashana', locale) + ' ' + this.hyear;
    }
    getEmoji() {
        return "\uD83C\uDF4F\uD83C\uDF6F";
    }
}
const $35e955bca89ef86b$var$roshChodeshStr = 'Rosh Chodesh';
/** Represents Rosh Chodesh, the beginning of a new month */ class $35e955bca89ef86b$export$244411573148d53 extends $35e955bca89ef86b$export$a950670998c93dc {
    /**
     * Constructs Rosh Chodesh event
     * @param date Hebrew date event occurs
     * @param monthName Hebrew month name (not translated)
     */ constructor(date, monthName){
        super(date, `${$35e955bca89ef86b$var$roshChodeshStr} ${monthName}`, (0, $439631353957c387$export$ceac1d294cf61000).ROSH_CHODESH);
    }
    /**
     * Returns (translated) description of this event
     * @param [locale] Optional locale name (defaults to active locale).
     */ render(locale) {
        const monthName = this.getDesc().substring($35e955bca89ef86b$var$roshChodeshStr.length + 1);
        const monthName0 = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext(monthName, locale);
        const monthName1 = monthName0.replace(/'/g, "\u2019");
        return (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext($35e955bca89ef86b$var$roshChodeshStr, locale) + ' ' + monthName1;
    }
    basename() {
        return this.getDesc();
    }
    getEmoji() {
        return this.emoji || "\uD83C\uDF12";
    }
}




/* eslint-disable max-len */ const $ae9f09b8aafe32c5$var$LIGHT_CANDLES = (0, $439631353957c387$export$ceac1d294cf61000).LIGHT_CANDLES;
const $ae9f09b8aafe32c5$var$LIGHT_CANDLES_TZEIS = (0, $439631353957c387$export$ceac1d294cf61000).LIGHT_CANDLES_TZEIS;
/**
 * @private
 */ function $ae9f09b8aafe32c5$export$647eb1e9aafe5fcd(ev, hd, options, isFriday, isSaturday) {
    let havdalahTitle = false;
    let useHavdalahOffset = isSaturday;
    let mask = ev ? ev.getFlags() : $ae9f09b8aafe32c5$var$LIGHT_CANDLES;
    if (typeof ev !== 'undefined') // if linked event && dow == FRI, use Candle lighting time & title
    {
        if (!isFriday) {
            if (mask & ($ae9f09b8aafe32c5$var$LIGHT_CANDLES_TZEIS | (0, $439631353957c387$export$ceac1d294cf61000).CHANUKAH_CANDLES)) useHavdalahOffset = true;
            else if (mask & (0, $439631353957c387$export$ceac1d294cf61000).YOM_TOV_ENDS) {
                havdalahTitle = true;
                useHavdalahOffset = true;
            }
        }
    } else if (isSaturday) {
        havdalahTitle = true;
        mask = $ae9f09b8aafe32c5$var$LIGHT_CANDLES_TZEIS;
    }
    // if Havdalah offset is 0 or undefined, we'll use tzeit time
    const offset = useHavdalahOffset ? Number(options.havdalahMins) : Number(options.candleLightingMins);
    const location = options.location;
    const useElevation = Boolean(options.useElevation);
    const zmanim = new (0, $dcc49aa98f3628f5$export$c5e94b89b957f48e)(location, hd, useElevation);
    const time = useHavdalahOffset && !offset ? zmanim.tzeit(options.havdalahDeg) : zmanim.sunsetOffset(offset, true);
    if (isNaN(time.getTime())) return undefined; // no sunset
    if (havdalahTitle) return new (0, $f048777e58045d14$export$3cc96e2f983407bc)(hd, mask, time, location, options.havdalahMins, ev, options);
    else {
        mask |= $ae9f09b8aafe32c5$var$LIGHT_CANDLES;
        return new (0, $f048777e58045d14$export$52911af90e169491)(hd, mask, time, location, ev, options);
    }
}
const $ae9f09b8aafe32c5$var$FAST_BEGINS = 'Fast begins';
const $ae9f09b8aafe32c5$var$FAST_ENDS = 'Fast ends';
/** A fast day also contains a start and end time */ class $ae9f09b8aafe32c5$export$682271910271b314 extends (0, $35e955bca89ef86b$export$a950670998c93dc) {
    constructor(linkedEvent, startEvent, endEvent){
        super(linkedEvent.getDate(), linkedEvent.getDesc(), linkedEvent.getFlags());
        this.linkedEvent = linkedEvent;
        this.startEvent = startEvent;
        this.endEvent = endEvent;
    }
    render(locale) {
        return this.linkedEvent.render(locale);
    }
    renderBrief(locale) {
        return this.linkedEvent.renderBrief(locale);
    }
    urlDateSuffix() {
        return this.linkedEvent.urlDateSuffix();
    }
    url() {
        return this.linkedEvent.url();
    }
    getEmoji() {
        return this.linkedEvent.getEmoji();
    }
    getCategories() {
        return this.linkedEvent.getCategories();
    }
}
/**
 * Makes a pair of events representing fast start and end times
 * @private
 */ function $ae9f09b8aafe32c5$export$31a68e05b6290ca0(ev, options) {
    const desc = ev.getDesc();
    if (desc === 'Yom Kippur') throw new RangeError('YK does not require this function');
    const hd = ev.getDate();
    const dt = hd.greg();
    const location = options.location;
    const fastEndDeg = options.fastEndDeg;
    const useElevation = Boolean(options.useElevation);
    const zmanim = new (0, $dcc49aa98f3628f5$export$c5e94b89b957f48e)(location, dt, useElevation);
    let startEvent;
    let endEvent;
    if (desc === "Erev Tish'a B'Av") {
        const sunset = zmanim.sunset();
        if (!isNaN(sunset.getTime())) startEvent = $ae9f09b8aafe32c5$var$makeTimedEvent(ev, sunset, $ae9f09b8aafe32c5$var$FAST_BEGINS, options);
    } else if (desc.startsWith("Tish'a B'Av")) {
        const tzeit = zmanim.tzeit(fastEndDeg);
        if (!isNaN(tzeit.getTime())) endEvent = $ae9f09b8aafe32c5$var$makeTimedEvent(ev, tzeit, $ae9f09b8aafe32c5$var$FAST_ENDS, options);
    } else {
        const dawn = zmanim.alotHaShachar();
        if (!isNaN(dawn.getTime())) startEvent = $ae9f09b8aafe32c5$var$makeTimedEvent(ev, dawn, $ae9f09b8aafe32c5$var$FAST_BEGINS, options);
        if (dt.getDay() !== 5 && !(hd.getDate() === 14 && hd.getMonth() === (0, $0118a895d65cebcc$export$16352d1b10c5eb38).NISAN)) {
            const tzeit = zmanim.tzeit(fastEndDeg);
            if (!isNaN(tzeit.getTime())) endEvent = $ae9f09b8aafe32c5$var$makeTimedEvent(ev, tzeit, $ae9f09b8aafe32c5$var$FAST_ENDS, options);
        }
    }
    const ev2 = new $ae9f09b8aafe32c5$export$682271910271b314(ev, startEvent, endEvent);
    // copy properties such as memo or emoji
    Object.assign(ev2, ev);
    return ev2;
}
/**
 * @private
 */ function $ae9f09b8aafe32c5$var$makeTimedEvent(ev, time, desc, options) {
    const location = options.location;
    const hd = ev.getDate();
    return new (0, $f048777e58045d14$export$3d559cec8623ed88)(hd, desc, ev.getFlags(), time, location, ev, options);
}
class $ae9f09b8aafe32c5$export$a3cb860cb5cdd7f6 extends (0, $35e955bca89ef86b$export$71b4c478965bbe86) {
    constructor(date, desc, mask, eventTime, location){
        super(date, desc, mask);
        this.eventTime = (0, $dcc49aa98f3628f5$export$c5e94b89b957f48e).roundTime(eventTime);
        const timeFormat = location.getTimeFormatter();
        this.eventTimeStr = (0, $dcc49aa98f3628f5$export$c5e94b89b957f48e).formatTime(this.eventTime, timeFormat);
        this.location = location;
    }
}
/**
 * Makes a candle-lighting event for Chankah (not on Friday/Saturday).
 * At one point this used civil dusk (6 degrees below horizon).
 * Another source suggests 4.6667 degrees below horizon.
 * @private
 */ function $ae9f09b8aafe32c5$export$40734d065d728074(ev, hd, options) {
    const location = options.location;
    const useElevation = Boolean(options.useElevation);
    const zmanim = new (0, $dcc49aa98f3628f5$export$c5e94b89b957f48e)(location, hd.greg(), useElevation);
    const candleLightingTime = zmanim.beinHaShmashos();
    if (isNaN(candleLightingTime.getTime())) return null;
    const ev2 = new $ae9f09b8aafe32c5$export$a3cb860cb5cdd7f6(hd, ev.getDesc(), ev.getFlags(), candleLightingTime, location);
    ev2.emoji = ev.emoji;
    ev2.chanukahDay = ev.chanukahDay;
    return ev2;
}


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 



/* eslint-disable camelcase */ const $c73aa37de5a0c175$var$shortDayNames = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
const $c73aa37de5a0c175$var$heDayNames = [
    "\u05E8\u05B4\u05D0\u05E9\u05C1\u05D5\u05B9\u05DF",
    "\u05E9\u05B5\u05C1\u05E0\u05B4\u05D9",
    "\u05E9\u05B0\u05C1\u05DC\u05B4\u05D9\u05E9\u05B4\u05C1\u05D9",
    "\u05E8\u05B0\u05D1\u05B4\u05D9\u05E2\u05B4\u05D9",
    "\u05D7\u05B2\u05DE\u05B4\u05D9\u05E9\u05B4\u05C1\u05D9",
    "\u05E9\u05B4\u05C1\u05D9\u05E9\u05B4\u05BC\u05C1\u05D9",
    "\u05E9\u05B7\u05C1\u05D1\u05B8\u05BC\u05EA"
];
const $c73aa37de5a0c175$var$night = "\u05D1\u05B7\u05BC\u05DC\u05B7\u05BC\u05A5\u05D9\u05B0\u05DC\u05B8\u05D4";
function $c73aa37de5a0c175$var$getHebrewTimeOfDay(hour) {
    if (hour < 5) return $c73aa37de5a0c175$var$night;
    else if (hour < 12) return "\u05D1\u05B7\u05BC\u05D1\u05B9\u05BC\u05E7\u05B6\u05E8";
    else if (hour < 17) return "\u05D1\u05B7\u05BC\u05E6\u05C7\u05BC\u05D4\u05B3\u05E8\u05B7\u05D9\u05B4\u05D9\u05DD";
    else if (hour < 21) return "\u05D1\u05B8\u05BC\u05E2\u05B6\u05E8\u05B6\u05D1";
    return $c73aa37de5a0c175$var$night;
}
/**
 * Represents a molad, the moment when the new moon is "born"
 */ class $c73aa37de5a0c175$export$6240c2e81a7cb858 {
    /**
     * Calculates the molad for a Hebrew month
     * @param year
     * @param month
     */ constructor(year, month){
        this.m = (0, $260b4d0153c1f419$export$ffbbbf8d7a2143b3)(year, month);
    }
    /**
     */ getYear() {
        return this.m.year;
    }
    /**
     */ getMonth() {
        return this.m.month;
    }
    /**
     */ getMonthName() {
        return (0, $e7dd728d9f060a75$export$8f4940fd510e0848).getMonthName(this.m.month, this.m.year);
    }
    /**
     * @returns Day of Week (0=Sunday, 6=Saturday)
     */ getDow() {
        return this.m.dayOfWeek;
    }
    /**
     * @returns hour of day (0-23)
     */ getHour() {
        return this.m.hour;
    }
    /**
     * @returns minutes past hour (0-59)
     */ getMinutes() {
        return this.m.minutes;
    }
    /**
     * @returns parts of a minute (0-17)
     */ getChalakim() {
        return this.m.chalakim;
    }
    /**
     * @param [locale] Optional locale name (defaults to active locale)
     * @param options
     */ render(locale, options) {
        var _a;
        locale = locale !== null && locale !== undefined ? locale : (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).getLocaleName();
        if (typeof locale === 'string') locale = locale.toLowerCase();
        const isHebrewLocale = locale === 'he' || locale === 'he-x-nonikud' || locale === 'h';
        const monthName = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext(this.getMonthName(), locale);
        const dayNames = isHebrewLocale ? $c73aa37de5a0c175$var$heDayNames : $c73aa37de5a0c175$var$shortDayNames;
        const dow = dayNames[this.getDow()];
        const minutes = this.getMinutes();
        const hour = this.getHour();
        const chalakim = this.getChalakim();
        const moladStr = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext('Molad', locale);
        const minutesStr = (_a = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).lookupTranslation('min', locale)) !== null && _a !== undefined ? _a : 'minutes';
        const chalakimStr = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext('chalakim', locale);
        if (isHebrewLocale) {
            const ampm = $c73aa37de5a0c175$var$getHebrewTimeOfDay(hour);
            const result = `${moladStr} ${monthName} \u{5D9}\u{5B4}\u{5D4}\u{5B0}\u{5D9}\u{5B6}\u{5D4} \u{5D1}\u{5B7}\u{5BC}\u{5D9}\u{5BC}\u{5D5}\u{5B9}\u{5DD} ${dow} \u{5D1}\u{5E9}\u{5B8}\u{5C1}\u{5D1}\u{5D5}\u{5BC}\u{5E2}\u{5B7}, ` + `\u{5D1}\u{5B0}\u{5BC}\u{5E9}\u{5B8}\u{5C1}\u{5E2}\u{5B8}\u{5D4} ${hour} ${ampm}, ` + `\u{5D5}-${minutes} ${minutesStr} ` + `\u{5D5}-${chalakim} ${chalakimStr}`;
            if (locale === 'he-x-nonikud') return (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).hebrewStripNikkud(result);
            return result;
        }
        const fmtTime = (0, $572415ff68b4de58$export$9a72b7ab20a8c09d)(`${hour}:00`, 'pm', options);
        const month = monthName.replace(/'/g, "\u2019");
        return `${moladStr} ${month}: ${dow}, ${minutes} ${minutesStr} and ${chalakim} ${chalakimStr} after ${fmtTime}`;
    }
}
/** Represents a Molad announcement on Shabbat Mevarchim */ class $c73aa37de5a0c175$export$b3ef9a367289f2bc extends (0, $439631353957c387$export$d61e24a684f9e51) {
    /**
     * @param date Hebrew date event occurs
     * @param hyear molad year
     * @param hmonth molad month
     * @param options
     */ constructor(date, hyear, hmonth, options){
        const m = new $c73aa37de5a0c175$export$6240c2e81a7cb858(hyear, hmonth);
        const monthName = m.getMonthName();
        super(date, `Molad ${monthName} ${hyear}`, (0, $439631353957c387$export$ceac1d294cf61000).MOLAD);
        this.molad = m;
        this.options = options;
    }
    /**
     * @param [locale] Optional locale name (defaults to active locale).
     */ render(locale) {
        return this.molad.render(locale, this.options);
    }
}


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 


/** Represents a day 1-49 of counting the Omer from Pesach to Shavuot */ class $077570d7819d9417$export$68369c1aff1fe744 extends (0, $439631353957c387$export$d61e24a684f9e51) {
    /**
     * @param date
     * @param omerDay
     */ constructor(date, omerDay){
        super(date, `Omer ${omerDay}`, (0, $439631353957c387$export$ceac1d294cf61000).OMER_COUNT);
        if (omerDay < 1 || omerDay > 49) throw new RangeError(`Invalid Omer day ${omerDay}`);
        this.weekNumber = Math.floor((omerDay - 1) / 7) + 1;
        this.daysWithinWeeks = omerDay % 7 || 7;
        this.omer = omerDay;
    }
    /**
     * @param lang
     */ sefira(lang = 'en') {
        if (lang !== 'he' && lang !== 'translit') lang = 'en';
        return (0, $d7ca1ee2cae1c802$export$5897bb1afb34310a)(this.omer, lang);
    }
    /**
     * @todo use gettext()
     * @param [locale] Optional locale name (defaults to active locale).
     */ render(locale) {
        locale = locale !== null && locale !== undefined ? locale : (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).getLocaleName();
        if (typeof locale === 'string') locale = locale.toLowerCase();
        const isHebrewLocale = locale === 'he' || locale === 'he-x-nonikud' || locale === 'h';
        const omer = this.omer;
        const nth = isHebrewLocale ? (0, $b799e27e1258db2f$export$426b794b832b1254)(omer) : (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).ordinal(omer, locale);
        return nth + ' ' + (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext('day of the Omer', locale);
    }
    /**
     * Returns translation of "Omer day 22" without ordinal numbers.
     * @param [locale] Optional locale name (defaults to active locale).
     */ renderBrief(locale) {
        return (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext('Omer', locale) + ' ' + (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext('day', locale) + ' ' + this.omer;
    }
    getEmoji() {
        if (typeof this.emoji === 'string') return this.emoji;
        return (0, $d7ca1ee2cae1c802$export$36be16e9b3fb3077)(this.omer);
    }
    getWeeks() {
        const day7 = this.daysWithinWeeks === 7;
        return day7 ? this.weekNumber : this.weekNumber - 1;
    }
    getDaysWithinWeeks() {
        return this.daysWithinWeeks;
    }
    /**
     * @param locale
     */ getTodayIs(locale) {
        locale = locale !== null && locale !== undefined ? locale : (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).getLocaleName();
        if (typeof locale === 'string') locale = locale.toLowerCase();
        const omerLang = locale === 'he' || locale === 'he-x-nonikud' ? 'he' : 'en';
        const str = (0, $d7ca1ee2cae1c802$export$5eedd0aad646303d)(this.omer, omerLang);
        if (locale === 'he-x-nonikud') return (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).hebrewStripNikkud(str);
        return str;
    }
    url() {
        return `https://www.hebcal.com/omer/${this.getDate().getFullYear()}/${this.omer}`;
    }
}


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 
/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 

/** @private */ function $7f3f966ef905425e$export$c5b8905d1ccaa06c(parsha, locale) {
    const locale0 = locale !== null && locale !== undefined ? locale : (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).getLocaleName();
    let name = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext(parsha[0], locale0);
    if (parsha.length === 2) {
        const hyphen = locale0 === 'he' ? "\u05BE" : '-';
        name += hyphen + (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext(parsha[1], locale0);
    }
    name = name.replace(/'/g, "\u2019");
    const str = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext('Parashat', locale) + ' ' + name;
    return str.normalize();
}


class $119f9466c9ba00cb$export$2e2bcd8739ae039 extends Map {
    constructor(options = {}){
        super();
        if (!(options.maxSize && options.maxSize > 0)) throw new TypeError('`maxSize` must be a number greater than 0');
        if (typeof options.maxAge === 'number' && options.maxAge === 0) throw new TypeError('`maxAge` must be a number greater than 0');
        // TODO: Use private class fields when ESLint supports them.
        this.maxSize = options.maxSize;
        this.maxAge = options.maxAge || Number.POSITIVE_INFINITY;
        this.onEviction = options.onEviction;
        this.cache = new Map();
        this.oldCache = new Map();
        this._size = 0;
    }
    // TODO: Use private class methods when targeting Node.js 16.
    _emitEvictions(cache) {
        if (typeof this.onEviction !== 'function') return;
        for (const [key, item] of cache)this.onEviction(key, item.value);
    }
    _deleteIfExpired(key, item) {
        if (typeof item.expiry === 'number' && item.expiry <= Date.now()) {
            if (typeof this.onEviction === 'function') this.onEviction(key, item.value);
            return this.delete(key);
        }
        return false;
    }
    _getOrDeleteIfExpired(key, item) {
        const deleted = this._deleteIfExpired(key, item);
        if (deleted === false) return item.value;
    }
    _getItemValue(key, item) {
        return item.expiry ? this._getOrDeleteIfExpired(key, item) : item.value;
    }
    _peek(key, cache) {
        const item = cache.get(key);
        return this._getItemValue(key, item);
    }
    _set(key, value) {
        this.cache.set(key, value);
        this._size++;
        if (this._size >= this.maxSize) {
            this._size = 0;
            this._emitEvictions(this.oldCache);
            this.oldCache = this.cache;
            this.cache = new Map();
        }
    }
    _moveToRecent(key, item) {
        this.oldCache.delete(key);
        this._set(key, item);
    }
    *_entriesAscending() {
        for (const item of this.oldCache){
            const [key, value] = item;
            if (!this.cache.has(key)) {
                const deleted = this._deleteIfExpired(key, value);
                if (deleted === false) yield item;
            }
        }
        for (const item of this.cache){
            const [key, value] = item;
            const deleted = this._deleteIfExpired(key, value);
            if (deleted === false) yield item;
        }
    }
    get(key) {
        if (this.cache.has(key)) {
            const item = this.cache.get(key);
            return this._getItemValue(key, item);
        }
        if (this.oldCache.has(key)) {
            const item = this.oldCache.get(key);
            if (this._deleteIfExpired(key, item) === false) {
                this._moveToRecent(key, item);
                return item.value;
            }
        }
    }
    set(key, value, { maxAge: maxAge = this.maxAge } = {}) {
        const expiry = typeof maxAge === 'number' && maxAge !== Number.POSITIVE_INFINITY ? Date.now() + maxAge : undefined;
        if (this.cache.has(key)) this.cache.set(key, {
            value: value,
            expiry: expiry
        });
        else this._set(key, {
            value: value,
            expiry: expiry
        });
        return this;
    }
    has(key) {
        if (this.cache.has(key)) return !this._deleteIfExpired(key, this.cache.get(key));
        if (this.oldCache.has(key)) return !this._deleteIfExpired(key, this.oldCache.get(key));
        return false;
    }
    peek(key) {
        if (this.cache.has(key)) return this._peek(key, this.cache);
        if (this.oldCache.has(key)) return this._peek(key, this.oldCache);
    }
    delete(key) {
        const deleted = this.cache.delete(key);
        if (deleted) this._size--;
        return this.oldCache.delete(key) || deleted;
    }
    clear() {
        this.cache.clear();
        this.oldCache.clear();
        this._size = 0;
    }
    resize(newSize) {
        if (!(newSize && newSize > 0)) throw new TypeError('`maxSize` must be a number greater than 0');
        const items = [
            ...this._entriesAscending()
        ];
        const removeCount = items.length - newSize;
        if (removeCount < 0) {
            this.cache = new Map(items);
            this.oldCache = new Map();
            this._size = items.length;
        } else {
            if (removeCount > 0) this._emitEvictions(items.slice(0, removeCount));
            this.oldCache = new Map(items.slice(removeCount));
            this.cache = new Map();
            this._size = 0;
        }
        this.maxSize = newSize;
    }
    *keys() {
        for (const [key] of this)yield key;
    }
    *values() {
        for (const [, value] of this)yield value;
    }
    *[Symbol.iterator]() {
        for (const item of this.cache){
            const [key, value] = item;
            const deleted = this._deleteIfExpired(key, value);
            if (deleted === false) yield [
                key,
                value.value
            ];
        }
        for (const item of this.oldCache){
            const [key, value] = item;
            if (!this.cache.has(key)) {
                const deleted = this._deleteIfExpired(key, value);
                if (deleted === false) yield [
                    key,
                    value.value
                ];
            }
        }
    }
    *entriesDescending() {
        let items = [
            ...this.cache
        ];
        for(let i = items.length - 1; i >= 0; --i){
            const item = items[i];
            const [key, value] = item;
            const deleted = this._deleteIfExpired(key, value);
            if (deleted === false) yield [
                key,
                value.value
            ];
        }
        items = [
            ...this.oldCache
        ];
        for(let i = items.length - 1; i >= 0; --i){
            const item = items[i];
            const [key, value] = item;
            if (!this.cache.has(key)) {
                const deleted = this._deleteIfExpired(key, value);
                if (deleted === false) yield [
                    key,
                    value.value
                ];
            }
        }
    }
    *entriesAscending() {
        for (const [key, value] of this._entriesAscending())yield [
            key,
            value.value
        ];
    }
    get size() {
        if (!this._size) return this.oldCache.size;
        let oldCacheSize = 0;
        for (const key of this.oldCache.keys())if (!this.cache.has(key)) oldCacheSize++;
        return Math.min(this._size + oldCacheSize, this.maxSize);
    }
    entries() {
        return this.entriesAscending();
    }
    forEach(callbackFunction, thisArgument = this) {
        for (const [key, value] of this.entriesAscending())callbackFunction.call(thisArgument, value, key, this);
    }
    get [Symbol.toStringTag]() {
        return JSON.stringify([
            ...this.entriesAscending()
        ]);
    }
}



/*
    Hebcal - A Jewish Calendar Generator
    Copyright (c) 1994-2020 Danny Sadinoff
    Portions copyright Eyal Schachter and Michael J. Radwin

    https://github.com/hebcal/hebcal-es6

    This program is free software; you can redistribute it and/or
    modify it under the terms of the GNU General Public License
    as published by the Free Software Foundation; either version 2
    of the License, or (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program. If not, see <http://www.gnu.org/licenses/>.
 */ /*
 * Many of the following algorithms were taken from hebrew calendar
 * routines by Maimonedes, from his Mishneh Torah, and implemented by
 *  Nachum Dershowitz                Department of Computer Science
 *  (217) 333-4219                   University of Illinois at Urbana-Champaign
 *  nachum@cs.uiuedu               1304 West Springfield Avenue
 *                                   Urbana, Illinois 61801
 *
 * The routines were included in the emacs 19 distribution.
 *
 */ const $16a8384bbc778702$var$INCOMPLETE = 0;
const $16a8384bbc778702$var$REGULAR = 1;
const $16a8384bbc778702$var$COMPLETE = 2;
function $16a8384bbc778702$var$yearType(hyear) {
    const longC = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).longCheshvan(hyear);
    const shortK = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).shortKislev(hyear);
    if (longC && !shortK) return $16a8384bbc778702$var$COMPLETE;
    else if (!longC && shortK) return $16a8384bbc778702$var$INCOMPLETE;
    else return $16a8384bbc778702$var$REGULAR;
}
/**
 * Represents Parashah HaShavua for an entire Hebrew year
 */ class $16a8384bbc778702$export$81ce12b331357b02 {
    /**
     * Caculates the Parashah HaShavua for an entire Hebrew year
     * @param hyear - Hebrew year (e.g. 5749)
     * @param il - Use Israel sedra schedule (false for Diaspora)
     */ constructor(hyear, il){
        hyear = +hyear;
        this.year = hyear;
        const rh0 = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(1, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TISHREI, hyear);
        const rh = rh0.abs();
        const rhDay = rh0.getDay() + 1;
        // find the first Saturday on or after Rosh Hashana
        this.firstSaturday = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).dayOnOrBefore(6, rh + 6);
        const leap = +(0, $e7dd728d9f060a75$export$8f4940fd510e0848).isLeapYear(hyear);
        this.il = Boolean(il);
        const type = $16a8384bbc778702$var$yearType(hyear);
        let key = `${leap}${rhDay}${type}`;
        if ($16a8384bbc778702$var$types[key]) this.theSedraArray = $16a8384bbc778702$var$types[key];
        else {
            key = key + +this.il; // cast to num, then concat
            this.theSedraArray = $16a8384bbc778702$var$types[key];
        }
        if (!this.theSedraArray) throw new Error(`improper sedra year type ${key} calculated for ${hyear}`);
    }
    /**
     * Returns the parsha (or parshiyot) read on Hebrew date
     * @deprecated Use {@link lookup} instead
     * @param hd Hebrew date or R.D. days
     */ get(hd) {
        return this.lookup(hd).parsha;
    }
    /**
     * Looks up parsha for the date, then returns a translated or transliterated string
     * @deprecated Use {@link lookup} instead
     * @param hd Hebrew date or R.D. days
     * @param [locale] Optional locale name (i.e: `'he'`, `'fr'`). Defaults to active locale
     */ getString(hd, locale) {
        const parsha = this.get(hd);
        return (0, $7f3f966ef905425e$export$c5b8905d1ccaa06c)(parsha, locale);
    }
    /**
     * Checks to see if this day would be a regular parasha HaShavua
     * Torah reading or special holiday reading
     * @deprecated Use {@link lookup} instead
     * @param hd Hebrew date or R.D. days
     */ isParsha(hd) {
        return !this.lookup(hd).chag;
    }
    /**
     * Returns the date that a parsha occurs
     * or `null` if the parsha doesn't occur this year
     * @param parsha if a `string`, specified with Sephardic transliterations
     *  like `'Noach'` or `'Matot-Masei'`. If an array, must be a 1- or 2-element
     *  array such as `['Noach']` or `['Matot', 'Masei']`. If a `number`, should
     *  be a 0-based parsha index (`0` for Bereshit, `1` for Noach) or a negative
     *  number for a doubled parsha (e.g. `-21` for Vayakhel-Pekudei)
     */ find(parsha) {
        if (typeof parsha === 'number') {
            if (parsha >= $16a8384bbc778702$export$c675d5bd772ac2ed.length || parsha < 0 && !$16a8384bbc778702$var$isValidDouble(parsha)) throw new RangeError(`Invalid parsha number: ${parsha}`);
            return this.findInternal(parsha);
        } else if (typeof parsha === 'string') {
            const num = $16a8384bbc778702$var$parsha2id.get(parsha);
            if (typeof num === 'number') return this.find(num);
            else if (parsha.indexOf('-') !== -1) {
                if (parsha === $16a8384bbc778702$var$CHMPESACH || parsha === $16a8384bbc778702$var$CHMSUKOT) return this.findInternal(parsha);
                return this.find(parsha.split('-'));
            } else // try to find Saturday holiday like 'Yom Kippur'
            return this.findInternal(parsha);
        } else if (Array.isArray(parsha)) {
            const plen = parsha.length;
            if (plen !== 1 && plen !== 2 || typeof parsha[0] !== 'string') throw new TypeError(`Invalid parsha argument: ${JSON.stringify(parsha)}`);
            if (plen === 1) return this.find(parsha[0]);
            const p1 = parsha[0];
            const p2 = parsha[1];
            const num1 = $16a8384bbc778702$var$parsha2id.get(p1);
            const num2 = $16a8384bbc778702$var$parsha2id.get(p2);
            if (typeof num1 !== 'number' || typeof num2 !== 'number' || num2 !== num1 + 1 || !$16a8384bbc778702$var$isValidDouble(-num1)) throw new RangeError(`Unrecognized parsha name: ${p1}-${p2}`);
            return this.find(-num1);
        }
        return null; /* NOTREACHED */ 
    }
    findInternal(parsha) {
        const idx = this.theSedraArray.indexOf(parsha);
        if (idx === -1) return null; // doesn't occur this year
        return new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(this.firstSaturday + idx * 7);
    }
    /**
     * Returns the date that a parsha (or its doubled or undoubled counterpart)
     * occurs, or `null` if the parsha doesn't occur this year
     */ findContaining(parsha) {
        const hdate = this.find(parsha);
        if (hdate) return hdate;
        if (typeof parsha === 'number') {
            // a valid negative number (double parsha in a year where they are
            // combined) would've been found above, and a invalid negative number
            // would've thrown an error, so this parsha must be a positive number
            // representing either p1 or p2
            const p1 = -parsha;
            if ($16a8384bbc778702$var$isValidDouble(p1)) return this.find(p1);
            else // this must be the second individual parsha of a doubled pair
            // for example 29 for Kedoshim, so check for -28 for Achrei Mot-Kedoshim
            return this.find(p1 + 1);
        } else {
            const num = $16a8384bbc778702$var$parsha2id.get(parsha);
            if (num) {
                // parsha is either the first or second individual parsha of
                // a pair that is doubled this year
                const p1 = -num;
                if ($16a8384bbc778702$var$isValidDouble(p1)) return this.find(p1);
                else return this.find(p1 + 1);
            } else {
                // this was indeed a doubled parsha, so return date of the first half
                const [p1] = parsha.split('-');
                return this.find(p1);
            }
        }
    }
    /**
     * Returns the underlying annual sedra schedule.
     * Used by `@hebcal/triennial`
     */ getSedraArray() {
        return this.theSedraArray;
    }
    /**
     * R.D. date of the first Saturday on or after Rosh Hashana
     */ getFirstSaturday() {
        return this.firstSaturday;
    }
    getYear() {
        return this.year;
    }
    /**
     * Returns an object describing the parsha on the first Saturday on or after `hd`
     * @param hd Hebrew date or R.D. days
     */ lookup(hd) {
        const abs = typeof hd === 'number' ? hd : (0, $e7dd728d9f060a75$export$8f4940fd510e0848).isHDate(hd) ? hd.abs() : NaN;
        if (isNaN(abs)) throw new TypeError(`Bad date argument: ${hd}`);
        // find the first saturday on or after today's date
        const saturday = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).dayOnOrBefore(6, abs + 6);
        const weekNum = (saturday - this.firstSaturday) / 7;
        const index = this.theSedraArray[weekNum];
        if (typeof index === 'undefined') {
            const sedra = $16a8384bbc778702$export$46dd3945618c9426(this.year + 1, this.il);
            return sedra.lookup(saturday); // must be next year
        }
        const hdate = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(saturday);
        if (typeof index === 'string') // Shabbat has a chag. Return a description
        return {
            parsha: [
                index
            ],
            chag: true,
            hdate: hdate
        };
        if (index >= 0) return {
            parsha: [
                $16a8384bbc778702$export$c675d5bd772ac2ed[index]
            ],
            chag: false,
            num: index + 1,
            hdate: hdate
        };
        const p1 = $16a8384bbc778702$var$D(index); // undouble the parsha
        return {
            parsha: [
                $16a8384bbc778702$export$c675d5bd772ac2ed[p1],
                $16a8384bbc778702$export$c675d5bd772ac2ed[p1 + 1]
            ],
            chag: false,
            num: [
                p1 + 1,
                p1 + 2
            ],
            hdate: hdate
        };
    }
}
/**
 * The 54 parshiyot of the Torah as transilterated strings.
 * parshiot[0] == 'Bereshit', parshiot[1] == 'Noach', parshiot[52] == "Ha'azinu".
 * @readonly
 * @type {string[]}
 */ const $16a8384bbc778702$export$c675d5bd772ac2ed = [
    'Bereshit',
    'Noach',
    'Lech-Lecha',
    'Vayera',
    'Chayei Sara',
    'Toldot',
    'Vayetzei',
    'Vayishlach',
    'Vayeshev',
    'Miketz',
    'Vayigash',
    'Vayechi',
    'Shemot',
    'Vaera',
    'Bo',
    'Beshalach',
    'Yitro',
    'Mishpatim',
    'Terumah',
    'Tetzaveh',
    'Ki Tisa',
    'Vayakhel',
    'Pekudei',
    'Vayikra',
    'Tzav',
    'Shmini',
    'Tazria',
    'Metzora',
    'Achrei Mot',
    'Kedoshim',
    'Emor',
    'Behar',
    'Bechukotai',
    'Bamidbar',
    'Nasso',
    "Beha'alotcha",
    "Sh'lach",
    'Korach',
    'Chukat',
    'Balak',
    'Pinchas',
    'Matot',
    'Masei',
    'Devarim',
    'Vaetchanan',
    'Eikev',
    "Re'eh",
    'Shoftim',
    'Ki Teitzei',
    'Ki Tavo',
    'Nitzavim',
    'Vayeilech',
    "Ha'azinu"
];
// 0-based parsha IDs
const $16a8384bbc778702$var$parsha2id = new Map();
for(let id = 0; id < $16a8384bbc778702$export$c675d5bd772ac2ed.length; id++){
    const name = $16a8384bbc778702$export$c675d5bd772ac2ed[id];
    $16a8384bbc778702$var$parsha2id.set(name, id);
}
// 0-based parsha IDs
const $16a8384bbc778702$var$doubles = [
    21,
    26,
    28,
    31,
    38,
    41,
    50
];
/**
 * @private
 * @param id a negative number
 */ function $16a8384bbc778702$var$isValidDouble(id) {
    return $16a8384bbc778702$var$doubles.includes(-id);
}
/**
 * parsha doubler/undoubler
 * @private
 * @param p
 */ function $16a8384bbc778702$var$D(p) {
    return -p;
}
const $16a8384bbc778702$var$RH = 'Rosh Hashana'; // 0
const $16a8384bbc778702$var$YK = 'Yom Kippur'; // 1
const $16a8384bbc778702$var$SUKKOT = 'Sukkot'; // 0
const $16a8384bbc778702$var$CHMSUKOT = 'Sukkot Shabbat Chol ha-Moed'; // 0
const $16a8384bbc778702$var$SHMINI = 'Shmini Atzeret'; // 0
const $16a8384bbc778702$var$PESACH = 'Pesach'; // 25
const $16a8384bbc778702$var$PESACH1 = 'Pesach I';
const $16a8384bbc778702$var$CHMPESACH = 'Pesach Shabbat Chol ha-Moed'; // 25
const $16a8384bbc778702$var$PESACH7 = 'Pesach VII'; // 25
const $16a8384bbc778702$var$PESACH8 = 'Pesach VIII';
const $16a8384bbc778702$var$SHAVUOT = 'Shavuot'; // 33
/**
 * Returns an array from start to end
 * @private
 * @param start beginning number, inclusive
 * @param stop ending number, inclusive
 */ function $16a8384bbc778702$var$range(start, stop) {
    return Array.from({
        length: stop - start + 1
    }, (v, k)=>k + start);
}
const $16a8384bbc778702$var$yearStartVayeilech = [
    51,
    52,
    $16a8384bbc778702$var$CHMSUKOT
];
const $16a8384bbc778702$var$yearStartHaazinu = [
    52,
    $16a8384bbc778702$var$YK,
    $16a8384bbc778702$var$CHMSUKOT
];
const $16a8384bbc778702$var$yearStartRH = [
    $16a8384bbc778702$var$RH,
    52,
    $16a8384bbc778702$var$SUKKOT,
    $16a8384bbc778702$var$SHMINI
];
const $16a8384bbc778702$var$r020 = $16a8384bbc778702$var$range(0, 20);
const $16a8384bbc778702$var$r027 = $16a8384bbc778702$var$range(0, 27);
const $16a8384bbc778702$var$r3340 = $16a8384bbc778702$var$range(33, 40);
const $16a8384bbc778702$var$r4349 = $16a8384bbc778702$var$range(43, 49);
const $16a8384bbc778702$var$r4350 = $16a8384bbc778702$var$range(43, 50);
/**
 * The ordinary year types (keviot)
 * names are leap/nonleap - day - incomplete/regular/complete - diaspora/Israel
 * @private
 * @readonly
 */ const $16a8384bbc778702$var$types = {
    /* Hebrew year that starts on Monday, is `incomplete' (Heshvan and
     * Kislev each have 29 days), and has Passover start on Tuesday. */ // e.g. 5753
    '020': $16a8384bbc778702$var$yearStartVayeilech.concat($16a8384bbc778702$var$r020, $16a8384bbc778702$var$D(21), 23, 24, $16a8384bbc778702$var$PESACH, 25, $16a8384bbc778702$var$D(26), $16a8384bbc778702$var$D(28), 30, $16a8384bbc778702$var$D(31), $16a8384bbc778702$var$r3340, $16a8384bbc778702$var$D(41), $16a8384bbc778702$var$r4349, $16a8384bbc778702$var$D(50)),
    /* Hebrew year that starts on Monday, is `complete' (Heshvan and
     * Kislev each have 30 days), and has Passover start on Thursday. */ // e.g. 5756
    '0220': $16a8384bbc778702$var$yearStartVayeilech.concat($16a8384bbc778702$var$r020, $16a8384bbc778702$var$D(21), 23, 24, $16a8384bbc778702$var$PESACH, 25, $16a8384bbc778702$var$D(26), $16a8384bbc778702$var$D(28), 30, $16a8384bbc778702$var$D(31), 33, $16a8384bbc778702$var$SHAVUOT, $16a8384bbc778702$var$range(34, 37), $16a8384bbc778702$var$D(38), 40, $16a8384bbc778702$var$D(41), $16a8384bbc778702$var$r4349, $16a8384bbc778702$var$D(50)),
    /* Hebrew year that starts on Thursday, is `regular' (Heshvan has 29
     * days and Kislev has 30 days), and has Passover start on Saturday. */ // e.g. 5701
    '0510': $16a8384bbc778702$var$yearStartHaazinu.concat($16a8384bbc778702$var$r020, $16a8384bbc778702$var$D(21), 23, 24, $16a8384bbc778702$var$PESACH1, $16a8384bbc778702$var$PESACH8, 25, $16a8384bbc778702$var$D(26), $16a8384bbc778702$var$D(28), 30, $16a8384bbc778702$var$D(31), $16a8384bbc778702$var$r3340, $16a8384bbc778702$var$D(41), $16a8384bbc778702$var$r4350),
    /* Hebrew year that starts on Thursday, is `regular' (Heshvan has 29
     * days and Kislev has 30 days), and has Passover start on Saturday. */ // e.g. 5745
    '0511': $16a8384bbc778702$var$yearStartHaazinu.concat($16a8384bbc778702$var$r020, $16a8384bbc778702$var$D(21), 23, 24, $16a8384bbc778702$var$PESACH, 25, $16a8384bbc778702$var$D(26), $16a8384bbc778702$var$D(28), $16a8384bbc778702$var$range(30, 40), $16a8384bbc778702$var$D(41), $16a8384bbc778702$var$r4350),
    /* Hebrew year that starts on Thursday, is `complete' (Heshvan and
     * Kislev each have 30 days), and has Passover start on Sunday. */ // e.g. 5754
    '052': $16a8384bbc778702$var$yearStartHaazinu.concat($16a8384bbc778702$var$range(0, 24), $16a8384bbc778702$var$PESACH7, 25, $16a8384bbc778702$var$D(26), $16a8384bbc778702$var$D(28), 30, $16a8384bbc778702$var$D(31), $16a8384bbc778702$var$r3340, $16a8384bbc778702$var$D(41), $16a8384bbc778702$var$r4350),
    /* Hebrew year that starts on Saturday, is `incomplete' (Heshvan and Kislev
     * each have 29 days), and has Passover start on Sunday. */ // e.g. 5761
    '070': $16a8384bbc778702$var$yearStartRH.concat($16a8384bbc778702$var$r020, $16a8384bbc778702$var$D(21), 23, 24, $16a8384bbc778702$var$PESACH7, 25, $16a8384bbc778702$var$D(26), $16a8384bbc778702$var$D(28), 30, $16a8384bbc778702$var$D(31), $16a8384bbc778702$var$r3340, $16a8384bbc778702$var$D(41), $16a8384bbc778702$var$r4350),
    /* Hebrew year that starts on Saturday, is `complete' (Heshvan and
     * Kislev each have 30 days), and has Passover start on Tuesday. */ // e.g. 5716
    '072': $16a8384bbc778702$var$yearStartRH.concat($16a8384bbc778702$var$r020, $16a8384bbc778702$var$D(21), 23, 24, $16a8384bbc778702$var$CHMPESACH, 25, $16a8384bbc778702$var$D(26), $16a8384bbc778702$var$D(28), 30, $16a8384bbc778702$var$D(31), $16a8384bbc778702$var$r3340, $16a8384bbc778702$var$D(41), $16a8384bbc778702$var$r4349, $16a8384bbc778702$var$D(50)),
    /* --  The leap year types (keviot) -- */ /* Hebrew year that starts on Monday, is `incomplete' (Heshvan and
     * Kislev each have 29 days), and has Passover start on Thursday. */ // e.g. 5746
    '1200': $16a8384bbc778702$var$yearStartVayeilech.concat($16a8384bbc778702$var$r027, $16a8384bbc778702$var$CHMPESACH, $16a8384bbc778702$var$range(28, 33), $16a8384bbc778702$var$SHAVUOT, $16a8384bbc778702$var$range(34, 37), $16a8384bbc778702$var$D(38), 40, $16a8384bbc778702$var$D(41), $16a8384bbc778702$var$r4349, $16a8384bbc778702$var$D(50)),
    /* Hebrew year that starts on Monday, is `incomplete' (Heshvan and
     * Kislev each have 29 days), and has Passover start on Thursday. */ // e.g. 5746
    '1201': $16a8384bbc778702$var$yearStartVayeilech.concat($16a8384bbc778702$var$r027, $16a8384bbc778702$var$CHMPESACH, $16a8384bbc778702$var$range(28, 40), $16a8384bbc778702$var$D(41), $16a8384bbc778702$var$r4349, $16a8384bbc778702$var$D(50)),
    /* Hebrew year that starts on Monday, is `complete' (Heshvan and
     * Kislev each have 30 days), and has Passover start on Saturday. */ // e.g.5752
    '1220': $16a8384bbc778702$var$yearStartVayeilech.concat($16a8384bbc778702$var$r027, $16a8384bbc778702$var$PESACH1, $16a8384bbc778702$var$PESACH8, $16a8384bbc778702$var$range(28, 40), $16a8384bbc778702$var$D(41), $16a8384bbc778702$var$r4350),
    /* Hebrew year that starts on Monday, is `complete' (Heshvan and
     * Kislev each have 30 days), and has Passover start on Saturday. */ // e.g.5752
    '1221': $16a8384bbc778702$var$yearStartVayeilech.concat($16a8384bbc778702$var$r027, $16a8384bbc778702$var$PESACH, $16a8384bbc778702$var$range(28, 50)),
    /* Hebrew year that starts on Thursday, is `incomplete' (Heshvan and
     * Kislev both have 29 days), and has Passover start on Sunday. */ // e.g. 5768
    '150': $16a8384bbc778702$var$yearStartHaazinu.concat($16a8384bbc778702$var$range(0, 28), $16a8384bbc778702$var$PESACH7, $16a8384bbc778702$var$range(29, 50)),
    /* Hebrew year that starts on Thursday, is `complete' (Heshvan and
     * Kislev both have 30 days), and has Passover start on Tuesday. */ // eg. 5771
    '152': $16a8384bbc778702$var$yearStartHaazinu.concat($16a8384bbc778702$var$range(0, 28), $16a8384bbc778702$var$CHMPESACH, $16a8384bbc778702$var$range(29, 49), $16a8384bbc778702$var$D(50)),
    /* Hebrew year that starts on Saturday, is `incomplete' (Heshvan and
     * Kislev each have 29 days), and has Passover start on Tuesday. */ // e.g.5757
    '170': $16a8384bbc778702$var$yearStartRH.concat($16a8384bbc778702$var$r027, $16a8384bbc778702$var$CHMPESACH, $16a8384bbc778702$var$range(28, 40), $16a8384bbc778702$var$D(41), $16a8384bbc778702$var$r4349, $16a8384bbc778702$var$D(50)),
    /* Hebrew year that starts on Saturday, is `complete' (Heshvan and
     * Kislev each have 30 days), and has Passover start on Thursday. */ '1720': $16a8384bbc778702$var$yearStartRH.concat($16a8384bbc778702$var$r027, $16a8384bbc778702$var$CHMPESACH, $16a8384bbc778702$var$range(28, 33), $16a8384bbc778702$var$SHAVUOT, $16a8384bbc778702$var$range(34, 37), $16a8384bbc778702$var$D(38), 40, $16a8384bbc778702$var$D(41), $16a8384bbc778702$var$r4349, $16a8384bbc778702$var$D(50))
};
/* Hebrew year that starts on Monday, is `complete' (Heshvan and
 * Kislev each have 30 days), and has Passover start on Thursday. */ $16a8384bbc778702$var$types['0221'] = $16a8384bbc778702$var$types['020'];
/* Hebrew year that starts on Tuesday, is `regular' (Heshvan has 29
 * days and Kislev has 30 days), and has Passover start on Thursday. */ // e.g. 5715
$16a8384bbc778702$var$types['0310'] = $16a8384bbc778702$var$types['0220'];
/* Hebrew year that starts on Tuesday, is `regular' (Heshvan has 29
 * days and Kislev has 30 days), and has Passover start on Thursday. */ $16a8384bbc778702$var$types['0311'] = $16a8384bbc778702$var$types['020'];
/* Hebrew year that starts on Tuesday, is `regular' (Heshvan has 29
 * days and Kislev has 30 days), and has Passover start on Saturday. */ // e.g. 5715
$16a8384bbc778702$var$types['1310'] = $16a8384bbc778702$var$types['1220'];
/* Hebrew year that starts on Tuesday, is `regular' (Heshvan has 29
 * days and Kislev has 30 days), and has Passover start on Saturday. */ $16a8384bbc778702$var$types['1311'] = $16a8384bbc778702$var$types['1221'];
/* Hebrew year that starts on Saturday, is `complete' (Heshvan and
 * Kislev each have 30 days), and has Passover start on Thursday. */ $16a8384bbc778702$var$types['1721'] = $16a8384bbc778702$var$types['170'];
const $16a8384bbc778702$var$sedraCache = new (0, $119f9466c9ba00cb$export$2e2bcd8739ae039)({
    maxSize: 400
});
/**
 * Convenience function to create an instance of `Sedra` or reuse a previously
 * created and cached instance.
 * @param hyear
 * @param il
 */ function $16a8384bbc778702$export$46dd3945618c9426(hyear, il) {
    const cacheKey = `${hyear}-${il ? 1 : 0}`;
    let sedra = $16a8384bbc778702$var$sedraCache.get(cacheKey);
    if (!sedra) {
        sedra = new $16a8384bbc778702$export$81ce12b331357b02(hyear, il);
        $16a8384bbc778702$var$sedraCache.set(cacheKey, sedra);
    }
    return sedra;
}


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 



/**
 * Represents one of 54 weekly Torah portions, always on a Saturday
 */ class $5293135afc366466$export$eaf7b0b4ee904ad3 extends (0, $439631353957c387$export$d61e24a684f9e51) {
    /**
     * @param parsha - untranslated name of single or double parsha,
     *   such as ['Bereshit'] or ['Achrei Mot', 'Kedoshim']
     */ constructor(date, parsha, il = false, num = -1){
        if (!Array.isArray(parsha) || parsha.length === 0 || parsha.length > 2) throw new TypeError('Bad parsha argument');
        const desc = 'Parashat ' + parsha.join('-');
        super(date, desc, (0, $439631353957c387$export$ceac1d294cf61000).PARSHA_HASHAVUA);
        this.parsha = parsha;
        this.il = Boolean(il);
        this.num = num || -1;
    }
    /**
     * @param [locale] Optional locale name (i.e: `'he'`, `'fr'`). Defaults to active locale.
     */ render(locale) {
        return (0, $7f3f966ef905425e$export$c5b8905d1ccaa06c)(this.parsha, locale);
    }
    basename() {
        return this.parsha.join('-');
    }
    url() {
        const year = this.getDate().greg().getFullYear();
        if (year < 100) return undefined;
        const dt = this.urlDateSuffix();
        const url = 'https://www.hebcal.com/sedrot/' + this.basename().toLowerCase().replace(/'/g, '').replace(/ /g, '-') + '-' + dt;
        return this.il ? url + '?i=on' : url;
    }
    urlDateSuffix() {
        const isoDate = (0, $55283cdbe290c27d$export$1155ec213071851)(this.getDate().greg());
        return isoDate.replace(/-/g, '');
    }
}


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 


/**
 * Calculates weekly Torah Reading on Saturdays for entire year
 * @param year Hebrew year
 * @param il Israel (false for Diaspora)
 * @returns an array of `ParshaEvent` occurring on Saturdays that contain a regular
 *  (non-holiday) Parashat HaShavua
 */ function $7ea289d564faa6e4$export$3d651106caf76497(year, il) {
    const sedra = (0, $16a8384bbc778702$export$46dd3945618c9426)(year, il);
    const startAbs = sedra.getFirstSaturday();
    const endAbs = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).hebrew2abs(year, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ELUL, 29);
    const events = [];
    for(let absDt = startAbs; absDt <= endAbs; absDt += 7){
        const parsha = sedra.lookup(absDt);
        if (!parsha.chag) {
            const ev = new (0, $5293135afc366466$export$eaf7b0b4ee904ad3)(parsha.hdate, parsha.parsha, il, parsha.num);
            events.push(ev);
        }
    }
    return events;
}



/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 
const $cd0ad1d107f7c8fc$var$SUN = 0;
const $cd0ad1d107f7c8fc$var$TUE = 2;
const $cd0ad1d107f7c8fc$var$FRI = 5;
const $cd0ad1d107f7c8fc$var$SAT = 6;
const $cd0ad1d107f7c8fc$var$NISAN = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).NISAN;
const $cd0ad1d107f7c8fc$var$IYYAR = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).IYYAR;
/**
 * Yom HaShoah first observed in 1951.
 * When the actual date of Yom Hashoah falls on a Friday, the
 * state of Israel observes Yom Hashoah on the preceding
 * Thursday. When it falls on a Sunday, Yom Hashoah is observed
 * on the following Monday.
 * http://www.ushmm.org/remembrance/dor/calendar/
 * @private
 * @param year
 */ function $cd0ad1d107f7c8fc$export$c848f93eb5738d4f(year) {
    if (year < 5711) return null;
    let nisan27dt = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(27, $cd0ad1d107f7c8fc$var$NISAN, year);
    if (nisan27dt.getDay() === $cd0ad1d107f7c8fc$var$FRI) nisan27dt = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(26, $cd0ad1d107f7c8fc$var$NISAN, year);
    else if (nisan27dt.getDay() === $cd0ad1d107f7c8fc$var$SUN) nisan27dt = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(28, $cd0ad1d107f7c8fc$var$NISAN, year);
    return nisan27dt;
}
/**
 * Yom HaAtzma'ut only celebrated after 1948
 * @private
 * @param year
 */ function $cd0ad1d107f7c8fc$export$8ada79b1d52d505d(year) {
    if (year < 5708) return null;
    let day;
    const pesach = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(15, $cd0ad1d107f7c8fc$var$NISAN, year);
    const pdow = pesach.getDay();
    if (pdow === $cd0ad1d107f7c8fc$var$SUN) day = 2;
    else if (pdow === $cd0ad1d107f7c8fc$var$SAT) day = 3;
    else if (year < 5764) day = 4;
    else if (pdow === $cd0ad1d107f7c8fc$var$TUE) day = 5;
    else day = 4;
    return new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(day, $cd0ad1d107f7c8fc$var$IYYAR, year);
}




/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 



const $bce974a4116d897b$var$ykk = 'Yom Kippur Katan';
/** YKK is minor day of atonement on the day preceeding each Rosh Chodesh */ class $bce974a4116d897b$export$232a5be06b932145 extends (0, $35e955bca89ef86b$export$a950670998c93dc) {
    /**
     * @private
     * @param date Hebrew date event occurs
     * @param nextMonthName name of the upcoming month
     */ constructor(date, nextMonthName){
        super(date, `${$bce974a4116d897b$var$ykk} ${nextMonthName}`, (0, $439631353957c387$export$ceac1d294cf61000).MINOR_FAST | (0, $439631353957c387$export$ceac1d294cf61000).YOM_KIPPUR_KATAN);
        this.nextMonthName = nextMonthName;
        this.memo = `Minor Day of Atonement on the day preceeding Rosh Chodesh ${nextMonthName}`;
    }
    basename() {
        return this.getDesc();
    }
    /**
     * @param [locale] Optional locale name (defaults to active locale).
     */ render(locale) {
        const monthName0 = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext(this.nextMonthName, locale);
        const monthName = monthName0.replace(/'/g, "\u2019");
        return (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext($bce974a4116d897b$var$ykk, locale) + ' ' + monthName;
    }
    /**
     * @param [locale] Optional locale name (defaults to active locale).
     */ renderBrief(locale) {
        return (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext($bce974a4116d897b$var$ykk, locale);
    }
    url() {
        return undefined;
    }
}



/*
    Hebcal - A Jewish Calendar Generator
    Copyright (c) 1994-2020 Danny Sadinoff
    Portions copyright Eyal Schachter and Michael J. Radwin

    https://github.com/hebcal/hebcal-es6

    This program is free software; you can redistribute it and/or
    modify it under the terms of the GNU General Public License
    as published by the Free Software Foundation; either version 2
    of the License, or (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program. If not, see <http://www.gnu.org/licenses/>.
 */ /** @private */ function $dfdf4f8567e83d5d$var$observedInIsrael(ev) {
    return ev.observedInIsrael();
}
/** @private */ function $dfdf4f8567e83d5d$var$observedInDiaspora(ev) {
    return ev.observedInDiaspora();
}
/** @private */ function $dfdf4f8567e83d5d$var$holidayFilter(il) {
    return il ? $dfdf4f8567e83d5d$var$observedInIsrael : $dfdf4f8567e83d5d$var$observedInDiaspora;
}
/**
 * Returns an array of Events on this date (or `undefined` if no events)
 * @param date Hebrew Date, Gregorian date, or absolute R.D. day number
 * @param [il] use the Israeli schedule for holidays
 */ function $dfdf4f8567e83d5d$export$a2e6414e5cf3ed5a(date, il) {
    const hd = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).isHDate(date) ? date : new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(date);
    const hdStr = hd.toString();
    const yearMap = $dfdf4f8567e83d5d$export$1783645bc1165a67(hd.getFullYear());
    const events = yearMap.get(hdStr);
    // if il isn't a boolean return both diaspora + IL for day
    if (typeof il === 'undefined' || typeof events === 'undefined') return events;
    const filtered = events.filter($dfdf4f8567e83d5d$var$holidayFilter(il));
    return filtered;
}
const $dfdf4f8567e83d5d$var$CHAG = (0, $439631353957c387$export$ceac1d294cf61000).CHAG;
const $dfdf4f8567e83d5d$var$IL_ONLY = (0, $439631353957c387$export$ceac1d294cf61000).IL_ONLY;
const $dfdf4f8567e83d5d$var$LIGHT_CANDLES_TZEIS = (0, $439631353957c387$export$ceac1d294cf61000).LIGHT_CANDLES_TZEIS;
const $dfdf4f8567e83d5d$var$CHANUKAH_CANDLES = (0, $439631353957c387$export$ceac1d294cf61000).CHANUKAH_CANDLES;
const $dfdf4f8567e83d5d$var$MINOR_FAST = (0, $439631353957c387$export$ceac1d294cf61000).MINOR_FAST;
const $dfdf4f8567e83d5d$var$SPECIAL_SHABBAT = (0, $439631353957c387$export$ceac1d294cf61000).SPECIAL_SHABBAT;
const $dfdf4f8567e83d5d$var$MODERN_HOLIDAY = (0, $439631353957c387$export$ceac1d294cf61000).MODERN_HOLIDAY;
const $dfdf4f8567e83d5d$var$MAJOR_FAST = (0, $439631353957c387$export$ceac1d294cf61000).MAJOR_FAST;
const $dfdf4f8567e83d5d$var$MINOR_HOLIDAY = (0, $439631353957c387$export$ceac1d294cf61000).MINOR_HOLIDAY;
const $dfdf4f8567e83d5d$var$EREV = (0, $439631353957c387$export$ceac1d294cf61000).EREV;
const $dfdf4f8567e83d5d$var$SUN = 0;
const $dfdf4f8567e83d5d$var$TUE = 2;
const $dfdf4f8567e83d5d$var$THU = 4;
const $dfdf4f8567e83d5d$var$FRI = 5;
const $dfdf4f8567e83d5d$var$SAT = 6;
const $dfdf4f8567e83d5d$var$NISAN = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).NISAN;
const $dfdf4f8567e83d5d$var$TAMUZ = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TAMUZ;
const $dfdf4f8567e83d5d$var$AV = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).AV;
const $dfdf4f8567e83d5d$var$TISHREI = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TISHREI;
const $dfdf4f8567e83d5d$var$KISLEV = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).KISLEV;
const $dfdf4f8567e83d5d$var$TEVET = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TEVET;
const $dfdf4f8567e83d5d$var$ADAR_I = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ADAR_I;
const $dfdf4f8567e83d5d$var$ADAR_II = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ADAR_II;
const $dfdf4f8567e83d5d$var$emojiIsraelFlag = {
    emoji: "\uD83C\uDDEE\uD83C\uDDF1"
};
const $dfdf4f8567e83d5d$var$chanukahEmoji = "\uD83D\uDD4E";
const $dfdf4f8567e83d5d$var$yearCache = new (0, $119f9466c9ba00cb$export$2e2bcd8739ae039)({
    maxSize: 400
});
const $dfdf4f8567e83d5d$var$KEYCAP_DIGITS = [
    "0\uFE0F\u20E3",
    "1\uFE0F\u20E3",
    "2\uFE0F\u20E3",
    "3\uFE0F\u20E3",
    "4\uFE0F\u20E3",
    "5\uFE0F\u20E3",
    "6\uFE0F\u20E3",
    "7\uFE0F\u20E3",
    "8\uFE0F\u20E3",
    "9\uFE0F\u20E3"
];
/**
 * Lower-level holidays interface, which returns a `Map` of `Event`s indexed by
 * `HDate.toString()`. These events must filtered especially for `flags.IL_ONLY`
 * or `flags.CHUL_ONLY` depending on Israel vs. Diaspora holiday scheme.
 * @private
 */ function $dfdf4f8567e83d5d$export$1783645bc1165a67(year) {
    if (typeof year !== 'number') throw new TypeError(`bad Hebrew year: ${year}`);
    else if (year < 1 || year > 32658) throw new RangeError(`Hebrew year ${year} out of range 1-32658`);
    const cached = $dfdf4f8567e83d5d$var$yearCache.get(year);
    if (cached) return cached;
    const RH = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(1, $dfdf4f8567e83d5d$var$TISHREI, year);
    const pesach = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(15, $dfdf4f8567e83d5d$var$NISAN, year);
    const map = new Map();
    function add(...events) {
        for (const ev of events){
            const key = ev.date.toString();
            const arr = map.get(key);
            if (typeof arr === 'object') {
                if (arr[0].getFlags() & $dfdf4f8567e83d5d$var$EREV) arr.unshift(ev);
                else arr.push(ev);
            } else map.set(key, [
                ev
            ]);
        }
    }
    for (const h of (0, $cf7ca2f841f82e34$export$b4a8c98d57f3cbba)){
        const hd = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(h.dd, h.mm, year);
        const ev = new (0, $35e955bca89ef86b$export$a950670998c93dc)(hd, h.desc, h.flags);
        if (h.emoji) ev.emoji = h.emoji;
        if (h.chmDay) ev.cholHaMoedDay = h.chmDay;
        add(ev);
    }
    // standard holidays that don't shift based on year
    add(new (0, $35e955bca89ef86b$export$4b23eca099a2aa7d)(RH, year, $dfdf4f8567e83d5d$var$CHAG | $dfdf4f8567e83d5d$var$LIGHT_CANDLES_TZEIS));
    // Variable date holidays
    const tzomGedaliahDay = RH.getDay() === $dfdf4f8567e83d5d$var$THU ? 4 : 3;
    add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(tzomGedaliahDay, $dfdf4f8567e83d5d$var$TISHREI, year), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).TZOM_GEDALIAH, $dfdf4f8567e83d5d$var$MINOR_FAST));
    // first SAT after RH
    add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)((0, $e7dd728d9f060a75$export$8f4940fd510e0848).dayOnOrBefore($dfdf4f8567e83d5d$var$SAT, 7 + RH.abs())), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).SHABBAT_SHUVA, $dfdf4f8567e83d5d$var$SPECIAL_SHABBAT));
    const rchTevet = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).shortKislev(year) ? new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(1, $dfdf4f8567e83d5d$var$TEVET, year) : new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(30, $dfdf4f8567e83d5d$var$KISLEV, year);
    add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(rchTevet, (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).CHAG_HABANOT, $dfdf4f8567e83d5d$var$MINOR_HOLIDAY));
    // yes, we know Kislev 30-32 are wrong
    // HDate() corrects the month automatically
    for(let candles = 2; candles <= 8; candles++){
        const hd = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(23 + candles, $dfdf4f8567e83d5d$var$KISLEV, year);
        add(new (0, $35e955bca89ef86b$export$71b4c478965bbe86)(hd, `Chanukah: ${candles} Candles`, $dfdf4f8567e83d5d$var$MINOR_HOLIDAY | $dfdf4f8567e83d5d$var$CHANUKAH_CANDLES, {
            chanukahDay: candles - 1,
            emoji: $dfdf4f8567e83d5d$var$chanukahEmoji + $dfdf4f8567e83d5d$var$KEYCAP_DIGITS[candles]
        }));
    }
    add(new (0, $35e955bca89ef86b$export$71b4c478965bbe86)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(32, $dfdf4f8567e83d5d$var$KISLEV, year), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).CHANUKAH_8TH_DAY, $dfdf4f8567e83d5d$var$MINOR_HOLIDAY, {
        chanukahDay: 8,
        emoji: $dfdf4f8567e83d5d$var$chanukahEmoji
    }));
    add(new (0, $35e955bca89ef86b$export$4b00f1bf0e95af6c)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(10, $dfdf4f8567e83d5d$var$TEVET, year), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).ASARA_BTEVET, $dfdf4f8567e83d5d$var$MINOR_FAST));
    const pesachAbs = pesach.abs();
    add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)((0, $e7dd728d9f060a75$export$8f4940fd510e0848).dayOnOrBefore($dfdf4f8567e83d5d$var$SAT, pesachAbs - 43)), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).SHABBAT_SHEKALIM, $dfdf4f8567e83d5d$var$SPECIAL_SHABBAT), new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)((0, $e7dd728d9f060a75$export$8f4940fd510e0848).dayOnOrBefore($dfdf4f8567e83d5d$var$SAT, pesachAbs - 30)), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).SHABBAT_ZACHOR, $dfdf4f8567e83d5d$var$SPECIAL_SHABBAT), new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(pesachAbs - (pesach.getDay() === $dfdf4f8567e83d5d$var$TUE ? 33 : 31)), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).TAANIT_ESTHER, $dfdf4f8567e83d5d$var$MINOR_FAST));
    const haChodeshAbs = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).dayOnOrBefore($dfdf4f8567e83d5d$var$SAT, pesachAbs - 14);
    add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(haChodeshAbs - 7), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).SHABBAT_PARAH, $dfdf4f8567e83d5d$var$SPECIAL_SHABBAT), new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(haChodeshAbs), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).SHABBAT_HACHODESH, $dfdf4f8567e83d5d$var$SPECIAL_SHABBAT), new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)((0, $e7dd728d9f060a75$export$8f4940fd510e0848).dayOnOrBefore($dfdf4f8567e83d5d$var$SAT, pesachAbs - 1)), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).SHABBAT_HAGADOL, $dfdf4f8567e83d5d$var$SPECIAL_SHABBAT), new (0, $35e955bca89ef86b$export$a950670998c93dc)(// if the fast falls on Shabbat, move to Thursday
    pesach.prev().getDay() === $dfdf4f8567e83d5d$var$SAT ? pesach.onOrBefore($dfdf4f8567e83d5d$var$THU) : new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(14, $dfdf4f8567e83d5d$var$NISAN, year), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).TAANIT_BECHOROT, $dfdf4f8567e83d5d$var$MINOR_FAST));
    add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)((0, $e7dd728d9f060a75$export$8f4940fd510e0848).dayOnOrBefore($dfdf4f8567e83d5d$var$SAT, new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(1, $dfdf4f8567e83d5d$var$TISHREI, year + 1).abs() - 4)), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).LEIL_SELICHOT, $dfdf4f8567e83d5d$var$MINOR_HOLIDAY, {
        emoji: "\uD83D\uDD4D"
    }));
    if (pesach.getDay() === $dfdf4f8567e83d5d$var$SUN) add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(16, $dfdf4f8567e83d5d$var$ADAR_II, year), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).PURIM_MESHULASH, $dfdf4f8567e83d5d$var$MINOR_HOLIDAY));
    if ((0, $e7dd728d9f060a75$export$8f4940fd510e0848).isLeapYear(year)) {
        add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(14, $dfdf4f8567e83d5d$var$ADAR_I, year), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).PURIM_KATAN, $dfdf4f8567e83d5d$var$MINOR_HOLIDAY, {
            emoji: "\uD83C\uDFAD\uFE0F"
        }));
        add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(15, $dfdf4f8567e83d5d$var$ADAR_I, year), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).SHUSHAN_PURIM_KATAN, $dfdf4f8567e83d5d$var$MINOR_HOLIDAY, {
            emoji: "\uD83C\uDFAD\uFE0F"
        }));
    }
    const nisan27dt = (0, $cd0ad1d107f7c8fc$export$c848f93eb5738d4f)(year);
    if (nisan27dt) add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(nisan27dt, (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).YOM_HASHOAH, $dfdf4f8567e83d5d$var$MODERN_HOLIDAY));
    const yomHaZikaronDt = (0, $cd0ad1d107f7c8fc$export$8ada79b1d52d505d)(year);
    if (yomHaZikaronDt) add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(yomHaZikaronDt, (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).YOM_HAZIKARON, $dfdf4f8567e83d5d$var$MODERN_HOLIDAY, $dfdf4f8567e83d5d$var$emojiIsraelFlag), new (0, $35e955bca89ef86b$export$a950670998c93dc)(yomHaZikaronDt.next(), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).YOM_HAATZMA_UT, $dfdf4f8567e83d5d$var$MODERN_HOLIDAY, $dfdf4f8567e83d5d$var$emojiIsraelFlag));
    for (const h of (0, $cf7ca2f841f82e34$export$93a085f73ed96ba6))if (year >= h.firstYear) {
        let hd = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(h.dd, h.mm, year);
        const dow = hd.getDay();
        if (h.friSatMovetoThu && (dow === $dfdf4f8567e83d5d$var$FRI || dow === $dfdf4f8567e83d5d$var$SAT)) hd = hd.onOrBefore($dfdf4f8567e83d5d$var$THU);
        else if (h.friPostponeToSun && dow === $dfdf4f8567e83d5d$var$FRI) hd = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(hd.abs() + 2);
        else if (h.satPostponeToSun && dow === $dfdf4f8567e83d5d$var$SAT) hd = hd.next();
        const mask = h.chul ? $dfdf4f8567e83d5d$var$MODERN_HOLIDAY : $dfdf4f8567e83d5d$var$MODERN_HOLIDAY | $dfdf4f8567e83d5d$var$IL_ONLY;
        const ev = new (0, $35e955bca89ef86b$export$a950670998c93dc)(hd, h.desc, mask);
        if (!h.suppressEmoji) ev.emoji = "\uD83C\uDDEE\uD83C\uDDF1";
        add(ev);
    }
    let tamuz17 = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(17, $dfdf4f8567e83d5d$var$TAMUZ, year);
    let tamuz17attrs;
    if (tamuz17.getDay() === $dfdf4f8567e83d5d$var$SAT) {
        tamuz17 = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(18, $dfdf4f8567e83d5d$var$TAMUZ, year);
        tamuz17attrs = {
            observed: true
        };
    }
    add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(tamuz17, (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).TZOM_TAMMUZ, $dfdf4f8567e83d5d$var$MINOR_FAST, tamuz17attrs));
    let av9dt = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(9, $dfdf4f8567e83d5d$var$AV, year);
    let av9title = (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).TISHA_BAV;
    let av9attrs;
    if (av9dt.getDay() === $dfdf4f8567e83d5d$var$SAT) {
        av9dt = av9dt.next();
        av9attrs = {
            observed: true
        };
        av9title += ' (observed)';
    }
    const av9abs = av9dt.abs();
    add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)((0, $e7dd728d9f060a75$export$8f4940fd510e0848).dayOnOrBefore($dfdf4f8567e83d5d$var$SAT, av9abs)), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).SHABBAT_CHAZON, $dfdf4f8567e83d5d$var$SPECIAL_SHABBAT), new (0, $35e955bca89ef86b$export$a950670998c93dc)(av9dt.prev(), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).EREV_TISHA_BAV, $dfdf4f8567e83d5d$var$EREV | $dfdf4f8567e83d5d$var$MAJOR_FAST, av9attrs), new (0, $35e955bca89ef86b$export$a950670998c93dc)(av9dt, av9title, $dfdf4f8567e83d5d$var$MAJOR_FAST, av9attrs), new (0, $35e955bca89ef86b$export$a950670998c93dc)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)((0, $e7dd728d9f060a75$export$8f4940fd510e0848).dayOnOrBefore($dfdf4f8567e83d5d$var$SAT, av9abs + 7)), (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).SHABBAT_NACHAMU, $dfdf4f8567e83d5d$var$SPECIAL_SHABBAT));
    const monthsInYear = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).monthsInYear(year);
    for(let month = 1; month <= monthsInYear; month++){
        const monthName = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).getMonthName(month, year);
        if ((month === $dfdf4f8567e83d5d$var$NISAN ? (0, $e7dd728d9f060a75$export$8f4940fd510e0848).daysInMonth((0, $e7dd728d9f060a75$export$8f4940fd510e0848).monthsInYear(year - 1), year - 1) : (0, $e7dd728d9f060a75$export$8f4940fd510e0848).daysInMonth(month - 1, year)) === 30) {
            add(new (0, $35e955bca89ef86b$export$244411573148d53)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(1, month, year), monthName));
            add(new (0, $35e955bca89ef86b$export$244411573148d53)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(30, month - 1, year), monthName));
        } else if (month !== $dfdf4f8567e83d5d$var$TISHREI) add(new (0, $35e955bca89ef86b$export$244411573148d53)(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(1, month, year), monthName));
    }
    // Begin: Yom Kippur Katan
    // start at Iyyar because one may not fast during Nisan
    for(let month = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).IYYAR; month <= monthsInYear; month++){
        const nextMonth = month + 1;
        // Yom Kippur Katan is not observed on the day before Rosh Hashanah.
        // Not observed prior to Rosh Chodesh Cheshvan because Yom Kippur has just passed.
        // Not observed before Rosh Chodesh Tevet, because that day is Hanukkah.
        if (nextMonth === $dfdf4f8567e83d5d$var$TISHREI || nextMonth === (0, $0118a895d65cebcc$export$16352d1b10c5eb38).CHESHVAN || nextMonth === $dfdf4f8567e83d5d$var$TEVET) continue;
        let ykk = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(29, month, year);
        const dow = ykk.getDay();
        if (dow === $dfdf4f8567e83d5d$var$FRI || dow === $dfdf4f8567e83d5d$var$SAT) ykk = ykk.onOrBefore($dfdf4f8567e83d5d$var$THU);
        const nextMonthName = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).getMonthName(nextMonth, year);
        const ev = new (0, $bce974a4116d897b$export$232a5be06b932145)(ykk, nextMonthName);
        add(ev);
    }
    const sedra = (0, $16a8384bbc778702$export$46dd3945618c9426)(year, false);
    const beshalachHd = sedra.find(15);
    add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(beshalachHd, (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).SHABBAT_SHIRAH, $dfdf4f8567e83d5d$var$SPECIAL_SHABBAT));
    // Birkat Hachamah appears only once every 28 years
    const birkatHaChama = $dfdf4f8567e83d5d$var$getBirkatHaChama(year);
    if (birkatHaChama) {
        const hd = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(birkatHaChama);
        add(new (0, $35e955bca89ef86b$export$a950670998c93dc)(hd, (0, $cf7ca2f841f82e34$export$bdd04469d771cf34).BIRKAT_HACHAMAH, $dfdf4f8567e83d5d$var$MINOR_HOLIDAY, {
            emoji: "\u2600\uFE0F"
        }));
    }
    $dfdf4f8567e83d5d$var$yearCache.set(year, map);
    return map;
}
/**
 * Birkat Hachamah appears only once every 28 years.
 * Although almost always in Nisan, it can occur in Adar II.
 *   - 27 Adar II 5461 (Gregorian year 1701)
 *   - 29 Adar II 5993 (Gregorian year 2233)
 *
 * Due to drift, this will eventually slip into Iyyar
 *   - 2 Iyyar 7141 (Gregorian year 3381)
 * @private
 */ function $dfdf4f8567e83d5d$var$getBirkatHaChama(year) {
    const leap = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).isLeapYear(year);
    const startMonth = leap ? $dfdf4f8567e83d5d$var$ADAR_II : $dfdf4f8567e83d5d$var$NISAN;
    const startDay = leap ? 20 : 1;
    const baseRd = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).hebrew2abs(year, startMonth, startDay);
    for(let day = 0; day <= 40; day++){
        const abs = baseRd + day;
        const elapsed = abs + 1373429;
        if (elapsed % 10227 === 172) return abs;
    }
    return 0;
}
/**
 * Returns an array of holidays for the year
 * @param year Hebrew year
 * @param il use the Israeli schedule for holidays
 */ function $dfdf4f8567e83d5d$export$50bc37b07e957528(year, il) {
    const yearMap = $dfdf4f8567e83d5d$export$1783645bc1165a67(year);
    const startAbs = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).hebrew2abs(year, $dfdf4f8567e83d5d$var$TISHREI, 1);
    const endAbs = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).hebrew2abs(year + 1, $dfdf4f8567e83d5d$var$TISHREI, 1) - 1;
    let events = [];
    const myFilter = il ? $dfdf4f8567e83d5d$var$observedInIsrael : $dfdf4f8567e83d5d$var$observedInDiaspora;
    for(let absDt = startAbs; absDt <= endAbs; absDt++){
        const hd = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(absDt);
        const holidays = yearMap.get(hd.toString());
        if (holidays) {
            const filtered = holidays.filter(myFilter);
            events = events.concat(filtered);
        }
    }
    return events;
}


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 



const $dce2c5f9248cc8c1$var$mevarchimChodeshStr = 'Shabbat Mevarchim Chodesh';
/** Represents Mevarchim haChodesh, the announcement of the new month */ class $dce2c5f9248cc8c1$export$d672f969e07f065b extends (0, $439631353957c387$export$d61e24a684f9e51) {
    /**
     * Constructs Mevarchim haChodesh event
     * @param date Hebrew date event occurs
     * @param monthName Hebrew month name (not translated)
     * @param [memo]
     */ constructor(date, monthName, memo){
        super(date, `${$dce2c5f9248cc8c1$var$mevarchimChodeshStr} ${monthName}`, (0, $439631353957c387$export$ceac1d294cf61000).SHABBAT_MEVARCHIM);
        this.monthName = monthName;
        if (memo) this.memo = memo;
        else {
            const hyear = date.getFullYear();
            const hmonth = date.getMonth();
            const monNext = hmonth === (0, $e7dd728d9f060a75$export$8f4940fd510e0848).monthsInYear(hyear) ? (0, $0118a895d65cebcc$export$16352d1b10c5eb38).NISAN : hmonth + 1;
            const molad = new (0, $c73aa37de5a0c175$export$6240c2e81a7cb858)(hyear, monNext);
            this.memo = molad.render('en', {
                hour12: false
            });
        }
    }
    basename() {
        return this.getDesc();
    }
    /**
     * Returns (translated) description of this event
     * @param [locale] Optional locale name (defaults to active locale).
     */ render(locale) {
        const monthName0 = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext(this.monthName, locale);
        const monthName = monthName0.replace(/'/g, "\u2019");
        return (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).gettext($dce2c5f9248cc8c1$var$mevarchimChodeshStr, locale) + ' ' + monthName;
    }
    /**
     * Returns (translated) description of this event
     * @param [locale] Optional locale name (defaults to active locale).
     */ renderBrief(locale) {
        const str = this.render(locale);
        const space = str.indexOf(' ');
        return str.substring(space + 1);
    }
}




/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ const $e29b38910ce1f1c9$var$cals = new Map();
/**
 * Plug-ins for daily learning calendars such as Daf Yomi, Mishna Yomi, Nach Yomi, etc.
 *
 * Learning schedules are provided by the `@hebcal/learning` package.
 */ class $e29b38910ce1f1c9$export$e03d32857f8fc133 {
    /**
     * Register a new learning calendar.
     * @param name case insensitive
     * @param calendar a function that returns an `Event` or `null`
     * @param startDate the first date for which this calendar is valid
     */ static addCalendar(name, calendar, startDate) {
        if (typeof calendar !== 'function') throw new TypeError(`Invalid calendar function: ${calendar}`);
        $e29b38910ce1f1c9$var$cals.set(name.toLowerCase(), {
            fn: calendar,
            startDate: startDate
        });
    }
    /**
     * Returns an event from daily calendar for a given date. Returns `null` if there
     * is no learning from this calendar on this date.
     * @param name case insensitive
     * @param hd Hebrew Date
     * @param il true for Israel, false for Diaspora
     */ static lookup(name, hd, il) {
        const cal = $e29b38910ce1f1c9$var$cals.get(name.toLowerCase());
        if (typeof cal === 'object') return cal.fn(hd, il);
        return null;
    }
    static getStartDate(name) {
        const cal = $e29b38910ce1f1c9$var$cals.get(name.toLowerCase());
        if (typeof cal === 'object') return cal.startDate;
        return undefined;
    }
    /**
     * Tests to see if learning calendar has been registered
     * @param name case insensitive
     */ static has(name) {
        return $e29b38910ce1f1c9$var$cals.has(name.toLowerCase());
    }
    /** Returns the names of all calendars registered */ static getCalendars() {
        return Array.from($e29b38910ce1f1c9$var$cals.keys());
    }
}


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 




/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 

const $76848cb7ff12d4f2$var$NONE = 0;
const $76848cb7ff12d4f2$var$HALF = 1;
const $76848cb7ff12d4f2$var$WHOLE = 2;
/**
 * @private
 */ function $76848cb7ff12d4f2$export$f2738d08858f50af(events, hdate) {
    const whole = events.filter((ev)=>{
        const desc = ev.getDesc();
        const hd = ev.getDate();
        const month = hd.getMonth();
        const mday = hd.getDate();
        return desc.startsWith('Chanukah') || desc.startsWith('Shavuot') || desc.startsWith('Sukkot') || month === (0, $0118a895d65cebcc$export$16352d1b10c5eb38).NISAN && (mday === 15 || mday === 16) && ev.getFlags() & (0, $439631353957c387$export$ceac1d294cf61000).CHAG || // Pesach
        desc === "Yom HaAtzma'ut" || desc === 'Yom Yerushalayim';
    }).map((ev)=>{
        return ev.getDate().abs();
    });
    const abs = hdate.abs();
    if (whole.includes(abs)) return $76848cb7ff12d4f2$var$WHOLE;
    const half = events.filter((ev)=>{
        const desc = ev.getDesc();
        return ev.getFlags() & (0, $439631353957c387$export$ceac1d294cf61000).ROSH_CHODESH || desc.startsWith('Pesach') && desc !== 'Pesach I' && desc !== 'Pesach II';
    }).map((ev)=>{
        return ev.getDate().abs();
    });
    if (half.includes(abs)) return $76848cb7ff12d4f2$var$HALF;
    return $76848cb7ff12d4f2$var$NONE;
}




/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 

function $f106ded439541295$var$range(start, end) {
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
}
const $f106ded439541295$var$NONE = {
    shacharit: false,
    mincha: false,
    allCongs: false
};
/**
 * Return details on what Tachanun (or Tzidchatcha on Shabbat) is said on `hdate`.
 *
 * Tachanun is not said on Rosh Chodesh, the month of Nisan, Lag Baomer,
 * Rosh Chodesh Sivan until Isru Chag, Tisha B'av, 15 Av, Erev Rosh Hashanah,
 * Rosh Hashanah, Erev Yom Kippur until after Simchat Torah, Chanukah,
 * Tu B'shvat, Purim and Shushan Purim, and Purim and Shushan Purim Katan.
 *
 * In some congregations Tachanun is not said until from Rosh Chodesh Sivan
 * until 14th Sivan, Sukkot until after Rosh Chodesh Cheshvan, Pesach Sheini,
 * Yom Ha'atzmaut, and Yom Yerushalayim.
 *
 * Tachanun is not said at Mincha on days before it is not said at Shacharit.
 *
 * Tachanun is not said at Shacharit on Shabbat, but is at Mincha, usually.
 */ function $f106ded439541295$export$a7ebc0487bc516c5(hdate, il) {
    return $f106ded439541295$var$tachanun0(hdate, il, true);
}
function $f106ded439541295$var$tachanun0(hdate, il, checkNext) {
    const year = hdate.yy;
    const dates = $f106ded439541295$var$tachanunYear(year, il);
    const abs = hdate.abs();
    if (dates.none.indexOf(abs) > -1) return $f106ded439541295$var$NONE;
    const dow = hdate.getDay();
    const ret = {
        shacharit: false,
        mincha: false,
        allCongs: false
    };
    if (dates.some.indexOf(abs) === -1) ret.allCongs = true;
    if (dow !== 6) ret.shacharit = true;
    const tomorrow = abs + 1;
    if (checkNext && dates.yesPrev.indexOf(tomorrow) === -1) {
        const tmp = $f106ded439541295$var$tachanun0(new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(tomorrow), il, false);
        ret.mincha = tmp.shacharit;
    } else ret.mincha = dow !== 5;
    if (ret.allCongs && !ret.mincha && !ret.shacharit) return $f106ded439541295$var$NONE;
    return ret;
}
function $f106ded439541295$var$tachanunYear(year, il) {
    const leap = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).isLeapYear(year);
    const monthsInYear = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).monthsInYear(year);
    let av9dt = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(9, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).AV, year);
    if (av9dt.getDay() === 6) av9dt = av9dt.next();
    let shushPurim = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(15, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ADAR_II, year);
    if (shushPurim.getDay() === 6) shushPurim = shushPurim.next();
    const none = [
        new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(2, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TISHREI, year)
    ].concat(// Rosh Chodesh - 1st of every month. Also includes RH day 1 (1 Tishrei)
    $f106ded439541295$var$range(1, monthsInYear).map((month)=>new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(1, month, year)), // Rosh Chodesh - 30th of months that have one
    $f106ded439541295$var$range(1, monthsInYear).filter((month)=>(0, $e7dd728d9f060a75$export$8f4940fd510e0848).daysInMonth(month, year) === 30).map((month)=>new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(30, month, year)), // entire month of Nisan
    $f106ded439541295$var$range(1, (0, $e7dd728d9f060a75$export$8f4940fd510e0848).daysInMonth((0, $0118a895d65cebcc$export$16352d1b10c5eb38).NISAN, year)).map((mday)=>new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(mday, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).NISAN, year)), new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(18, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).IYYAR, year), // Rosh Chodesh Sivan thru Isru Chag
    $f106ded439541295$var$range(1, 8 - (il ? 1 : 0)).map((mday)=>new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(mday, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).SIVAN, year)), av9dt, new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(15, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).AV, year), new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(29, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ELUL, year), // Erev Yom Kippur thru Isru Chag
    $f106ded439541295$var$range(9, 24 - (il ? 1 : 0)).map((mday)=>new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(mday, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TISHREI, year)), // Chanukah
    $f106ded439541295$var$range(25, 33).map((mday)=>new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(mday, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).KISLEV, year)), new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(15, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).SHVAT, year), new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(14, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ADAR_II, year), shushPurim, leap ? new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(14, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ADAR_I, year) : [] // Purim Katan
    );
    const some = [
        new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(14, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).IYYAR, year)
    ].concat(// Until 14 Sivan
    $f106ded439541295$var$range(1, 13).map((mday)=>new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(mday, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).SIVAN, year)), // Until after Rosh Chodesh Cheshvan
    $f106ded439541295$var$range(20, 31).map((mday)=>new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(mday, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TISHREI, year)), // Yom HaAtzma'ut, which changes based on day of week
    year >= 5708 ? (0, $cd0ad1d107f7c8fc$export$8ada79b1d52d505d)(year).next() : [], // Yom Yerushalayim
    year >= 5727 ? new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(28, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).IYYAR, year) : []);
    const yesPrev = [
        new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(29, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ELUL, year - 1),
        new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(9, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TISHREI, year),
        new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(14, (0, $0118a895d65cebcc$export$16352d1b10c5eb38).IYYAR, year)
    ];
    return {
        none: none.map((hd)=>hd.abs()).sort((a, b)=>a - b),
        some: some.map((hd)=>hd.abs()).sort((a, b)=>a - b),
        yesPrev: yesPrev.map((hd)=>hd.abs()).sort((a, b)=>a - b)
    };
}


/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 



/*! @hebcal/core v5.9.0, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */ 
const $21086e9a113bef08$var$TISHREI = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TISHREI;
/**
 * Gets the R.D. days for a number, Date, or HDate
 * @private
 */ function $21086e9a113bef08$var$getAbs(d) {
    if (typeof d === 'number') return d;
    if ((0, $95162f6f50e12e59$export$871608497c498473)(d)) return (0, $95162f6f50e12e59$export$5562ed62796cf6a1)(d);
    if ((0, $e7dd728d9f060a75$export$8f4940fd510e0848).isHDate(d)) return d.abs();
    throw new TypeError(`Invalid date type: ${d}`);
}
function $21086e9a113bef08$var$getYear(options) {
    if (typeof options.year !== 'undefined') return Number(options.year);
    return options.isHebrewYear ? new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)().getFullYear() : new Date().getFullYear();
}
/**
 * Parse options object to determine start & end days
 * @private
 */ function $21086e9a113bef08$export$ec0ef97391c7ee61(options) {
    if (options.start && !options.end || options.end && !options.start) throw new TypeError('Both options.start and options.end are required');
    else if (options.start && options.end) return [
        $21086e9a113bef08$var$getAbs(options.start),
        $21086e9a113bef08$var$getAbs(options.end)
    ];
    const isHebrewYear = Boolean(options.isHebrewYear);
    const theYear = $21086e9a113bef08$var$getYear(options);
    if (isNaN(theYear)) throw new RangeError(`Invalid year ${options.year}`);
    else if (isHebrewYear && theYear < 1) throw new RangeError(`Invalid Hebrew year ${theYear}`);
    const theMonth = $21086e9a113bef08$var$getMonth(options);
    const numYears = Number(options.numYears) || 1;
    if (isHebrewYear) return $21086e9a113bef08$var$startEndHebrew(theMonth, theYear, numYears);
    else return $21086e9a113bef08$var$startEndGregorian(theMonth, theYear, numYears);
}
function $21086e9a113bef08$var$getMonth(options) {
    if (options.month) {
        if (options.isHebrewYear) return (0, $e7dd728d9f060a75$export$8f4940fd510e0848).monthNum(options.month);
        else if (typeof options.month === 'number') return options.month;
    }
    return NaN;
}
function $21086e9a113bef08$var$startEndGregorian(theMonth, theYear, numYears) {
    const gregMonth = theMonth ? theMonth - 1 : 0;
    const startGreg = new Date(theYear, gregMonth, 1);
    if (theYear < 100) startGreg.setFullYear(theYear);
    const startAbs = (0, $95162f6f50e12e59$export$5562ed62796cf6a1)(startGreg);
    let endAbs;
    if (theMonth) endAbs = startAbs + (0, $95162f6f50e12e59$export$f7b5f2637d35d70d)(theMonth, theYear) - 1;
    else {
        const endYear = theYear + numYears;
        const endGreg = new Date(endYear, 0, 1);
        if (endYear < 100) endGreg.setFullYear(endYear);
        endAbs = (0, $95162f6f50e12e59$export$5562ed62796cf6a1)(endGreg) - 1;
    }
    return [
        startAbs,
        endAbs
    ];
}
function $21086e9a113bef08$var$startEndHebrew(theMonth, theYear, numYears) {
    const startDate = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(1, theMonth || $21086e9a113bef08$var$TISHREI, theYear);
    let startAbs = startDate.abs();
    const endAbs = theMonth ? startAbs + startDate.daysInMonth() : new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(1, $21086e9a113bef08$var$TISHREI, theYear + numYears).abs() - 1;
    // for full Hebrew year, start on Erev Rosh Hashana which
    // is technically in the previous Hebrew year
    // (but conveniently lets us get candle-lighting time for Erev)
    if (!theMonth && theYear > 1) startAbs--;
    return [
        startAbs,
        endAbs
    ];
}













/**
 * Calculates holidays and other Hebrew calendar events based on {@link CalOptions}.
 *
 * Each holiday is represented by an {@link Event} object which includes a date,
 * a description, flags and optional attributes.
 * If given no options, returns holidays for the Diaspora for the current Gregorian year.
 *
 * The date range returned by this function can be controlled by:
 * * `options.year` - Gregorian (e.g. 1993) or Hebrew year (e.g. 5749)
 * * `options.isHebrewYear` - to interpret `year` as Hebrew year
 * * `options.numYears` - generate calendar for multiple years (default 1)
 * * `options.month` - Gregorian or Hebrew month (to filter results to a single month)
 *
 * Alternatively, specify start and end days with `Date` or {@link HDate} instances:
 * * `options.start` - use specific start date (requires `end` date)
 * * `options.end` - use specific end date (requires `start` date)
 *
 * Unless `options.noHolidays == true`, default holidays include:
 * * Major holidays - Rosh Hashana, Yom Kippur, Pesach, Sukkot, etc.
 * * Minor holidays - Purim, Chanukah, Tu BiShvat, Lag BaOmer, etc.
 * * Minor fasts - Ta'anit Esther, Tzom Gedaliah, etc. (unless `options.noMinorFast`)
 * * Special Shabbatot - Shabbat Shekalim, Zachor, etc. (unless `options.noSpecialShabbat`)
 * * Modern Holidays - Yom HaShoah, Yom HaAtzma'ut, etc. (unless `options.noModern`)
 * * Rosh Chodesh (unless `options.noRoshChodesh`)
 *
 * Holiday and Torah reading schedules differ between Israel and the Disapora.
 * Set `options.il=true` to use the Israeli schedule.
 *
 * Additional non-default event types can be specified:
 * * Parashat HaShavua - weekly Torah Reading on Saturdays (`options.sedrot`)
 * * Counting of the Omer (`options.omer`)
 * * Shabbat Mevarchim HaChodesh on Saturday before Rosh Chodesh (`options.shabbatMevarchim`)
 * * Molad announcement on Saturday before Rosh Chodesh (`options.molad`)
 * * Yom Kippur Katan (`options.yomKippurKatan`)
 * * Yizkor (`options.yizkor`)
 *
 * Daily Study of texts are supported by the
 * {@link https://github.com/hebcal/hebcal-learning @hebcal/learning} package,
 * for example:
 * * Babylonian Talmud Daf Yomi (`options.dailyLearning.dafYomi`)
 * * Jerusalem Talmud (Yerushalmi) Yomi (`options.dailyLearning.yerushalmi`)
 * * Mishna Yomi (`options.dailyLearning.mishnaYomi`)
 * * Nach Yomi (`options.dailyLearning.nachYomi`)
 *
 * Candle-lighting and Havdalah times are approximated using latitude and longitude
 * specified by the {@link Location} class. The `Location` class contains a small
 * database of cities with their associated geographic information and time-zone information.
 * If you ever have any doubts about Hebcal's times, consult your local halachic authority.
 * If you enter geographic coordinates above the arctic circle or antarctic circle,
 * the times are guaranteed to be wrong.
 *
 * To add candle-lighting options, set `options.candlelighting=true` and set
 * `options.location` to an instance of `Location`. By default, candle lighting
 * time is 18 minutes before sundown (40 minutes for Jerusalem,
 * 30 minutes for Haifa and Zikhron Ya'akov) and Havdalah is
 * calculated according to Tzeit Hakochavim - Nightfall (the point when 3 small stars
 * are observable in the night time sky with the naked eye). The default Havdalah
 * option (Tzeit Hakochavim) is calculated when the sun is 8.5° below the horizon.
 * These defaults can be changed using these options:
 * * `options.candleLightingMins` - minutes before sundown to light candles
 * * `options.havdalahMins` - minutes after sundown for Havdalah (typical values are 42, 50, or 72).
 *    Havdalah times are suppressed when `options.havdalahMins=0`.
 * * `options.havdalahDeg` - degrees for solar depression for Havdalah.
 *    Default is 8.5 degrees for 3 small stars. Use 7.083 degrees for 3 medium-sized stars.
 *    Havdalah times are suppressed when `options.havdalahDeg=0`.
 *
 * If both `options.candlelighting=true` and `options.location` is specified,
 * Chanukah candle-lighting times and minor fast start/end times will also be generated.
 * Chanukah candle-lighting is at Bein HaShmashos (13.5 minutes before
 * the sun is 7.083° below the horizon in the evening)
 * on weekdays, at regular candle-lighting time on Fridays, and at regular Havdalah time on
 * Saturday night (see above).
 *
 * Minor fasts begin at Alot HaShachar (sun is 16.1° below the horizon in the morning) and
 * end when 3 medium-sized stars are observable in the night sky (sun is 7.083° below the horizon
 * in the evening).
 *
 * Two options also exist for generating an Event with the Hebrew date:
 * * `options.addHebrewDates` - print the Hebrew date for the entire date range
 * * `options.addHebrewDatesForEvents` - print the Hebrew date for dates with some events
 *
 * Lastly, translation and transliteration of event titles is controlled by
 * `options.locale` and the {@link Locale} API.
 * `@hebcal/core` supports three locales by default:
 * * `en` - default, Sephardic transliterations (e.g. "Shabbat")
 * * `ashkenazi` - Ashkenazi transliterations (e.g. "Shabbos")
 * * `he` - Hebrew (e.g. "שַׁבָּת")
 *
 * Additional locales (such as `ru` or `fr`) are supported by the
 * {@link https://github.com/hebcal/hebcal-locales @hebcal/locales} package
 *
 * @example
 * import {HebrewCalendar, HDate, Location, Event} from '@hebcal/core';
 * const options: CalOptions = {
 *   year: 1981,
 *   isHebrewYear: false,
 *   candlelighting: true,
 *   location: Location.lookup('San Francisco'),
 *   sedrot: true,
 *   omer: true,
 * };
 * const events = HebrewCalendar.calendar(options);
 * for (const ev of events) {
 *   const hd = ev.getDate();
 *   const date = hd.greg();
 *   console.log(date.toLocaleDateString(), ev.render('en'), hd.toString());
 * }
 */ function $7ae6ee87b7df885d$export$56bbcdb8aca31149(options = {}) {
    options = Object.assign({}, options); // so we can modify freely
    $7ae6ee87b7df885d$var$checkCandleOptions(options);
    const location = options.location = options.location || $7ae6ee87b7df885d$var$defaultLocation;
    const il = options.il = options.il || location.getIsrael() || false;
    const hasUserMask = typeof options.mask === 'number';
    options.mask = $7ae6ee87b7df885d$var$getMaskFromOptions(options);
    if (options.ashkenazi || options.locale) {
        if (options.locale && typeof options.locale !== 'string') throw new TypeError(`Invalid options.locale: ${options.locale}`);
        const locale = options.ashkenazi ? 'ashkenazi' : options.locale;
        const translationObj = (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).useLocale(locale);
        if (!translationObj) throw new TypeError(`Locale '${locale}' not found; did you forget to import @hebcal/locales?`);
    } else (0, $1cde68ba834f0fa8$export$d4f428a61c37ddfa).useLocale('en');
    const evts = [];
    let sedra;
    let holidaysYear;
    let beginOmer = -1;
    let endOmer = -1;
    let currentYear = -1;
    const startAndEnd = (0, $21086e9a113bef08$export$ec0ef97391c7ee61)(options);
    $7ae6ee87b7df885d$var$warnUnrecognizedOptions(options);
    const startAbs = startAndEnd[0];
    const endAbs = startAndEnd[1];
    const startGreg = (0, $95162f6f50e12e59$export$fa5d0dc73ec17c41)(startAbs);
    if (startGreg.getFullYear() < 100) options.candlelighting = false;
    for(let abs = startAbs; abs <= endAbs; abs++){
        const hd = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(abs);
        const hyear = hd.getFullYear();
        if (hyear !== currentYear) {
            currentYear = hyear;
            holidaysYear = (0, $dfdf4f8567e83d5d$export$1783645bc1165a67)(currentYear);
            if (options.sedrot) sedra = (0, $16a8384bbc778702$export$46dd3945618c9426)(currentYear, il);
            if (options.omer) {
                beginOmer = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).hebrew2abs(currentYear, $7ae6ee87b7df885d$var$NISAN, 16);
                endOmer = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).hebrew2abs(currentYear, $7ae6ee87b7df885d$var$SIVAN, 5);
            }
        }
        const prevEventsLength = evts.length;
        const dow = hd.getDay();
        const isFriday = dow === $7ae6ee87b7df885d$var$FRI;
        const isSaturday = dow === $7ae6ee87b7df885d$var$SAT;
        let candlesEv;
        const holidays = holidaysYear.get(hd.toString()) || [];
        for (const ev of holidays)candlesEv = $7ae6ee87b7df885d$var$appendHolidayAndRelated(candlesEv, evts, ev, options, isFriday, isSaturday, hasUserMask);
        if (options.sedrot && isSaturday) {
            const parsha0 = sedra.lookup(abs);
            if (!parsha0.chag) evts.push(new (0, $5293135afc366466$export$eaf7b0b4ee904ad3)(hd, parsha0.parsha, il, parsha0.num));
        }
        if (options.yizkor) {
            const mm = hd.getMonth();
            const dd = hd.getDate();
            if (mm === (0, $0118a895d65cebcc$export$16352d1b10c5eb38).TISHREI && (dd === 10 || dd === 22) || mm === $7ae6ee87b7df885d$var$NISAN && dd === (il ? 21 : 22) || mm === $7ae6ee87b7df885d$var$SIVAN && dd === (il ? 6 : 7)) {
                const linkedEvent = holidays.filter((ev)=>ev.observedIn(il))[0];
                const ev = new (0, $439631353957c387$export$d61e24a684f9e51)(hd, 'Yizkor', (0, $439631353957c387$export$ceac1d294cf61000).YIZKOR, {
                    emoji: "\uD83D\uDD6F\uFE0F",
                    linkedEvent: linkedEvent
                });
                evts.push(ev);
            }
        }
        const dailyLearning = options.dailyLearning;
        if (typeof dailyLearning === 'object') {
            const events = $7ae6ee87b7df885d$var$makeDailyLearning(hd, dailyLearning, il);
            evts.push(...events);
        }
        if (options.omer && abs >= beginOmer && abs <= endOmer) {
            const omer = abs - beginOmer + 1;
            const omerEv = $7ae6ee87b7df885d$var$makeOmerEvent(hd, omer, options);
            evts.push(omerEv);
        }
        if (isSaturday && (options.molad || options.shabbatMevarchim)) {
            const events = $7ae6ee87b7df885d$var$makeMoladAndMevarchimChodesh(hd, options);
            evts.push(...events);
        }
        if (!candlesEv && options.candlelighting && (isFriday || isSaturday)) {
            candlesEv = (0, $ae9f09b8aafe32c5$export$647eb1e9aafe5fcd)(undefined, hd, options, isFriday, isSaturday);
            if (isFriday && candlesEv && sedra) {
                const parsha = sedra.lookup(abs);
                const pe = new (0, $5293135afc366466$export$eaf7b0b4ee904ad3)(hd.next(), parsha.parsha, il, parsha.num);
                candlesEv.memo = pe.render(options.locale);
            }
        }
        // suppress Havdalah when options.havdalahMins=0 or options.havdalahDeg=0
        if (candlesEv instanceof (0, $f048777e58045d14$export$3cc96e2f983407bc) && (options.havdalahMins === 0 || options.havdalahDeg === 0)) candlesEv = undefined;
        if (candlesEv) evts.push(candlesEv);
        if (options.addHebrewDates || options.addHebrewDatesForEvents && prevEventsLength !== evts.length) {
            const e2 = new (0, $c280aa2ce5054669$export$8b3ae31ab70ccff2)(hd);
            if (prevEventsLength === evts.length) evts.push(e2);
            else evts.splice(prevEventsLength, 0, e2);
        }
    }
    return evts;
}
const $7ae6ee87b7df885d$var$FRI = 5;
const $7ae6ee87b7df885d$var$SAT = 6;
const $7ae6ee87b7df885d$var$NISAN = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).NISAN;
const $7ae6ee87b7df885d$var$SIVAN = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).SIVAN;
const $7ae6ee87b7df885d$var$ELUL = (0, $0118a895d65cebcc$export$16352d1b10c5eb38).ELUL;
const $7ae6ee87b7df885d$var$LIGHT_CANDLES = (0, $439631353957c387$export$ceac1d294cf61000).LIGHT_CANDLES;
const $7ae6ee87b7df885d$var$YOM_TOV_ENDS = (0, $439631353957c387$export$ceac1d294cf61000).YOM_TOV_ENDS;
const $7ae6ee87b7df885d$var$CHUL_ONLY = (0, $439631353957c387$export$ceac1d294cf61000).CHUL_ONLY;
const $7ae6ee87b7df885d$var$IL_ONLY = (0, $439631353957c387$export$ceac1d294cf61000).IL_ONLY;
const $7ae6ee87b7df885d$var$LIGHT_CANDLES_TZEIS = (0, $439631353957c387$export$ceac1d294cf61000).LIGHT_CANDLES_TZEIS;
const $7ae6ee87b7df885d$var$CHANUKAH_CANDLES = (0, $439631353957c387$export$ceac1d294cf61000).CHANUKAH_CANDLES;
const $7ae6ee87b7df885d$var$MINOR_FAST = (0, $439631353957c387$export$ceac1d294cf61000).MINOR_FAST;
const $7ae6ee87b7df885d$var$SPECIAL_SHABBAT = (0, $439631353957c387$export$ceac1d294cf61000).SPECIAL_SHABBAT;
const $7ae6ee87b7df885d$var$MODERN_HOLIDAY = (0, $439631353957c387$export$ceac1d294cf61000).MODERN_HOLIDAY;
const $7ae6ee87b7df885d$var$MAJOR_FAST = (0, $439631353957c387$export$ceac1d294cf61000).MAJOR_FAST;
const $7ae6ee87b7df885d$var$ROSH_CHODESH = (0, $439631353957c387$export$ceac1d294cf61000).ROSH_CHODESH;
const $7ae6ee87b7df885d$var$PARSHA_HASHAVUA = (0, $439631353957c387$export$ceac1d294cf61000).PARSHA_HASHAVUA;
const $7ae6ee87b7df885d$var$DAF_YOMI = (0, $439631353957c387$export$ceac1d294cf61000).DAF_YOMI;
const $7ae6ee87b7df885d$var$MISHNA_YOMI = (0, $439631353957c387$export$ceac1d294cf61000).MISHNA_YOMI;
const $7ae6ee87b7df885d$var$NACH_YOMI = (0, $439631353957c387$export$ceac1d294cf61000).NACH_YOMI;
const $7ae6ee87b7df885d$var$YERUSHALMI_YOMI = (0, $439631353957c387$export$ceac1d294cf61000).YERUSHALMI_YOMI;
const $7ae6ee87b7df885d$var$OMER_COUNT = (0, $439631353957c387$export$ceac1d294cf61000).OMER_COUNT;
const $7ae6ee87b7df885d$var$SHABBAT_MEVARCHIM = (0, $439631353957c387$export$ceac1d294cf61000).SHABBAT_MEVARCHIM;
const $7ae6ee87b7df885d$var$MINOR_HOLIDAY = (0, $439631353957c387$export$ceac1d294cf61000).MINOR_HOLIDAY;
const $7ae6ee87b7df885d$var$EREV = (0, $439631353957c387$export$ceac1d294cf61000).EREV;
const $7ae6ee87b7df885d$var$CHOL_HAMOED = (0, $439631353957c387$export$ceac1d294cf61000).CHOL_HAMOED;
const $7ae6ee87b7df885d$var$YOM_KIPPUR_KATAN = (0, $439631353957c387$export$ceac1d294cf61000).YOM_KIPPUR_KATAN;
const $7ae6ee87b7df885d$var$YIZKOR = (0, $439631353957c387$export$ceac1d294cf61000).YIZKOR;
const $7ae6ee87b7df885d$var$unrecognizedAlreadyWarned = new Set();
const $7ae6ee87b7df885d$var$RECOGNIZED_OPTIONS = {
    location: 1,
    year: 1,
    isHebrewYear: 1,
    month: 1,
    numYears: 1,
    start: 1,
    end: 1,
    candlelighting: 1,
    candleLightingMins: 1,
    havdalahMins: 1,
    havdalahDeg: 1,
    fastEndDeg: 1,
    sedrot: 1,
    il: 1,
    noMinorFast: 1,
    noModern: 1,
    shabbatMevarchim: 1,
    noRoshChodesh: 1,
    noSpecialShabbat: 1,
    noHolidays: 1,
    omer: 1,
    molad: 1,
    ashkenazi: 1,
    locale: 1,
    addHebrewDates: 1,
    addHebrewDatesForEvents: 1,
    mask: 1,
    yomKippurKatan: 1,
    hour12: 1,
    dailyLearning: 1,
    useElevation: 1,
    yizkor: 1
};
/**
 * @private
 */ function $7ae6ee87b7df885d$var$warnUnrecognizedOptions(options) {
    for (const k of Object.keys(options))if (typeof $7ae6ee87b7df885d$var$RECOGNIZED_OPTIONS[k] === 'undefined' && !$7ae6ee87b7df885d$var$unrecognizedAlreadyWarned.has(k)) {
        console.warn(`Ignoring unrecognized HebrewCalendar option: ${k}`);
        $7ae6ee87b7df885d$var$unrecognizedAlreadyWarned.add(k);
    }
    if (options.dailyLearning) {
        for (const k of Object.keys(options.dailyLearning))if (!$7ae6ee87b7df885d$var$unrecognizedAlreadyWarned.has(k) && !(0, $e29b38910ce1f1c9$export$e03d32857f8fc133).has(k)) {
            console.warn(`Ignoring unrecognized DailyLearning calendar: ${k}`);
            $7ae6ee87b7df885d$var$unrecognizedAlreadyWarned.add(k);
        }
    }
}
const $7ae6ee87b7df885d$var$israelCityOffset = {
    Jerusalem: 40,
    Haifa: 30,
    "Zikhron Ya'aqov": 30,
    "Zikhron Ya'akov": 30,
    'Zikhron Yaakov': 30,
    "Zichron Ya'akov": 30,
    'Zichron Yaakov': 30
};
const $7ae6ee87b7df885d$var$geoIdCandleOffset = {
    '281184': 40,
    '294801': 30,
    '293067': 30
};
/**
 * @private
 * @constant
 * This calculation is based on the position of the sun 36 minutes after sunset in Jerusalem
 * around the equinox / equilux, which is 8.5° below geometric zenith.
 * The Ohr Meir considers this the time that 3 small stars are visible,
 * which is later than the required 3 medium stars.
 * @see {https://kosherjava.com/zmanim/docs/api/com/kosherjava/zmanim/ZmanimCalendar.html#ZENITH_8_POINT_5}
 */ const $7ae6ee87b7df885d$var$TZEIT_3SMALL_STARS = 8.5;
/**
 * @private
 * @constant
 * This calculation is based on observation of 3 medium sized stars by Dr. Baruch Cohen
 * in his calendar published in in 1899 in Strasbourg, France.
 * This calculates to 7.0833333° below geometric zenith.
 * @see {https://kosherjava.com/zmanim/docs/api/com/kosherjava/zmanim/ComplexZmanimCalendar.html#ZENITH_7_POINT_083}
 */ const $7ae6ee87b7df885d$var$TZEIT_3MEDIUM_STARS = 7.0833333;
/**
 * Modifies options in-place
 * @private
 */ function $7ae6ee87b7df885d$var$checkCandleOptions(options) {
    if (!options.candlelighting) return;
    const location = options.location;
    if (typeof location === 'undefined' || !(location instanceof (0, $2f64a42ff459546f$export$18a2be9195644f38))) throw new TypeError('options.candlelighting requires valid options.location');
    if (typeof options.havdalahMins === 'number' && typeof options.havdalahDeg === 'number') throw new TypeError('options.havdalahMins and options.havdalahDeg are mutually exclusive');
    const min0 = options.candleLightingMins;
    let min = typeof min0 === 'number' && !isNaN(min0) ? Math.trunc(min0) : 18;
    if (location.getIsrael() && Math.abs(min) === 18) min = $7ae6ee87b7df885d$var$overrideIsraelCandleMins(location, min);
    options.candleLightingMins = -1 * Math.abs(min);
    if (typeof options.havdalahMins === 'number') options.havdalahMins = Math.trunc(Math.abs(options.havdalahMins));
    else if (typeof options.havdalahDeg === 'number') options.havdalahDeg = Math.abs(options.havdalahDeg);
    else options.havdalahDeg = $7ae6ee87b7df885d$var$TZEIT_3SMALL_STARS;
    if (typeof options.fastEndDeg !== 'number') options.fastEndDeg = $7ae6ee87b7df885d$var$TZEIT_3MEDIUM_STARS;
}
function $7ae6ee87b7df885d$var$overrideIsraelCandleMins(location, min) {
    const geoid = location.getGeoId();
    if (geoid) {
        const offset = $7ae6ee87b7df885d$var$geoIdCandleOffset[geoid];
        if (typeof offset === 'number') return offset;
    }
    const shortName = location.getShortName();
    if (shortName) {
        const offset = $7ae6ee87b7df885d$var$israelCityOffset[shortName];
        if (typeof offset === 'number') return offset;
    }
    return min;
}
/**
 * Mask to filter Holiday array
 * @private
 */ function $7ae6ee87b7df885d$var$getMaskFromOptions(options) {
    var _a;
    if (typeof options.mask === 'number') return $7ae6ee87b7df885d$var$setOptionsFromMask(options);
    const il = options.il || ((_a = options.location) === null || _a === undefined ? undefined : _a.getIsrael()) || false;
    let mask = 0;
    // default options
    if (!options.noHolidays) mask |= $7ae6ee87b7df885d$var$ROSH_CHODESH | $7ae6ee87b7df885d$var$YOM_TOV_ENDS | $7ae6ee87b7df885d$var$MINOR_FAST | $7ae6ee87b7df885d$var$SPECIAL_SHABBAT | $7ae6ee87b7df885d$var$MODERN_HOLIDAY | $7ae6ee87b7df885d$var$MAJOR_FAST | $7ae6ee87b7df885d$var$MINOR_HOLIDAY | $7ae6ee87b7df885d$var$EREV | $7ae6ee87b7df885d$var$CHOL_HAMOED | $7ae6ee87b7df885d$var$LIGHT_CANDLES | $7ae6ee87b7df885d$var$LIGHT_CANDLES_TZEIS | $7ae6ee87b7df885d$var$CHANUKAH_CANDLES;
    if (options.candlelighting) mask |= $7ae6ee87b7df885d$var$LIGHT_CANDLES | $7ae6ee87b7df885d$var$LIGHT_CANDLES_TZEIS | $7ae6ee87b7df885d$var$YOM_TOV_ENDS;
    // suppression of defaults
    if (options.noRoshChodesh) mask &= ~$7ae6ee87b7df885d$var$ROSH_CHODESH;
    if (options.noModern) mask &= ~$7ae6ee87b7df885d$var$MODERN_HOLIDAY;
    if (options.noMinorFast) mask &= ~$7ae6ee87b7df885d$var$MINOR_FAST;
    if (options.noSpecialShabbat) {
        mask &= ~$7ae6ee87b7df885d$var$SPECIAL_SHABBAT;
        mask &= ~$7ae6ee87b7df885d$var$SHABBAT_MEVARCHIM;
    }
    if (il) mask |= $7ae6ee87b7df885d$var$IL_ONLY;
    else mask |= $7ae6ee87b7df885d$var$CHUL_ONLY;
    // non-default options
    if (options.sedrot) mask |= $7ae6ee87b7df885d$var$PARSHA_HASHAVUA;
    if (options.omer) mask |= $7ae6ee87b7df885d$var$OMER_COUNT;
    if (options.shabbatMevarchim) mask |= $7ae6ee87b7df885d$var$SHABBAT_MEVARCHIM;
    if (options.yomKippurKatan) mask |= $7ae6ee87b7df885d$var$YOM_KIPPUR_KATAN;
    if (options.yizkor) mask |= $7ae6ee87b7df885d$var$YIZKOR;
    if (options.dailyLearning) {
        const dailyLearning = options.dailyLearning;
        if (dailyLearning.dafYomi) mask |= $7ae6ee87b7df885d$var$DAF_YOMI;
        if (dailyLearning.mishnaYomi) mask |= $7ae6ee87b7df885d$var$MISHNA_YOMI;
        if (dailyLearning.nachYomi) mask |= $7ae6ee87b7df885d$var$NACH_YOMI;
        if (dailyLearning.yerushalmi) mask |= $7ae6ee87b7df885d$var$YERUSHALMI_YOMI;
    }
    return mask;
}
const $7ae6ee87b7df885d$var$MASK_LIGHT_CANDLES = $7ae6ee87b7df885d$var$LIGHT_CANDLES | $7ae6ee87b7df885d$var$LIGHT_CANDLES_TZEIS | $7ae6ee87b7df885d$var$CHANUKAH_CANDLES | $7ae6ee87b7df885d$var$YOM_TOV_ENDS;
const $7ae6ee87b7df885d$var$defaultLocation = new (0, $2f64a42ff459546f$export$18a2be9195644f38)(0, 0, false, 'UTC');
/**
 * @private
 */ function $7ae6ee87b7df885d$var$setOptionsFromMask(options) {
    const m = options.mask || 0;
    if (m & $7ae6ee87b7df885d$var$ROSH_CHODESH) delete options.noRoshChodesh;
    if (m & $7ae6ee87b7df885d$var$MODERN_HOLIDAY) delete options.noModern;
    if (m & $7ae6ee87b7df885d$var$MINOR_FAST) delete options.noMinorFast;
    if (m & $7ae6ee87b7df885d$var$SPECIAL_SHABBAT) delete options.noSpecialShabbat;
    if (m & $7ae6ee87b7df885d$var$PARSHA_HASHAVUA) options.sedrot = true;
    if (m & ($7ae6ee87b7df885d$var$DAF_YOMI | $7ae6ee87b7df885d$var$MISHNA_YOMI | $7ae6ee87b7df885d$var$NACH_YOMI | $7ae6ee87b7df885d$var$YERUSHALMI_YOMI)) {
        options.dailyLearning = options.dailyLearning || {};
        if (m & $7ae6ee87b7df885d$var$DAF_YOMI) options.dailyLearning.dafYomi = true;
        if (m & $7ae6ee87b7df885d$var$MISHNA_YOMI) options.dailyLearning.mishnaYomi = true;
        if (m & $7ae6ee87b7df885d$var$NACH_YOMI) options.dailyLearning.nachYomi = true;
        if (m & $7ae6ee87b7df885d$var$YERUSHALMI_YOMI) options.dailyLearning.yerushalmi = 1;
    }
    if (m & $7ae6ee87b7df885d$var$OMER_COUNT) options.omer = true;
    if (m & $7ae6ee87b7df885d$var$SHABBAT_MEVARCHIM) options.shabbatMevarchim = true;
    if (m & $7ae6ee87b7df885d$var$YOM_KIPPUR_KATAN) options.yomKippurKatan = true;
    if (m & $7ae6ee87b7df885d$var$YIZKOR) options.yizkor = true;
    return m;
}
/**
 * Appends the Event `ev` to the `events` array. Also may add related
 * timed events like candle-lighting or fast start/end
 * @private
 */ function $7ae6ee87b7df885d$var$appendHolidayAndRelated(candlesEv, events, ev, options, isFriday, isSaturday, hasUserMask) {
    const il = options.il || false;
    if (!ev.observedIn(il)) return candlesEv; // holiday isn't observed here; bail out early
    const eFlags = ev.getFlags();
    if (!options.yomKippurKatan && eFlags & $7ae6ee87b7df885d$var$YOM_KIPPUR_KATAN || options.noModern && eFlags & $7ae6ee87b7df885d$var$MODERN_HOLIDAY) return candlesEv; // bail out early
    const isMajorFast = Boolean(eFlags & $7ae6ee87b7df885d$var$MAJOR_FAST);
    const isMinorFast = Boolean(eFlags & $7ae6ee87b7df885d$var$MINOR_FAST);
    let fastEv;
    if (options.candlelighting && (isMajorFast || isMinorFast) && ev.getDesc() !== 'Yom Kippur') {
        ev = fastEv = (0, $ae9f09b8aafe32c5$export$31a68e05b6290ca0)(ev, options);
        if (fastEv.startEvent && (isMajorFast || isMinorFast && !options.noMinorFast)) events.push(fastEv.startEvent);
    }
    if (eFlags & Number(options.mask) || !eFlags && !hasUserMask) {
        if (options.candlelighting && eFlags & $7ae6ee87b7df885d$var$MASK_LIGHT_CANDLES) {
            const hd = ev.getDate();
            candlesEv = (0, $ae9f09b8aafe32c5$export$647eb1e9aafe5fcd)(ev, hd, options, isFriday, isSaturday);
            if (eFlags & $7ae6ee87b7df885d$var$CHANUKAH_CANDLES && candlesEv && !options.noHolidays) {
                // Replace Chanukah event with a clone that includes candle lighting time.
                // For clarity, allow a "duplicate" candle lighting event to remain for Shabbat
                const chanukahEv = (0, $ae9f09b8aafe32c5$export$40734d065d728074)(ev, hd, options);
                if (chanukahEv) {
                    if (isFriday || isSaturday) {
                        chanukahEv.eventTime = candlesEv.eventTime;
                        chanukahEv.eventTimeStr = candlesEv.eventTimeStr;
                    }
                    ev = chanukahEv;
                }
                candlesEv = undefined;
            }
        }
        if (!options.noHolidays || options.yomKippurKatan && eFlags & $7ae6ee87b7df885d$var$YOM_KIPPUR_KATAN) events.push(ev); // the original event itself
    }
    if ((isMajorFast || isMinorFast && !options.noMinorFast) && fastEv && fastEv.endEvent) events.push(fastEv.endEvent);
    return candlesEv;
}
function $7ae6ee87b7df885d$var$makeMoladAndMevarchimChodesh(hd, options) {
    const evts = [];
    const hmonth = hd.getMonth();
    const hdate = hd.getDate();
    if (hmonth !== $7ae6ee87b7df885d$var$ELUL && hdate >= 23 && hdate <= 29) {
        const hyear = hd.getFullYear();
        const monNext = hmonth === (0, $e7dd728d9f060a75$export$8f4940fd510e0848).monthsInYear(hyear) ? $7ae6ee87b7df885d$var$NISAN : hmonth + 1;
        if (options.molad) evts.push(new (0, $c73aa37de5a0c175$export$b3ef9a367289f2bc)(hd, hyear, monNext, options));
        if (options.shabbatMevarchim) {
            const nextMonthName = (0, $e7dd728d9f060a75$export$8f4940fd510e0848).getMonthName(monNext, hyear);
            const molad = new (0, $c73aa37de5a0c175$export$6240c2e81a7cb858)(hyear, monNext);
            const memo = molad.render(options.locale || 'en', options);
            evts.push(new (0, $dce2c5f9248cc8c1$export$d672f969e07f065b)(hd, nextMonthName, memo));
        }
    }
    return evts;
}
function $7ae6ee87b7df885d$var$dailyLearningName(key, val) {
    if (key === 'yerushalmi') return val === 2 ? 'yerushalmi-schottenstein' : 'yerushalmi-vilna';
    return key;
}
function $7ae6ee87b7df885d$var$makeDailyLearning(hd, dailyLearning, il) {
    const evts = [];
    for (const [key, val] of Object.entries(dailyLearning))if (val) {
        const name = $7ae6ee87b7df885d$var$dailyLearningName(key, val);
        const learningEv = (0, $e29b38910ce1f1c9$export$e03d32857f8fc133).lookup(name, hd, il);
        if (learningEv) evts.push(learningEv);
    }
    return evts;
}
function $7ae6ee87b7df885d$var$makeOmerEvent(hd, omerDay, options) {
    const omerEv = new (0, $077570d7819d9417$export$68369c1aff1fe744)(hd, omerDay);
    if (options.candlelighting) {
        const location = options.location;
        const zmanim = new (0, $dcc49aa98f3628f5$export$c5e94b89b957f48e)(location, hd.prev(), false);
        const tzeit = zmanim.tzeit(7.0833);
        if (!isNaN(tzeit.getTime())) omerEv.alarm = tzeit;
    }
    return omerEv;
}


/*
    Hebcal - A Jewish Calendar Generator
    Copyright (c) 1994-2020 Danny Sadinoff
    Portions copyright Eyal Schachter and Michael J. Radwin

    https://github.com/hebcal/hebcal-es6

    This program is free software; you can redistribute it and/or
    modify it under the terms of the GNU General Public License
    as published by the Free Software Foundation; either version 2
    of the License, or (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program. If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * HebrewCalendar is the main interface to the `@hebcal/core` library.
 * This namespace is used to calculate holidays, rosh chodesh, candle lighting & havdalah times,
 * Parashat HaShavua, Daf Yomi, days of the omer, and the molad.
 * Event names can be rendered in several languges using the `locale` option.
 */ class $b05a391256b46d23$export$ca405048b8fb5af {
    constructor(){}
    /**
     * Calculates holidays and other Hebrew calendar events based on {@link CalOptions}.
     *
     * Each holiday is represented by an {@link Event} object which includes a date,
     * a description, flags and optional attributes.
     * If given no options, returns holidays for the Diaspora for the current Gregorian year.
     *
     * The date range returned by this function can be controlled by:
     * * `options.year` - Gregorian (e.g. 1993) or Hebrew year (e.g. 5749)
     * * `options.isHebrewYear` - to interpret `year` as Hebrew year
     * * `options.numYears` - generate calendar for multiple years (default 1)
     * * `options.month` - Gregorian or Hebrew month (to filter results to a single month)
     *
     * Alternatively, specify start and end days with `Date` or {@link HDate} instances:
     * * `options.start` - use specific start date (requires `end` date)
     * * `options.end` - use specific end date (requires `start` date)
     *
     * Unless `options.noHolidays == true`, default holidays include:
     * * Major holidays - Rosh Hashana, Yom Kippur, Pesach, Sukkot, etc.
     * * Minor holidays - Purim, Chanukah, Tu BiShvat, Lag BaOmer, etc.
     * * Minor fasts - Ta'anit Esther, Tzom Gedaliah, etc. (unless `options.noMinorFast`)
     * * Special Shabbatot - Shabbat Shekalim, Zachor, etc. (unless `options.noSpecialShabbat`)
     * * Modern Holidays - Yom HaShoah, Yom HaAtzma'ut, etc. (unless `options.noModern`)
     * * Rosh Chodesh (unless `options.noRoshChodesh`)
     *
     * Holiday and Torah reading schedules differ between Israel and the Disapora.
     * Set `options.il=true` to use the Israeli schedule.
     *
     * Additional non-default event types can be specified:
     * * Parashat HaShavua - weekly Torah Reading on Saturdays (`options.sedrot`)
     * * Counting of the Omer (`options.omer`)
     * * Shabbat Mevarchim HaChodesh on Saturday before Rosh Chodesh (`options.shabbatMevarchim`)
     * * Molad announcement on Saturday before Rosh Chodesh (`options.molad`)
     * * Yom Kippur Katan (`options.yomKippurKatan`)
     * * Yizkor (`options.yizkor`)
     *
     * Daily Study of texts are supported by the
     * {@link https://github.com/hebcal/hebcal-learning @hebcal/learning} package,
     * for example:
     * * Babylonian Talmud Daf Yomi (`options.dailyLearning.dafYomi`)
     * * Jerusalem Talmud (Yerushalmi) Yomi (`options.dailyLearning.yerushalmi`)
     * * Mishna Yomi (`options.dailyLearning.mishnaYomi`)
     * * Nach Yomi (`options.dailyLearning.nachYomi`)
     *
     * Candle-lighting and Havdalah times are approximated using latitude and longitude
     * specified by the {@link Location} class. The `Location` class contains a small
     * database of cities with their associated geographic information and time-zone information.
     * If you ever have any doubts about Hebcal's times, consult your local halachic authority.
     * If you enter geographic coordinates above the arctic circle or antarctic circle,
     * the times are guaranteed to be wrong.
     *
     * To add candle-lighting options, set `options.candlelighting=true` and set
     * `options.location` to an instance of `Location`. By default, candle lighting
     * time is 18 minutes before sundown (40 minutes for Jerusalem,
     * 30 minutes for Haifa and Zikhron Ya'akov) and Havdalah is
     * calculated according to Tzeit Hakochavim - Nightfall (the point when 3 small stars
     * are observable in the night time sky with the naked eye). The default Havdalah
     * option (Tzeit Hakochavim) is calculated when the sun is 8.5° below the horizon.
     * These defaults can be changed using these options:
     * * `options.candleLightingMins` - minutes before sundown to light candles
     * * `options.havdalahMins` - minutes after sundown for Havdalah (typical values are 42, 50, or 72).
     *    Havdalah times are suppressed when `options.havdalahMins=0`.
     * * `options.havdalahDeg` - degrees for solar depression for Havdalah.
     *    Default is 8.5 degrees for 3 small stars. Use 7.083 degrees for 3 medium-sized stars.
     *    Havdalah times are suppressed when `options.havdalahDeg=0`.
     *
     * If both `options.candlelighting=true` and `options.location` is specified,
     * Chanukah candle-lighting times and minor fast start/end times will also be generated.
     * Chanukah candle-lighting is at Bein HaShmashos (13.5 minutes before
     * the sun is 7.083° below the horizon in the evening)
     * on weekdays, at regular candle-lighting time on Fridays, and at regular Havdalah time on
     * Saturday night (see above).
     *
     * Minor fasts begin at Alot HaShachar (sun is 16.1° below the horizon in the morning) and
     * end when 3 medium-sized stars are observable in the night sky (sun is 7.083° below the horizon
     * in the evening).
     *
     * Two options also exist for generating an Event with the Hebrew date:
     * * `options.addHebrewDates` - print the Hebrew date for the entire date range
     * * `options.addHebrewDatesForEvents` - print the Hebrew date for dates with some events
     *
     * Lastly, translation and transliteration of event titles is controlled by
     * `options.locale` and the {@link Locale} API.
     * `@hebcal/core` supports three locales by default:
     * * `en` - default, Sephardic transliterations (e.g. "Shabbat")
     * * `ashkenazi` - Ashkenazi transliterations (e.g. "Shabbos")
     * * `he` - Hebrew (e.g. "שַׁבָּת")
     *
     * Additional locales (such as `ru` or `fr`) are supported by the
     * {@link https://github.com/hebcal/hebcal-locales @hebcal/locales} package
     *
     * @example
     * import {HebrewCalendar, HDate, Location, Event} from '@hebcal/core';
     * const options: CalOptions = {
     *   year: 1981,
     *   isHebrewYear: false,
     *   candlelighting: true,
     *   location: Location.lookup('San Francisco'),
     *   sedrot: true,
     *   omer: true,
     * };
     * const events = HebrewCalendar.calendar(options);
     * for (const ev of events) {
     *   const hd = ev.getDate();
     *   const date = hd.greg();
     *   console.log(date.toLocaleDateString(), ev.render('en'), hd.toString());
     * }
     */ static calendar(options = {}) {
        return (0, $7ae6ee87b7df885d$export$56bbcdb8aca31149)(options);
    }
    /**
     * Calculates a birthday or anniversary (non-yahrzeit).
     * `hyear` must be after original `gdate` of anniversary.
     * Returns `undefined` when requested year preceeds or is same as original year.
     *
     * Hebcal uses the algorithm defined in "Calendrical Calculations"
     * by Edward M. Reingold and Nachum Dershowitz.
     *
     * The birthday of someone born in Adar of an ordinary year or Adar II of
     * a leap year is also always in the last month of the year, be that Adar
     * or Adar II. The birthday in an ordinary year of someone born during the
     * first 29 days of Adar I in a leap year is on the corresponding day of Adar;
     * in a leap year, the birthday occurs in Adar I, as expected.
     *
     * Someone born on the thirtieth day of Marcheshvan, Kislev, or Adar I
     * has his birthday postponed until the first of the following month in
     * years where that day does not occur. [Calendrical Calculations p. 111]
     * @example
     * import {HebrewCalendar} from '@hebcal/core';
     * const dt = new Date(2014, 2, 2); // '2014-03-02' == '30 Adar I 5774'
     * const hd = HebrewCalendar.getBirthdayOrAnniversary(5780, dt); // '1 Nisan 5780'
     * console.log(hd.greg().toLocaleDateString('en-US')); // '3/26/2020'
     * @param hyear Hebrew year
     * @param gdate Gregorian or Hebrew date of event
     * @returns anniversary occurring in `hyear`
     */ static getBirthdayOrAnniversary(hyear, gdate) {
        const dt = (0, $6ddeffc610e4c6d6$export$e4a94214ee3df22c)(hyear, gdate);
        if (typeof dt === 'undefined') return dt;
        return new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(dt);
    }
    /**
     * Calculates yahrzeit.
     * `hyear` must be after original `gdate` of death.
     * Returns `undefined` when requested year preceeds or is same as original year.
     *
     * Hebcal uses the algorithm defined in "Calendrical Calculations"
     * by Edward M. Reingold and Nachum Dershowitz.
     *
     * The customary anniversary date of a death is more complicated and depends
     * also on the character of the year in which the first anniversary occurs.
     * There are several cases:
     *
     * * If the date of death is Marcheshvan 30, the anniversary in general depends
     *   on the first anniversary; if that first anniversary was not Marcheshvan 30,
     *   use the day before Kislev 1.
     * * If the date of death is Kislev 30, the anniversary in general again depends
     *   on the first anniversary — if that was not Kislev 30, use the day before
     *   Tevet 1.
     * * If the date of death is Adar II, the anniversary is the same day in the
     *   last month of the Hebrew year (Adar or Adar II).
     * * If the date of death is Adar I 30, the anniversary in a Hebrew year that
     *   is not a leap year (in which Adar only has 29 days) is the last day in
     *   Shevat.
     * * In all other cases, use the normal (that is, same month number) anniversary
     *   of the date of death. [Calendrical Calculations p. 113]
     * @example
     * import {HebrewCalendar} from '@hebcal/core';
     * const dt = new Date(2014, 2, 2); // '2014-03-02' == '30 Adar I 5774'
     * const hd = HebrewCalendar.getYahrzeit(5780, dt); // '30 Sh\'vat 5780'
     * console.log(hd.greg().toLocaleDateString('en-US')); // '2/25/2020'
     * @param hyear Hebrew year
     * @param gdate Gregorian or Hebrew date of death
     * @returns anniversary occurring in hyear
     */ static getYahrzeit(hyear, gdate) {
        const dt = (0, $6ddeffc610e4c6d6$export$662088c602cc6396)(hyear, gdate);
        if (typeof dt === 'undefined') return dt;
        return new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(dt);
    }
    /**
     * Lower-level holidays interface, which returns a `Map` of `Event`s indexed by
     * `HDate.toString()`. These events must filtered especially for `flags.IL_ONLY`
     * or `flags.CHUL_ONLY` depending on Israel vs. Diaspora holiday scheme.
     * @param year Hebrew year
     */ static getHolidaysForYear(year) {
        return (0, $dfdf4f8567e83d5d$export$1783645bc1165a67)(year);
    }
    /**
     * Returns an array of holidays for the year
     * @param year Hebrew year
     * @param il use the Israeli schedule for holidays
     */ static getHolidaysForYearArray(year, il) {
        return (0, $dfdf4f8567e83d5d$export$50bc37b07e957528)(year, il);
    }
    /**
     * Returns an array of Events on this date (or `undefined` if no events)
     * @param date Hebrew Date, Gregorian date, or absolute R.D. day number
     * @param [il] use the Israeli schedule for holidays
     */ static getHolidaysOnDate(date, il) {
        return (0, $dfdf4f8567e83d5d$export$a2e6414e5cf3ed5a)(date, il);
    }
    /**
     * Eruv Tavshilin
     */ static eruvTavshilin(date, il) {
        if (date.getDay() < 3 || date.getDay() > 4) return false;
        const today = new (0, $e7dd728d9f060a75$export$8f4940fd510e0848)(date);
        const friday = today.after(5);
        const tomorrow = today.next();
        if (!$b05a391256b46d23$var$isChag(friday, il) || $b05a391256b46d23$var$isChag(today, il) || !$b05a391256b46d23$var$isChag(tomorrow, il)) return false;
        return true;
    }
    /**
     * Helper function to format a 23-hour (00:00-23:59) time in US format ("8:13pm") or
     * keep as "20:13" for any other locale/country. Uses {@link CalOptions} to determine
     * locale.
     * If `options.hour12` is `false`, locale is ignored and always returns 24-hour time.
     * If `options.hour12` is `true`, locale is ignored and always returns 12-hour time.
     * @param timeStr - original time like "20:30"
     * @param suffix - "p" or "pm" or " P.M.". Add leading space if you want it
     * @param options
     */ static reformatTimeStr(timeStr, suffix, options) {
        return (0, $572415ff68b4de58$export$9a72b7ab20a8c09d)(timeStr, suffix, options);
    }
    static version() {
        return 0, $b14b56bfe58815ff$export$83d89fbfd8236492;
    }
    /**
     * Convenience function to create an instance of `Sedra` or reuse a previously
     * created and cached instance.
     */ static getSedra(hyear, il) {
        return (0, $16a8384bbc778702$export$46dd3945618c9426)(hyear, il);
    }
    /**
     * Return a number containing information on what Hallel is said on that day.
     *
     * Whole Hallel is said on Chanukah, the first Yom Tov of Pesach, Shavuot, Sukkot,
     * Yom Ha'atzmaut, and Yom Yerushalayim.
     *
     * Half Hallel is said on Rosh Chodesh (not Rosh Hashanah), and the last 6 days of Pesach.
     *
     * The number is one of the following values:
     *
     * 0 - No Hallel
     * 1 - Half Hallel
     * 2 - Whole Hallel
     */ static hallel(hdate, il) {
        const events = (0, $dfdf4f8567e83d5d$export$50bc37b07e957528)(hdate.getFullYear(), il);
        return (0, $76848cb7ff12d4f2$export$f2738d08858f50af)(events, hdate);
    }
    /**
     * Return details on what Tachanun (or Tzidchatcha on Shabbat) is said on `hdate`.
     *
     * Tachanun is not said on Rosh Chodesh, the month of Nisan, Lag Baomer,
     * Rosh Chodesh Sivan until Isru Chag, Tisha B'av, 15 Av, Erev Rosh Hashanah,
     * Rosh Hashanah, Erev Yom Kippur until after Simchat Torah, Chanukah,
     * Tu B'shvat, Purim and Shushan Purim, and Purim and Shushan Purim Katan.
     *
     * In some congregations Tachanun is not said until from Rosh Chodesh Sivan
     * until 14th Sivan, Sukkot until after Rosh Chodesh Cheshvan, Pesach Sheini,
     * Yom Ha'atzmaut, and Yom Yerushalayim.
     *
     * Tachanun is not said at Mincha on days before it is not said at Shacharit.
     *
     * Tachanun is not said at Shacharit on Shabbat, but is at Mincha, usually.
     */ static tachanun(hdate, il) {
        return (0, $f106ded439541295$export$a7ebc0487bc516c5)(hdate, il);
    }
}
/**
 * @private
 */ function $b05a391256b46d23$var$isChag(date, il) {
    const events = (0, $dfdf4f8567e83d5d$export$a2e6414e5cf3ed5a)(date, il) || [];
    const chag = events.filter((ev)=>ev.getFlags() & (0, $439631353957c387$export$ceac1d294cf61000).CHAG);
    return chag.length !== 0;
}




var $fc034be10a6fa8a8$require$Sedra = $16a8384bbc778702$export$81ce12b331357b02;
var $fc034be10a6fa8a8$require$HDate = $e7dd728d9f060a75$export$8f4940fd510e0848;
var $fc034be10a6fa8a8$require$HebrewCalendar = $b05a391256b46d23$export$ca405048b8fb5af;
const $fc034be10a6fa8a8$var$sedraMap = {};
const $fc034be10a6fa8a8$var$getSedra = (hYear)=>{
    if (!$fc034be10a6fa8a8$var$sedraMap[hYear]) $fc034be10a6fa8a8$var$sedraMap[hYear] = new $fc034be10a6fa8a8$require$Sedra(hYear);
    return $fc034be10a6fa8a8$var$sedraMap[hYear];
};
const $fc034be10a6fa8a8$var$CHAG_FLAG = 1;
const $fc034be10a6fa8a8$var$isYomTov = (holidays)=>{
    if (!holidays || !holidays.length) return false;
    return holidays.some((h)=>{
        const flags = h.getFlags();
        return flags & $fc034be10a6fa8a8$var$CHAG_FLAG;
    });
};
const $fc034be10a6fa8a8$var$getHebInfo = (originDate)=>{
    let date;
    try {
        date = new $fc034be10a6fa8a8$require$HDate(originDate);
    } catch (error) {
        console.error(error);
        return {
            hebDate: '',
            occasion: ''
        };
    }
    const sedra = $fc034be10a6fa8a8$var$getSedra(date.getFullYear());
    const parsha = sedra.getString(date).replace('Parashat ', '');
    const holidays = $fc034be10a6fa8a8$require$HebrewCalendar.getHolidaysOnDate(date);
    const hebDate = `${date.getDate()} ${date.getMonthName()}`;
    const occasion = $fc034be10a6fa8a8$var$isYomTov(holidays) ? holidays[0].desc : parsha;
    return {
        hebDate: hebDate,
        occasion: occasion
    };
};
window.getHebInfo = $fc034be10a6fa8a8$var$getHebInfo;
$fc034be10a6fa8a8$exports = $fc034be10a6fa8a8$var$getHebInfo;

})();
//# sourceMappingURL=zmanim.js.map
